import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineDirective, Directive, Input, ɵɵinject, ɵɵdirectiveInject, ɵɵdefineComponent, ɵɵcontentQuery, TemplateRef, ɵɵqueryRefresh, ɵɵloadQuery, ɵɵelementContainer, Component, ContentChildren, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, ɵɵgetCurrentView, ɵɵelement, ɵɵpipe, ɵɵtemplate, ɵɵlistener, ɵɵrestoreView, ɵɵnextContext, ɵɵadvance, ɵɵproperty, ɵɵpipeBind1, ɵɵsanitizeHtml, ɵɵpureFunction0, EventEmitter, Output, ɵɵclassProp, ɵɵtextInterpolate1, ɵɵpipeBind2, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵattribute, ElementRef, ɵɵreference, ɵɵtextInterpolate2, ɵɵviewQuery, ViewChild, ɵɵpureFunction1, ɵɵtextInterpolate, ɵɵstyleProp, ɵɵclassMapInterpolate1, HostListener, ɵɵpureFunction2, ɵɵtemplateRefExtractor, ɵɵclassMapInterpolate2, ɵɵNgOnChangesFeature, ɵɵpropertyInterpolate, ɵɵsanitizeUrl, ɵɵsanitizeResourceUrl, ɵɵpropertyInterpolate1, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { __awaiter } from 'tslib';
import { HttpService } from '@akeela/properties';
import { isNullOrUndefined, isNull } from 'util';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UploadService, ErrorService, FileService, PreviewDocComponent, WebcamService, WebcamButtonsComponent, WebcamComponent, AkeelaCommonModule } from '@akeela/common';
import { NgIf, DatePipe, NgForOf, NgClass, NgTemplateOutlet, CommonModule } from '@angular/common';
import swal from 'sweetalert2';
import { I18nPipe, I18nModule } from '@akeela/i18n';
import { LocalService } from '@akeela/local-storage';
import { SwalPortalTargets, SwalComponent, SwalPortalDirective, SwalDirective, SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { MyDatePicker, MyDatePickerModule } from 'mydatepicker';
import { RequiredValidator, NgControlStatus, NgModel, FormControl, Validators, FormBuilder, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, SelectControlValueAccessor, FormControlName, NgSelectOption, ɵangular_packages_forms_forms_x, DefaultValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Howl } from 'howler';
import { FaceDetectorResponseService, FaceCompareService, ModelLoaderService, NgxFaceApiJsModule } from '@akeela/ngx-face-api-js';
import { ImageCompressorService, NgxImageCompressorModule } from 'ngx-image-compressor';
import { WebCamModule } from 'ack-angular-webcam';

class AkeelaTemplateService {
    constructor() {
        this.templates = {};
    }
    addTemplate(componentName, template) {
        this.templates[componentName] = template;
    }
    getTemplates() {
        return this.templates;
    }
    getTemplate(componentName) {
        return this.templates[componentName];
    }
}
/** @nocollapse */ AkeelaTemplateService.ɵfac = function AkeelaTemplateService_Factory(t) { return new (t || AkeelaTemplateService)(); };
/** @nocollapse */ AkeelaTemplateService.ɵprov = ɵɵdefineInjectable({ token: AkeelaTemplateService, factory: AkeelaTemplateService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaTemplateService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class AkeelaRequirementContentDirective {
    constructor() {
    }
}
/** @nocollapse */ AkeelaRequirementContentDirective.ɵfac = function AkeelaRequirementContentDirective_Factory(t) { return new (t || AkeelaRequirementContentDirective)(); };
/** @nocollapse */ AkeelaRequirementContentDirective.ɵdir = ɵɵdefineDirective({ type: AkeelaRequirementContentDirective, selectors: [["", "akeelaRequirementsContent", ""]], inputs: { componentName: "componentName" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaRequirementContentDirective, [{
        type: Directive,
        args: [{
                selector: '[akeelaRequirementsContent]'
            }]
    }], function () { return []; }, { componentName: [{
            type: Input
        }] }); })();

class RequirementsService {
    constructor(_httpService) {
        this._httpService = _httpService;
        this.updateModalRQ$ = new BehaviorSubject(true);
    }
    setUpdateModalRQ(value) {
        this.updateModalRQ$.next(value);
    }
    resizeImg(file) {
        return __awaiter(this, void 0, void 0, function* () {
            const img = document.createElement('img');
            img.src = yield new Promise(resolve => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.readAsDataURL(file);
            });
            yield new Promise(resolve => img.onload = resolve);
            const canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            const MAX_WIDTH = 1000;
            const MAX_HEIGHT = 1000;
            let width = img.naturalWidth;
            let height = img.naturalHeight;
            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            }
            else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }
            canvas.width = width;
            canvas.height = height;
            ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            const result = yield new Promise(resolve => { canvas.toBlob(resolve, 'image/jpeg', 0.95); });
            return result;
        });
    }
    getPermitedExtensions(extensions) {
        const extensions_split = extensions.split(' ');
        const response = [];
        for (const ext of extensions_split) {
            switch (ext) {
                case '.PDF':
                    response.push('application/pdf');
                    break;
                case '.PNG':
                    response.push('image/png');
                    break;
                case '.JPG':
                    response.push('image/jpg');
                    break;
                case '.JPEG':
                    response.push('image/jpeg');
                    break;
                case '.XLS':
                    response.push('application/vnd.ms-excel');
                    break;
                case '.XLSX':
                    response.push('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    break;
                case '.DOC':
                    response.push('application/msword');
                    break;
                case '.DOCX':
                    response.push('application/vnd.openxmlformats-officedocument.wordprocessingml.document');
                    break;
            }
        }
        return response;
    }
    getPermitedExtensionsDescription(extensions) {
        const response = [];
        if (!isNullOrUndefined(extensions)) {
            const extensions_split = extensions.split(' ');
            for (const ext of extensions_split) {
                switch (ext) {
                    case '.PDF':
                        response.push('pdf');
                        break;
                    case '.PNG':
                        response.push('png');
                        break;
                    case '.JPG':
                        response.push('jpg');
                        break;
                    case '.JPEG':
                        response.push('jpeg');
                        break;
                    case '.XLS':
                        response.push('xls');
                        break;
                    case '.XLSX':
                        response.push('xlsx');
                        break;
                    case '.DOC':
                        response.push('doc');
                        break;
                    case '.DOCX':
                        response.push('docx');
                        break;
                }
            }
        }
        return response;
    }
    verifyStatusUploadFiles(config) {
        return new Promise((resolve, reject) => {
            this._httpService.executeRequest(config.endpoints.getRequirements.name, config.endpoints.getRequirements.params, true).subscribe((response) => {
                const requirements = this.format_response(response, config);
                const files = this.loadFileObject(requirements, config);
                resolve(this.check_requirements(requirements, files, config));
            }, error => {
                reject(error);
            });
        });
    }
    verifyRequirementsRequireDates(config) {
        return new Promise((resolve, reject) => {
            this._httpService.executeRequest(config.endpoints.getRequirements.name, config.endpoints.getRequirements.params, true).subscribe((response) => {
                const requirements = this.format_response(response, config);
                const files = this.loadFileObject(requirements, config);
                resolve(this.check_date_cases(requirements, files, config));
            }, error => {
                reject(error);
            });
        });
    }
    check_date_cases(requirements, files, config) {
        requirements.forEach(element => {
            element.value.forEach(element2 => {
            });
        });
        return [];
    }
    getRequirementsWithStatus(config, status) {
        return new Promise((resolve, reject) => {
            this._httpService.executeRequest(config.endpoints.getRequirements.name, config.endpoints.getRequirements.params, true).subscribe((response) => {
                const requirements = this.format_response(response, config);
                const files = this.loadFileObject(requirements, config);
                resolve(this.getRequirements(requirements, files, status));
            }, error => {
                reject(error);
            });
        });
    }
    getRequirementsWithMultipleStatus(config, status) {
        return new Promise((resolve, reject) => {
            this._httpService.executeRequest(config.endpoints.getRequirements.name, config.endpoints.getRequirements.params, true).subscribe((response) => {
                const requirements = this.format_response(response, config);
                const files = this.loadFileObject(requirements, config);
                const _response = [];
                for (const statu of status) {
                    for (const req of this.getRequirements(requirements, files, statu)) {
                        _response.push(req);
                    }
                }
                resolve(_response);
            }, error => {
                reject(error);
            });
        });
    }
    mergeDeep(target, source) {
        let output = Object.assign({}, target);
        if (this.isObject(target) && this.isObject(source)) {
            Object.keys(source).forEach(key => {
                if (this.isObject(source[key])) {
                    if (!(key in target))
                        Object.assign(output, { [key]: source[key] });
                    else
                        output[key] = this.mergeDeep(target[key], source[key]);
                }
                else {
                    Object.assign(output, { [key]: source[key] });
                }
            });
        }
        return output;
    }
    isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    }
    format_response(response, config) {
        const evilResponseProps = Object.keys(response);
        let goodResponse = [];
        let aux = [];
        evilResponseProps.forEach((value) => {
            const temp = {};
            temp['index'] = value;
            aux = [];
            let val_flag = null;
            response[value].forEach(ele => {
                var _a;
                val_flag = null;
                if (((_a = ele === null || ele === void 0 ? void 0 : ele.requirement) === null || _a === void 0 ? void 0 : _a.showInRequirements) === true) {
                    // APLICA FILTROS...
                    if (!isNullOrUndefined(config === null || config === void 0 ? void 0 : config.isFilterRequirementsByResponse)) {
                        if (config.isFilterRequirementsByResponse) {
                            if (!isNullOrUndefined(config.filterRequirementsByResponse.state)) {
                                if (config.filterRequirementsByResponse.state === ele.response && ele.response !== null) {
                                    val_flag = true;
                                }
                                else {
                                    if (config.filterRequirementsByResponse.state === '') {
                                        val_flag = true;
                                    }
                                    else {
                                        val_flag = false;
                                    }
                                }
                            }
                            else {
                                val_flag = true;
                            }
                        }
                        else {
                            val_flag = true;
                        }
                    }
                    else {
                        val_flag = true;
                    }
                    // .................
                    // APLICA FILTROS CATEGORY...
                    if (!isNullOrUndefined(config.isFilterRequirementsByCategory)) {
                        if (config.isFilterRequirementsByCategory) {
                            if (!isNullOrUndefined(config.filterRequirementsByCategory.name)) {
                                if (config.filterRequirementsByCategory.name === ele.requirement.requirementCategory.identifier && ele.requirement.requirementCategory.identifier !== null) {
                                    if (isNull(val_flag)) {
                                        val_flag = true;
                                    }
                                }
                                else {
                                    if ((isNull(val_flag) || val_flag) && config.filterRequirementsByCategory.name === '') {
                                        val_flag = true;
                                    }
                                    else {
                                        if (isNull(val_flag) || val_flag) {
                                            val_flag = false;
                                        }
                                    }
                                }
                            }
                            else {
                                if (isNull(val_flag)) {
                                    val_flag = true;
                                }
                            }
                        }
                    }
                    else {
                        if (isNull(val_flag)) {
                            val_flag = true;
                        }
                    }
                    // .................
                    if (val_flag) {
                        aux.push(ele);
                    }
                }
            });
            temp['value'] = aux;
            goodResponse.push(temp);
        });
        // si el filtro de categoria esta activado y la categoria esta completamente vacia, la borro.
        if (config.isFilterRequirementsByCategory) {
            if (!isNullOrUndefined(config.filterRequirementsByCategory.name)) {
                const goodResponse_aux = [];
                for (const resp of goodResponse) {
                    if (resp.value.length > 0) {
                        goodResponse_aux.push(resp);
                    }
                }
                goodResponse = goodResponse_aux;
            }
        }
        return goodResponse;
    }
    format_response2(response, config) {
        const evilResponseProps = Object.keys(response);
        let goodResponse = [];
        let aux = [];
        evilResponseProps.forEach((value) => {
            const temp = {};
            temp['index'] = value;
            aux = [];
            response[value].forEach(ele => {
                aux.push(ele);
            });
            temp['value'] = aux;
            goodResponse.push(temp);
        });
        // si el filtro de categoria esta activado y la categoria esta completamente vacia, la borro.
        if (config.isFilterRequirementsByCategory) {
            if (!isNullOrUndefined(config.filterRequirementsByCategory.name)) {
                const goodResponse_aux = [];
                for (const resp of goodResponse) {
                    if (resp.value.length > 0) {
                        goodResponse_aux.push(resp);
                    }
                }
                goodResponse = goodResponse_aux;
            }
        }
        return goodResponse;
    }
    loadFileObject(files, config, service) {
        const i = 0;
        const obj = {};
        files.forEach((elem) => {
            var _a;
            for (const row of elem.value) {
                const arr = {};
                arr['type'] = row.requirement.requirementType;
                if (!isNullOrUndefined(row.identifier) || row.hasFiles === true) {
                    arr['status'] = 'COMPLETED';
                }
                else {
                    arr['status'] = !isNullOrUndefined(row.status) ? row.status : 'A';
                }
                arr['response'] = !isNullOrUndefined(row.response) ? row.response : null;
                if ((_a = config === null || config === void 0 ? void 0 : config.enableEspecialUpload) === null || _a === void 0 ? void 0 : _a.active) {
                    if (isNullOrUndefined(row === null || row === void 0 ? void 0 : row.response) && !isNullOrUndefined(row === null || row === void 0 ? void 0 : row.responseDescription)) {
                        if (row === null || row === void 0 ? void 0 : row.responseDescription.includes('Incompleto')) {
                            arr['response'] = 'INCOMPLETED';
                        }
                        if (row === null || row === void 0 ? void 0 : row.responseDescription.includes('Rechazado')) {
                            arr['response'] = 'REJECTED';
                        }
                    }
                }
                arr['identifier'] = row.requirement.identifier;
                arr['alternateName'] = row.requirement.alternateName;
                arr['object'] = row;
                arr['idFile'] = null;
                arr['nameFile'] = null;
                arr['link-youtube'] = null;
                if (!isNullOrUndefined(row.link_youtube)) {
                    arr['link-youtube'] = row.link_youtube;
                }
                // if (row.requirement.requirementType === 'FILE') {
                arr['progress'] = null;
                arr['save'] = {
                    service: isNullOrUndefined(service) ? 'requirements' : service,
                    method: 'POST',
                    function: 'upload_doc',
                    data: config.endpoints.saveRequirement.params.body
                },
                    arr['delete'] = {
                        service: isNullOrUndefined(service) ? 'requirements' : service,
                        method: 'DELETE',
                        function: 'upload_doc',
                        data: config.endpoints.deleteRequirement.params.body
                    };
                // }
                obj[row.requirement.identifier] = arr;
            }
        });
        return obj;
    }
    // solo para el load del componente de camara
    loadFileObjectCamera(files, config, service) {
        const i = 0;
        const obj = {};
        files.forEach((elem) => {
            for (const row of elem.value) {
                const arr = {};
                arr['type'] = row.requirement.requirementType;
                if (!isNullOrUndefined(row.identifier) || row.hasFiles === true) {
                    arr['status'] = 'COMPLETED';
                }
                else {
                    arr['status'] = !isNullOrUndefined(row.status) ? row.status : 'A';
                }
                arr['response'] = !isNullOrUndefined(row.response) ? row.response : null;
                arr['identifier'] = row.requirement.identifier;
                arr['alternateName'] = row.requirement.alternateName;
                arr['object'] = row;
                arr['idFile'] = null;
                arr['nameFile'] = null;
                // if (row.requirement.requirementType === 'FILE') {
                arr['progress'] = null;
                arr['save'] = {
                    service: isNullOrUndefined(service) ? ' requirements' : service,
                    method: 'POST',
                    function: 'upload_doc',
                    data: config.endpoints.saveRequirement.params.body
                },
                    arr['delete'] = {
                        service: isNullOrUndefined(service) ? ' requirements' : service,
                        method: 'DELETE',
                        function: 'upload_doc',
                        data: config.endpoints.deleteRequirement.params.body
                    };
                // }
                obj[row.requirement.alternateName] = arr;
            }
        });
        return obj;
    }
    getRequirements(requirements, files, status) {
        const response = new Array();
        requirements.forEach(element => {
            element.value.forEach(element2 => {
                if (files[element2.requirement.identifier].response === status) {
                    response.push({
                        name: element2.requirement.name,
                        description: files[element2.requirement.identifier].object.responseDescription,
                        response: status
                    });
                }
            });
        });
        return response;
    }
    check_requirements(requirements, files, config) {
        const response = {
            total_requirements: 0,
            total_required_requirements: 0,
            total_required_requirements_completed: 0,
            total_requirements_completed: 0,
            total_required_physical_requirements: 0,
            total_required_physical_requirements_completed: 0,
            total_required_responses_requirements: 0,
            total_required_responses_user_requirements: 0,
            total_required_responses_user_requirements_completed: 0,
            total_required_responses_user_requirements_completed_in_status_verified: 0,
            total_required_responses_user_requirements_completed_in_status_incompleted: 0,
            total_required_responses_user_requirements_completed_in_status_rejected: 0,
            total_required_responses_user_requirements_completed_in_status_inconsistent: 0,
            total_responses_user_incomplete_active: 0
        };
        requirements.forEach(element => {
            element.value.forEach(element2 => {
                response.total_requirements++;
                if (element2.requirement.required) {
                    response.total_required_requirements++;
                    response.total_required_responses_user_requirements++;
                }
                if (element2.requirement.secondRequired) {
                    response.total_required_physical_requirements++;
                }
                if (!isNullOrUndefined(files[element2.requirement.identifier])) {
                    if (files[element2.requirement.identifier].status === 'COMPLETED') {
                        response.total_requirements_completed++;
                        if (element2.requirement.upload && element2.requirement.required) {
                            response.total_required_requirements_completed++;
                        }
                        if (element2.requirement.upload && element2.requirement.secondRequired) {
                            response.total_required_physical_requirements_completed++;
                        }
                    }
                }
                if (!isNullOrUndefined(files[element2.requirement.identifier])) {
                    if (files[element2.requirement.identifier].response !== null && files[element2.requirement.identifier].response !== config.statusResponseRequirement.inconsistent) {
                        if (files[element2.requirement.identifier].response === config.statusResponseRequirement.incomplete) {
                            response.total_responses_user_incomplete_active++;
                            response.total_required_responses_user_requirements_completed_in_status_incompleted++;
                            response.total_required_responses_user_requirements_completed++;
                        }
                        if (files[element2.requirement.identifier].response === config.statusResponseRequirement.rejected) {
                            response.total_required_responses_user_requirements_completed_in_status_rejected++;
                            response.total_required_responses_user_requirements_completed++;
                        }
                        if (files[element2.requirement.identifier].response === config.statusResponseRequirement.verified) {
                            response.total_required_responses_user_requirements_completed_in_status_verified++;
                            response.total_required_responses_user_requirements_completed++;
                        }
                    }
                    else {
                        if (files[element2.requirement.identifier].response === config.statusResponseRequirement.inconsistent) {
                            response.total_required_responses_user_requirements_completed_in_status_inconsistent++;
                        }
                    }
                }
            });
        });
        return response;
    }
    validateRequiredRule(config, requirement) {
        if (!isNullOrUndefined(config.requiredFieldValidation)) {
            if (config.requiredFieldValidation === 'secondRequired') {
                return requirement.secondRequired;
            }
            else {
                return requirement.required;
            }
        }
        else {
            return requirement.required;
        }
    }
}
/** @nocollapse */ RequirementsService.ɵfac = function RequirementsService_Factory(t) { return new (t || RequirementsService)(ɵɵinject(HttpService)); };
/** @nocollapse */ RequirementsService.ɵprov = ɵɵdefineInjectable({ token: RequirementsService, factory: RequirementsService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RequirementsService, [{
        type: Injectable
    }], function () { return [{ type: HttpService }]; }, null); })();

class AkeelaRequirementsTemplateComponent {
    constructor(templateService) {
        this.templateService = templateService;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.contentsRef.forEach((item, index) => {
                const template = this.templatesRef.find((_template, templateIndex) => templateIndex === index);
                this.templateService.addTemplate(item.componentName, template);
            });
        }, 10);
    }
}
/** @nocollapse */ AkeelaRequirementsTemplateComponent.ɵfac = function AkeelaRequirementsTemplateComponent_Factory(t) { return new (t || AkeelaRequirementsTemplateComponent)(ɵɵdirectiveInject(AkeelaTemplateService)); };
/** @nocollapse */ AkeelaRequirementsTemplateComponent.ɵcmp = ɵɵdefineComponent({ type: AkeelaRequirementsTemplateComponent, selectors: [["akeela-requirements-template"]], contentQueries: function AkeelaRequirementsTemplateComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, AkeelaRequirementContentDirective, false);
        ɵɵcontentQuery(dirIndex, AkeelaRequirementContentDirective, false, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.contentsRef = _t);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.templatesRef = _t);
    } }, decls: 1, vars: 0, template: function AkeelaRequirementsTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementContainer(0);
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaRequirementsTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-requirements-template',
                templateUrl: './akeela-template.component.html',
                styleUrls: ['./akeela-template.component.css']
            }]
    }], function () { return [{ type: AkeelaTemplateService }]; }, { contentsRef: [{
            type: ContentChildren,
            args: [AkeelaRequirementContentDirective]
        }], templatesRef: [{
            type: ContentChildren,
            args: [AkeelaRequirementContentDirective, { read: TemplateRef }]
        }] }); })();

function RequirementDatesComponent_div_8_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 9);
    ɵɵelementStart(1, "label", 10);
    ɵɵtext(2, "*");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
const _c0 = function () { return { dateFormat: "dd-mm-yyyy" }; };
function RequirementDatesComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 5);
    ɵɵelement(1, "label", 6);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, RequirementDatesComponent_div_8_span_3_Template, 3, 0, "span", 7);
    ɵɵelementStart(4, "my-date-picker", 8);
    ɵɵlistener("ngModelChange", function RequirementDatesComponent_div_8_Template_my_date_picker_ngModelChange_4_listener($event) { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(); return ctx_r4.expedition = $event; });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 5, "@collections-text-emission"), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r0.transactionrequirement == null ? null : ctx_r0.transactionrequirement.requirement == null ? null : ctx_r0.transactionrequirement.requirement.mandatoryIssueDate);
    ɵɵadvance(1);
    ɵɵproperty("options", ɵɵpureFunction0(7, _c0))("ngModel", ctx_r0.expedition)("disabled", ctx_r0.config.isReadonly && !(ctx_r0.files[ctx_r0.transactionrequirement == null ? null : ctx_r0.transactionrequirement.requirement == null ? null : ctx_r0.transactionrequirement.requirement.identifier].response === ctx_r0.config.enableEspecialUpload.status && ctx_r0.config.enableEspecialUpload.active) && ctx_r0.showInputIssue(ctx_r0.transactionrequirement.requirement));
} }
function RequirementDatesComponent_div_9_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 9);
    ɵɵelementStart(1, "label", 10);
    ɵɵtext(2, "*");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function RequirementDatesComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 5);
    ɵɵelement(1, "label", 6);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, RequirementDatesComponent_div_9_span_3_Template, 3, 0, "span", 7);
    ɵɵelementStart(4, "my-date-picker", 11);
    ɵɵlistener("ngModelChange", function RequirementDatesComponent_div_9_Template_my_date_picker_ngModelChange_4_listener($event) { ɵɵrestoreView(_r8); const ctx_r7 = ɵɵnextContext(); return ctx_r7.expiration = $event; });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 5, "@collections-text-expiration"), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r1.transactionrequirement == null ? null : ctx_r1.transactionrequirement.requirement == null ? null : ctx_r1.transactionrequirement.requirement.mandatoryExpirationDate);
    ɵɵadvance(1);
    ɵɵproperty("options", ɵɵpureFunction0(7, _c0))("ngModel", ctx_r1.expiration)("disabled", ctx_r1.config.isReadonly && !(ctx_r1.files[ctx_r1.transactionrequirement == null ? null : ctx_r1.transactionrequirement.requirement == null ? null : ctx_r1.transactionrequirement.requirement.identifier].response === ctx_r1.config.enableEspecialUpload.status && ctx_r1.config.enableEspecialUpload.active) && ctx_r1.showInputExpiration(ctx_r1.transactionrequirement.requirement));
} }
function RequirementDatesComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 0);
    ɵɵelement(1, "br");
    ɵɵelementStart(2, "div", 2);
    ɵɵelementStart(3, "div", 0);
    ɵɵelementStart(4, "div", 2);
    ɵɵelementStart(5, "button", 12);
    ɵɵlistener("click", function RequirementDatesComponent_div_11_Template_button_click_5_listener() { ɵɵrestoreView(_r10); const ctx_r9 = ɵɵnextContext(); return ctx_r9.update_dates(); });
    ɵɵpipe(6, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(5);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(6, 1, "@collections-text-apply"), ɵɵsanitizeHtml);
} }
class RequirementDatesComponent {
    constructor(_i18n, _upload, _httpService, _error, swalTargets) {
        this._i18n = _i18n;
        this._upload = _upload;
        this._httpService = _httpService;
        this._error = _error;
        this.swalTargets = swalTargets;
        this.expired = new EventEmitter();
        this.currentdate = new Date();
        this.expedition = {};
        this.expiration = {};
        this.myDatePickerOptions = {
            dateFormat: null
        };
    }
    ngOnInit() {
        this.myDatePickerOptions.dateFormat = this.config.endpoints.updateDate.dateFormat;
        if (this.type !== 'transaction') {
            if (this.file.dateCreated) {
                if (this.file.dateCreated.startDate) {
                    this.expedition = this.format_date(this.file.dateCreated.startDate);
                }
            }
            if (this.file.expires) {
                if (this.file.expires.orderDate) {
                    this.expiration = this.format_date(this.file.expires.orderDate);
                }
            }
        }
        else {
            if (!isNullOrUndefined(this.transactionrequirement.emissionDate)) {
                if (this.transactionrequirement.emissionDate.orderDate) {
                    this.expedition = this.format_date(this.transactionrequirement.emissionDate.orderDate);
                }
            }
            if (!isNullOrUndefined(this.transactionrequirement.expirationDate)) {
                if (this.transactionrequirement.expirationDate.orderDate) {
                    this.expiration = this.format_date(this.transactionrequirement.expirationDate.orderDate);
                }
            }
        }
    }
    validate_expiration() {
        if (Object.entries(this.expiration).length !== 0) {
            if (this.expiration.jsdate) {
                const date = this.generate_object_date(this.expiration.jsdate);
                if (this.currentdate.getTime() > date.getTime()) {
                    console.log('vencido');
                }
                else {
                    console.log('valido');
                }
            }
        }
    }
    generate_object_date(epoc) {
        return new Date(epoc * 1000);
    }
    format_date(timestamp) {
        if (timestamp !== '' && timestamp !== null) {
            const date = this.generate_object_date(timestamp);
            return {
                jsdate: date
            };
        }
        else {
            return {};
        }
    }
    update_dates() {
        if (Object.entries(this.expedition).length !== 0 || Object.entries(this.expiration).length !== 0) {
            // se validan los requeridos, según aplique.
            this.create_object();
        }
    }
    create_object() {
        const currentime = new Date();
        let preventDefault = false;
        let expiration_epoc = 0;
        if (this.expiration.epoc) {
            expiration_epoc = this.expiration.epoc * 1000;
        }
        if ((expiration_epoc * 1000) >= currentime.getTime() || expiration_epoc === 0) {
            const obj = this.config.endpoints.updateDate.params.body;
            obj['requirement'] = {
                'identifier': this.transactionrequirement.requirement.identifier
            };
            if (this.type === 'transaction') {
                if (Object.entries(this.expedition).length !== 0) {
                    obj['emissionDate'] = {
                        'orderDate': (this.expedition.epoc)
                    };
                }
                if (Object.entries(this.expiration).length !== 0) {
                    obj['expirationDate'] = {
                        'orderDate': (this.expiration.epoc)
                    };
                }
            }
            else {
                obj['requirementArchives'] = [
                    {
                        'identifier': this.file.identifier
                    }
                ];
                if (Object.entries(this.expedition).length !== 0) {
                    obj['requirementArchives'][0]['dateCreated'] = {
                        'orderDate': (this.expedition.epoc)
                    };
                }
                if (Object.entries(this.expiration).length !== 0) {
                    obj['requirementArchives'][0]['expires'] = {
                        'orderDate': (this.expiration.epoc)
                    };
                }
            }
            if (this.validateRequiredInputIssue()) {
                if (Object.entries(this.expedition).length === 0) {
                    swal.fire({
                        title: 'Error',
                        html: this._i18n.transform('@collections-text-error-date-expedition-required')
                    });
                    preventDefault = true;
                }
            }
            if (this.validateRequiredInputExpiration()) {
                if (Object.entries(this.expiration).length === 0) {
                    swal.fire({
                        title: 'Error',
                        html: this._i18n.transform('@collections-text-error-date-expiration-required')
                    });
                    preventDefault = true;
                }
            }
            if (!preventDefault) {
                this._httpService.executeRequest(this.config.endpoints.updateDate.name, this.config.endpoints.updateDate.params, true).subscribe((response) => {
                    this.close();
                    this._upload.setChangeRequirementById(this.transactionrequirement.requirement.identifier);
                }, error => {
                    this._error.show(error);
                });
            }
        }
        else {
            swal.fire({
                title: 'Error',
                html: this._i18n.transform('@collections-text-error-date-expiration-invalid')
            });
        }
    }
    showInputExpiration(requirement) {
        if (!isNullOrUndefined(requirement.showExpirationDate)) {
            if (requirement.showExpirationDate === true) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }
    showInputIssue(requirement) {
        //alert(requirement.showDateOfIssue);
        if (!isNullOrUndefined(requirement.showDateOfIssue)) {
            if (requirement.showDateOfIssue === true) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }
    validateRequiredInputIssue() {
        if (!isNullOrUndefined(this.transactionrequirement.requirement.mandatoryIssueDate)) {
            return this.transactionrequirement.requirement.mandatoryIssueDate;
        }
        else {
            return false;
        }
    }
    validateRequiredInputExpiration() {
        if (!isNullOrUndefined(this.transactionrequirement.requirement.mandatoryExpirationDate)) {
            return this.transactionrequirement.requirement.mandatoryExpirationDate;
        }
        else {
            return false;
        }
    }
    close() {
        swal.fire({
            title: '',
            showCancelButton: false,
            showCloseButton: false,
            showConfirmButton: false,
            html: '',
            timer: 3
        });
    }
}
/** @nocollapse */ RequirementDatesComponent.ɵfac = function RequirementDatesComponent_Factory(t) { return new (t || RequirementDatesComponent)(ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(ErrorService), ɵɵdirectiveInject(SwalPortalTargets)); };
/** @nocollapse */ RequirementDatesComponent.ɵcmp = ɵɵdefineComponent({ type: RequirementDatesComponent, selectors: [["akeela-requirement-dates"]], inputs: { transactionrequirement: "transactionrequirement", config: "config", type: "type", file: "file", files: "files" }, outputs: { expired: "expired" }, decls: 12, vars: 3, consts: [[1, "row"], [1, "col-12", "mb-3"], [1, "col-12"], ["class", "col-12 col-sm-6 pull-left", 4, "ngIf"], ["class", "row ", 4, "ngIf"], [1, "col-12", "col-sm-6", "pull-left"], [1, "text-bold", "pull-left", 3, "innerHTML"], ["class", "text-bold", 4, "ngIf"], ["name", "expedition", "required", "", 3, "options", "ngModel", "disabled", "ngModelChange"], [1, "text-bold"], [1, "text-bold", "pull-left", "text-red"], ["name", "expiration", "required", "", 3, "options", "ngModel", "disabled", "ngModelChange"], [1, "btn", "btn-primary", "btn-md", "btn-block", 3, "innerHTML", "click"]], template: function RequirementDatesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 0);
        ɵɵelement(3, "br");
        ɵɵelement(4, "br");
        ɵɵelement(5, "br");
        ɵɵelementStart(6, "div", 2);
        ɵɵelementStart(7, "div", 0);
        ɵɵtemplate(8, RequirementDatesComponent_div_8_Template, 5, 8, "div", 3);
        ɵɵtemplate(9, RequirementDatesComponent_div_9_Template, 5, 8, "div", 3);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(10, "br");
        ɵɵtemplate(11, RequirementDatesComponent_div_11_Template, 7, 3, "div", 4);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(8);
        ɵɵproperty("ngIf", ctx.showInputIssue(ctx.transactionrequirement.requirement));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showInputExpiration(ctx.transactionrequirement.requirement));
        ɵɵadvance(2);
        ɵɵproperty("ngIf", !ctx.config.isReadonly || ctx.files[ctx.transactionrequirement == null ? null : ctx.transactionrequirement.requirement == null ? null : ctx.transactionrequirement.requirement.identifier].response === ctx.config.enableEspecialUpload.status && ctx.config.enableEspecialUpload.active);
    } }, directives: [NgIf, MyDatePicker, RequiredValidator, NgControlStatus, NgModel], pipes: [I18nPipe], styles: [".text-red[_ngcontent-%COMP%]{color:red}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RequirementDatesComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-requirement-dates',
                templateUrl: './requirement-dates.component.html',
                styleUrls: ['./requirement-dates.component.css']
            }]
    }], function () { return [{ type: I18nPipe }, { type: UploadService }, { type: HttpService }, { type: ErrorService }, { type: SwalPortalTargets }]; }, { transactionrequirement: [{
            type: Input
        }], config: [{
            type: Input
        }], type: [{
            type: Input
        }], file: [{
            type: Input
        }], files: [{
            type: Input
        }], expired: [{
            type: Output
        }] }); })();

class IconResponseComponent {
    constructor() { }
    ngOnInit() {
    }
}
/** @nocollapse */ IconResponseComponent.ɵfac = function IconResponseComponent_Factory(t) { return new (t || IconResponseComponent)(); };
/** @nocollapse */ IconResponseComponent.ɵcmp = ɵɵdefineComponent({ type: IconResponseComponent, selectors: [["akeela-icon-response"]], inputs: { config: "config", transactionrequirement: "transactionrequirement" }, decls: 3, vars: 21, consts: [[1, "far", 3, "title"]], template: function IconResponseComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "i", 0);
        ɵɵpipe(1, "i18n");
        ɵɵtext(2, " \u00A0 ");
    } if (rf & 2) {
        ɵɵclassProp("fa-times-circle", (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === "REJECTED" && ctx.config.isHistoryResponsesShow)("fa-check-circle", ((ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === null || (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === "" || (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === undefined || (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === "VERIFIED" || (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === "INCONSISTENT" || (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === "INCOMPLETED") && ctx.config.isHistoryResponsesShow || !ctx.config.isEnabledIconColors)("fa-circle", ctx.transactionrequirement === null)("color-gray-light", ((ctx.transactionrequirement === null || (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === null || (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === "" || (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === undefined || (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) !== "INCOMPLETED" && (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) !== "REJECTED" && (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) !== "INCONSISTENT" && (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) !== "VERIFIED") && ctx.config.isHistoryResponsesShow || !ctx.config.isEnabledIconColors) && !ctx.transactionrequirement.requirement.required)("color-black", ((ctx.transactionrequirement === null || (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === null || (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === "" || (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === undefined || (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) !== "INCOMPLETED" && (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) !== "REJECTED" && (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) !== "INCONSISTENT" && (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) !== "VERIFIED") && ctx.config.isHistoryResponsesShow || !ctx.config.isEnabledIconColors) && ctx.transactionrequirement.requirement.required)("color-orange", (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === "INCOMPLETED" && ctx.config.isHistoryResponsesShow)("color-red", (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === "REJECTED" && ctx.config.isHistoryResponsesShow)("color-purple", (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === "INCONSISTENT" && ctx.config.isHistoryResponsesShow)("color-green", (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) === "VERIFIED" && ctx.config.isHistoryResponsesShow);
        ɵɵproperty("title", (ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) ? "Recaudo marcado como: " + ɵɵpipeBind1(1, 19, ctx.transactionrequirement == null ? null : ctx.transactionrequirement.response) : "");
    } }, pipes: [I18nPipe], styles: [".color-white[_ngcontent-%COMP%]{color:transparent}.color-yellow[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-incomplete)}.color-orange[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-warning)}.color-purple[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-inconsistent)}.color-blue[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-success)}.color-red[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-error)}.color-green[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-success)}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(IconResponseComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-icon-response',
                templateUrl: './icon-response.component.html',
                styleUrls: ['./icon-response.component.css']
            }]
    }], function () { return []; }, { config: [{
            type: Input
        }], transactionrequirement: [{
            type: Input
        }] }); })();

function IndividualResponseComponent_akeela_icon_response_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-icon-response", 9);
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("config", ctx_r0.config)("transactionrequirement", ctx_r0.response);
} }
function IndividualResponseComponent_p_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "p", 6);
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵproperty("innerHTML", ctx_r1.response == null ? null : ctx_r1.response.internalComment, ɵɵsanitizeHtml);
} }
function IndividualResponseComponent_p_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "p", 6);
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("innerHTML", ctx_r2.response == null ? null : ctx_r2.response.reasonIncomplete == null ? null : ctx_r2.response.reasonIncomplete.alternateName, ɵɵsanitizeHtml);
} }
function IndividualResponseComponent_p_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "p", 10);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, "@i18n-requirements-text-msg-incompleted"), ɵɵsanitizeHtml);
} }
class IndividualResponseComponent {
    constructor() { }
    ngOnInit() {
    }
}
/** @nocollapse */ IndividualResponseComponent.ɵfac = function IndividualResponseComponent_Factory(t) { return new (t || IndividualResponseComponent)(); };
/** @nocollapse */ IndividualResponseComponent.ɵcmp = ɵɵdefineComponent({ type: IndividualResponseComponent, selectors: [["akeela-individual-response"]], inputs: { config: "config", response: "response" }, decls: 13, vars: 12, consts: [[1, "d-flex", "mb-3", "p-2", "mt-2", "bg-info-requirements", "rounded", "shadow-sm", 2, "font-size", "14px"], [1, "lh-10", "fs-label-requirements", "pr-2"], [3, "config", "transactionrequirement", 4, "ngIf"], [1, "lh-90", "fs-label-requirements"], [1, "mb-0", "fc-label-requirements"], [3, "innerHTML"], [1, "mb-0", 3, "innerHTML"], ["class", "mb-0", 3, "innerHTML", 4, "ngIf"], ["class", "mb-0 fc-label-requirements", 3, "innerHTML", 4, "ngIf"], [3, "config", "transactionrequirement"], [1, "mb-0", "fc-label-requirements", 3, "innerHTML"]], template: function IndividualResponseComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵtemplate(2, IndividualResponseComponent_akeela_icon_response_2_Template, 1, 2, "akeela-icon-response", 2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "p", 4);
        ɵɵelement(5, "b", 5);
        ɵɵpipe(6, "i18n");
        ɵɵtext(7);
        ɵɵpipe(8, "date");
        ɵɵelementEnd();
        ɵɵelement(9, "p", 6);
        ɵɵtemplate(10, IndividualResponseComponent_p_10_Template, 1, 1, "p", 7);
        ɵɵtemplate(11, IndividualResponseComponent_p_11_Template, 1, 1, "p", 7);
        ɵɵtemplate(12, IndividualResponseComponent_p_12_Template, 2, 3, "p", 8);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.response && ctx.config);
        ɵɵadvance(3);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(6, 7, ctx.response == null ? null : ctx.response.response), ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵtextInterpolate1(" ", ɵɵpipeBind2(8, 9, ctx.response.responseDate.orderDate, "d MMMd, y - hh:mm aa"), " ");
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ctx.response == null ? null : ctx.response.responseDescription, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.config.isModeUserActive && (ctx.response == null ? null : ctx.response.internalComment));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.response == null ? null : ctx.response.reasonIncomplete);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.response == null ? null : ctx.response.response) === "INCOMPLETED");
    } }, directives: [NgIf, IconResponseComponent], pipes: [I18nPipe, DatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(IndividualResponseComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-individual-response',
                templateUrl: './individual-response.component.html',
                styleUrls: ['./individual-response.component.css']
            }]
    }], function () { return []; }, { config: [{
            type: Input
        }], response: [{
            type: Input
        }] }); })();

function PreviewImgComponent_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 4);
} }
function PreviewImgComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p");
    ɵɵtext(1, "Cargando vista previa...");
    ɵɵelementEnd();
} }
class PreviewImgComponent {
    constructor(file, sanitizer) {
        this.file = file;
        this.sanitizer = sanitizer;
        this.response = new EventEmitter();
        this.safe_file = null;
        this.isImage = false;
        this.progress_download = false;
    }
    ngOnInit() {
        this.response.emit({
            response: 'success',
            identifier: this.identifier
        });
    }
}
/** @nocollapse */ PreviewImgComponent.ɵfac = function PreviewImgComponent_Factory(t) { return new (t || PreviewImgComponent)(ɵɵdirectiveInject(FileService), ɵɵdirectiveInject(DomSanitizer)); };
/** @nocollapse */ PreviewImgComponent.ɵcmp = ɵɵdefineComponent({ type: PreviewImgComponent, selectors: [["app-preview-img"]], inputs: { identifier: "identifier", name: "name" }, outputs: { response: "response" }, decls: 4, vars: 3, consts: [[1, "w-100"], [3, "identifier"], ["class", "fas fa-spinner fa-spin fa-2x", 4, "ngIf"], [4, "ngIf"], [1, "fas", "fa-spinner", "fa-spin", "fa-2x"]], template: function PreviewImgComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelement(1, "akeela-preview-doc", 1);
        ɵɵelementEnd();
        ɵɵtemplate(2, PreviewImgComponent_i_2_Template, 1, 0, "i", 2);
        ɵɵtemplate(3, PreviewImgComponent_p_3_Template, 2, 0, "p", 3);
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("identifier", ctx.identifier);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.loading);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.loading);
    } }, directives: [PreviewDocComponent, NgIf], styles: [".container-noPreview[_ngcontent-%COMP%]{border-radius:12px;color:#000;margin-bottom:40px;padding:20px;text-align:center}.noPreview-title[_ngcontent-%COMP%]{-webkit-user-select:text;display:inline-block;font-size:19px;line-height:27px}.noPreview-download[_ngcontent-%COMP%]{margin-left:35px;margin-right:10px}.noPreview-download-button[_ngcontent-%COMP%]{background-color:#4d90fe;border:1px solid #4d90fe;border-radius:2px;box-shadow:inset 0 1px 0 hsla(0,0%,39.6%,.1);color:#fff;display:inline-block;font-size:11px;font-weight:700;height:28px;line-height:28px;margin-top:20px;min-width:54px;padding:0 20px 0 7px;text-align:center;text-shadow:0 1px 0 #fff;vertical-align:middle;white-space:nowrap}.container-image[_ngcontent-%COMP%]{position:relative;width:100%}.image-column[_ngcontent-%COMP%]{align-items:center;background:#cecece;display:block;height:180px;justify-content:center;min-width:100%!important;overflow:hidden}.image-column[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{left:50%;position:relative;top:50%;transform:translate(-50%,-50%)}.overlay[_ngcontent-%COMP%]{background-color:rgba(101,103,105,.719);bottom:0;height:100%;left:0;opacity:0;position:absolute;right:0;top:0;transition:.5s ease;width:100%}.container-image[_ngcontent-%COMP%]:hover   .overlay[_ngcontent-%COMP%]{opacity:1}.text[_ngcontent-%COMP%]{color:#fff;font-size:20px;left:50%;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%)}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PreviewImgComponent, [{
        type: Component,
        args: [{
                selector: 'app-preview-img',
                templateUrl: './preview-img.component.html',
                styleUrls: ['./preview-img.component.css']
            }]
    }], function () { return [{ type: FileService }, { type: DomSanitizer }]; }, { identifier: [{
            type: Input
        }], name: [{
            type: Input
        }], response: [{
            type: Output
        }] }); })();

function TableFilesComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 7);
    ɵɵelement(1, "akeela-requirement-dates", 8);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("files", ctx_r5.files)("transactionrequirement", ctx_r5.transactionrequirement)("type", ctx_r5.sel_type)("file", ctx_r5.sel_file)("config", ctx_r5.config);
} }
function TableFilesComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, TableFilesComponent_ng_container_2_div_1_Template, 2, 5, "div", 6);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.requirement);
} }
function TableFilesComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 9);
    ɵɵtext(2);
    ɵɵpipe(3, "i18n");
    ɵɵpipe(4, "i18n");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ctx_r2.readOnly ? ɵɵpipeBind1(3, 1, "@i18n-requirements-no-documents-loaded-readonly") : ɵɵpipeBind1(4, 3, "@i18n-requirements-no-documents-loaded"), " ");
} }
function TableFilesComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 10);
    ɵɵelement(2, "br");
    ɵɵelement(3, "img", 11);
    ɵɵelement(4, "br");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function TableFilesComponent_ng_container_7_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 23);
    ɵɵelementStart(1, "div", 24);
    ɵɵelementStart(2, "div", 25);
    ɵɵlistener("click", function TableFilesComponent_ng_container_7_div_1_div_2_Template_div_click_2_listener() { ɵɵrestoreView(_r15); const row2_r7 = ɵɵnextContext().$implicit; const ctx_r13 = ɵɵnextContext(2); return ctx_r13.show_file(row2_r7); });
    ɵɵelementStart(3, "app-preview-img", 26);
    ɵɵlistener("response", function TableFilesComponent_ng_container_7_div_1_div_2_Template_app_preview_img_response_3_listener($event) { ɵɵrestoreView(_r15); const ctx_r16 = ɵɵnextContext(3); return ctx_r16.getResponsePreview($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const row2_r7 = ɵɵnextContext().$implicit;
    ɵɵadvance(3);
    ɵɵproperty("identifier", row2_r7 == null ? null : row2_r7.identifier);
} }
function TableFilesComponent_ng_container_7_div_1_hr_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "hr");
} }
function TableFilesComponent_ng_container_7_div_1_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "i", 27);
    ɵɵlistener("click", function TableFilesComponent_ng_container_7_div_1_ng_container_15_Template_i_click_1_listener() { ɵɵrestoreView(_r20); const row2_r7 = ɵɵnextContext().$implicit; const ctx_r18 = ɵɵnextContext(2); return ctx_r18.trash_file(row2_r7); });
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("title", "Eliminar");
} }
function TableFilesComponent_ng_container_7_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 13);
    ɵɵelementStart(1, "div", 14);
    ɵɵtemplate(2, TableFilesComponent_ng_container_7_div_1_div_2_Template, 4, 1, "div", 15);
    ɵɵelementStart(3, "div", 16);
    ɵɵtemplate(4, TableFilesComponent_ng_container_7_div_1_hr_4_Template, 1, 0, "hr", 5);
    ɵɵelementStart(5, "div", 17);
    ɵɵelementStart(6, "div", 18);
    ɵɵtext(7);
    ɵɵelement(8, "br");
    ɵɵtext(9);
    ɵɵelement(10, "br");
    ɵɵtext(11);
    ɵɵelement(12, "br");
    ɵɵtext(13);
    ɵɵelement(14, "br");
    ɵɵelementEnd();
    ɵɵtemplate(15, TableFilesComponent_ng_container_7_div_1_ng_container_15_Template, 2, 1, "ng-container", 5);
    ɵɵelementEnd();
    ɵɵelementStart(16, "div", 19);
    ɵɵlistener("click", function TableFilesComponent_ng_container_7_div_1_Template_div_click_16_listener() { ɵɵrestoreView(_r22); const row2_r7 = ctx.$implicit; const ctx_r21 = ɵɵnextContext(2); return ctx_r21.show_file(row2_r7); });
    ɵɵelement(17, "span", 20);
    ɵɵpipe(18, "i18n");
    ɵɵelementEnd();
    ɵɵelementStart(19, "div", 21);
    ɵɵtext(20, " Modificado ");
    ɵɵelement(21, "span", 22);
    ɵɵpipe(22, "date");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const row2_r7 = ctx.$implicit;
    const i_stf_r9 = ctx.index;
    const ctx_r6 = ɵɵnextContext(2);
    ɵɵattribute("data-index", i_stf_r9);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r6.config.preview);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r6.config.preview);
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", ctx_r6.config.isEnableLogicDelete, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ctx_r6.readOnly, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ctx_r6.validateDateResponse(ctx_r6.transactionrequirement == null ? null : ctx_r6.transactionrequirement.responseDate == null ? null : ctx_r6.transactionrequirement.responseDate.orderDate, row2_r7) + " - " + (ctx_r6.transactionrequirement == null ? null : ctx_r6.transactionrequirement.responseDate == null ? null : ctx_r6.transactionrequirement.responseDate.orderDate), "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ctx_r6.readOnly, "");
    ɵɵadvance(2);
    ɵɵproperty("ngIf", (ctx_r6.config.isEnableLogicDelete && !ctx_r6.readOnly && ctx_r6.validateDateResponse(ctx_r6.transactionrequirement == null ? null : ctx_r6.transactionrequirement.responseDate == null ? null : ctx_r6.transactionrequirement.responseDate.orderDate, row2_r7) || ctx_r6.validateSpecialApplySpecialCase(ctx_r6.transactionrequirement.response)) && !ctx_r6.readOnly || !ctx_r6.config.isReadonly && ctx_r6.config.isDigitalUploadActive === true);
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(18, 10, row2_r7 == null ? null : row2_r7.name), ɵɵsanitizeHtml);
    ɵɵadvance(4);
    ɵɵproperty("innerHTML", (row2_r7.dateOfThing == null ? null : row2_r7.dateOfThing.startDate) ? ɵɵpipeBind2(22, 12, row2_r7.dateOfThing == null ? null : row2_r7.dateOfThing.startDate, "d MMM, y") : "-", ɵɵsanitizeHtml);
} }
function TableFilesComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, TableFilesComponent_ng_container_7_div_1_Template, 23, 15, "div", 12);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r4.list);
} }
class TableFilesComponent {
    constructor(_httpService, _i18n, _upload, eleRef, _error, swalTargets) {
        this._httpService = _httpService;
        this._i18n = _i18n;
        this._upload = _upload;
        this.eleRef = eleRef;
        this._error = _error;
        this.swalTargets = swalTargets;
        this.readOnly = false;
        this.onlyActive = true;
        this.showFile = new EventEmitter();
        this.sel_requirement = null;
        this.sel_transactionrequirement = null;
        this.sel_type = null;
        this.sel_file = null;
        this.loaded = false;
        this.currentdate = new Date();
        this.validateDateResponse = (dateResponse, file) => {
            // if (!isNullOrUndefined(dateResponse) && !isNullOrUndefined(file)) {
            //     if (file?.dateOfThing?.startDate > dateResponse) {
            //         return true;
            //     }
            // }
            // return false;
            return true;
        };
    }
    set lista(values) {
        this.list = values;
        if (this.onlyActive) {
            this.filter_by_status();
        }
    }
    ;
    ngOnInit() {
    }
    filter_by_status() {
        if (!isNullOrUndefined(this.list)) {
            if (this.list !== 'LOADING') {
                this.list.filter((file) => {
                    return file.status === 'A';
                });
            }
        }
    }
    trash_file(file) {
        swal.fire({
            title: this._i18n.transform('@i18n-popup-text-delete-question'),
            text: this._i18n.transform('@i18n-popup-text-delete-question-text'),
            showCancelButton: true,
            confirmButtonText: this._i18n.transform('@i18n-popup-text-yes'),
            cancelButtonText: this._i18n.transform('@i18n-popup-text-no'),
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                // const params = this.config.endpoints.deleteRequirement.params;
                //     params.body.requirement.identifier = this.requirement.identifier;
                //     params.body.requirementArchives[0].identifier = file.identifier;
                //     this._httpService.executeRequest(this.config.endpoints.deleteRequirement.name, this.config.endpoints.deleteRequirement.params, true).subscribe((response: any) => {
                //         this.loaded = false;
                //         this.list = 'LOADING';
                //         this._upload.setChangeRequirementById(this.requirement.identifier);
                //     }, error => {
                //         this._error.show(error);
                //     });
                // delete type: logic
                // this.transactionrequirement.responseDate.orderDate < file.dateOfThing.startDate &&
                if ((this.config.isEnableLogicDelete) && this.validateSpecialApplySpecialCase(this.transactionrequirement.response)) {
                    const params = this.config.endpoints.saveLogicArchiveDelete.params;
                    params.path.idRequirement = this.requirement.identifier;
                    params.path.idArchive = file.identifier;
                    this._httpService.executeRequest(this.config.endpoints.saveLogicArchiveDelete.name, this.config.endpoints.saveLogicArchiveDelete.params, true).subscribe((response) => {
                        console.log('El delete logico Responde: ' + this.requirement.identifier);
                        if (!isNullOrUndefined(response)) {
                            console.log('Y envia positivo');
                            this._upload.setResponseUpload({
                                body: {
                                    transaction: {
                                        identifier: response
                                    }
                                }
                            });
                        }
                        this.loaded = false;
                        this.list = 'LOADING';
                        this._upload.setChangeRequirementById(this.requirement.identifier);
                    });
                }
                else {
                    const params = this.config.endpoints.deleteRequirement.params;
                    params.body.requirement.identifier = this.requirement.identifier;
                    params.body.requirementArchives[0].identifier = file.identifier;
                    this._httpService.executeRequest(this.config.endpoints.deleteRequirement.name, this.config.endpoints.deleteRequirement.params, true).subscribe((response) => {
                        console.log('El delete Responde: ' + this.requirement.identifier);
                        this.loaded = false;
                        this.list = 'LOADING';
                        this._upload.setChangeRequirementById(this.requirement.identifier);
                    }, error => {
                        this._error.show(error);
                    });
                }
            }
        });
    }
    validateSpecialApplySpecialCase(response) {
        if (!isNullOrUndefined(this.config.enableEspecialUpload)) {
            if (!isNullOrUndefined(this.config.enableEspecialUpload.active)) {
                if (this.config.enableEspecialUpload.active) {
                    for (const status of this.config.enableEspecialUpload.status) {
                        if (status === response) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
    show_file(file) {
        if (this.config.preview) {
            this.showFile.emit(file);
        }
    }
    update_dates(object, type) {
        this.sel_type = type;
        if (type !== 'transaction') {
            this.sel_file = object;
        }
        const box = this.eleRef.nativeElement.querySelector('#idshowdates');
        box.dispatchEvent(new Event('click'));
    }
    validate_expiration(expiration) {
        if (expiration !== null) {
            const date = this.generate_object_date(expiration);
            if (this.currentdate.getTime() > date.getTime()) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    generate_object_date(epoc) {
        return new Date(epoc * 1000);
    }
    validateDatesConditions(requirement) {
        if (!isNullOrUndefined(requirement.showDateOfIssue) || !isNullOrUndefined(requirement.showExpirationDate)) {
            if (requirement.showDateOfIssue === true || requirement.showExpirationDate === true) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }
    getResponsePreview(response) {
    }
}
/** @nocollapse */ TableFilesComponent.ɵfac = function TableFilesComponent_Factory(t) { return new (t || TableFilesComponent)(ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(ErrorService), ɵɵdirectiveInject(SwalPortalTargets)); };
/** @nocollapse */ TableFilesComponent.ɵcmp = ɵɵdefineComponent({ type: TableFilesComponent, selectors: [["akeela-table-files"]], inputs: { config: "config", transactionrequirement: "transactionrequirement", requirement: "requirement", files: "files", readOnly: "readOnly", onlyActive: "onlyActive", lista: "lista" }, outputs: { showFile: "showFile" }, decls: 8, vars: 7, consts: [[3, "showCloseButton", "showConfirmButton"], ["swaldates", ""], [4, "swalPortal"], [2, "display", "none"], ["id", "idshowdates", 3, "swal"], [4, "ngIf"], ["class", "text-center", 4, "ngIf"], [1, "text-center"], [3, "files", "transactionrequirement", "type", "file", "config"], [1, "w-100", "text-center", "text-bold", "pt-4", "pb-4", "section-box", "ak-shadow"], [1, "w-100", "text-center", "text-bold"], ["src", "./assets/public/images/loading.gif", "alt", ""], ["class", "w-100 text-secondary", 4, "ngFor", "ngForOf"], [1, "w-100", "text-secondary"], [1, "w-100", "section-box", "pl-2", "pr-2", "pb-2", "pt-0", "mb-4"], ["class", "row mt-4 mb-3 ", 4, "ngIf"], [1, "w-100"], [1, "float-right", "text-secondary"], [1, "d-none"], [1, "ak-text-req-name", "description", "text-dark", "active-cursor", 3, "click"], [3, "innerHTML"], [1, "mt-1", "fz-14", "pl-3", "fz-14"], [1, "pl-2", "fz-14", 3, "innerHTML"], [1, "row", "mt-4", "mb-3"], [1, "col-12", "col-md-8", "offset-md-2"], [1, "image-column", "text-center", "br-10", 3, "click"], [3, "identifier", "response"], [1, "fa", "fa-trash", "active-cursor", 3, "title", "click"]], template: function TableFilesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "swal", 0, 1);
        ɵɵtemplate(2, TableFilesComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", 3);
        ɵɵelement(4, "a", 4);
        ɵɵelementEnd();
        ɵɵtemplate(5, TableFilesComponent_ng_container_5_Template, 5, 5, "ng-container", 5);
        ɵɵtemplate(6, TableFilesComponent_ng_container_6_Template, 5, 0, "ng-container", 5);
        ɵɵtemplate(7, TableFilesComponent_ng_container_7_Template, 2, 1, "ng-container", 5);
    } if (rf & 2) {
        const _r0 = ɵɵreference(1);
        ɵɵproperty("showCloseButton", true)("showConfirmButton", false);
        ɵɵadvance(2);
        ɵɵproperty("swalPortal", ctx.swalTargets.content);
        ɵɵadvance(2);
        ɵɵproperty("swal", _r0);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.list === null);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.list == "LOADING");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.list !== "LOADING" && ctx.list !== null);
    } }, directives: [SwalComponent, SwalPortalDirective, SwalDirective, NgIf, RequirementDatesComponent, NgForOf, PreviewImgComponent], pipes: [I18nPipe, DatePipe], styles: [".w-33[_ngcontent-%COMP%]{widows:33%}.fz-12[_ngcontent-%COMP%]{font-size:12px}.ak-text-req-name[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.image-column[_ngcontent-%COMP%]{align-items:center;background:#cecece;display:block;display:flex;height:180px;justify-content:center;overflow:hidden;width:100%}.image-column[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{left:50%;position:relative;top:50%;transform:translate(-50%,-50%)}.overlay[_ngcontent-%COMP%]{background-color:rgba(101,103,105,.719);bottom:0;height:100%;left:0;opacity:0;position:absolute;right:0;top:0;transition:.5s ease;width:100%}.container-image[_ngcontent-%COMP%]:hover   .overlay[_ngcontent-%COMP%]{opacity:1}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TableFilesComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-table-files',
                templateUrl: './table-files.component.html',
                styleUrls: ['./table-files.component.css']
            }]
    }], function () { return [{ type: HttpService }, { type: I18nPipe }, { type: UploadService }, { type: ElementRef }, { type: ErrorService }, { type: SwalPortalTargets }]; }, { config: [{
            type: Input
        }], transactionrequirement: [{
            type: Input
        }], requirement: [{
            type: Input
        }], files: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], onlyActive: [{
            type: Input
        }], lista: [{
            type: Input
        }], showFile: [{
            type: Output
        }] }); })();

const _c0$1 = ["fileInput"];
function InputUploadFileFlexComponent_ng_container_0_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 4);
    ɵɵelementStart(1, "a", 11);
    ɵɵtext(2, " \u00A0\u00A0\u00A0\u00A0/\u00A0\u00A0\u00A0\u00A0 ");
    ɵɵelement(3, "i", 12);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵnextContext(2);
    const _r2 = ɵɵreference(3);
    ɵɵadvance(1);
    ɵɵproperty("swal", _r2);
} }
function InputUploadFileFlexComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 4);
    ɵɵtext(2, " \u00A0\u00A0 ");
    ɵɵelementStart(3, "span", 5);
    ɵɵelement(4, "i", 6);
    ɵɵtext(5, "\u00A0 ");
    ɵɵelementContainerStart(6, 7);
    ɵɵtext(7);
    ɵɵpipe(8, "i18n");
    ɵɵelementContainerEnd();
    ɵɵelementEnd();
    ɵɵtext(9, "@i18n-requirements-choose-file ");
    ɵɵelementStart(10, "input", 8, 9);
    ɵɵlistener("change", function InputUploadFileFlexComponent_ng_container_0_Template_input_change_10_listener() { ɵɵrestoreView(_r8); const ctx_r7 = ɵɵnextContext(); return ctx_r7.updateToQueue(ctx_r7.identifier); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(12, InputUploadFileFlexComponent_ng_container_0_div_12_Template, 4, 1, "div", 10);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(7);
    ɵɵtextInterpolate1("\u00A0", ɵɵpipeBind1(8, 2, "@i18n-requirements-choose-file"), "");
    ɵɵadvance(5);
    ɵɵproperty("ngIf", ctx_r0.active_camera && !ctx_r0.block_camera);
} }
function InputUploadFileFlexComponent_ng_container_1_input_7_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "input", 18, 9);
    ɵɵlistener("change", function InputUploadFileFlexComponent_ng_container_1_input_7_Template_input_change_0_listener() { ɵɵrestoreView(_r13); const ctx_r12 = ɵɵnextContext(2); return ctx_r12.updateToQueue(ctx_r12.identifier); });
    ɵɵelementEnd();
} }
function InputUploadFileFlexComponent_ng_container_1_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 4);
    ɵɵelementStart(1, "a", 11);
    ɵɵelement(2, "i", 12);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵnextContext(2);
    const _r2 = ɵɵreference(3);
    ɵɵadvance(1);
    ɵɵproperty("swal", _r2);
} }
function InputUploadFileFlexComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 13);
    ɵɵelementStart(2, "span", 14);
    ɵɵelement(3, "i", 15);
    ɵɵelementContainerStart(4, 16);
    ɵɵtext(5);
    ɵɵpipe(6, "i18n");
    ɵɵelementContainerEnd();
    ɵɵelementEnd();
    ɵɵtemplate(7, InputUploadFileFlexComponent_ng_container_1_input_7_Template, 2, 0, "input", 17);
    ɵɵelementEnd();
    ɵɵtemplate(8, InputUploadFileFlexComponent_ng_container_1_div_8_Template, 3, 1, "div", 10);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(5);
    ɵɵtextInterpolate1("\u00A0", ɵɵpipeBind1(6, 3, "@i18n-requirements-choose-file"), "\u00A0\u00A0");
    ɵɵadvance(2);
    ɵɵproperty("ngIf", !ctx_r1.refresh);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.config.isCameraActive && !ctx_r1.block_camera);
} }
function InputUploadFileFlexComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵpipe(2, "i18n");
    ɵɵelement(3, "br");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate2(" ", ɵɵpipeBind1(2, 2, "@i18n-requirements-max-size-accepted"), ": ", ctx_r3.config.file.mb_max_filesize, " Mb ");
} }
function InputUploadFileFlexComponent_ng_container_6_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ", ", " ");
} }
function InputUploadFileFlexComponent_ng_container_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵtemplate(2, InputUploadFileFlexComponent_ng_container_6_ng_container_3_ng_container_2_Template, 2, 1, "ng-container", 0);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const format_r15 = ctx.$implicit;
    const i_r16 = ctx.index;
    const ctx_r14 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", format_r15, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r14.config.file.file_type_accepts_description.length !== i_r16 + 1);
} }
function InputUploadFileFlexComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, InputUploadFileFlexComponent_ng_container_6_ng_container_3_Template, 3, 2, "ng-container", 19);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 2, "@i18n-requirements-formats-accepted"), ": ");
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r4.config.file.file_type_accepts_description);
} }
class InputUploadFileFlexComponent {
    constructor(swalTargets, uploader) {
        this.swalTargets = swalTargets;
        this.uploader = uploader;
        this.active_camera = true; // si no quiero dar la opcion de camara, se pasa el parametro en false.
        // tslint:disable-next-line:no-output-on-prefix
        this.onCompleteItem = new EventEmitter();
        this.response = new EventEmitter();
        this.modal_camera = false;
        this.block_camera = false;
        this.refresh = false;
        this.subscriptions = new Subscription;
        this.completeItem = (item, response) => {
            this.onCompleteItem.emit({ item, response });
        };
    }
    ngOnInit() {
        const protocol = window.location.protocol;
        const browser = navigator.userAgent;
        const M = browser.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (M[1] === 'Chrome') {
            if (protocol.trim().toUpperCase() === 'HTTP:') {
                this.block_camera = true;
            }
        }
    }
    validateTypeFile(file_type, file_type_accepts) {
        let accept = false;
        file_type_accepts.forEach(element => {
            if (element === file_type) {
                accept = true;
            }
        });
        return accept;
    }
    validateTypeSize(size, max_size) {
        if (!isNullOrUndefined(max_size)) {
            if (size <= max_size) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }
    updateToQueue(identifier) {
        this.refresh = true;
        const file_type_accepts = this.config.file.file_type_accepts;
        let max_file_size = null;
        if (!isNullOrUndefined(this.config.file.mb_max_filesize)) {
            max_file_size = this.config.file.mb_max_filesize * 1000000;
        }
        const fileBrowser = this.fileInput.nativeElement;
        if (this.validateTypeFile(fileBrowser.files[(fileBrowser.files.length - 1)].type, file_type_accepts)) {
            if (this.validateTypeSize(fileBrowser.files[(fileBrowser.files.length - 1)].size, max_file_size)) {
                debugger;
                this.subscriptions.add(this.uploader.postFile(fileBrowser.files, identifier, this.config.viewName, false).subscribe((data) => {
                    this.refresh = false;
                    if (!isNullOrUndefined(this.fileInput)) {
                        this.fileInput.nativeElement.value = '';
                    }
                    this.response.emit({ type: 'success' });
                }));
            }
            else {
                this.refresh = false;
                if (!isNullOrUndefined(this.fileInput)) {
                    this.fileInput.nativeElement.value = '';
                }
                this.response.emit({ type: 'error', title: 'Error', html: 'Tamaño del archivo excede el máximo de ' + this.config.file.mb_max_filesize + ' MB permitido por archivo.' });
            }
        }
        else {
            this.refresh = false;
            if (!isNullOrUndefined(this.fileInput)) {
                this.fileInput.nativeElement.value = '';
            }
            this.response.emit({ type: 'error', title: 'Error', html: 'La extensión del archivo no es permitida.' });
        }
    }
    updateCameraImageToQueue(params) {
        this.subscriptions.add(this.uploader.postFile(params['form'], params['identifier'], this.config.viewName, true).subscribe((data) => {
        }, error => {
            this.response.emit({ type: 'error', title: 'Error', html: 'Error subiendo el archivo.' });
        }));
    }
    showOptions() {
        swal.fire({
            html: 'OPCIONES'
        });
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
/** @nocollapse */ InputUploadFileFlexComponent.ɵfac = function InputUploadFileFlexComponent_Factory(t) { return new (t || InputUploadFileFlexComponent)(ɵɵdirectiveInject(SwalPortalTargets), ɵɵdirectiveInject(UploadService)); };
/** @nocollapse */ InputUploadFileFlexComponent.ɵcmp = ɵɵdefineComponent({ type: InputUploadFileFlexComponent, selectors: [["akeela-input-upload-file-flex"]], viewQuery: function InputUploadFileFlexComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$1, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.fileInput = _t.first);
    } }, inputs: { config: "config", identifier: "identifier", type: "type", active_camera: "active_camera" }, outputs: { onCompleteItem: "onCompleteItem", response: "response" }, decls: 7, vars: 8, consts: [[4, "ngIf"], [3, "showCloseButton", "showConfirmButton", "showCancelButton", "grow"], ["showCam", ""], [2, "text-align", "right", "font-size", ".7rem", "color", "gray"], [1, "upload-btn-wrapper", "active-cursor"], [1, "btn-file"], [1, "fa", "fa-upload"], [1, "d-none", "d-sm-none", "d-md-block", "d-lg-block"], ["type", "file", "title", "Seleccione", 1, "w-100", 3, "change"], ["fileInput", ""], ["class", "upload-btn-wrapper active-cursor", 4, "ngIf"], [1, "d-block", "d-sm-block", "d-md-none", "d-lg-none", 3, "swal"], [1, "fa", "fa-camera"], [1, "upload-btn-wrapper", "active-cursor", "btn", "btn-primary", "pt-2", "pt2", "mb-2"], [1, "w-100"], [1, "fa", "fa-upload", "pl-2"], [1, "d-none", "d-sm-none", "d-md-block", "d-lg-block", "w-100"], ["class", "w-100 active-cursor", "type", "file", 3, "change", 4, "ngIf"], ["type", "file", 1, "w-100", "active-cursor", 3, "change"], [4, "ngFor", "ngForOf"]], template: function InputUploadFileFlexComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, InputUploadFileFlexComponent_ng_container_0_Template, 13, 4, "ng-container", 0);
        ɵɵtemplate(1, InputUploadFileFlexComponent_ng_container_1_Template, 9, 5, "ng-container", 0);
        ɵɵelement(2, "swal", 1, 2);
        ɵɵelementStart(4, "div", 3);
        ɵɵtemplate(5, InputUploadFileFlexComponent_ng_container_5_Template, 4, 4, "ng-container", 0);
        ɵɵtemplate(6, InputUploadFileFlexComponent_ng_container_6_Template, 4, 4, "ng-container", 0);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngIf", !ctx.type);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.type === "button");
        ɵɵadvance(1);
        ɵɵproperty("showCloseButton", true)("showConfirmButton", false)("showCancelButton", false)("grow", "fullscreen");
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.config.file.mb_max_filesize);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.config.file.file_type_accepts_description);
    } }, directives: [NgIf, SwalComponent, SwalDirective, NgForOf], pipes: [I18nPipe], styles: [".upload-btn-wrapper[_ngcontent-%COMP%]{cursor:pointer;display:inline-block;overflow:hidden;position:relative}.btn-file[_ngcontent-%COMP%]{background-color:#fff;color:grey;cursor:pointer;font-size:.7rem;font-weight:700}.upload-btn-wrapper[_ngcontent-%COMP%]   input[type=file][_ngcontent-%COMP%]{cursor:pointer;font-size:.6rem;left:0;opacity:0;position:absolute;right:0;top:0}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(InputUploadFileFlexComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-input-upload-file-flex',
                templateUrl: './input-upload-file-flex.component.html',
                styleUrls: ['./input-upload-file-flex.component.css']
            }]
    }], function () { return [{ type: SwalPortalTargets }, { type: UploadService }]; }, { config: [{
            type: Input
        }], identifier: [{
            type: Input
        }], type: [{
            type: Input
        }], active_camera: [{
            type: Input
        }], onCompleteItem: [{
            type: Output
        }], response: [{
            type: Output
        }], fileInput: [{
            type: ViewChild,
            args: ['fileInput', { static: false }]
        }] }); })();

const _c0$2 = function (a0) { return { identifier: a0 }; };
function ResponseIndividualRequirementComponent_ng_container_0_ng_container_18_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "option", 15);
    ɵɵtext(2);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const statu_r8 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngValue", ɵɵpureFunction1(4, _c0$2, statu_r8.name));
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(3, 2, statu_r8.name));
} }
function ResponseIndividualRequirementComponent_ng_container_0_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ResponseIndividualRequirementComponent_ng_container_0_ng_container_18_ng_container_1_Template, 4, 6, "ng-container", 14);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r1.listTransactionStatus);
} }
function ResponseIndividualRequirementComponent_ng_container_0_div_19_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 13);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r9 = ɵɵnextContext(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r9.lang), ɵɵsanitizeHtml);
} }
function ResponseIndividualRequirementComponent_ng_container_0_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 16);
    ɵɵtemplate(1, ResponseIndividualRequirementComponent_ng_container_0_div_19_div_1_Template, 2, 4, "div", 17);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.form.get("response").errors["required"] && !ctx_r2.form.get("response").pristine);
} }
function ResponseIndividualRequirementComponent_ng_container_0_ng_container_20_ng_container_1_div_1_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "option", 15);
    ɵɵtext(2);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const statu_r14 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngValue", statu_r14.item.alternateName);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(3, 2, statu_r14.name));
} }
function ResponseIndividualRequirementComponent_ng_container_0_ng_container_20_ng_container_1_div_1_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 13);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r15 = ɵɵnextContext(6);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r15.lang), ɵɵsanitizeHtml);
} }
function ResponseIndividualRequirementComponent_ng_container_0_ng_container_20_ng_container_1_div_1_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 16);
    ɵɵtemplate(1, ResponseIndividualRequirementComponent_ng_container_0_ng_container_20_ng_container_1_div_1_div_11_div_1_Template, 2, 4, "div", 17);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r13.form.get("reasonIncomplete").errors["required"] && !ctx_r13.form.get("reasonIncomplete").pristine);
} }
const _c1 = function (a0) { return { "error": a0 }; };
function ResponseIndividualRequirementComponent_ng_container_0_ng_container_20_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 3);
    ɵɵelementStart(1, "div", 4);
    ɵɵelement(2, "br");
    ɵɵelementStart(3, "label");
    ɵɵtext(4);
    ɵɵpipe(5, "i18n");
    ɵɵelementEnd();
    ɵɵelementStart(6, "select", 19);
    ɵɵelementStart(7, "option", 20);
    ɵɵtext(8);
    ɵɵpipe(9, "i18n");
    ɵɵelementEnd();
    ɵɵtemplate(10, ResponseIndividualRequirementComponent_ng_container_0_ng_container_20_ng_container_1_div_1_ng_container_10_Template, 4, 4, "ng-container", 14);
    ɵɵelementEnd();
    ɵɵtemplate(11, ResponseIndividualRequirementComponent_ng_container_0_ng_container_20_ng_container_1_div_1_div_11_Template, 2, 1, "div", 7);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵɵnextContext(4);
    ɵɵadvance(4);
    ɵɵtextInterpolate(ɵɵpipeBind1(5, 5, "@collections-text-reasonIncomplete"));
    ɵɵadvance(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(9, _c1, ctx_r11.form.controls.reasonIncomplete.invalid && ctx_r11.form.controls.reasonIncomplete.dirty));
    ɵɵadvance(2);
    ɵɵtextInterpolate(ɵɵpipeBind1(9, 7, "@collections-text-select"));
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r11.config.responseOptionalFieldsIndividualResponse.reasonIncompleted);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r11.form.get("reasonIncomplete").errors);
} }
function ResponseIndividualRequirementComponent_ng_container_0_ng_container_20_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ResponseIndividualRequirementComponent_ng_container_0_ng_container_20_ng_container_1_div_1_Template, 12, 11, "div", 18);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r10.incomplete && ctx_r10.config.responseOptionalFieldsIndividualResponse.reasonIncompleted);
} }
function ResponseIndividualRequirementComponent_ng_container_0_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ResponseIndividualRequirementComponent_ng_container_0_ng_container_20_ng_container_1_Template, 2, 1, "ng-container", 0);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.config.responseOptionalFieldsIndividualResponse.reasonIncompleted);
} }
function ResponseIndividualRequirementComponent_ng_container_0_div_31_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 13);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r16 = ɵɵnextContext(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r16.lang), ɵɵsanitizeHtml);
} }
function ResponseIndividualRequirementComponent_ng_container_0_div_31_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 16);
    ɵɵtemplate(1, ResponseIndividualRequirementComponent_ng_container_0_div_31_div_1_Template, 2, 4, "div", 17);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.form.get("observation").errors["required"] && !ctx_r4.form.get("observation").pristine);
} }
function ResponseIndividualRequirementComponent_ng_container_0_ng_container_32_ng_container_1_div_1_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 13);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r20 = ɵɵnextContext(6);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r20.lang), ɵɵsanitizeHtml);
} }
function ResponseIndividualRequirementComponent_ng_container_0_ng_container_32_ng_container_1_div_1_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 16);
    ɵɵtemplate(1, ResponseIndividualRequirementComponent_ng_container_0_ng_container_32_ng_container_1_div_1_div_10_div_1_Template, 2, 4, "div", 17);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r19.form.get("observationInside").errors["required"] && !ctx_r19.form.get("observationInside").pristine);
} }
function ResponseIndividualRequirementComponent_ng_container_0_ng_container_32_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 3);
    ɵɵelementStart(1, "div", 8);
    ɵɵelement(2, "br");
    ɵɵelementStart(3, "label", 21);
    ɵɵtext(4);
    ɵɵpipe(5, "i18n");
    ɵɵelementEnd();
    ɵɵelementStart(6, "textarea", 22);
    ɵɵtext(7, "              ");
    ɵɵelementEnd();
    ɵɵelementStart(8, "div", 10);
    ɵɵtext(9, " No podr\u00E1 ser visualizado por el cliente ");
    ɵɵelementEnd();
    ɵɵtemplate(10, ResponseIndividualRequirementComponent_ng_container_0_ng_container_32_ng_container_1_div_1_div_10_Template, 2, 1, "div", 7);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵɵnextContext(4);
    ɵɵadvance(4);
    ɵɵtextInterpolate(ɵɵpipeBind1(5, 3, "@collections-text-comment-inside"));
    ɵɵadvance(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(5, _c1, ctx_r18.form.controls.observationInside.invalid && ctx_r18.form.controls.observationInside.dirty));
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r18.form.get("observationInside").errors);
} }
function ResponseIndividualRequirementComponent_ng_container_0_ng_container_32_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ResponseIndividualRequirementComponent_ng_container_0_ng_container_32_ng_container_1_div_1_Template, 11, 7, "div", 18);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r17.config.responseOptionalFieldsIndividualResponse.observationInside);
} }
function ResponseIndividualRequirementComponent_ng_container_0_ng_container_32_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ResponseIndividualRequirementComponent_ng_container_0_ng_container_32_ng_container_1_Template, 2, 1, "ng-container", 0);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.config.responseOptionalFieldsIndividualResponse.observationInside);
} }
function ResponseIndividualRequirementComponent_ng_container_0_span_40_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵelement(1, "i", 23);
    ɵɵelementEnd();
} }
function ResponseIndividualRequirementComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "br");
    ɵɵelementStart(2, "h5");
    ɵɵtext(3);
    ɵɵpipe(4, "i18n");
    ɵɵelementEnd();
    ɵɵelement(5, "hr", 1);
    ɵɵelement(6, "br");
    ɵɵtext(7, "responder ");
    ɵɵelementStart(8, "form", 2);
    ɵɵlistener("ngSubmit", function ResponseIndividualRequirementComponent_ng_container_0_Template_form_ngSubmit_8_listener() { ɵɵrestoreView(_r22); const ctx_r21 = ɵɵnextContext(); return ctx_r21.submit(); });
    ɵɵelementStart(9, "div", 3);
    ɵɵelementStart(10, "div", 4);
    ɵɵelementStart(11, "label");
    ɵɵtext(12);
    ɵɵpipe(13, "i18n");
    ɵɵelementEnd();
    ɵɵelementStart(14, "select", 5);
    ɵɵlistener("change", function ResponseIndividualRequirementComponent_ng_container_0_Template_select_change_14_listener($event) { ɵɵrestoreView(_r22); const ctx_r23 = ɵɵnextContext(); return ctx_r23.responseEvent($event); });
    ɵɵelementStart(15, "option", 6);
    ɵɵtext(16);
    ɵɵpipe(17, "i18n");
    ɵɵelementEnd();
    ɵɵtemplate(18, ResponseIndividualRequirementComponent_ng_container_0_ng_container_18_Template, 2, 1, "ng-container", 0);
    ɵɵelementEnd();
    ɵɵtemplate(19, ResponseIndividualRequirementComponent_ng_container_0_div_19_Template, 2, 1, "div", 7);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(20, ResponseIndividualRequirementComponent_ng_container_0_ng_container_20_Template, 2, 1, "ng-container", 0);
    ɵɵelementStart(21, "div", 3);
    ɵɵelementStart(22, "div", 8);
    ɵɵelement(23, "br");
    ɵɵelementStart(24, "label");
    ɵɵtext(25);
    ɵɵpipe(26, "i18n");
    ɵɵelementEnd();
    ɵɵelementStart(27, "textarea", 9);
    ɵɵtext(28, "                 ");
    ɵɵelementEnd();
    ɵɵelementStart(29, "div", 10);
    ɵɵtext(30, " Podr\u00E1 ser visualizado por el cliente ");
    ɵɵelementEnd();
    ɵɵtemplate(31, ResponseIndividualRequirementComponent_ng_container_0_div_31_Template, 2, 1, "div", 7);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(32, ResponseIndividualRequirementComponent_ng_container_0_ng_container_32_Template, 2, 1, "ng-container", 0);
    ɵɵelementStart(33, "div", 3);
    ɵɵelementStart(34, "div", 11);
    ɵɵelement(35, "br");
    ɵɵelementStart(36, "button", 12);
    ɵɵelement(37, "span", 13);
    ɵɵpipe(38, "i18n");
    ɵɵtext(39, "\u00A0 ");
    ɵɵtemplate(40, ResponseIndividualRequirementComponent_ng_container_0_span_40_Template, 2, 0, "span", 0);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(41, "div", 3);
    ɵɵelementStart(42, "div", 11);
    ɵɵelement(43, "br");
    ɵɵelement(44, "br");
    ɵɵelement(45, "br");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate(ɵɵpipeBind1(4, 18, "@collections-text-responder"));
    ɵɵadvance(5);
    ɵɵproperty("formGroup", ctx_r0.form);
    ɵɵadvance(4);
    ɵɵtextInterpolate(ɵɵpipeBind1(13, 20, "@collections-text-response"));
    ɵɵadvance(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(29, _c1, ctx_r0.form.controls.response.invalid && ctx_r0.form.controls.response.dirty));
    ɵɵadvance(1);
    ɵɵproperty("selected", true);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(17, 22, "@collections-text-select"));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r0.listTransactionStatus);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.form.get("response").errors);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.config.responseOptionalFieldsIndividualResponse);
    ɵɵadvance(4);
    ɵɵstyleProp("font-weight", ctx_r0.observation_required ? "bold" : "normal");
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(26, 24, "@collections-text-comment"));
    ɵɵadvance(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(31, _c1, ctx_r0.form.controls.observation.invalid && ctx_r0.form.controls.observation.dirty));
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r0.form.get("observation").errors);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.config.responseOptionalFieldsIndividualResponse);
    ɵɵadvance(4);
    ɵɵproperty("disabled", !ctx_r0.form.valid || ctx_r0.submit_disabled);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(38, 26, "@collection-text-save", ctx_r0.lang), ɵɵsanitizeHtml);
    ɵɵadvance(3);
    ɵɵproperty("ngIf", ctx_r0.submit_disabled);
} }
class ResponseIndividualRequirementComponent {
    constructor(formBuilder, _error, _router, _i18n, _upload, _httpService) {
        this.formBuilder = formBuilder;
        this._error = _error;
        this._router = _router;
        this._i18n = _i18n;
        this._upload = _upload;
        this._httpService = _httpService;
        this.responses = new EventEmitter();
        this.transactionrequirementresponse = new EventEmitter();
        this.listTransactionStatus = [];
        this.submit_disabled = false;
        this.incomplete = false;
        this.dropdownList = [];
        this.selectedItems = [];
        this.dropdownSettings = {};
        this.nextLoanOrCreditStatus = null;
        this.itemsSelected = [];
        this.arrayCreditStatus = [];
        this.conditioned = false;
        this.refresh = true;
        this.observation_required = false;
    }
    ngOnInit() {
        setTimeout(() => {
            this.listTransactionStatus = this.config.lists.responsesRequirements;
            this.form = this.formBuilder.group(({
                'response': new FormControl('', Validators.required),
                'observation': new FormControl('', []),
            }));
            console.log(this.config);
            // Mientras se dinamiza, se coloca de una forma dinamica, cableada.
            if (this.config.responseOptionalFieldsIndividualResponse.observationInside) {
                this.form.addControl('observationInside', new FormControl(''));
            }
            if (this.config.responseOptionalFieldsIndividualResponse.reasonIncompleted) {
                this.form.addControl('reasonIncomplete', new FormControl(''));
            }
        }, 2);
    }
    responseEvent($event) {
        this.incomplete = (this.form.get('response').value).identifier === 'INCOMPLETED' ? true : false;
        if ((this.form.get('response').value).identifier === this.config.statusResponseRequirement.rejected || (this.form.get('response').value).identifier === this.config.statusResponseRequirement.incomplete) {
            this.observation_required = true;
        }
        else {
            this.observation_required = false;
        }
    }
    objectLength(object) {
        let length = 0;
        // tslint:disable-next-line:forin
        for (const key in object) {
            length++;
        }
        return length;
    }
    getObjectResponse(response) {
        let resp = null;
        this.config.lists.responsesRequirements.forEach(element => {
            if (element.identifier === response) {
                resp = element;
            }
        });
        return resp;
    }
    submit() {
        const sectionsIncomplete = [];
        const observation = this.form.get('observation').value;
        const response = (this.form.get('response').value).identifier;
        let observationInside = '';
        let reasonIncomplete = '';
        if (this.config.responseOptionalFieldsIndividualResponse) {
            if (this.config.responseOptionalFieldsIndividualResponse.observationInside) {
                observationInside = this.form.get('observationInside').value;
            }
            if (this.config.responseOptionalFieldsIndividualResponse.reasonIncompleted) {
                reasonIncomplete = this.form.get('reasonIncomplete').value;
            }
        }
        if (this.form.dirty && this.form.valid) {
            const obj_response = this.getObjectResponse(response);
            this.submit_disabled = true;
            const params = this.config.endpoints.saveResponseRequirement.params;
            params.body.identifier = this.transactionrequirement.identifier;
            params.body.response = response;
            params.body.responseDescription = observation;
            if (!isNullOrUndefined(this.config.responseOptionalFieldsIndividualResponse)) {
                if (!isNullOrUndefined(this.config.responseOptionalFieldsIndividualResponse.reasonIncompleted) && (this.form.get('response').value).identifier === 'INCOMPLETED' && (this.form.get('reasonIncomplete').value === '' || isNullOrUndefined(this.form.get('reasonIncomplete').value))) {
                    swal.fire({
                        title: '¡Espere!',
                        html: '<b>Por el tipo de respuesta, es necesario seleccionar la Razón de la Respuesta Incompleta.</b>',
                    });
                    this.submit_disabled = false;
                }
                else {
                    if ((obj_response.requireObservation && (observation === null || observation === '' || observation === undefined)) && (response === this.config.statusResponseRequirement.incomplete || response === this.config.statusResponseRequirement.rejected)) {
                        swal.fire({
                            title: '¡Espere!',
                            html: '<b>Por el tipo de respuesta, es necesario agregar las observaciones.</b>',
                        });
                        this.submit_disabled = false;
                    }
                    else {
                        if (this.config.responseOptionalFieldsIndividualResponse) {
                            if (!isNullOrUndefined(this.config.responseOptionalFieldsIndividualResponse.observationInside)) {
                                params.body.internalComment = observationInside;
                            }
                            if (!isNullOrUndefined(this.config.responseOptionalFieldsIndividualResponse.reasonIncompleted)) {
                                params.body.reasonIncomplete = { 'identifier': reasonIncomplete };
                            }
                        }
                        this._httpService.executeRequest(this.config.endpoints.saveResponseRequirement.name, params, true).subscribe((_response) => {
                            this.transactionrequirementresponse.emit(_response);
                        }, (err) => {
                            this.submit_disabled = false;
                            this._error.show(err);
                        });
                    }
                }
            }
            else {
                if ((obj_response.requireObservation && (observation === null || observation === '' || observation === undefined)) && (response === this.config.statusResponseRequirement.incomplete || response === this.config.statusResponseRequirement.rejected)) {
                    swal.fire({
                        title: '¡Espere!',
                        html: '<b>Por el tipo de respuesta, es necesario agregar las observaciones.</b>',
                    });
                    this.submit_disabled = false;
                }
                else {
                    if (this.config.responseOptionalFieldsIndividualResponse) {
                        if (!isNullOrUndefined(this.config.responseOptionalFieldsIndividualResponse.observationInside)) {
                            params.body.internalComment = observationInside;
                        }
                        if (!isNullOrUndefined(this.config.responseOptionalFieldsIndividualResponse.reasonIncompleted)) {
                            params.body.reasonIncomplete = { 'identifier': reasonIncomplete };
                        }
                    }
                    this._httpService.executeRequest(this.config.endpoints.saveResponseRequirement.name, params, true).subscribe((_response) => {
                        this.transactionrequirementresponse.emit(_response);
                    }, (err) => {
                        this.submit_disabled = false;
                        this._error.show(err);
                    });
                }
            }
        }
    }
}
/** @nocollapse */ ResponseIndividualRequirementComponent.ɵfac = function ResponseIndividualRequirementComponent_Factory(t) { return new (t || ResponseIndividualRequirementComponent)(ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(ErrorService), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(HttpService)); };
/** @nocollapse */ ResponseIndividualRequirementComponent.ɵcmp = ɵɵdefineComponent({ type: ResponseIndividualRequirementComponent, selectors: [["akeela-individual-response-requirement"]], inputs: { transactionNumber: "transactionNumber", requirement: "requirement", transactionrequirement: "transactionrequirement", config: "config", next_credit_id: ["nextCreditId", "next_credit_id"] }, outputs: { responses: "responses", transactionrequirementresponse: "transactionrequirementresponse" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "bt2gray"], ["novalidate", "", 3, "formGroup", "ngSubmit"], [1, "row"], [1, "col-12", "col-md-12", "col-sm", "col-lg-6"], ["formControlName", "response", 1, "form-control", 3, "ngClass", "change"], ["value", "", 3, "selected"], ["class", "form-control-feedback help-block", 4, "ngIf"], [1, "col-12"], ["formControlName", "observation", 1, "form-control", 3, "ngClass"], [1, "text-secondary", "fz-14", "mt-1"], [1, "col-4", "offset-8", "text-right"], ["type", "submit", 1, "btn", "btn-block", "btn-primary", "btn-lg", 3, "disabled"], [3, "innerHTML"], [4, "ngFor", "ngForOf"], [3, "ngValue"], [1, "form-control-feedback", "help-block"], [3, "innerHTML", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["formControlName", "reasonIncomplete", 1, "form-control", 3, "ngClass"], ["value", "", "selected", ""], [2, "font-weight", "normal"], ["formControlName", "observationInside", 1, "form-control", 3, "ngClass"], [1, "fa", "fa-refresh", "fa-spin"]], template: function ResponseIndividualRequirementComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, ResponseIndividualRequirementComponent_ng_container_0_Template, 46, 33, "ng-container", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.refresh);
    } }, directives: [NgIf, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, SelectControlValueAccessor, NgControlStatus, FormControlName, NgClass, NgSelectOption, ɵangular_packages_forms_forms_x, DefaultValueAccessor, NgForOf], pipes: [I18nPipe], styles: [".bt2gray[_ngcontent-%COMP%]{border-top:1px solid #ccc}.description[_ngcontent-%COMP%]{font-size:1rem}.description-2[_ngcontent-%COMP%]{font-size:14px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:40px}.img-folder[_ngcontent-%COMP%]{width:30px}@media (max-width:768px){.description[_ngcontent-%COMP%]{font-size:15px}.description-2[_ngcontent-%COMP%]{font-size:13px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:30px!important}.img-folder[_ngcontent-%COMP%]{width:26px}}.description-label[_ngcontent-%COMP%]{font-size:.875rem}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ResponseIndividualRequirementComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-individual-response-requirement',
                templateUrl: './response-requirements.component.html',
                styleUrls: ['./response-requirements.component.css']
            }]
    }], function () { return [{ type: FormBuilder }, { type: ErrorService }, { type: Router }, { type: I18nPipe }, { type: UploadService }, { type: HttpService }]; }, { transactionNumber: [{
            type: Input
        }], requirement: [{
            type: Input
        }], transactionrequirement: [{
            type: Input
        }], config: [{
            type: Input
        }], next_credit_id: [{
            type: Input,
            args: ['nextCreditId']
        }], responses: [{
            type: Output
        }], transactionrequirementresponse: [{
            type: Output
        }] }); })();

function RequirementDetailComponent_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 7);
    ɵɵelement(1, "akeela-requirement-dates", 8);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("files", ctx_r3.files)("transactionrequirement", ctx_r3.transactionrequirement)("type", ctx_r3.sel_type)("file", ctx_r3.sel_file)("config", ctx_r3._config);
} }
function RequirementDetailComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "br");
    ɵɵtemplate(2, RequirementDetailComponent_ng_container_2_div_2_Template, 2, 5, "div", 6);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r1.requirement);
} }
function RequirementDetailComponent_div_5_ng_container_6_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 17);
    ɵɵelementStart(1, "span");
    ɵɵtext(2, "...");
    ɵɵelementEnd();
    ɵɵelementStart(3, "span", 18);
    ɵɵtext(4, "Ver m\u00E1s");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function RequirementDetailComponent_div_5_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 15);
    ɵɵlistener("click", function RequirementDetailComponent_div_5_ng_container_6_Template_div_click_1_listener() { ɵɵrestoreView(_r10); const ctx_r9 = ɵɵnextContext(2); return ctx_r9.descroptionRq = !ctx_r9.descroptionRq; });
    ɵɵelementStart(2, "div");
    ɵɵelement(3, "span", 12);
    ɵɵelementEnd();
    ɵɵtemplate(4, RequirementDetailComponent_div_5_ng_container_6_div_4_Template, 5, 0, "div", 16);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵclassMapInterpolate1("text-secondary pt-2  ", !ctx_r4.descroptionRq ? "min-h ak-text-req-name " : "", " ");
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ctx_r4.requirement == null ? null : ctx_r4.requirement.description, ɵɵsanitizeHtml);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r4.descroptionRq);
} }
function RequirementDetailComponent_div_5_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function RequirementDetailComponent_div_5_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailComponent_div_5_ng_container_7_ng_container_1_Template, 1, 0, "ng-container", 19);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r5.templates["requirementsDetailHeaderContent"]);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_3_ng_container_1_akeela_individual_response_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-individual-response", 29);
} if (rf & 2) {
    const ctx_r22 = ɵɵnextContext(6);
    ɵɵproperty("response", ctx_r22.transactionrequirement)("config", ctx_r22._config);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "span", 27);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_3_ng_container_1_akeela_individual_response_3_Template, 1, 2, "akeela-individual-response", 28);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r21 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 2, "@i18n-requirements-version") + " 1.0", ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r21.transactionrequirement && ctx_r21.config && !ctx_r21.lastVersion);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_3_ng_container_1_Template, 4, 4, "ng-container", 14);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r14.transactionrequirement == null ? null : ctx_r14.transactionrequirement.responseDescription) && (ctx_r14.files[ctx_r14.requirement == null ? null : ctx_r14.requirement.identifier].response === ctx_r14._config.enableEspecialUpload.status && ctx_r14._config.enableEspecialUpload.active && !ctx_r14.validateNewFilesUpdated()) && !ctx_r14.lastVersion);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_4_ng_container_1_ng_container_1_akeela_individual_response_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-individual-response", 29);
} if (rf & 2) {
    const history_r25 = ɵɵnextContext().$implicit;
    const ctx_r27 = ɵɵnextContext(6);
    ɵɵproperty("response", history_r25)("config", ctx_r27.config);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_4_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_4_ng_container_1_ng_container_1_akeela_individual_response_1_Template, 1, 2, "akeela-individual-response", 28);
    ɵɵelement(2, "br");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const history_r25 = ctx.$implicit;
    const ctx_r24 = ɵɵnextContext(6);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", history_r25 && ctx_r24.config);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_4_ng_container_1_ng_container_1_Template, 3, 1, "ng-container", 30);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r23 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r23.history_responses);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 14);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r15.transactionrequirement == null ? null : ctx_r15.transactionrequirement.response);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_akeela_table_files_6_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "akeela-table-files", 31);
    ɵɵlistener("showFile", function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_akeela_table_files_6_Template_akeela_table_files_showFile_0_listener($event) { ɵɵrestoreView(_r30); const ctx_r29 = ɵɵnextContext(4); return ctx_r29.show_file($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵɵnextContext(4);
    ɵɵproperty("files", ctx_r16.files)("config", ctx_r16._config)("transactionrequirement", ctx_r16.transactionrequirement)("requirement", ctx_r16.requirement)("lista", ctx_r16.list)("readOnly", ctx_r16.lastVersion);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 32);
    ɵɵlistener("click", function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_div_7_Template_div_click_0_listener() { ɵɵrestoreView(_r32); const ctx_r31 = ɵɵnextContext(4); return ctx_r31.openDocument(ctx_r31.transactionrequirement == null ? null : ctx_r31.transactionrequirement.requirement == null ? null : ctx_r31.transactionrequirement.requirement.alternateName); });
    ɵɵtext(1, " Ver Ficha \u00DAnica ");
    ɵɵelementEnd();
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 32);
    ɵɵlistener("click", function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_div_8_Template_div_click_0_listener() { ɵɵrestoreView(_r34); const ctx_r33 = ɵɵnextContext(4); return ctx_r33.openDocument(ctx_r33.requirement == null ? null : ctx_r33.requirement.alternateName); });
    ɵɵtext(1, " Ver Ficha \u00DAnica ");
    ɵɵelementEnd();
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_9_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 34);
    ɵɵelementStart(1, "div", 35);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵstyleProp("width", ctx_r35.files[ctx_r35.requirement == null ? null : ctx_r35.requirement.identifier].progress + "%");
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r35.files[ctx_r35.requirement == null ? null : ctx_r35.requirement.identifier].progress, " % ");
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_9_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_9_ng_container_4_akeela_input_upload_file_flex_22_Template(rf, ctx) { if (rf & 1) {
    const _r40 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "akeela-input-upload-file-flex", 38);
    ɵɵlistener("response", function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_9_ng_container_4_akeela_input_upload_file_flex_22_Template_akeela_input_upload_file_flex_response_0_listener($event) { ɵɵrestoreView(_r40); const ctx_r39 = ɵɵnextContext(6); return ctx_r39.notificacion($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = ɵɵnextContext(6);
    ɵɵproperty("config", ctx_r38._config)("type", "button")("identifier", ctx_r38.requirement == null ? null : ctx_r38.requirement.identifier);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_9_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 36);
    ɵɵtext(2, " files[requirement?.identifier].response ");
    ɵɵelement(3, "br");
    ɵɵtext(4);
    ɵɵelement(5, "br");
    ɵɵtext(6);
    ɵɵelement(7, "br");
    ɵɵtext(8);
    ɵɵelement(9, "br");
    ɵɵtext(10);
    ɵɵelement(11, "br");
    ɵɵtext(12);
    ɵɵelement(13, "br");
    ɵɵtext(14);
    ɵɵelement(15, "br");
    ɵɵtext(16);
    ɵɵelement(17, "br");
    ɵɵtext(18);
    ɵɵelement(19, "br");
    ɵɵelement(20, "br");
    ɵɵtext(21, " ((files[requirement.identifier].progress===null) && !this._config.isReadonly && this._config.isDigitalUploadActive===true) || (validateSpecialApplySpecialCase(files[requirement?.identifier].response) && _config.enableEspecialUpload.active ) || (!this._config.isReadonly && this._config.isDigitalUploadActive)");
    ɵɵelementEnd();
    ɵɵtemplate(22, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_9_ng_container_4_akeela_input_upload_file_flex_22_Template, 1, 3, "akeela-input-upload-file-flex", 37);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r37 = ɵɵnextContext(5);
    ɵɵadvance(4);
    ɵɵtextInterpolate1(" files[requirement.identifier].progress : ", ctx_r37.files[ctx_r37.requirement.identifier].progress, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" this._config.isReadonly : ", ctx_r37._config.isReadonly, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" this._config.isDigitalUploadActive : ", ctx_r37._config.isDigitalUploadActive, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" files[requirement?.identifier].response : ", ctx_r37.files[ctx_r37.requirement == null ? null : ctx_r37.requirement.identifier].response, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" validateSpecialApplySpecialCase(files[requirement?.identifier].response) : ", ctx_r37.validateSpecialApplySpecialCase(ctx_r37.files[ctx_r37.requirement == null ? null : ctx_r37.requirement.identifier].response), "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" _config.enableEspecialUpload.active : ", ctx_r37._config.enableEspecialUpload.active, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" this._config.isReadonly : ", ctx_r37._config.isReadonly, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" this._config.isDigitalUploadActive: ", ctx_r37._config.isDigitalUploadActive, "");
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r37.files[ctx_r37.requirement.identifier].progress === null && !ctx_r37._config.isReadonly && ctx_r37._config.isDigitalUploadActive === true || ctx_r37.validateSpecialApplySpecialCase(ctx_r37.files[ctx_r37.requirement == null ? null : ctx_r37.requirement.identifier].response) && ctx_r37._config.enableEspecialUpload.active || !ctx_r37._config.isReadonly && ctx_r37._config.isDigitalUploadActive);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 21);
    ɵɵtemplate(2, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_9_div_2_Template, 3, 3, "div", 33);
    ɵɵtemplate(3, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_9_ng_container_3_Template, 1, 0, "ng-container", 14);
    ɵɵtemplate(4, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_9_ng_container_4_Template, 23, 9, "ng-container", 14);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = ɵɵnextContext(4);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r19.files[ctx_r19.requirement == null ? null : ctx_r19.requirement.identifier].progress !== null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r19.modeDebug);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r19.files[ctx_r19.requirement == null ? null : ctx_r19.requirement.identifier].progress === null);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_10_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r45 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "akeela-individual-response-requirement", 39);
    ɵɵlistener("transactionrequirementresponse", function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_10_ng_container_1_ng_container_1_ng_container_1_Template_akeela_individual_response_requirement_transactionrequirementresponse_1_listener($event) { ɵɵrestoreView(_r45); const ctx_r44 = ɵɵnextContext(7); return ctx_r44.update_transaction_requirement($event); });
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r43 = ɵɵnextContext(7);
    ɵɵadvance(1);
    ɵɵproperty("transactionrequirement", ctx_r43.transactionrequirement)("transactionNumber", ctx_r43._config.transactionData.transactionNumber)("requirement", ctx_r43.requirement)("nextCreditId", ctx_r43._next)("config", ctx_r43._config);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_10_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_10_ng_container_1_ng_container_1_ng_container_1_Template, 2, 5, "ng-container", 14);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r42 = ɵɵnextContext(6);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r42.transactionrequirement == null ? null : ctx_r42.transactionrequirement.additionalType) !== "false" && ctx_r42.transactionrequirement.response !== "VERIFIED");
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_10_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 14);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r41 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r41._config.isResponseActive);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_10_ng_container_1_Template, 2, 1, "ng-container", 14);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r20.list !== null);
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 21);
    ɵɵelementStart(2, "div", 22);
    ɵɵtemplate(3, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_3_Template, 2, 1, "ng-container", 14);
    ɵɵtemplate(4, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_4_Template, 2, 1, "ng-container", 14);
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 23);
    ɵɵtemplate(6, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_akeela_table_files_6_Template, 1, 6, "akeela-table-files", 24);
    ɵɵelementEnd();
    ɵɵtemplate(7, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_div_7_Template, 2, 0, "div", 25);
    ɵɵtemplate(8, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_div_8_Template, 2, 0, "div", 26);
    ɵɵtemplate(9, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_9_Template, 5, 3, "ng-container", 14);
    ɵɵtemplate(10, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_ng_container_10_Template, 2, 1, "ng-container", 14);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext(3);
    ɵɵadvance(3);
    ɵɵproperty("ngIf", ctx_r12.list);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r12._config.isHistoryResponsesShow);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r12.loaded);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r12.transactionrequirement == null ? null : ctx_r12.transactionrequirement.requirement == null ? null : ctx_r12.transactionrequirement.requirement.additionalType) === "SINGLE_TAB");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r12.requirement == null ? null : ctx_r12.requirement.additionalType) === "SINGLE_TAB");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r12.requirement.upload === true && !ctx_r12.lastVersion);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r12.list !== "LOADING");
} }
function RequirementDetailComponent_div_5_ng_container_8_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 40);
    ɵɵelement(2, "img", 41);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function RequirementDetailComponent_div_5_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r47 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 20);
    ɵɵlistener("window.scroll", function RequirementDetailComponent_div_5_ng_container_8_Template_div_window_scroll_1_listener($event) { ɵɵrestoreView(_r47); const ctx_r46 = ɵɵnextContext(2); return ctx_r46.doSomethingOnWindowsScroll($event); });
    ɵɵtemplate(2, RequirementDetailComponent_div_5_ng_container_8_ng_container_2_Template, 11, 7, "ng-container", 14);
    ɵɵtemplate(3, RequirementDetailComponent_div_5_ng_container_8_ng_container_3_Template, 3, 0, "ng-container", 14);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r6.loaded);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r6.loaded);
} }
function RequirementDetailComponent_div_5_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 40);
    ɵɵelement(2, "img", 41);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function RequirementDetailComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 9);
    ɵɵelementStart(1, "div", 10);
    ɵɵelementStart(2, "div", 11);
    ɵɵelement(3, "span", 12);
    ɵɵpipe(4, "i18n");
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 13);
    ɵɵtemplate(6, RequirementDetailComponent_div_5_ng_container_6_Template, 5, 5, "ng-container", 14);
    ɵɵelementEnd();
    ɵɵtemplate(7, RequirementDetailComponent_div_5_ng_container_7_Template, 2, 1, "ng-container", 14);
    ɵɵtemplate(8, RequirementDetailComponent_div_5_ng_container_8_Template, 4, 2, "ng-container", 14);
    ɵɵtemplate(9, RequirementDetailComponent_div_5_ng_container_9_Template, 3, 0, "ng-container", 14);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(4, 5, ctx_r2.requirement == null ? null : ctx_r2.requirement.name), ɵɵsanitizeHtml);
    ɵɵadvance(3);
    ɵɵproperty("ngIf", ctx_r2.requirement == null ? null : ctx_r2.requirement.description);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2._config.showDetailHeaderContent);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.loaded);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r2.loaded);
} }
class RequirementDetailComponent {
    constructor(datePipe, templateService, eleRef, _httpService, _i18n, _upload, _requirement, _error, localStorage, swalTargets) {
        this.datePipe = datePipe;
        this.templateService = templateService;
        this.eleRef = eleRef;
        this._httpService = _httpService;
        this._i18n = _i18n;
        this._upload = _upload;
        this._requirement = _requirement;
        this._error = _error;
        this.localStorage = localStorage;
        this.swalTargets = swalTargets;
        this._config = null;
        this.close = new EventEmitter();
        this.open = new EventEmitter();
        this.showFile = new EventEmitter();
        this.response = new EventEmitter();
        this.finishupload = new EventEmitter();
        this.updatefiles = new EventEmitter();
        this.templates = {};
        this.list = 'LOADING';
        this.obj_aux = [];
        this.loaded = false;
        this.history_responses = null;
        this.transactionrequirement = null;
        this.transactionrequirementbackup = null;
        this._back = null;
        this._next = null;
        this.sel_requirement = null;
        this.sel_transactionrequirement = null;
        this.sel_type = null;
        this.sel_file = null;
        this.currentdate = new Date();
        this.lastVersion = false;
        this.descroptionRq = false;
        this.modeDebug = false;
    }
    set config(value) {
        if (!isNullOrUndefined(value)) {
            console.log('Entrooooooooo');
            console.log(value);
            this._config = value;
            // this.initConfig();
            setTimeout(() => {
                if (this._config.isHistoryResponsesShow) {
                    this.getRequirementHistory();
                }
                this.getRequirementFiles();
                this._upload.files[this._config.viewName][this.requirement.identifier]['save']['data']['requirement']['identifier'] = this.requirement.identifier;
                this._upload.files[this._config.viewName][this.requirement.identifier]['delete']['data']['requirement']['identifier'] = this.requirement.identifier;
                this.files = this._upload.files[this._config.viewName];
                this.getBackNext();
                this.loaded = true;
                this.check_requirements();
            }, 100);
        }
    }
    ngOnInit() {
        this.currentdate = this.currentdate.getTime();
        // this.subscription_files_inic = this._requirement.updateModalRQ$.subscribe((updateModalRQ) => {
        // this.ngOnDestroy();
        this._upload.resetChangeRequirementById();
        if (this.localStorage.getItem('modeDebug')) {
            this.modeDebug = this.localStorage.getItem('modeDebug');
        }
        this.subscription_change_files = this._upload.getChangresFilesArr().subscribe((files) => {
            this.files = this._upload.files[this._config.viewName];
            this.loaded = true;
            this.check_requirements();
        });
        this.subscription_files = this._upload.getChangeRequirementById().subscribe((idRequirement) => {
            // console.log('Se recibe el cambio ' + idRequirement);
            if (idRequirement !== null) {
                //  console.log(idRequirement);
                // se indica que el archivo ya cargo...
                this.finishupload.emit(true);
                this.list = 'LOADING';
                this.requirement = this.getRequirementById(idRequirement);
                if (this._config.isHistoryResponsesShow) {
                    this.getRequirementHistory();
                }
                setTimeout(() => {
                    // console.log('Entra en llamada' + idRequirement);
                    this.getRequirementFiles();
                    //console.log('Sale en llamada' + idRequirement);
                    this._upload.files[this._config.viewName][this.requirement.identifier]['save']['data']['requirement']['identifier'] = this.requirement.identifier;
                    this._upload.files[this._config.viewName][this.requirement.identifier]['delete']['data']['requirement']['identifier'] = this.requirement.identifier;
                    this.files = this._upload.files[this._config.viewName];
                    this.getBackNext();
                    this.loaded = true;
                    this.check_requirements();
                }, 10);
            }
        });
    }
    openDocument(documentName) {
        this.open.emit(documentName);
    }
    getLastVersion() {
        debugger;
        this.transactionrequirementbackup = this.transactionrequirement;
        const params = this._config.endpoints.getHistoricRequirement.params;
        params.path.idRequirement = this.requirement.identifier;
        this._httpService.executeRequest(this._config.endpoints.getHistoricRequirement.name, params, true).subscribe((response) => {
            if (response.length > 0) {
                this.transactionrequirement = response[0];
                if (this.transactionrequirement.requirementArchives) {
                    if (this.transactionrequirement.requirementArchives.length > 0) {
                        this.list = this.transactionrequirement.requirementArchives;
                    }
                    else {
                        this._upload.files[this._config.viewName][this.requirement.identifier].status = null;
                        this.updatefiles.emit(this._upload.files[this._config.viewName]);
                        this.list = null;
                    }
                }
                else {
                    this._upload.files[this._config.viewName][this.requirement.identifier].status = null;
                    this.updatefiles.emit(this._upload.files[this._config.viewName]);
                    this.list = null;
                }
            }
            else {
                this._upload.files[this._config.viewName][this.requirement.identifier].status = null;
                this.updatefiles.emit(this._upload.files[this._config.viewName]);
                this.list = null;
            }
        });
    }
    check_requirements() {
        this.response.emit(this._requirement.check_requirements(this.requirements, this.files, this._config));
    }
    update_transaction_requirement(transactionrequirement) {
        if (transactionrequirement) {
            // window.scroll(0, 0);
            this._upload.files[this._config.viewName][this.requirement.identifier].response = transactionrequirement.response;
            // if (this._config.enableEspecialUpload.active) {
            //   if (isNullOrUndefined(transactionrequirement.response) && !isNullOrUndefined(transactionrequirement.responseDescription)) {
            //     if (transactionrequirement.responseDescription.includes('Incompleto')) {
            //       this._upload.files[this._config.viewName][this.requirement.identifier].response = 'INCOMPLETED';
            //     }
            //     if (transactionrequirement.responseDescription.includes('Rechazado')) {
            //       this._upload.files[this._config.viewName][this.requirement.identifier].response = 'REJECTED';
            //     }
            //   }
            // }
            // acá se actualiza el contador de respuestas del user...
            this.updatefiles.emit(this._upload.files[this._config.viewName]);
            this.transactionrequirement = transactionrequirement;
            this.check_requirements();
            this.next(true);
            this.cerrar();
        }
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
    getRequirementFiles() {
        // console.log('Invoco el servicio que solicita los files');
        const params = this._config.endpoints.getRequirement.params;
        params.path.idRequirement = this.requirement.identifier;
        if (this.subscription_files_options) {
            this.subscription_files_options.unsubscribe();
        }
        // console.log('entro inicioo');
        this.subscription_files_options = this._httpService.executeRequest(this._config.endpoints.getRequirement.name, params, true).subscribe((response) => {
            debugger;
            this.list = null;
            this.transactionrequirement = response;
            if (response.requirementArchives && response.requirementArchives.length > 0) {
                // console.log('entro en caso 1');
                // console.log(response.requirementArchives);
                this.list = response.requirementArchives;
            }
            else {
                // console.log('entro en caso 2');
                // console.log(this._upload.files[this._config.viewName]);
                this._upload.files[this._config.viewName][this.requirement.identifier].status = null;
                this.updatefiles.emit(this._upload.files[this._config.viewName]);
                this.list = null;
            }
        }, error => {
            // alert('va por el error');
            this.transactionrequirement = null;
            this._upload.files[this._config.viewName][this.requirement.identifier].status = null;
            this.updatefiles.emit(this._upload.files[this._config.viewName]);
            this.list = null;
        });
    }
    getRequirementHistory() {
        this.history_responses = null;
        const params = this._config.endpoints.getHistoryResponseRequirement.params;
        params.path.idRequirement = this.requirement.identifier;
        this._httpService.executeRequest(this._config.endpoints.getHistoryResponseRequirement.name, params, true).subscribe((history) => {
            this.history_responses = history;
        });
    }
    getRequirementById(identifier) {
        let response = null;
        this.requirements.forEach((element) => {
            element.value.forEach((element2) => {
                if (element2.requirement.identifier.toString() === identifier.toString()) {
                    response = element2.requirement;
                }
            });
        });
        return response;
    }
    getBackNext() {
        this.lastVersion = false;
        let next = null;
        let back = null;
        let case_break = 0;
        const auxiliar = [];
        for (const aux of this.requirements) {
            for (const req of aux.value) {
                auxiliar.push(req.requirement.identifier);
            }
        }
        for (const r of auxiliar) {
            if (case_break < 2) {
                if (parseInt(r, 10) !== parseInt(this.requirement.identifier, 10) && case_break === 0) {
                    back = r;
                }
                else if (parseInt(r, 10) === parseInt(this.requirement.identifier, 10)) {
                    case_break = 1;
                }
                else if (case_break === 1) {
                    next = r;
                    case_break = 2;
                }
            }
        }
        this._next = next;
        this._back = back;
    }
    notificacion(evt) {
        swal.fire({
            title: this._i18n.transform(evt.title),
            text: this._i18n.transform(evt.html),
        });
    }
    validate_expiration(expiration) {
        if (expiration !== null) {
            const date = this.generate_object_date(expiration);
            if (this.currentdate.getTime() > date.getTime()) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    generate_object_date(epoc) {
        return new Date(epoc * 1000);
    }
    next(close) {
        if (this._next) {
            //   window.scroll(0, 0);
            this.loaded = false;
            this._upload.setChangeRequirementById(this._next);
        }
        else {
            if (close) {
                this.cerrar();
            }
        }
    }
    back() {
        // window.scroll(0, 0);
        this.loaded = false;
        this._upload.setChangeRequirementById(this._back);
    }
    cerrar() {
        this.close.emit(true);
    }
    show_file(file) {
        this.showFile.emit(file);
    }
    update_dates(object, type) {
        this.sel_type = type;
        if (type !== 'transaction') {
            this.sel_file = object;
        }
        const box = this.eleRef.nativeElement.querySelector('#idshowdates');
        box.dispatchEvent(new Event('click'));
    }
    ngOnDestroy() {
        if (this.subscription_files) {
            this.subscription_files.unsubscribe();
        }
        if (this.subscription_files_options) {
            this.subscription_files_options.unsubscribe();
        }
        if (this.subscription_change_files) {
            this.subscription_change_files.unsubscribe();
        }
    }
    swipeleft(event) {
        this.next();
    }
    swiperight(event) {
        this.back();
    }
    doSomethingOnWindowsScroll($event) {
        // TODO: MIGRACIÓN
        // this.scrollOffset = $event.srcElement.children[0].scrollTop;
        // console.log('window scroll: ', this.scrollOffset);
    }
    countCurrentElement(identifier) {
        let count = 1;
        for (const element of this.requirements) {
            for (const requirement of element.value) {
                if (requirement.requirement.identifier === identifier) {
                    return count;
                }
                else {
                    count++;
                }
            }
        }
    }
    countRequirements() {
        let count = 0;
        this.requirements.forEach((element) => {
            element.value.forEach((element2) => {
                count++;
            });
        });
        return count;
    }
    validateNewFilesUpdated() {
        for (const row of this.list) {
            if (this.transactionrequirement.responseDate) {
                if (this.transactionrequirement.responseDate.orderDate < row.dateOfThing.startDate) {
                    return true;
                }
            }
        }
        return false;
    }
    changeVersion() {
        this.list = 'LOADING';
        this.lastVersion = !this.lastVersion;
        if (this.lastVersion) {
            this.getLastVersion();
            this.files = this._upload.files[this._config.viewName];
            this.loaded = true;
            this.check_requirements();
        }
        else {
            this.transactionrequirement = this.transactionrequirementbackup;
            this.getRequirementFiles();
            this.files = this._upload.files[this._config.viewName];
            this.loaded = true;
            this.check_requirements();
        }
    }
    download_files_requirement() {
        const params = this._config.endpoints.downloadRequirementFilesZip.params;
        params.request.idTransactionRequirement = this.transactionrequirement.identifier;
        this._httpService.executeRequest(this._config.endpoints.downloadRequirementFilesZip.name, params, true).subscribe((response) => {
            if (!isNullOrUndefined(response)) {
                response['action'] = 'downloadzip';
                if (true) {
                    response['deleteAfterShow'] = this._config.endpoints.deleteArchive;
                    response['deleteAfterShow']['params']['body']['identifier'] = response.identifier;
                }
            }
            this.showFile.emit(response);
        }, error => {
            this._error.show(error);
        });
    }
    time_to_expiration(expiration_date) {
        if (!isNullOrUndefined(expiration_date)) {
            if (expiration_date > 0) {
                return this.calcDate(new Date(), new Date(expiration_date * 1000));
            }
        }
        return '';
    }
    calcDate(date1, date2) {
        const diff = Math.floor(date2.getTime() - date1.getTime());
        const day = 1000 * 60 * 60 * 24;
        const days = Math.floor(diff / day);
        const months = Math.floor(days / 31);
        const years = Math.floor(months / 12);
        let message = '';
        if (years > 0 || months > 0 || days > 0) {
            message += '(';
            if (years > 0) {
                message += years + 'a';
            }
            if (months > 0) {
                message += months + 'm ';
            }
            if (days > 0) {
                message += days + 'd ';
            }
            message += ')';
        }
        else if (years < -1 || months < -1 || days < -1) {
            message = '<span class="text-danger">(Vencido)</span>';
        }
        else {
            message = '';
        }
        return message;
    }
    validateSpecialApplySpecialCase(response) {
        if (!isNullOrUndefined(this._config.enableEspecialUpload)) {
            if (!isNullOrUndefined(this._config.enableEspecialUpload.active)) {
                if (this._config.enableEspecialUpload.active == true) {
                    for (const status of this._config.enableEspecialUpload.status) {
                        if (status === response || response === '' || response === null) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
    validateRequiredRule(requirement) {
        return this._requirement.validateRequiredRule(this._config, requirement);
    }
    word_count(word) {
        // Obtenemos el texto del campo
        let texto = word;
        // Reemplazamos los saltos de linea por espacios
        texto = texto.replace(/\r?\n/g, " ");
        // Reemplazamos los espacios seguidos por uno solo
        texto = texto.replace(/[ ]+/g, " ");
        // Quitarmos los espacios del principio y del final
        texto = texto.replace(/^ /, "");
        texto = texto.replace(/ $/, "");
        // Troceamos el texto por los espacios
        const textoTroceado = texto.split(" ");
        // Contamos todos los trozos de cadenas que existen
        const numeroPalabras = textoTroceado.length;
        // Mostramos el número de palabras
        return numeroPalabras;
    }
    ak_splice(textoHTML) {
        let response = '';
        if (!isNullOrUndefined(textoHTML)) {
            response = textoHTML
                .replace(/<[^>]*>/g, "")
                .split(" ")
                .splice(0, 10)
                .join(" ");
        }
        return response;
    }
    ak_sanatize_html(text) {
        return text.replace(/<[^>]*>/g, '');
    }
    validateDatesConditions(requirement) {
        if (!isNullOrUndefined(requirement.showDateOfIssue) || !isNullOrUndefined(requirement.showExpirationDate)) {
            if (requirement.showDateOfIssue === true || requirement.showExpirationDate === true) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }
}
/** @nocollapse */ RequirementDetailComponent.ɵfac = function RequirementDetailComponent_Factory(t) { return new (t || RequirementDetailComponent)(ɵɵdirectiveInject(DatePipe), ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(RequirementsService), ɵɵdirectiveInject(ErrorService), ɵɵdirectiveInject(LocalService), ɵɵdirectiveInject(SwalPortalTargets)); };
/** @nocollapse */ RequirementDetailComponent.ɵcmp = ɵɵdefineComponent({ type: RequirementDetailComponent, selectors: [["akeela-requirement-detail"]], hostBindings: function RequirementDetailComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("scroll", function RequirementDetailComponent_scroll_HostBindingHandler($event) { return ctx.doSomethingOnWindowsScroll($event); });
    } }, inputs: { requirement: "requirement", config: "config", requirements: "requirements" }, outputs: { close: "close", open: "open", showFile: "showFile", response: "response", finishupload: "finishupload", updatefiles: "updatefiles" }, decls: 6, vars: 5, consts: [[3, "showCloseButton", "showConfirmButton"], ["swaldates", ""], [4, "swalPortal"], [2, "display", "none"], ["id", "idshowdates", 3, "swal"], ["class", "w-100 ", "style", "touch-action: auto !important", 4, "ngIf"], ["class", "text-center", 4, "ngIf"], [1, "text-center"], [3, "files", "transactionrequirement", "type", "file", "config"], [1, "w-100", 2, "touch-action", "auto !important"], [1, "p-3"], [1, "description-3text-center", "font-weight-bold", "pr-2", "w-100", "mb-4"], [3, "innerHTML"], [1, "w-100", 2, "font-size", "14px"], [4, "ngIf"], [1, "active-cursor", "d-flex", "justify-content-start", "des-rq", 3, "click"], ["class", "pt-2", "style", "min-width:90px;", 4, "ngIf"], [1, "pt-2", 2, "min-width", "90px"], [1, "pl-2", "text-primary", "active-cursor"], [4, "ngTemplateOutlet"], [1, "mb-3", 3, "window.scroll"], [1, ""], [1, "mt-4"], [1, "mt-2", "mb-4"], [3, "files", "config", "transactionrequirement", "requirement", "lista", "readOnly", "showFile", 4, "ngIf"], ["class", "pt-2 pb-2", "style", "cursor: pointer;text-decoration: underline", 3, "click", 4, "ngIf"], ["class", "pt-2 pb-2", "style", "cursor: pointer; text-decoration: underline", 3, "click", 4, "ngIf"], [1, "fs-label-requirements", 3, "innerHTML"], [3, "response", "config", 4, "ngIf"], [3, "response", "config"], [4, "ngFor", "ngForOf"], [3, "files", "config", "transactionrequirement", "requirement", "lista", "readOnly", "showFile"], [1, "pt-2", "pb-2", 2, "cursor", "pointer", "text-decoration", "underline", 3, "click"], ["style", "height:30px", "class", "w-100 progress", 4, "ngIf"], [1, "w-100", "progress", 2, "height", "30px"], ["role", "progressbar", "aria-valuenow", "0", "aria-valuemin", "0", "aria-valuemax", "100", 1, "progress-bar", "progress-bar-striped"], [1, "d-none"], [3, "config", "type", "identifier", "response", 4, "ngIf"], [3, "config", "type", "identifier", "response"], [3, "transactionrequirement", "transactionNumber", "requirement", "nextCreditId", "config", "transactionrequirementresponse"], [1, "col-12"], ["src", "/assets/public/images/loading.gif", "alt", ""]], template: function RequirementDetailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "swal", 0, 1);
        ɵɵtemplate(2, RequirementDetailComponent_ng_container_2_Template, 3, 1, "ng-container", 2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", 3);
        ɵɵelement(4, "a", 4);
        ɵɵelementEnd();
        ɵɵtemplate(5, RequirementDetailComponent_div_5_Template, 10, 7, "div", 5);
    } if (rf & 2) {
        const _r0 = ɵɵreference(1);
        ɵɵproperty("showCloseButton", true)("showConfirmButton", false);
        ɵɵadvance(2);
        ɵɵproperty("swalPortal", ctx.swalTargets.content);
        ɵɵadvance(2);
        ɵɵproperty("swal", _r0);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx._config);
    } }, directives: [SwalComponent, SwalPortalDirective, SwalDirective, NgIf, RequirementDatesComponent, NgTemplateOutlet, IndividualResponseComponent, NgForOf, TableFilesComponent, InputUploadFileFlexComponent, ResponseIndividualRequirementComponent], pipes: [I18nPipe], styles: [".box[_ngcontent-%COMP%]{background-color:#fff;box-shadow:0 2px 4px 0 hsla(0,0%,91.8%,.5);color:#4a4a4a;margin-left:auto;margin-right:auto;max-height:90vh!important}box_scroll[_ngcontent-%COMP%]{min-height:1px;overflow-y:auto}.box-button[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto}.bg-gray[_ngcontent-%COMP%]{background-color:#f5f7fa;min-height:auto}@media (max-width:768px){.box[_ngcontent-%COMP%]{font-size:1rem!important}.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}@media (max-width:992px){.box[_ngcontent-%COMP%], .box-button[_ngcontent-%COMP%]{width:auto!important}}.caret-down[_ngcontent-%COMP%]{color:#e2e2e4;font-size:3rem;line-height:.7rem}.m-b-1[_ngcontent-%COMP%]{margin-bottom:1rem}.m-b-3[_ngcontent-%COMP%]{margin-bottom:3rem}.m-b-2[_ngcontent-%COMP%]{margin-bottom:2rem}.m-t-2[_ngcontent-%COMP%]{margin-top:2rem}.m-t-3[_ngcontent-%COMP%]{margin-top:3rem}.p-t-0[_ngcontent-%COMP%]{padding-top:0}.p-b-2[_ngcontent-%COMP%]{padding-bottom:2rem}@media (max-width:768px){.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}.text-size-1[_ngcontent-%COMP%]{font-size:.5rem}.text-size-2[_ngcontent-%COMP%]{font-size:2rem}.text-size-3[_ngcontent-%COMP%]{font-size:1rem}@media (min-width:1200px){.container[_ngcontent-%COMP%]{max-width:960px}}.box-2[_ngcontent-%COMP%], .box-3[_ngcontent-%COMP%]{text-align:center}.box-2[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #ccc;font-size:3rem;height:70px;margin-left:auto;margin-right:auto;margin-top:-50px;width:69px}.fz-title[_ngcontent-%COMP%]{font-size:1.5rem}.bt2black[_ngcontent-%COMP%]{border-top:1px solid #000}.bt2gray[_ngcontent-%COMP%]{border-top:1px solid #ccc}.termsAndConditions[_ngcontent-%COMP%]{color:#777;font-size:.75rem}.color-white[_ngcontent-%COMP%]{color:transparent}.color-yellow[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-incomplete)}.color-orange[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-warning)}.color-purple[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-inconsistent)}.color-blue[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-success)}.color-red[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-error)}.color-green[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-success)}.color-gray-light[_ngcontent-%COMP%]{color:#ccc}.color-a4a4a4[_ngcontent-%COMP%]{color:#4a4a4a}.section-title[_ngcontent-%COMP%]{font-size:.7rem}.Button--secondary[_ngcontent-%COMP%]:not(.Button--disabled){background:#fff;color:#646f79;fill:#848f99}.Button.Button--small[_ngcontent-%COMP%]{height:30px;line-height:30px;padding:0 9px}.Button[_ngcontent-%COMP%]{align-items:center;border-radius:4px;border-style:solid;border-width:1px;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-size:13px;justify-content:center;line-height:1;min-width:50px;text-align:center;transition-duration:.2s;transition-property:background,border,box-shadow,color,fill}.border-red[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-error)}.border-green[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-success)}.border-purple[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-inconsistent)}.border-yellow[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-incomplete)}.border-orange[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-warning)}.badge-gray-light[_ngcontent-%COMP%]{background-color:#bdbdbd;color:#fff}.nav[_ngcontent-%COMP%]{align-items:center;border-radius:5 5 0 0;display:block;flex-wrap:nowrap;height:50px;list-style:none;margin-bottom:0}.nav-item[_ngcontent-%COMP%]{margin-right:1.8rem;padding-top:3px}.nav-item[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{background:var(--ak-step-nav-link-background);border:1px solid var(--ak-step-nav-link-borderColor);border-radius:3rem;color:var(--ak-step-nav-link-color);font-size:.9rem;margin-top:5px;padding:3px 15px}.nav-item.active[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{background:var(--ak-step-nav-link-backgroundActive)}.nav-item[_ngcontent-%COMP%]   .nav-link.bg-disabled[_ngcontent-%COMP%]{background:#ddd!important}.ModalLayer[_ngcontent-%COMP%]{align-items:center;bottom:0;display:flex;flex-direction:column;left:0;position:fixed;right:0;top:0;z-index:10000}.Carousel-leftButtonContainer[_ngcontent-%COMP%]{left:45px}.Carousel-rightButtonContainer[_ngcontent-%COMP%]{right:55px}@media (max-width:576px){.Carousel-leftButtonContainer[_ngcontent-%COMP%], .Carousel-rightButtonContainer[_ngcontent-%COMP%]{border-color:transparent;position:relative}.Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-leftButton[_ngcontent-%COMP%], .Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-rightButton[_ngcontent-%COMP%]{border-color:transparent}.CircularButton--circular[_ngcontent-%COMP%]{border:0 solid #fff}}.Carousel-leftButtonContainer[_ngcontent-%COMP%], .Carousel-rightButtonContainer[_ngcontent-%COMP%]{align-items:center;bottom:0;cursor:pointer;display:flex;flex-direction:column;height:100vh;justify-content:center;position:absolute;top:0;z-index:10331}.center-vertical[_ngcontent-%COMP%]{align-items:center;height:100vh}.Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-leftButton[_ngcontent-%COMP%], .Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-rightButton[_ngcontent-%COMP%]{border-color:grey;color:grey;filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}.Carousel-leftButtonContainer[_ngcontent-%COMP%]:hover, .Carousel-rightButtonContainer[_ngcontent-%COMP%]:hover{border-color:var(--ak-color-2);color:var(--ak-color-2)}.CircularButton.CircularButton--medium[_ngcontent-%COMP%]{height:45px;width:45px}.Carousel-leftButton[_ngcontent-%COMP%], .Carousel-rightButton[_ngcontent-%COMP%]{box-shadow:0 5px 20px 0 rgba(21,27,38,.08)}.CircularButton--circular[_ngcontent-%COMP%]{background:#fff;border:1px solid #b7bfc6;border-radius:50%;box-sizing:border-box;color:#848f99;fill:#848f99;flex:0 0 auto;font-size:13px;height:30px;line-height:1;transition:box-shadow .2s,color .2s,background .2s,fill .2s,border-color .2s;width:30px}.CircularButton[_ngcontent-%COMP%]{align-items:center;display:inline-flex;justify-content:center}a[_ngcontent-%COMP%]{color:#14aaf5;cursor:pointer;text-decoration:none}.AttachmentMetadataBar[_ngcontent-%COMP%]{align-items:center;background-color:#000;border-bottom:1px solid rgba(100,111,121,.4);color:#fff;display:flex;flex:0 0 auto;font-size:16px;font-weight:400;line-height:20px}.AttachmentsCarousel[_ngcontent-%COMP%]{background-color:#0c0c0c;display:flex;flex:1 1 auto;flex-direction:column;min-height:1px;min-width:1px;width:100%}.CloseButton[_ngcontent-%COMP%]{align-items:center;display:inline-flex;fill:#848f99}.AttachmentImageWithRotation[_ngcontent-%COMP%]{align-items:center;box-sizing:border-box;display:flex;flex-direction:column;height:100%;justify-content:center;position:relative;width:100%}.AttachmentImageWithRotation-image[_ngcontent-%COMP%]{background-color:#fff;flex:0 1 auto;max-height:100%;max-width:100%;min-height:1px;width:auto}.AttachmentsCarousel-previewImage.AttachmentsCarouselSlide[_ngcontent-%COMP%]{border-left-width:65px;border-right-width:65px}.AttachmentsCarouselSlide[_ngcontent-%COMP%]{background:#000}.Carousel-child[_ngcontent-%COMP%]{height:100%;left:0;position:absolute;top:0;width:100%}.AttachmentsCarouselPlaceholder-nonImagePlaceholder[_ngcontent-%COMP%]{align-items:center;color:#fff;display:flex;flex-direction:column}.AttachmentMetadataBar-left[_ngcontent-%COMP%]{align-items:center;display:flex;flex:1 1 auto;justify-content:space-between;margin-right:20px;min-width:1px}.AttachmentMetadataBar-attachmentDetails[_ngcontent-%COMP%]{display:flex;flex:1 1 auto;flex-direction:column;margin-left:20px;margin-right:20px;min-width:1px}.AttachmentMetadataBar-attachmentName[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.AttachmentMetadataBar-attachmentCreatedTime[_ngcontent-%COMP%]{color:#848f99}.AttachmentMetadataBar-attachmentButtons[_ngcontent-%COMP%]{display:flex;flex-direction:row}.AttachmentMetadataBar-closeButton[_ngcontent-%COMP%]   .Icon[_ngcontent-%COMP%]{height:24px;width:24px}.AttachmentMetadataBar-closeButton[_ngcontent-%COMP%]{fill:#fff;opacity:.5}.AttachmentMetadataBar-annotateIcon[_ngcontent-%COMP%], .AttachmentMetadataBar-downloadIcon[_ngcontent-%COMP%]{flex:0 0 auto;margin-right:10px}.Icon[_ngcontent-%COMP%]{height:16px;width:16px}foreignObject[_ngcontent-%COMP%], image[_ngcontent-%COMP%], marker[_ngcontent-%COMP%], pattern[_ngcontent-%COMP%], svg[_ngcontent-%COMP%]:not(:root), symbol[_ngcontent-%COMP%], user[_ngcontent-%COMP%]   agent[_ngcontent-%COMP%]   stylesheet[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]:not(:root){overflow:hidden}.Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-leftButton[_ngcontent-%COMP%], .Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-rightButton[_ngcontent-%COMP%]{background:transparent;border-color:#fff;color:#fff;fill:#fff}.AttachmentMetadataBar-right[_ngcontent-%COMP%]{align-items:center;border-left:1px solid rgba(100,111,121,.4);display:flex;flex:0 0 auto;height:60px;justify-content:center;width:60px}.AttachmentsCarousel-carouselContainer[_ngcontent-%COMP%]{display:flex;flex:1 1 auto;flex-direction:row;min-height:1px}.AttachmentsCarousel-carousel[_ngcontent-%COMP%]{flex:1 1 auto;min-width:1px}.Carousel[_ngcontent-%COMP%]{overflow:hidden;position:relative;z-index:100}.AttachmentsCarousel-previewImage[_ngcontent-%COMP%]{border-left-width:65px;border-right-width:65px}.AttachmentsCarouselSlide[_ngcontent-%COMP%]{align-items:center;border:20px solid transparent;box-sizing:border-box;display:flex;flex-direction:column;justify-content:center}.AttachmentMetadataBar-downloadLink[_ngcontent-%COMP%], .AttachmentMetadataBar-openOriginalLink[_ngcontent-%COMP%], .AttachmentMetadataBar-proofingToggle[_ngcontent-%COMP%]{align-items:center;border-radius:4px;color:#fff;display:flex;fill:#fff;flex:0 0 auto;height:40px;margin-right:15px;padding:0 10px;white-space:nowrap}.SingleTaskPaneSpreadsheet-header[_ngcontent-%COMP%]{background:#fff;flex-shrink:0}.SingleTaskPaneToolbar[_ngcontent-%COMP%]{height:80px}.SingleTaskPaneToolbar-button[_ngcontent-%COMP%]{flex-shrink:0;height:80px;margin-left:4px}.SingleTaskPaneToolbarAnimation-row[_ngcontent-%COMP%]{align-items:flex-end;box-sizing:border-box;display:flex;height:40px;max-width:10000px;opacity:1;overflow:hidden;padding-left:2px;transition:opacity .2s ease-in}.SingleTaskPaneToolbarAnimation[_ngcontent-%COMP%]{flex-grow:1;height:80px;margin-right:16px;min-width:1px;overflow-y:hidden;width:100%}.SingleTaskPaneToolbarAnimation-title[_ngcontent-%COMP%]{cursor:pointer;flex-grow:1;font-size:16px;line-height:56px;overflow:hidden;padding:28px 0;text-overflow:ellipsis;white-space:nowrap}.inline[_ngcontent-%COMP%]{float:left}.description[_ngcontent-%COMP%]{font-size:1rem}.description-2[_ngcontent-%COMP%]{font-size:14px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:40px}.img-folder[_ngcontent-%COMP%]{width:30px}@media (max-width:768px){.description[_ngcontent-%COMP%]{font-size:15px}.box-rq-detail[_ngcontent-%COMP%]{max-height:60vh!important;overflow-y:scroll}.description-2[_ngcontent-%COMP%]{font-size:13px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:30px!important}.img-folder[_ngcontent-%COMP%]{width:26px}}.box-rq-detail[_ngcontent-%COMP%]{max-height:73vh;overflow-y:scroll}.contex[_ngcontent-%COMP%]{padding-top:20px}@media (max-width:768px){.contex[_ngcontent-%COMP%]{height:90vh!important;padding-top:0}}.ak-text-req-name[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.min-h[_ngcontent-%COMP%]{height:32px}.des-rq[_ngcontent-%COMP%]{background:#f3f3f3;border-radius:10px;color:#444}.fz-14[_ngcontent-%COMP%]{font-size:14px}.bobillo[_ngcontent-%COMP%]{width:50px}.blink_me[_ngcontent-%COMP%]{-webkit-animation:blinker 2s linear infinite;animation:blinker 2s linear infinite}@-webkit-keyframes blinker{50%{opacity:0}}@keyframes blinker{50%{opacity:0}}.description-3[_ngcontent-%COMP%]{font-size:18px!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RequirementDetailComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-requirement-detail',
                templateUrl: './requirement-detail.component.html',
                styleUrls: ['./requirement-detail.component.css']
            }]
    }], function () { return [{ type: DatePipe }, { type: AkeelaTemplateService }, { type: ElementRef }, { type: HttpService }, { type: I18nPipe }, { type: UploadService }, { type: RequirementsService }, { type: ErrorService }, { type: LocalService }, { type: SwalPortalTargets }]; }, { requirement: [{
            type: Input
        }], config: [{
            type: Input
        }], requirements: [{
            type: Input
        }], close: [{
            type: Output
        }], open: [{
            type: Output
        }], showFile: [{
            type: Output
        }], response: [{
            type: Output
        }], finishupload: [{
            type: Output
        }], updatefiles: [{
            type: Output
        }], doSomethingOnWindowsScroll: [{
            type: HostListener,
            args: ['scroll', ['$event']]
        }] }); })();

function ConsiderationsComponent_ng_container_0_div_1_hr_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "hr");
} }
function ConsiderationsComponent_ng_container_0_div_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "div", 5);
    ɵɵpipe(2, "i18n");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const consideration_r4 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, consideration_r4), ɵɵsanitizeHtml);
} }
function ConsiderationsComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 2);
    ɵɵelement(1, "span", 3);
    ɵɵpipe(2, "i18n");
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, ConsiderationsComponent_ng_container_0_div_1_hr_4_Template, 1, 0, "hr", 0);
    ɵɵtemplate(5, ConsiderationsComponent_ng_container_0_div_1_ng_container_5_Template, 3, 3, "ng-container", 4);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ctx_r1.general ? ɵɵpipeBind1(2, 3, "@i18n-text-considerations-general") : ɵɵpipeBind1(3, 5, "@i18n-text-considerations"), ɵɵsanitizeHtml);
    ɵɵadvance(3);
    ɵɵproperty("ngIf", ctx_r1.general);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r1.considerations);
} }
function ConsiderationsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ConsiderationsComponent_ng_container_0_div_1_Template, 6, 7, "div", 1);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.considerations.length > 0);
} }
class ConsiderationsComponent {
    constructor() {
        this.considerations = [];
        this.general = false;
    }
    ngOnInit() {
    }
}
/** @nocollapse */ ConsiderationsComponent.ɵfac = function ConsiderationsComponent_Factory(t) { return new (t || ConsiderationsComponent)(); };
/** @nocollapse */ ConsiderationsComponent.ɵcmp = ɵɵdefineComponent({ type: ConsiderationsComponent, selectors: [["akeela-considerations"]], inputs: { considerations: "considerations", general: "general" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["class", "c-alert c-alert-bg-gray", "role", "alert", 4, "ngIf"], ["role", "alert", 1, "c-alert", "c-alert-bg-gray"], [1, "font-weight-bold", 3, "innerHTML"], [4, "ngFor", "ngForOf"], [2, "padding-top", "12px", 3, "innerHTML"]], template: function ConsiderationsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, ConsiderationsComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.considerations);
    } }, directives: [NgIf, NgForOf], pipes: [I18nPipe], styles: [".c-alert[_ngcontent-%COMP%]{font-size:.9rem;margin-bottom:1rem;padding:.75rem 1.25rem;position:relative}.c-alert-bg-gray[_ngcontent-%COMP%]{background-color:#f4f1f1}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ConsiderationsComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-considerations',
                templateUrl: './considerations.component.html',
                styleUrls: ['./considerations.component.css']
            }]
    }], function () { return []; }, { considerations: [{
            type: Input
        }], general: [{
            type: Input
        }] }); })();

const _c0$3 = function (a0) { return { identifier: a0 }; };
function ResponseComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "option", 13);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const statu_r4 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngValue", ɵɵpureFunction1(2, _c0$3, statu_r4.identifier));
    ɵɵadvance(1);
    ɵɵtextInterpolate(statu_r4.name);
} }
function ResponseComponent_div_16_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 11);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r5.lang), ɵɵsanitizeHtml);
} }
function ResponseComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 14);
    ɵɵtemplate(1, ResponseComponent_div_16_div_1_Template, 2, 4, "div", 15);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.form.get("response").errors["required"] && !ctx_r1.form.get("response").pristine);
} }
function ResponseComponent_div_18_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 11);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r7.lang), ɵɵsanitizeHtml);
} }
function ResponseComponent_div_18_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 14);
    ɵɵtemplate(1, ResponseComponent_div_18_div_7_div_1_Template, 2, 4, "div", 15);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r6.form.get("observation").errors["required"] && !ctx_r6.form.get("observation").pristine);
} }
const _c1$1 = function (a0) { return { "error": a0 }; };
function ResponseComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 16);
    ɵɵelementStart(2, "label");
    ɵɵtext(3);
    ɵɵpipe(4, "i18n");
    ɵɵelementEnd();
    ɵɵelementStart(5, "textarea", 17);
    ɵɵtext(6, "      ");
    ɵɵelementEnd();
    ɵɵtemplate(7, ResponseComponent_div_18_div_7_Template, 2, 1, "div", 7);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate(ɵɵpipeBind1(4, 3, "@collections-text-comment"));
    ɵɵadvance(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(5, _c1$1, ctx_r2.form.controls.observation.invalid && ctx_r2.form.controls.observation.dirty));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r2.form.get("observation").errors);
} }
function ResponseComponent_span_26_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵelement(1, "i", 18);
    ɵɵelementEnd();
} }
class ResponseComponent {
    constructor(formBuilder, _error, _router, _i18n, _upload, _httpService) {
        this.formBuilder = formBuilder;
        this._error = _error;
        this._router = _router;
        this._i18n = _i18n;
        this._upload = _upload;
        this._httpService = _httpService;
        this.responsetransaction = new EventEmitter();
        this.submit_disabled = false;
        this.incomplete = false;
        this.dropdownList = [];
        this.selectedItems = [];
        this.listTransactionStatus = null;
        this.dropdownSettings = {};
        this.nextLoanOrCreditStatus = null;
        this.itemsSelected = [];
        this.arrayCreditStatus = [];
        this.conditioned = false;
    }
    ngOnInit() {
        setTimeout(() => {
            this.form = this.formBuilder.group(({
                'response': new FormControl('', Validators.required),
                'observation': new FormControl('', [Validators.required]),
                'guarantor': new FormControl('', Validators.required),
            }));
        }, 300);
        // this.form = this.formBuilder.group({
        //   response: ['', Validators.required],
        //   observation: [''],
        //   guarantor: ['']
        // });
        this._httpService.executeRequest(this.config.endpoints.getStatusResponseRequirements.name, this.config.endpoints.getStatusResponseRequirements.params, true).subscribe((response) => {
            this.listTransactionStatus = response;
        });
    }
    objectLength(object) {
        let length = 0;
        // tslint:disable-next-line:forin
        for (const key in object) {
            ++length;
        }
        return length;
    }
    submit() {
        const sectionsIncomplete = [];
        const observation = this.form.get('observation').value;
        const response = (this.form.get('response').value).identifier;
        if (this.form.dirty && this.form.valid) {
            if ((response !== '5' && response !== 5) && (observation === '' || observation === undefined || observation === null)) {
                swal.fire({
                    title: '¡Espere!',
                    html: '<b>Por el tipo de respuesta, es necesario agregar las observaciones.</b>',
                });
            }
            else {
                this.submit_disabled = true;
                const params = this.config.endpoints.saveResponseGlobalRequirements.params;
                params.body.response.identifier = response;
                params.body.responseDescription = observation;
                switch (response) {
                    case '4':
                        params.body.name = 'DS_VERIFIED';
                        break;
                    case '5':
                        params.body.name = 'DS_REJECTED';
                        break;
                    case '6':
                        params.body.name = 'DS_INCOMPLETE';
                        break;
                }
                this._httpService.executeRequest(this.config.endpoints.saveResponseGlobalRequirements.name, params, true).subscribe((resp) => {
                    swal.fire({
                        title: 'Exito',
                        html: '<b>Se ha respondido correctamente.</b>',
                    });
                    this.submit_disabled = false;
                    this.responsetransaction.emit(resp);
                }, error => {
                    if (error.error.name === 'ValidationException') {
                        this._error.show(error, '¡Faltan documentos por válidar!', 'Para dar respuesta al trámite, el trámite debe poseer todos los documentos fisicos (check) y digitales (upload), si ya los recaudos digitales requeridos se encuentran cargados, por favor, verifique los fisicos.');
                    }
                    else {
                        this._error.show(error);
                    }
                    this.submit_disabled = false;
                });
            }
        }
    }
}
/** @nocollapse */ ResponseComponent.ɵfac = function ResponseComponent_Factory(t) { return new (t || ResponseComponent)(ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(ErrorService), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(HttpService)); };
/** @nocollapse */ ResponseComponent.ɵcmp = ɵɵdefineComponent({ type: ResponseComponent, selectors: [["akeela-requirements-response"]], inputs: { transactionrequirement: "transactionrequirement", requirement: "requirement", config: "config" }, outputs: { responsetransaction: "responsetransaction" }, decls: 32, vars: 22, consts: [[1, "bt2gray"], ["novalidate", "", 3, "formGroup", "ngSubmit"], [1, "row"], [1, "col-12", "col-md-12", "col-sm", "col-lg-6"], ["formControlName", "response", 1, "form-control", 3, "ngClass"], ["value", "", "selected", ""], [4, "ngFor", "ngForOf"], ["class", "form-control-feedback help-block", 4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "col-4", "offset-8", "text-right"], ["type", "submit", 1, "btn", "btn-block", "btn-primary", "btn-lg", 3, "disabled"], [3, "innerHTML"], [4, "ngIf"], [3, "ngValue"], [1, "form-control-feedback", "help-block"], [3, "innerHTML", 4, "ngIf"], [1, "col-12"], ["formControlName", "observation", 1, "form-control", 3, "ngClass"], [1, "fa", "fa-refresh", "fa-spin"]], template: function ResponseComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "h5");
        ɵɵtext(1);
        ɵɵpipe(2, "i18n");
        ɵɵelementEnd();
        ɵɵelement(3, "hr", 0);
        ɵɵelement(4, "br");
        ɵɵelementStart(5, "form", 1);
        ɵɵlistener("ngSubmit", function ResponseComponent_Template_form_ngSubmit_5_listener() { return ctx.submit(); });
        ɵɵelementStart(6, "div", 2);
        ɵɵelementStart(7, "div", 3);
        ɵɵelementStart(8, "label");
        ɵɵtext(9);
        ɵɵpipe(10, "i18n");
        ɵɵelementEnd();
        ɵɵelementStart(11, "select", 4);
        ɵɵelementStart(12, "option", 5);
        ɵɵtext(13);
        ɵɵpipe(14, "i18n");
        ɵɵelementEnd();
        ɵɵtemplate(15, ResponseComponent_ng_container_15_Template, 3, 4, "ng-container", 6);
        ɵɵelementEnd();
        ɵɵtemplate(16, ResponseComponent_div_16_Template, 2, 1, "div", 7);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(17, "br");
        ɵɵtemplate(18, ResponseComponent_div_18_Template, 8, 7, "div", 8);
        ɵɵelement(19, "br");
        ɵɵelementStart(20, "div", 2);
        ɵɵelementStart(21, "div", 9);
        ɵɵelementStart(22, "button", 10);
        ɵɵelement(23, "span", 11);
        ɵɵpipe(24, "i18n");
        ɵɵtext(25, "\u00A0 ");
        ɵɵtemplate(26, ResponseComponent_span_26_Template, 2, 0, "span", 12);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(27, "div", 2);
        ɵɵelementStart(28, "div", 9);
        ɵɵelement(29, "br");
        ɵɵelement(30, "br");
        ɵɵelement(31, "br");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵtextInterpolate(ɵɵpipeBind1(2, 11, "@collections-text-responder"));
        ɵɵadvance(4);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(4);
        ɵɵtextInterpolate(ɵɵpipeBind1(10, 13, "@collections-text-response"));
        ɵɵadvance(2);
        ɵɵproperty("ngClass", ɵɵpureFunction1(20, _c1$1, ctx.form.controls.response.invalid && ctx.form.controls.response.dirty));
        ɵɵadvance(2);
        ɵɵtextInterpolate1("--", ɵɵpipeBind1(14, 15, "@collections-text-select"), "--");
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ctx.listTransactionStatus);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.form.get("response").errors);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", !ctx.incomplete && !ctx.conditioned);
        ɵɵadvance(4);
        ɵɵproperty("disabled", !ctx.form.valid || ctx.submit_disabled);
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ɵɵpipeBind2(24, 17, "@i18n-requirements-button-save", ctx.lang), ɵɵsanitizeHtml);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.submit_disabled);
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, SelectControlValueAccessor, NgControlStatus, FormControlName, NgClass, NgSelectOption, ɵangular_packages_forms_forms_x, NgForOf, NgIf, DefaultValueAccessor], pipes: [I18nPipe], styles: [".bt2gray[_ngcontent-%COMP%]{border-top:1px solid #ccc}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ResponseComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-requirements-response',
                templateUrl: './response.component.html',
                styleUrls: ['./response.component.css']
            }]
    }], function () { return [{ type: FormBuilder }, { type: ErrorService }, { type: Router }, { type: I18nPipe }, { type: UploadService }, { type: HttpService }]; }, { transactionrequirement: [{
            type: Input
        }], requirement: [{
            type: Input
        }], config: [{
            type: Input
        }], responsetransaction: [{
            type: Output
        }] }); })();

function RequirementsComponent_ng_template_1_div_0_ng_container_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function RequirementsComponent_ng_template_1_div_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementsComponent_ng_template_1_div_0_ng_container_9_ng_container_1_Template, 1, 0, "ng-container", 19);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵɵnextContext(3);
    const _r1 = ɵɵreference(3);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", _r1);
} }
function RequirementsComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 11);
    ɵɵlistener("click", function RequirementsComponent_ng_template_1_div_0_Template_div_click_0_listener() { ɵɵrestoreView(_r14); const ctx_r13 = ɵɵnextContext(2); return ctx_r13.close_window(); });
    ɵɵelementStart(1, "div", 12);
    ɵɵlistener("click", function RequirementsComponent_ng_template_1_div_0_Template_div_click_1_listener() { ɵɵrestoreView(_r14); const ctx_r15 = ɵɵnextContext(2); return ctx_r15.close_window(); });
    ɵɵelementStart(2, "div", 13);
    ɵɵlistener("click", function RequirementsComponent_ng_template_1_div_0_Template_div_click_2_listener($event) { ɵɵrestoreView(_r14); return $event == null ? null : $event.stopPropagation(); });
    ɵɵelementContainerStart(3);
    ɵɵelementStart(4, "div", 14);
    ɵɵelementStart(5, "div", 15);
    ɵɵlistener("click", function RequirementsComponent_ng_template_1_div_0_Template_div_click_5_listener() { ɵɵrestoreView(_r14); const ctx_r17 = ɵɵnextContext(2); return ctx_r17.close_window(); });
    ɵɵelement(6, "i", 16);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 17);
    ɵɵelementStart(8, "div", 18);
    ɵɵtemplate(9, RequirementsComponent_ng_template_1_div_0_ng_container_9_Template, 2, 1, "ng-container", 6);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext(2);
    ɵɵadvance(9);
    ɵɵproperty("ngIf", !ctx_r10.show_window_requirement_close);
} }
function RequirementsComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵtemplate(0, RequirementsComponent_ng_template_1_div_0_Template, 10, 1, "div", 10);
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("ngIf", ctx_r0.show_window_requirement);
} }
function RequirementsComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "akeela-requirement-detail", 20);
    ɵɵlistener("showFile", function RequirementsComponent_ng_template_2_Template_akeela_requirement_detail_showFile_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r18 = ɵɵnextContext(); return ctx_r18.show_file($event); })("finishupload", function RequirementsComponent_ng_template_2_Template_akeela_requirement_detail_finishupload_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r20 = ɵɵnextContext(); return ctx_r20.finish_upload($event); })("response", function RequirementsComponent_ng_template_2_Template_akeela_requirement_detail_response_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r21 = ɵɵnextContext(); return ctx_r21.emit_response($event); })("updatefiles", function RequirementsComponent_ng_template_2_Template_akeela_requirement_detail_updatefiles_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r22 = ɵɵnextContext(); return ctx_r22.update_files($event); })("close", function RequirementsComponent_ng_template_2_Template_akeela_requirement_detail_close_0_listener() { ɵɵrestoreView(_r19); const ctx_r23 = ɵɵnextContext(); return ctx_r23.close_window(); })("open", function RequirementsComponent_ng_template_2_Template_akeela_requirement_detail_open_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r24 = ɵɵnextContext(); return ctx_r24.openDocument($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("requirement", ctx_r2.currentRequirement)("requirements", ctx_r2.requirements)("config", ctx_r2._config);
} }
function RequirementsComponent_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function RequirementsComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 21);
    ɵɵtemplate(1, RequirementsComponent_div_5_ng_container_1_Template, 1, 0, "ng-container", 19);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r3.templates["requirementsHeaderContent"]);
} }
function RequirementsComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 22);
    ɵɵelement(2, "img", 23);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 27);
    ɵɵelementStart(1, "div", 28);
    ɵɵelement(2, "div", 29);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement_r29 = ɵɵnextContext().$implicit;
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 1, requirement_r29.index), ɵɵsanitizeHtml);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_5_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 43);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_5_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 44);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_5_hr_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "hr", 45);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_5_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 46);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const row2_r38 = ɵɵnextContext(3).$implicit;
    const ctx_r49 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r49.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r49.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].object == null ? null : ctx_r49.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].object.responseDescription, " ");
} }
const _c0$4 = function (a0, a1) { return { "text-secondary-2": a0, "text-primary": a1 }; };
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 36);
    ɵɵelement(2, "i", 37);
    ɵɵtemplate(3, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_5_i_3_Template, 1, 0, "i", 38);
    ɵɵtemplate(4, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_5_i_4_Template, 1, 0, "i", 39);
    ɵɵelementEnd();
    ɵɵelement(5, "div", 40);
    ɵɵpipe(6, "i18n");
    ɵɵtemplate(7, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_5_hr_7_Template, 1, 0, "hr", 41);
    ɵɵtemplate(8, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_5_div_8_Template, 2, 1, "div", 42);
    ɵɵelementEnd();
} if (rf & 2) {
    const row2_r38 = ɵɵnextContext(2).$implicit;
    const ctx_r42 = ɵɵnextContext(5);
    ɵɵadvance(2);
    ɵɵproperty("ngClass", ɵɵpureFunction2(8, _c0$4, !((ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].status) == "COMPLETED"), (ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].status) == "COMPLETED"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].status) == "COMPLETED" && (!(ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) || (ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) && ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response == "VERIFIED"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response && ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response != "VERIFIED");
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(6, 6, row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.name), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", (ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].object == null ? null : ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].object.responseDescription) && (ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) && (ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) != "VERIFIED");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].object == null ? null : ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].object.responseDescription) && (ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) && (ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r42.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) != "VERIFIED");
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_6_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 50);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_6_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 51);
} }
const _c1$2 = function (a0, a1) { return { "ak-text-req-name ": a0, "animate__animated animate__fadeIn": a1 }; };
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r55 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_6_i_1_Template, 1, 0, "i", 47);
    ɵɵtemplate(2, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_6_i_2_Template, 1, 0, "i", 48);
    ɵɵelementStart(3, "div", 49);
    ɵɵlistener("mouseout", function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_6_Template_div_mouseout_3_listener() { ɵɵrestoreView(_r55); const i_stf_r40 = ɵɵnextContext(2).index; const ctx_r54 = ɵɵnextContext(5); return (ctx_r54.akFocus[i_stf_r40] = false); })("mouseover", function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_6_Template_div_mouseover_3_listener() { ɵɵrestoreView(_r55); const i_stf_r40 = ɵɵnextContext(2).index; const ctx_r57 = ɵɵnextContext(5); return (ctx_r57.akFocus[i_stf_r40] = true); });
    ɵɵpipe(4, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = ɵɵnextContext(2);
    const row2_r38 = ctx_r59.$implicit;
    const i_stf_r40 = ctx_r59.index;
    const ctx_r43 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r43.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r43.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].status) == "COMPLETED" && (!(ctx_r43.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r43.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) || (ctx_r43.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r43.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) && ctx_r43.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response == "VERIFIED"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r43.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] && ctx_r43.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response == "INCOMPLETED");
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction2(6, _c1$2, !ctx_r43.akFocus[i_stf_r40], ctx_r43.akFocus[i_stf_r40]))("innerHTML", ɵɵpipeBind1(4, 4, row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.name), ɵɵsanitizeHtml);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_7_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 58);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_7_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 59);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_7_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 60);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_7_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 61);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_7_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 62);
    ɵɵtext(1, "Adjuntar");
    ɵɵelementEnd();
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_7_i_1_Template, 1, 0, "i", 52);
    ɵɵtemplate(2, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_7_i_2_Template, 1, 0, "i", 53);
    ɵɵtemplate(3, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_7_i_3_Template, 1, 0, "i", 54);
    ɵɵtemplate(4, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_7_i_4_Template, 1, 0, "i", 55);
    ɵɵtemplate(5, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_7_span_5_Template, 2, 0, "span", 56);
    ɵɵelement(6, "div", 57);
    ɵɵpipe(7, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const row2_r38 = ɵɵnextContext(2).$implicit;
    const ctx_r44 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].status) == "COMPLETED" && (!(ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) || (ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) && ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response == "VERIFIED"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] && ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response == "INCOMPLETED");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] && ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response == "REJECTED");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !((ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].status) == "COMPLETED" && (!(ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) || (ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) && ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response == "VERIFIED")));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !((ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].status) == "COMPLETED" && (!(ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) || (ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) && ctx_r44.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response == "VERIFIED")));
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(7, 6, row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.name), ɵɵsanitizeHtml);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 29);
} if (rf & 2) {
    const row2_r38 = ɵɵnextContext(2).$implicit;
    ɵɵproperty("innerHTML", row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.description, ɵɵsanitizeHtml);
} }
const _c2 = function (a0) { return { "selected": a0 }; };
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r69 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 33);
    ɵɵlistener("click", function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_Template_div_click_1_listener() { ɵɵrestoreView(_r69); const row2_r38 = ɵɵnextContext().$implicit; const ctx_r67 = ɵɵnextContext(5); return ctx_r67.open_window(row2_r38.requirement); });
    ɵɵpipe(2, "i18n");
    ɵɵelementStart(3, "div");
    ɵɵelementStart(4, "div", 34);
    ɵɵtemplate(5, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_5_Template, 9, 11, "div", 6);
    ɵɵtemplate(6, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_6_Template, 5, 9, "div", 6);
    ɵɵtemplate(7, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_7_Template, 8, 8, "div", 6);
    ɵɵelementEnd();
    ɵɵtemplate(8, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_div_8_Template, 1, 1, "div", 35);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const row2_r38 = ɵɵnextContext().$implicit;
    const ctx_r41 = ɵɵnextContext(5);
    ɵɵclassMapInterpolate1("col-12 ", ctx_r41.akGrid != 3 ? "col-md-4" : "", "  fz-14 mt-4 ");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1(" active-cursor rq section-box ", ctx_r41.akGrid != 1 ? "h-100" : "", "  p-2 pb-3 pt-3 text-dark");
    ɵɵproperty("ngClass", ɵɵpureFunction1(15, _c2, (ctx_r41.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r41.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].status) == "COMPLETED" && (!(ctx_r41.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r41.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) || (ctx_r41.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier] == null ? null : ctx_r41.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response) && ctx_r41.files[row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.identifier].response == "VERIFIED")))("title", ɵɵpipeBind1(2, 13, row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.name));
    ɵɵadvance(3);
    ɵɵproperty("title", row2_r38 == null ? null : row2_r38.requirement == null ? null : row2_r38.requirement.name);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r41.akGrid == 2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r41.akGrid == 1);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r41.akGrid == 3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r41._config.isDetailEnable);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_div_1_Template, 9, 17, "div", 32);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const row2_r38 = ctx.$implicit;
    const ctx_r37 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r37.viewOptional || ctx_r37.validateRequiredRule(row2_r38 == null ? null : row2_r38.requirement));
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 30);
    ɵɵtemplate(2, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_ng_container_2_Template, 2, 1, "ng-container", 31);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement_r29 = ɵɵnextContext().$implicit;
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", requirement_r29.value);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 65);
    ɵɵpipe(1, "i18n");
    ɵɵpipe(2, "i18n");
} if (rf & 2) {
    const ctx_r72 = ɵɵnextContext(5);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, "@i18n-no-requirements-criteria") + ɵɵpipeBind1(2, 3, ctx_r72._config.filterRequirementsByResponse.state), ɵɵsanitizeHtml);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "div", 63);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_3_div_3_Template, 3, 5, "div", 64);
    ɵɵelement(4, "hr");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r34 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 2, "@i18n-no-requirements"), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r34._config.isFilterRequirementsByResponse);
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_akeela_considerations_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-considerations", 66);
} if (rf & 2) {
    const requirement_r29 = ɵɵnextContext().$implicit;
    const ctx_r35 = ɵɵnextContext(3);
    ɵɵproperty("considerations", ctx_r35.getConsiderations(requirement_r29.index));
} }
function RequirementsComponent_ng_container_9_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 17);
    ɵɵtemplate(1, RequirementsComponent_ng_container_9_ng_container_1_div_1_div_1_Template, 4, 3, "div", 25);
    ɵɵtemplate(2, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_2_Template, 3, 1, "ng-container", 6);
    ɵɵtemplate(3, RequirementsComponent_ng_container_9_ng_container_1_div_1_ng_container_3_Template, 5, 4, "ng-container", 6);
    ɵɵelement(4, "br");
    ɵɵtemplate(5, RequirementsComponent_ng_container_9_ng_container_1_div_1_akeela_considerations_5_Template, 1, 1, "akeela-considerations", 26);
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement_r29 = ctx.$implicit;
    const ctx_r28 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r28.viewOptional || !ctx_r28.viewOptional && (requirement_r29 == null ? null : requirement_r29.contentOblig) == true);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement_r29.value.length > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement_r29.value.length === 0);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r28._config.isEnableConsiderationsByCategory);
} }
function RequirementsComponent_ng_container_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementsComponent_ng_container_9_ng_container_1_div_1_Template, 6, 4, "div", 24);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r26 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r26.requirements);
} }
function RequirementsComponent_ng_container_9_ng_container_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 65);
    ɵɵpipe(1, "i18n");
    ɵɵpipe(2, "i18n");
} if (rf & 2) {
    const ctx_r74 = ɵɵnextContext(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, "@i18n-no-requirements-criteria") + ɵɵpipeBind1(2, 3, ctx_r74._config.filterRequirementsByResponse.state), ɵɵsanitizeHtml);
} }
function RequirementsComponent_ng_container_9_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "div", 63);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, RequirementsComponent_ng_container_9_ng_container_2_div_3_Template, 3, 5, "div", 64);
    ɵɵelement(4, "hr");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r27 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 2, "@i18n-no-requirements"), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r27._config.isFilterRequirementsByResponse);
} }
function RequirementsComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementsComponent_ng_container_9_ng_container_1_Template, 2, 1, "ng-container", 6);
    ɵɵtemplate(2, RequirementsComponent_ng_container_9_ng_container_2_Template, 5, 4, "ng-container", 6);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.requirements.length > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.requirements.length === 0);
} }
function RequirementsComponent_akeela_considerations_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-considerations", 67);
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext();
    ɵɵproperty("considerations", ctx_r6.considerations_plan)("general", true);
} }
function RequirementsComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r76 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 68);
    ɵɵelementStart(1, "div", 17);
    ɵɵelementStart(2, "div", 30);
    ɵɵelementStart(3, "div", 5);
    ɵɵelementStart(4, "akeela-requirements-response", 69);
    ɵɵlistener("responsetransaction", function RequirementsComponent_div_11_Template_akeela_requirements_response_responsetransaction_4_listener($event) { ɵɵrestoreView(_r76); const ctx_r75 = ɵɵnextContext(); return ctx_r75.emit_response_transaction($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("transactionrequirement", ctx_r7.transactionrequirement)("config", ctx_r7._config);
} }
function RequirementsComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r78 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 70);
    ɵɵelementStart(1, "div", 17);
    ɵɵelementStart(2, "div", 30);
    ɵɵelementStart(3, "div", 5);
    ɵɵelementStart(4, "div", 71);
    ɵɵelementStart(5, "div", 72);
    ɵɵlistener("click", function RequirementsComponent_div_12_Template_div_click_5_listener() { ɵɵrestoreView(_r78); const ctx_r77 = ɵɵnextContext(); return ctx_r77.updateDocRecibidoPrepareArray(); });
    ɵɵtext(6, "Guardar Fisicos");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function RequirementsComponent_div_13_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function RequirementsComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 70);
    ɵɵtemplate(1, RequirementsComponent_div_13_ng_container_1_Template, 1, 0, "ng-container", 19);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r9.templates["requirementsFooterContent"]);
} }
class RequirementsComponent {
    constructor(templateService, _httpService, _requerementsService, _upload, _error) {
        this.templateService = templateService;
        this._httpService = _httpService;
        this._requerementsService = _requerementsService;
        this._upload = _upload;
        this._error = _error;
        this._config = null;
        this.showFile = new EventEmitter();
        this.response = new EventEmitter();
        this.open = new EventEmitter();
        this.openWindowRequirement = new EventEmitter(false);
        this.responsetransaction = new EventEmitter(); // en caso de que este activada la respuesta al trámite
        this.responseTransactionChange = new EventEmitter(); // en caso de que este activado el cambio de valor del trámite (caso de incompleto)
        this.finishupload = new EventEmitter();
        this.templates = {};
        this.inputreadonly = false;
        this.readonly = false;
        this.activate_physical_file = false;
        this.selected = null;
        this.requirements = null;
        this.transactionrequirement = null;
        this.files = {};
        this.currentRequirement = null;
        this.show_window_requirement = false;
        this.show_window_requirement_close = true;
        this.activate_save_checkmark = false;
        this.check_doc_physical = [];
        this.submit_disabled = false;
        this.response_active = false;
        this.categories = null;
        this.plans = null;
        this.considerations_plan = null;
        this.animate_init = true;
        this.screenMin = false;
        this.akFocus = {};
        this.akGrid = 3;
        this.initConfig = () => {
            this._upload.resetResponseUpload();
            this.getCategories();
            this.getPlansByProduct();
            this.initFiles();
        };
    }
    set config(value) {
        if (!isNullOrUndefined(value)) {
            console.log('Entrooooooooo');
            console.log(value);
            this._config = value;
            this.initConfig();
        }
    }
    ngOnDestroy() {
        this.close_window();
    }
    ngOnInit() {
        if (screen.width < 768) {
            this.screenMin = true;
        }
        else {
            this.screenMin = false;
        }
        // Versionamiento al cargar un archivo ó al eliminar archivo lógico
        this._upload.getResponseUpload().subscribe((response) => {
            if (response) {
                console.log(response);
                console.log(this._config.isActiveVerifyChangeTransaction);
                console.log(response.body.transaction.identifier);
                if (this._config.isActiveVerifyChangeTransaction === true) {
                    if (String(response.body.transaction.identifier) !== String(this._config.idCurrentTransaction)) {
                        this.responseTransactionChange.emit(response.body.transaction.identifier);
                    }
                }
            }
        });
    }
    getCategories() {
        this._httpService.executeRequest(this._config.endpoints.getCategoriesByPlan.name, this._config.endpoints.getCategoriesByPlan.params, true).subscribe((response) => {
            this.categories = response;
        });
    }
    getPlansByProduct() {
        this._httpService.executeRequest(this._config.endpoints.getPlansByProduct.name, this._config.endpoints.getPlansByProduct.params, true).subscribe((response) => {
            this.plans = response;
            let plan = null;
            let plan_selected = null;
            plan = this.plans.filter((plan) => {
                return plan.identifier === this._config.transactionData.idPlan;
            });
            if (!isNullOrUndefined(plan)) {
                if (plan.length === 1) {
                    plan_selected = (plan[0].personMarkets).filter((pm) => {
                        return pm.audienceType === this._config.transactionData.audience;
                    });
                }
                if (!isNullOrUndefined(plan_selected)) {
                    if (plan_selected[0].alternateName) {
                        this.considerations_plan = Array(plan_selected[0].alternateName);
                    }
                }
            }
        });
    }
    initFiles() {
        this._httpService.executeRequest(this._config.endpoints.getRequirements.name, this._config.endpoints.getRequirements.params, true).subscribe((response) => {
            let requirements = this._requerementsService.format_response(response, this._config);
            for (const row in requirements) {
                let rql = requirements[row];
                for (const row2 in rql.value) {
                    let rq = rql.value[row2];
                    if ((this.validateRequiredRule(rq === null || rq === void 0 ? void 0 : rq.requirement))) {
                        requirements[row]['contentOblig'] = true;
                    }
                }
            }
            this.requirements = requirements;
            this.transactionrequirement = response;
            this.files = this._upload.files[this._config.viewName] = this._requerementsService.loadFileObject(this.requirements, this._config);
            this.check_requirements();
            this.generate_array_doc_physical();
        });
    }
    check_requirements() {
        if (this._config.isResponseActive) {
            this.response_active = this.isCompletedResponses();
        }
        this.response.emit(this._requerementsService.check_requirements(this.requirements, this.files, this._config));
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
    open_window(requirement) {
        if (this.show_window_requirement) {
            setTimeout(() => {
                this.show_window_requirement_close = true;
                this.openWindowRequirement.emit(false);
            }, 0);
            setTimeout(() => {
                this.open_rq(requirement);
            }, 60);
        }
        else {
            this.open_rq(requirement);
        }
    }
    open_rq(requirement) {
        this._upload.resetChangeRequirementById();
        // window.scroll(0, 0);
        this.currentRequirement = requirement;
        // this._requerementsService.setUpdateModalRQ(true);
        this.show_window_requirement = true;
        this.animate_init = false;
        this.show_window_requirement_close = false;
        this.openWindowRequirement.emit(true);
    }
    close_window() {
        setTimeout(() => {
            this.openWindowRequirement.emit(false);
            this.show_window_requirement_close = true;
        }, 600);
        this.show_window_requirement = false;
    }
    openDocument(documentName) {
        this.open.emit(documentName);
    }
    show_file(file) {
        this.showFile.emit(file);
    }
    emit_response(response) {
        this.response.emit(response);
    }
    finish_upload(response) {
        this.finishupload.emit(response);
        this.initFiles();
    }
    emit_response_transaction(event) {
        this.responsetransaction.emit(event);
    }
    generate_array_doc_physical() {
        // tslint:disable-next-line:forin
        for (const index in this.files) {
            this.check_doc_physical[index] = {
                checked: this.files[index].object.consigned,
                consigned: this.files[index].object.consigned,
                object: {}
            };
        }
    }
    update_files($event) {
        this.files = $event;
        // console.log(this.files);
        this.check_requirements();
    }
    isCompletedResponses() {
        for (const index in this.files) {
            if ((isNullOrUndefined(this.files[index].response) || this.files[index].response === this._config.statusResponseRequirement.inconsistent) && this.validateRequiredRule(this.files[index].object.requirement)) {
                return false;
            }
        }
        return true;
    }
    updateDocRecibido(event) {
        this.activate_save_checkmark = true;
        if (event.checked) {
            this.check_doc_physical[event.identifier].checked = !this.check_doc_physical[event.identifier].checked;
        }
        else {
            this.check_doc_physical[event.identifier].checked = false;
        }
    }
    updateDocRecibidoPrepareArray() {
        const object_send = [];
        const object = {};
        this.submit_disabled = true;
        this.activate_save_checkmark = true;
        // tslint:disable-next-line:forin
        for (const index in this.files) {
            if (this.check_doc_physical[index].checked === true && (this.check_doc_physical[index].consigned === false || isNullOrUndefined(this.check_doc_physical[index].consigned))) {
                if (this.files[index].object.identifier !== null) {
                    object_send.push({
                        identifier: this.files[index].object.identifier,
                        consigned: true,
                        consignedUsername: this._config.endpoints.saveRequirementPhysical.format.consignedUsername
                    });
                }
                else {
                    object_send.push({
                        transaction: { identifier: this.files[index].object.transaction.identifier },
                        requirement: { identifier: this.files[index].object.requirement.identifier },
                        person: { identifier: this._config.endpoints.saveRequirementPhysical.format.person.identifier },
                        consigned: true,
                        consignedUsername: this._config.endpoints.saveRequirementPhysical.format.consignedUsername
                    });
                }
            }
            else if (this.check_doc_physical[index].checked === false && this.check_doc_physical[index].consigned === true) {
                if (this.files[index].object.identifier !== null) {
                    object_send.push({
                        identifier: this.files[index].object.identifier,
                        consigned: false,
                        consignedUsername: this._config.endpoints.saveRequirementPhysical.format.consignedUsername
                    });
                }
                else {
                    object_send.push({
                        transaction: { identifier: this.files[index].object.transaction.identifier },
                        requirement: { identifier: this.files[index].object.requirement.identifier },
                        person: { identifier: this._config.endpoints.saveRequirementPhysical.format.person.identifier },
                        consigned: false,
                        consignedUsername: this._config.endpoints.saveRequirementPhysical.format.consignedUsername
                    });
                }
            }
        }
        this._config.endpoints.saveRequirementPhysical.params.body = {
            transactionRequirements: object_send
        };
        this._httpService.executeRequest(this._config.endpoints.saveRequirementPhysical.name, this._config.endpoints.saveRequirementPhysical.params, true).subscribe((response) => {
        }, error => {
            this._error.show(error);
        });
    }
    download_files() {
        this._httpService.executeRequest(this._config.endpoints.downloadAllFilesZip.name, this._config.endpoints.downloadAllFilesZip.params, true).subscribe((response) => {
            if (!isNullOrUndefined(response)) {
                response['action'] = 'downloadzip';
                if (true) {
                    response['deleteAfterShow'] = this._config.endpoints.deleteArchive;
                    response['deleteAfterShow']['params']['body']['identifier'] = response.identifier;
                    // this._httpService.executeRequest(response.deleteAfterShow.name, response.deleteAfterShow.params, true).subscribe((del: any) => {
                    // }, error => {
                    // });
                }
            }
            this.showFile.emit(response);
        }, error => {
            this._error.show(error);
        });
    }
    validateRequiredRule(requirement) {
        return this._requerementsService.validateRequiredRule(this._config, requirement);
    }
    ak_sanatize_html(text) {
        return text.replace(/<[^>]*>/g, '');
    }
    getConsiderations(category) {
        const response = [];
        if (!isNullOrUndefined(this.categories)) {
            response.push(this.categories.filter((cat) => {
                return cat.name === category;
            }));
            if (response.length > 0) {
                return response[0].alternateName;
            }
        }
        return response;
    }
}
/** @nocollapse */ RequirementsComponent.ɵfac = function RequirementsComponent_Factory(t) { return new (t || RequirementsComponent)(ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(RequirementsService), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(ErrorService)); };
/** @nocollapse */ RequirementsComponent.ɵcmp = ɵɵdefineComponent({ type: RequirementsComponent, selectors: [["akeela-requirements"]], inputs: { folder: "folder", viewOptional: "viewOptional", config: "config" }, outputs: { showFile: "showFile", response: "response", open: "open", openWindowRequirement: "openWindowRequirement", responsetransaction: "responsetransaction", responseTransactionChange: "responseTransactionChange", finishupload: "finishupload" }, decls: 14, vars: 7, consts: [["akeelaRequirementsContent", "", "componentName", "requirementsWindowContent"], ["requirement", ""], [1, "animated", "fadeIn"], ["class", "box", 4, "ngIf"], [1, "box", "p-b-1"], [1, "col-12"], [4, "ngIf"], [3, "considerations", "general", 4, "ngIf"], ["class", "box m-t-2  m-b-2 p-b-1 p-t-1", 4, "ngIf"], ["class", "box-transparent m-t-2  m-b-2 p-b-1 p-t-1", 4, "ngIf"], ["class", "ak-form-modal full-modal teme-gray compleat-modal", 3, "click", 4, "ngIf"], [1, "ak-form-modal", "full-modal", "teme-gray", "compleat-modal", 3, "click"], [1, "body", "ml-2", "mr-2", 3, "click"], [1, "container", "bg-white", "mb-2", "radius", 3, "click"], [1, "d-flex", "w-100", "pt-3"], [1, "ml-auto", "text-right", 3, "click"], [1, "fas", "fa-times", 2, "font-size", "1.5rem"], [1, "w-100"], [1, "d-block", "overflow-auto", "pb-5", 2, "max-height", "100%", "background", "#fcfcfc"], [4, "ngTemplateOutlet"], [3, "requirement", "requirements", "config", "showFile", "finishupload", "response", "updatefiles", "close", "open"], [1, "box"], [1, "col-12", "p-t-1", "p-b-1"], ["src", "./assets/public/images/loading.gif", "alt", ""], ["class", "w-100", 4, "ngFor", "ngForOf"], ["class", "font-weight-normal mt-2 mt-4", 4, "ngIf"], [3, "considerations", 4, "ngIf"], [1, "font-weight-normal", "mt-2", "mt-4"], [1, "d-flex", "justify-content-star"], [3, "innerHTML"], [1, "row"], [4, "ngFor", "ngForOf"], [3, "class", 4, "ngIf"], [3, "ngClass", "title", "click"], [3, "title"], [3, "innerHTML", 4, "ngIf"], [1, "mb-1", "mt-2", "text-center"], [1, "fas", "fa-file-alt", "fa-3x", 3, "ngClass"], ["class", "fa fa-check-circle text-success cat-icon2", 4, "ngIf"], ["class", "fa fa-info-circle  text-warning cat-icon2", 4, "ngIf"], [1, "animate__animated", "animate__fadeIn", "pl-2", 3, "innerHTML"], ["class", "p-0 mb-0", 4, "ngIf"], ["class", "p-2 text-dark", "style", "font-size:13px", 4, "ngIf"], [1, "fa", "fa-check-circle", "text-success", "cat-icon2"], [1, "fa", "fa-info-circle", "text-warning", "cat-icon2"], [1, "p-0", "mb-0"], [1, "p-2", "text-dark", 2, "font-size", "13px"], ["class", "text-success fa  fa-check-circle float-right mt-1", 4, "ngIf"], ["class", "fa fa-info-circle text-warning float-right mt-1", 4, "ngIf"], [3, "ngClass", "innerHTML", "mouseout", "mouseover"], [1, "text-success", "fa", "fa-check-circle", "float-right", "mt-1"], [1, "fa", "fa-info-circle", "text-warning", "float-right", "mt-1"], ["class", "text-success fa  fa-check-circle float-left mt-1", 4, "ngIf"], ["class", "fa fa-info-circle text-warning float-left mt-1", 4, "ngIf"], ["class", "fa fa-info-circle text-danger float-left mt-1", 4, "ngIf"], ["class", " far  fa-circle float-left mt-1", "style", "color:#bbb !important", 4, "ngIf"], ["class", "float-right text-primary ml-2 small", 4, "ngIf"], [1, "rc3", "animate__animated", "animate__fadeIn", "pl-2", 3, "innerHTML"], [1, "text-success", "fa", "fa-check-circle", "float-left", "mt-1"], [1, "fa", "fa-info-circle", "text-warning", "float-left", "mt-1"], [1, "fa", "fa-info-circle", "text-danger", "float-left", "mt-1"], [1, "far", "fa-circle", "float-left", "mt-1", 2, "color", "#bbb !important"], [1, "float-right", "text-primary", "ml-2", "small"], [1, "w-100", "text-center", "pt-2", 3, "innerHTML"], ["class", "w-100 text-center", 3, "innerHTML", 4, "ngIf"], [1, "w-100", "text-center", 3, "innerHTML"], [3, "considerations"], [3, "considerations", "general"], [1, "box", "m-t-2", "m-b-2", "p-b-1", "p-t-1"], [3, "transactionrequirement", "config", "responsetransaction"], [1, "box-transparent", "m-t-2", "m-b-2", "p-b-1", "p-t-1"], [1, "col-12", "pull-right", "text-right"], [1, "btn", "btn-primary", "pull-right", 3, "click"]], template: function RequirementsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "akeela-requirements-template");
        ɵɵtemplate(1, RequirementsComponent_ng_template_1_Template, 1, 1, "ng-template", 0);
        ɵɵelementEnd();
        ɵɵtemplate(2, RequirementsComponent_ng_template_2_Template, 1, 3, "ng-template", null, 1, ɵɵtemplateRefExtractor);
        ɵɵelementStart(4, "div", 2);
        ɵɵtemplate(5, RequirementsComponent_div_5_Template, 2, 1, "div", 3);
        ɵɵelementStart(6, "div", 4);
        ɵɵelementStart(7, "div", 5);
        ɵɵtemplate(8, RequirementsComponent_div_8_Template, 3, 0, "div", 6);
        ɵɵelementEnd();
        ɵɵtemplate(9, RequirementsComponent_ng_container_9_Template, 3, 2, "ng-container", 6);
        ɵɵelementEnd();
        ɵɵtemplate(10, RequirementsComponent_akeela_considerations_10_Template, 1, 2, "akeela-considerations", 7);
        ɵɵtemplate(11, RequirementsComponent_div_11_Template, 5, 2, "div", 8);
        ɵɵtemplate(12, RequirementsComponent_div_12_Template, 7, 0, "div", 9);
        ɵɵtemplate(13, RequirementsComponent_div_13_Template, 2, 1, "div", 9);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(5);
        ɵɵproperty("ngIf", ctx._config.showHeaderContent);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.requirements === null || ctx._config === null);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.requirements !== null && ctx._config !== null);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx._config.isEnableConsiderationsByRequirements && ctx.considerations_plan !== null);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx._config.isResponseActive && ctx.response_active && ctx._config.isGlobalResponseActive);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx._config.isPhysicalCheckActive && ctx.activate_save_checkmark && !ctx._config.isReadonlyPhysical);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx._config.showFooterContent);
    } }, directives: [AkeelaRequirementsTemplateComponent, AkeelaRequirementContentDirective, NgIf, NgTemplateOutlet, RequirementDetailComponent, NgForOf, NgClass, ConsiderationsComponent, ResponseComponent], pipes: [I18nPipe], styles: [".box[_ngcontent-%COMP%]{background-color:#fff}.box[_ngcontent-%COMP%], .box-transparent[_ngcontent-%COMP%]{color:#4a4a4a}.box[_ngcontent-%COMP%], .box-button[_ngcontent-%COMP%], .box-transparent[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto}.bg-gray[_ngcontent-%COMP%]{background-color:#f5f7fa;min-height:auto}@media (max-width:768px){.box[_ngcontent-%COMP%]{font-size:1rem!important}.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}@media (max-width:992px){.box[_ngcontent-%COMP%], .box-button[_ngcontent-%COMP%]{width:auto!important}}.caret-down[_ngcontent-%COMP%]{color:#e2e2e4;font-size:3rem;line-height:.7rem}.m-b-1[_ngcontent-%COMP%]{margin-bottom:1rem}.m-b-3[_ngcontent-%COMP%]{margin-bottom:3rem}.m-b-2[_ngcontent-%COMP%]{margin-bottom:2rem}.m-t-2[_ngcontent-%COMP%]{margin-top:2rem}.m-t-3[_ngcontent-%COMP%]{margin-top:3rem}.p-t-0[_ngcontent-%COMP%]{padding-top:0}.p-b-2[_ngcontent-%COMP%]{padding-bottom:2rem}@media (max-width:768px){.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}.text-size-1[_ngcontent-%COMP%]{font-size:.5rem}.box-2[_ngcontent-%COMP%], .box-3[_ngcontent-%COMP%]{text-align:center}.box-2[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #ccc;font-size:3rem;height:70px;margin-left:auto;margin-right:auto;margin-top:-50px;width:69px}.box_1[_ngcontent-%COMP%]{margin-top:25px}.description[_ngcontent-%COMP%]{font-size:1rem}.description-2[_ngcontent-%COMP%]{font-size:14px;line-height:14px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:50px}.img-folder[_ngcontent-%COMP%]{width:30px}@media (max-width:768px){.description[_ngcontent-%COMP%]{font-size:14px}.description-2[_ngcontent-%COMP%]{font-size:13px;line-height:13px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:34px!important}.img-folder[_ngcontent-%COMP%]{width:26px}}.description-label[_ngcontent-%COMP%]{font-size:.875rem}.fz-title[_ngcontent-%COMP%]{font-size:1.5rem}.bt2black[_ngcontent-%COMP%]{border-top:1px solid #000}.termsAndConditions[_ngcontent-%COMP%]{color:#777;font-size:.75rem}.color-white[_ngcontent-%COMP%]{color:transparent}.color-yellow[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-incomplete)}.color-orange[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-warning)}.color-purple[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-inconsistent)}.color-blue[_ngcontent-%COMP%], .color-green[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-success)}.color-red[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-error)}.color-gray-light[_ngcontent-%COMP%]{color:#ccc}.color-black[_ngcontent-%COMP%]{color:#000}.section-title[_ngcontent-%COMP%]{font-size:.7rem}.selected-icon[_ngcontent-%COMP%]{background:#ededed;background:-webkit-gradient(left bottom,right top,color-stop(0,#ededed),color-stop(53%,#f6f6f6),color-stop(100%,#fff));background:linear-gradient(45deg,#ededed,#f6f6f6 53%,#fff);border-radius:10px;cursor:pointer;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ededed\",endColorstr=\"#ffffff\",GradientType=1)}.Button[_ngcontent-%COMP%]{border-radius:4px;transition-duration:.2s;transition-property:background,border,box-shadow,color,fill}.border-red[_ngcontent-%COMP%]{border-color:red}.border-green[_ngcontent-%COMP%]{border-color:green}.Button--secondary[_ngcontent-%COMP%]:not(.Button--disabled){background:#fff;color:#646f79;fill:#848f99}.Button.Button--small[_ngcontent-%COMP%]{height:30px;line-height:30px;padding:0 9px}.Button[_ngcontent-%COMP%]{align-items:center;border-style:solid;border-width:1px;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-size:13px;justify-content:center;line-height:1;min-width:50px;text-align:center}.color-blue[_ngcontent-%COMP%]{background-color:#007bff;color:#fff}.color-gray[_ngcontent-%COMP%]{background-color:#d8d8d8;border-color:#d8d8d8;color:#000}.border-red[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-error)}.border-green[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-success)}.border-purple[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-inconsistent)}.border-yellow[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-incomplete)}.border-orange[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-warning)}.skin-white[_ngcontent-%COMP%]{background-color:#fff}.badge-gray-light[_ngcontent-%COMP%]{background-color:#bdbdbd;color:#fff}.badge-gray[_ngcontent-%COMP%]{background-color:#848f99;color:#fff}.font-light[_ngcontent-%COMP%]{opacity:.7}.font-color-gray[_ngcontent-%COMP%]{color:#bdbdbd}.font-color-black[_ngcontent-%COMP%]{color:#000}.ak-icon-req[_ngcontent-%COMP%]{color:#adb5bd}.ak-text-req-name[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.px-12[_ngcontent-%COMP%]{font-size:12px}.cirecle-status[_ngcontent-%COMP%]{font-size:7px;margin-top:5px;position:absolute}.ak-req-add[_ngcontent-%COMP%]{border-radius:21px;color:#fff;font-size:12px;font-weight:900;height:24px;padding:3px;width:24px}.fz-12[_ngcontent-%COMP%]{font-size:9px}.rq-coments[_ngcontent-%COMP%]{background:#efefef;border-radius:10px;padding:6px 20px}.section-box.rq[_ngcontent-%COMP%]{border:1px solid #fafafa}.section-box.rq[_ngcontent-%COMP%]:hover{background:#fafafa;border:1px solid #d8d8d8}.ak-modal-right[_ngcontent-%COMP%]{background:#fff;box-shadow:0 0 10px -5px #444;height:100%;position:fixed;right:0;width:40%;z-index:999}.fz-14[_ngcontent-%COMP%]{font-size:14px}.cat-icon[_ngcontent-%COMP%]{color:#ccc;font-size:12px;margin-top:5px;padding-right:5px}.cat-icon2[_ngcontent-%COMP%]{background-color:#fff;border-radius:14px;font-size:18px;margin-left:-14px;padding:4px;position:absolute;top:28px}.full-modal[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.5)!important;display:flex;flex:1;flex-direction:column;justify-content:center;overflow:auto;padding:50px 200px;right:0;top:0}@media (max-width:900px){.full-modal[_ngcontent-%COMP%]{padding:0}}.radius[_ngcontent-%COMP%]{border-radius:10px}.full-modal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{background:#fff;box-shadow:0 1px 0 rgba(0,0,0,.10196078);margin-bottom:0;min-height:3.3rem;padding:.7rem;position:static}.full-modal[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]{background-color:transparent;margin-top:0;overflow:auto}.title-section[_ngcontent-%COMP%]{color:var(--ak-color-title-section);margin-top:.3rem}.title-section.selected[_ngcontent-%COMP%]{color:var(--ak-color-title-section-selected)}.text-secondary-2[_ngcontent-%COMP%]{color:#ccc!important}.fz-13[_ngcontent-%COMP%]{font-size:13px}.ptn[_ngcontent-%COMP%]{font-size:12px;position:absolute}.rc3[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.section-box[_ngcontent-%COMP%]{box-shadow:none!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RequirementsComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-requirements',
                templateUrl: './requirements.component.html',
                styleUrls: ['./requirements.component.css']
            }]
    }], function () { return [{ type: AkeelaTemplateService }, { type: HttpService }, { type: RequirementsService }, { type: UploadService }, { type: ErrorService }]; }, { folder: [{
            type: Input
        }], viewOptional: [{
            type: Input
        }], config: [{
            type: Input
        }], showFile: [{
            type: Output
        }], response: [{
            type: Output
        }], open: [{
            type: Output
        }], openWindowRequirement: [{
            type: Output
        }], responsetransaction: [{
            type: Output
        }], responseTransactionChange: [{
            type: Output
        }], finishupload: [{
            type: Output
        }] }); })();

function RequirementDetailUserComponent_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 12);
    ɵɵelement(1, "akeela-requirement-dates", 13);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("files", ctx_r6.files)("transactionrequirement", ctx_r6.transactionrequirement)("type", ctx_r6.sel_type)("file", ctx_r6.sel_file)("config", ctx_r6.config);
} }
function RequirementDetailUserComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "br");
    ɵɵtemplate(2, RequirementDetailUserComponent_ng_container_2_div_2_Template, 2, 5, "div", 11);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r1.requirement);
} }
function RequirementDetailUserComponent_ng_container_11_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 16);
    ɵɵelementStart(1, "span");
    ɵɵtext(2, "...");
    ɵɵelementEnd();
    ɵɵelementStart(3, "span", 17);
    ɵɵtext(4, "Ver m\u00E1s");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function RequirementDetailUserComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 14);
    ɵɵlistener("click", function RequirementDetailUserComponent_ng_container_11_Template_div_click_1_listener() { ɵɵrestoreView(_r9); const ctx_r8 = ɵɵnextContext(); return ctx_r8.descroptionRq = !ctx_r8.descroptionRq; });
    ɵɵelementStart(2, "div");
    ɵɵelement(3, "span", 8);
    ɵɵelementEnd();
    ɵɵtemplate(4, RequirementDetailUserComponent_ng_container_11_div_4_Template, 5, 0, "div", 15);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵclassMapInterpolate1("text-secondary pt-2  ", !ctx_r2.descroptionRq ? "min-h ak-text-req-name " : "", " ");
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ctx_r2.requirement == null ? null : ctx_r2.requirement.description, ɵɵsanitizeHtml);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r2.descroptionRq);
} }
function RequirementDetailUserComponent_ng_container_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function RequirementDetailUserComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailUserComponent_ng_container_12_ng_container_1_Template, 1, 0, "ng-container", 18);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r3.templates["requirementsDetailHeaderContent"]);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_3_ng_container_1_akeela_individual_response_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-individual-response", 26);
} if (rf & 2) {
    const ctx_r19 = ɵɵnextContext(5);
    ɵɵproperty("response", ctx_r19.transactionrequirement)("config", ctx_r19.config);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "span", 24);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_3_ng_container_1_akeela_individual_response_3_Template, 1, 2, "akeela-individual-response", 25);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 2, "@i18n-requirements-version") + " 1.0", ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r18.transactionrequirement && ctx_r18.config && !ctx_r18.lastVersion);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_3_ng_container_1_Template, 4, 4, "ng-container", 10);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r13.transactionrequirement == null ? null : ctx_r13.transactionrequirement.responseDescription) && (ctx_r13.files[ctx_r13.requirement == null ? null : ctx_r13.requirement.identifier].response === ctx_r13.config.enableEspecialUpload.status && ctx_r13.config.enableEspecialUpload.active && !ctx_r13.validateNewFilesUpdated()) && !ctx_r13.lastVersion);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_4_ng_container_1_ng_container_1_akeela_individual_response_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-individual-response", 26);
} if (rf & 2) {
    const history_r22 = ɵɵnextContext().$implicit;
    const ctx_r24 = ɵɵnextContext(5);
    ɵɵproperty("response", history_r22)("config", ctx_r24.config);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_4_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_4_ng_container_1_ng_container_1_akeela_individual_response_1_Template, 1, 2, "akeela-individual-response", 25);
    ɵɵelement(2, "br");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const history_r22 = ctx.$implicit;
    const i_r23 = ctx.index;
    const ctx_r21 = ɵɵnextContext(5);
    ɵɵattribute("data-index", i_r23);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", history_r22 && ctx_r21.config);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_4_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 27);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r20.history_responses);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 10);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r14.transactionrequirement == null ? null : ctx_r14.transactionrequirement.response);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_akeela_table_files_6_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "akeela-table-files", 28);
    ɵɵlistener("showFile", function RequirementDetailUserComponent_ng_container_13_ng_container_2_akeela_table_files_6_Template_akeela_table_files_showFile_0_listener($event) { ɵɵrestoreView(_r27); const ctx_r26 = ɵɵnextContext(3); return ctx_r26.show_file($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵɵnextContext(3);
    ɵɵproperty("files", ctx_r15.files)("config", ctx_r15.config)("transactionrequirement", ctx_r15.transactionrequirement)("requirement", ctx_r15.requirement)("lista", ctx_r15.list)("readOnly", ctx_r15.lastVersion);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_7_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 30);
    ɵɵelementStart(1, "div", 31);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵstyleProp("width", ctx_r28.files[ctx_r28.requirement == null ? null : ctx_r28.requirement.identifier].progress + "%");
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r28.files[ctx_r28.requirement == null ? null : ctx_r28.requirement.identifier].progress, " % ");
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_7_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_7_ng_container_4_akeela_input_upload_file_flex_1_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "akeela-input-upload-file-flex", 33);
    ɵɵlistener("response", function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_7_ng_container_4_akeela_input_upload_file_flex_1_Template_akeela_input_upload_file_flex_response_0_listener($event) { ɵɵrestoreView(_r33); const ctx_r32 = ɵɵnextContext(5); return ctx_r32.notificacion($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = ɵɵnextContext(5);
    ɵɵproperty("config", ctx_r31.config)("type", "button")("identifier", ctx_r31.requirement == null ? null : ctx_r31.requirement.identifier);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_7_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_7_ng_container_4_akeela_input_upload_file_flex_1_Template, 1, 3, "akeela-input-upload-file-flex", 32);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r30 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r30.files[ctx_r30.requirement.identifier].progress === null && !ctx_r30.config.isReadonly && ctx_r30.config.isDigitalUploadActive === true || ctx_r30.validateSpecialApplySpecialCase(ctx_r30.files[ctx_r30.requirement == null ? null : ctx_r30.requirement.identifier].response) && ctx_r30.config.enableEspecialUpload.active || !ctx_r30.config.isReadonly && ctx_r30.config.isDigitalUploadActive);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 20);
    ɵɵtemplate(2, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_7_div_2_Template, 3, 3, "div", 29);
    ɵɵtemplate(3, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_7_ng_container_3_Template, 1, 0, "ng-container", 10);
    ɵɵtemplate(4, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_7_ng_container_4_Template, 2, 1, "ng-container", 10);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = ɵɵnextContext(3);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r16.files[ctx_r16.requirement == null ? null : ctx_r16.requirement.identifier].progress !== null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r16.modeDebug);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r16.files[ctx_r16.requirement == null ? null : ctx_r16.requirement.identifier].progress === null);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_8_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementContainerStart(1);
    ɵɵelementStart(2, "akeela-individual-response-requirement", 34);
    ɵɵlistener("transactionrequirementresponse", function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_8_ng_container_1_ng_container_1_Template_akeela_individual_response_requirement_transactionrequirementresponse_2_listener($event) { ɵɵrestoreView(_r37); const ctx_r36 = ɵɵnextContext(5); return ctx_r36.update_transaction_requirement($event); });
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r35 = ɵɵnextContext(5);
    ɵɵadvance(2);
    ɵɵproperty("transactionrequirement", ctx_r35.transactionrequirement)("transactionNumber", ctx_r35.config.transactionData.transactionNumber)("requirement", ctx_r35.requirement)("nextCreditId", ctx_r35._next)("config", ctx_r35.config);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_8_ng_container_1_ng_container_1_Template, 3, 5, "ng-container", 10);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r34 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r34.config.isResponseActive);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_8_ng_container_1_Template, 2, 1, "ng-container", 10);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r17.list !== null);
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 20);
    ɵɵelementStart(2, "div", 21);
    ɵɵtemplate(3, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_3_Template, 2, 1, "ng-container", 10);
    ɵɵtemplate(4, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_4_Template, 2, 1, "ng-container", 10);
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 22);
    ɵɵtemplate(6, RequirementDetailUserComponent_ng_container_13_ng_container_2_akeela_table_files_6_Template, 1, 6, "akeela-table-files", 23);
    ɵɵelementEnd();
    ɵɵtemplate(7, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_7_Template, 5, 3, "ng-container", 10);
    ɵɵtemplate(8, RequirementDetailUserComponent_ng_container_13_ng_container_2_ng_container_8_Template, 2, 1, "ng-container", 10);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = ɵɵnextContext(2);
    ɵɵadvance(3);
    ɵɵproperty("ngIf", ctx_r11.list);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r11.config.isHistoryResponsesShow);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r11.loaded);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r11.requirement.upload === true && !ctx_r11.lastVersion);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r11.list !== "LOADING");
} }
function RequirementDetailUserComponent_ng_container_13_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 35);
    ɵɵelement(2, "img", 36);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function RequirementDetailUserComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    const _r39 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 19);
    ɵɵlistener("window.scroll", function RequirementDetailUserComponent_ng_container_13_Template_div_window_scroll_1_listener($event) { ɵɵrestoreView(_r39); const ctx_r38 = ɵɵnextContext(); return ctx_r38.doSomethingOnWindowsScroll($event); });
    ɵɵtemplate(2, RequirementDetailUserComponent_ng_container_13_ng_container_2_Template, 9, 5, "ng-container", 10);
    ɵɵtemplate(3, RequirementDetailUserComponent_ng_container_13_ng_container_3_Template, 3, 0, "ng-container", 10);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r4.loaded);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r4.loaded);
} }
function RequirementDetailUserComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 35);
    ɵɵelement(2, "img", 36);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
class RequirementDetailUserComponent {
    constructor(datePipe, templateService, eleRef, _httpService, _i18n, _upload, _requirement, _error, localStorage, swalTargets) {
        this.datePipe = datePipe;
        this.templateService = templateService;
        this.eleRef = eleRef;
        this._httpService = _httpService;
        this._i18n = _i18n;
        this._upload = _upload;
        this._requirement = _requirement;
        this._error = _error;
        this.localStorage = localStorage;
        this.swalTargets = swalTargets;
        this.close = new EventEmitter();
        this.showFile = new EventEmitter();
        this.response = new EventEmitter();
        this.finishupload = new EventEmitter();
        this.updatefiles = new EventEmitter();
        this.templates = {};
        this.list = 'LOADING';
        this.obj_aux = [];
        this.loaded = false;
        this.history_responses = null;
        this.transactionrequirement = null;
        this.transactionrequirementbackup = null;
        this._back = null;
        this._next = null;
        this.sel_requirement = null;
        this.sel_transactionrequirement = null;
        this.sel_type = null;
        this.sel_file = null;
        this.currentdate = new Date();
        this.lastVersion = false;
        this.descroptionRq = false;
        this.modeDebug = false;
    }
    ngOnInit() {
        this.currentdate = this.currentdate.getTime();
        // this.subscription_files_inic = this._requirement.updateModalRQ$.subscribe((updateModalRQ) => {
        // this.ngOnDestroy();
        this._upload.resetChangeRequirementById();
        if (this.localStorage.getItem('modeDebug')) {
            this.modeDebug = this.localStorage.getItem('modeDebug');
        }
        setTimeout(() => {
            if (this.config.isHistoryResponsesShow) {
                this.getRequirementHistory();
            }
            this.getRequirementFiles();
            this._upload.files[this.config.viewName][this.requirement.identifier]['save']['data']['requirement']['identifier'] = this.requirement.identifier;
            this._upload.files[this.config.viewName][this.requirement.identifier]['delete']['data']['requirement']['identifier'] = this.requirement.identifier;
            this.files = this._upload.files[this.config.viewName];
            this.getBackNext();
            this.loaded = true;
            this.check_requirements();
        }, 100);
        this.subscription_change_files = this._upload.getChangresFilesArr().subscribe((files) => {
            this.files = this._upload.files[this.config.viewName];
            this.loaded = true;
            this.check_requirements();
        });
        //  });
        this.subscription_files = this._upload.getChangeRequirementById().subscribe((idRequirement) => {
            // console.log('Se recibe el cambio ' + idRequirement);
            if (idRequirement !== null) {
                //  console.log(idRequirement);
                // se indica que el archivo ya cargo...
                this.finishupload.emit(true);
                this.list = 'LOADING';
                this.requirement = this.getRequirementById(idRequirement);
                if (this.config.isHistoryResponsesShow) {
                    this.getRequirementHistory();
                }
                setTimeout(() => {
                    // console.log('Entra en llamada' + idRequirement);
                    this.getRequirementFiles();
                    //console.log('Sale en llamada' + idRequirement);
                    this._upload.files[this.config.viewName][this.requirement.identifier]['save']['data']['requirement']['identifier'] = this.requirement.identifier;
                    this._upload.files[this.config.viewName][this.requirement.identifier]['delete']['data']['requirement']['identifier'] = this.requirement.identifier;
                    this.files = this._upload.files[this.config.viewName];
                    this.getBackNext();
                    this.loaded = true;
                    this.check_requirements();
                }, 10);
            }
        });
    }
    getLastVersion() {
        this.transactionrequirementbackup = this.transactionrequirement;
        const params = this.config.endpoints.getHistoricRequirement.params;
        params.path.idRequirement = this.requirement.identifier;
        this._httpService.executeRequest(this.config.endpoints.getHistoricRequirement.name, params, true).subscribe((response) => {
            if (response.length > 0) {
                this.transactionrequirement = response[0];
                if (this.transactionrequirement.requirementArchives) {
                    if (this.transactionrequirement.requirementArchives.length > 0) {
                        this.list = this.transactionrequirement.requirementArchives;
                    }
                    else {
                        this._upload.files[this.config.viewName][this.requirement.identifier].status = null;
                        this.updatefiles.emit(this._upload.files[this.config.viewName]);
                        this.list = null;
                    }
                }
                else {
                    this._upload.files[this.config.viewName][this.requirement.identifier].status = null;
                    this.updatefiles.emit(this._upload.files[this.config.viewName]);
                    this.list = null;
                }
            }
            else {
                this._upload.files[this.config.viewName][this.requirement.identifier].status = null;
                this.updatefiles.emit(this._upload.files[this.config.viewName]);
                this.list = null;
            }
        });
    }
    check_requirements() {
        this.response.emit(this._requirement.check_requirements(this.requirements, this.files, this.config));
    }
    update_transaction_requirement(transactionrequirement) {
        if (transactionrequirement) {
            // window.scroll(0, 0);
            this._upload.files[this.config.viewName][this.requirement.identifier].response = transactionrequirement.response;
            // if (this.config.enableEspecialUpload.active) {
            //   if (isNullOrUndefined(transactionrequirement.response) && !isNullOrUndefined(transactionrequirement.responseDescription)) {
            //     if (transactionrequirement.responseDescription.includes('Incompleto')) {
            //       this._upload.files[this.config.viewName][this.requirement.identifier].response = 'INCOMPLETED';
            //     }
            //     if (transactionrequirement.responseDescription.includes('Rechazado')) {
            //       this._upload.files[this.config.viewName][this.requirement.identifier].response = 'REJECTED';
            //     }
            //   }
            // }
            // acá se actualiza el contador de respuestas del user...
            this.updatefiles.emit(this._upload.files[this.config.viewName]);
            this.transactionrequirement = transactionrequirement;
            this.check_requirements();
            this.next(true);
            this.cerrar();
        }
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
    getRequirementFiles() {
        // console.log('Invoco el servicio que solicita los files');
        const params = this.config.endpoints.getRequirement.params;
        params.path.idRequirement = this.requirement.identifier;
        if (this.subscription_files_options) {
            this.subscription_files_options.unsubscribe();
        }
        // console.log('entro inicioo');
        this.subscription_files_options = this._httpService.executeRequest(this.config.endpoints.getRequirement.name, params, true).subscribe((response) => {
            this.list = null;
            this.transactionrequirement = response;
            if (response.requirementArchives && response.requirementArchives.length > 0) {
                // console.log('entro en caso 1');
                // console.log(response.requirementArchives);
                this.list = response.requirementArchives;
            }
            else {
                // console.log('entro en caso 2');
                // console.log(this._upload.files[this.config.viewName]);
                this._upload.files[this.config.viewName][this.requirement.identifier].status = null;
                this.updatefiles.emit(this._upload.files[this.config.viewName]);
                this.list = null;
            }
        }, error => {
            // alert('va por el error');
            this.transactionrequirement = null;
            this._upload.files[this.config.viewName][this.requirement.identifier].status = null;
            this.updatefiles.emit(this._upload.files[this.config.viewName]);
            this.list = null;
        });
    }
    getRequirementHistory() {
        this.history_responses = null;
        const params = this.config.endpoints.getHistoryResponseRequirement.params;
        params.path.idRequirement = this.requirement.identifier;
        this._httpService.executeRequest(this.config.endpoints.getHistoryResponseRequirement.name, params, true).subscribe((history) => {
            this.history_responses = history;
        });
    }
    getRequirementById(identifier) {
        let response = null;
        this.requirements.forEach((element) => {
            element.value.forEach((element2) => {
                if (element2.requirement.identifier.toString() === identifier.toString()) {
                    response = element2.requirement;
                }
            });
        });
        return response;
    }
    getBackNext() {
        this.lastVersion = false;
        let next = null;
        let back = null;
        let case_break = 0;
        const auxiliar = [];
        for (const aux of this.requirements) {
            for (const req of aux.value) {
                auxiliar.push(req.requirement.identifier);
            }
        }
        for (const r of auxiliar) {
            if (case_break < 2) {
                if (parseInt(r, 10) !== parseInt(this.requirement.identifier, 10) && case_break === 0) {
                    back = r;
                }
                else if (parseInt(r, 10) === parseInt(this.requirement.identifier, 10)) {
                    case_break = 1;
                }
                else if (case_break === 1) {
                    next = r;
                    case_break = 2;
                }
            }
        }
        this._next = next;
        this._back = back;
    }
    notificacion(evt) {
        swal.fire({
            title: this._i18n.transform(evt.title),
            text: this._i18n.transform(evt.html),
        });
    }
    validate_expiration(expiration) {
        if (expiration !== null) {
            const date = this.generate_object_date(expiration);
            if (this.currentdate.getTime() > date.getTime()) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    generate_object_date(epoc) {
        return new Date(epoc * 1000);
    }
    next(close) {
        if (this._next) {
            //   window.scroll(0, 0);
            this.loaded = false;
            this._upload.setChangeRequirementById(this._next);
        }
        else {
            if (close) {
                this.cerrar();
            }
        }
    }
    back() {
        // window.scroll(0, 0);
        this.loaded = false;
        this._upload.setChangeRequirementById(this._back);
    }
    cerrar() {
        this.close.emit(true);
    }
    show_file(file) {
        this.showFile.emit(file);
    }
    update_dates(object, type) {
        this.sel_type = type;
        if (type !== 'transaction') {
            this.sel_file = object;
        }
        const box = this.eleRef.nativeElement.querySelector('#idshowdates');
        box.dispatchEvent(new Event('click'));
    }
    ngOnDestroy() {
        if (this.subscription_files) {
            this.subscription_files.unsubscribe();
        }
        if (this.subscription_files_options) {
            this.subscription_files_options.unsubscribe();
        }
        if (this.subscription_change_files) {
            this.subscription_change_files.unsubscribe();
        }
    }
    swipeleft(event) {
        this.next();
    }
    swiperight(event) {
        this.back();
    }
    doSomethingOnWindowsScroll($event) {
        // TODO: MIGRACIÓN
        // this.scrollOffset = $event.srcElement.children[0].scrollTop;
        // console.log('window scroll: ', this.scrollOffset);
    }
    countCurrentElement(identifier) {
        let count = 1;
        for (const element of this.requirements) {
            for (const requirement of element.value) {
                if (requirement.requirement.identifier === identifier) {
                    return count;
                }
                else {
                    count++;
                }
            }
        }
    }
    countRequirements() {
        let count = 0;
        this.requirements.forEach((element) => {
            element.value.forEach((element2) => {
                count++;
            });
        });
        return count;
    }
    validateNewFilesUpdated() {
        for (const row of this.list) {
            if (this.transactionrequirement.responseDate) {
                if (this.transactionrequirement.responseDate.orderDate < row.dateOfThing.startDate) {
                    return true;
                }
            }
        }
        return false;
    }
    changeVersion() {
        this.list = 'LOADING';
        this.lastVersion = !this.lastVersion;
        if (this.lastVersion) {
            this.getLastVersion();
            this.files = this._upload.files[this.config.viewName];
            this.loaded = true;
            this.check_requirements();
        }
        else {
            this.transactionrequirement = this.transactionrequirementbackup;
            this.getRequirementFiles();
            this.files = this._upload.files[this.config.viewName];
            this.loaded = true;
            this.check_requirements();
        }
    }
    download_files_requirement() {
        const params = this.config.endpoints.downloadRequirementFilesZip.params;
        params.request.idTransactionRequirement = this.transactionrequirement.identifier;
        this._httpService.executeRequest(this.config.endpoints.downloadRequirementFilesZip.name, params, true).subscribe((response) => {
            if (!isNullOrUndefined(response)) {
                response['action'] = 'downloadzip';
                if (true) {
                    response['deleteAfterShow'] = this.config.endpoints.deleteArchive;
                    response['deleteAfterShow']['params']['body']['identifier'] = response.identifier;
                }
            }
            this.showFile.emit(response);
        }, error => {
            this._error.show(error);
        });
    }
    time_to_expiration(expiration_date) {
        if (!isNullOrUndefined(expiration_date)) {
            if (expiration_date > 0) {
                return this.calcDate(new Date(), new Date(expiration_date * 1000));
            }
        }
        return '';
    }
    calcDate(date1, date2) {
        const diff = Math.floor(date2.getTime() - date1.getTime());
        const day = 1000 * 60 * 60 * 24;
        const days = Math.floor(diff / day);
        const months = Math.floor(days / 31);
        const years = Math.floor(months / 12);
        let message = '';
        if (years > 0 || months > 0 || days > 0) {
            message += '(';
            if (years > 0) {
                message += years + 'a';
            }
            if (months > 0) {
                message += months + 'm ';
            }
            if (days > 0) {
                message += days + 'd ';
            }
            message += ')';
        }
        else if (years < -1 || months < -1 || days < -1) {
            message = '<span class="text-danger">(Vencido)</span>';
        }
        else {
            message = '';
        }
        return message;
    }
    validateSpecialApplySpecialCase(response) {
        if (!isNullOrUndefined(this.config.enableEspecialUpload)) {
            if (!isNullOrUndefined(this.config.enableEspecialUpload.active)) {
                if (this.config.enableEspecialUpload.active) {
                    for (const status of this.config.enableEspecialUpload.status) {
                        if (status === response) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
    validateRequiredRule(requirement) {
        return this._requirement.validateRequiredRule(this.config, requirement);
    }
    word_count(word) {
        // Obtenemos el texto del campo
        let texto = word;
        // Reemplazamos los saltos de linea por espacios
        texto = texto.replace(/\r?\n/g, " ");
        // Reemplazamos los espacios seguidos por uno solo
        texto = texto.replace(/[ ]+/g, " ");
        // Quitarmos los espacios del principio y del final
        texto = texto.replace(/^ /, "");
        texto = texto.replace(/ $/, "");
        // Troceamos el texto por los espacios
        const textoTroceado = texto.split(" ");
        // Contamos todos los trozos de cadenas que existen
        const numeroPalabras = textoTroceado.length;
        // Mostramos el número de palabras
        return numeroPalabras;
    }
    ak_splice(textoHTML) {
        let response = '';
        if (!isNullOrUndefined(textoHTML)) {
            response = textoHTML
                .replace(/<[^>]*>/g, "")
                .split(" ")
                .splice(0, 10)
                .join(" ");
        }
        return response;
    }
    ak_sanatize_html(text) {
        return text.replace(/<[^>]*>/g, '');
    }
    validateDatesConditions(requirement) {
        if (!isNullOrUndefined(requirement.showDateOfIssue) || !isNullOrUndefined(requirement.showExpirationDate)) {
            if (requirement.showDateOfIssue === true || requirement.showExpirationDate === true) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }
}
/** @nocollapse */ RequirementDetailUserComponent.ɵfac = function RequirementDetailUserComponent_Factory(t) { return new (t || RequirementDetailUserComponent)(ɵɵdirectiveInject(DatePipe), ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(RequirementsService), ɵɵdirectiveInject(ErrorService), ɵɵdirectiveInject(LocalService), ɵɵdirectiveInject(SwalPortalTargets)); };
/** @nocollapse */ RequirementDetailUserComponent.ɵcmp = ɵɵdefineComponent({ type: RequirementDetailUserComponent, selectors: [["akeela-requirement-detail-user"]], hostBindings: function RequirementDetailUserComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("scroll", function RequirementDetailUserComponent_scroll_HostBindingHandler($event) { return ctx.doSomethingOnWindowsScroll($event); });
    } }, inputs: { requirement: "requirement", config: "config", requirements: "requirements" }, outputs: { close: "close", showFile: "showFile", response: "response", finishupload: "finishupload", updatefiles: "updatefiles" }, decls: 15, vars: 11, consts: [[3, "showCloseButton", "showConfirmButton"], ["swaldates", ""], [4, "swalPortal"], [2, "display", "none"], ["id", "idshowdates", 3, "swal"], [1, "w-100", 2, "touch-action", "auto !important"], [1, "p-3"], [1, "description-3text-center", "font-weight-bold", "pr-2", "w-100", "mb-4"], [3, "innerHTML"], [1, "w-100", 2, "font-size", "14px"], [4, "ngIf"], ["class", "text-center", 4, "ngIf"], [1, "text-center"], [3, "files", "transactionrequirement", "type", "file", "config"], [1, "active-cursor", "d-flex", "justify-content-start", "des-rq", 3, "click"], ["class", "pt-2", "style", "min-width:90px;", 4, "ngIf"], [1, "pt-2", 2, "min-width", "90px"], [1, "pl-2", "text-primary", "active-cursor"], [4, "ngTemplateOutlet"], [1, "mb-3", 3, "window.scroll"], [1, ""], [1, "mt-4"], [1, "mt-2", "mb-4"], [3, "files", "config", "transactionrequirement", "requirement", "lista", "readOnly", "showFile", 4, "ngIf"], [1, "fs-label-requirements", 3, "innerHTML"], [3, "response", "config", 4, "ngIf"], [3, "response", "config"], [4, "ngFor", "ngForOf"], [3, "files", "config", "transactionrequirement", "requirement", "lista", "readOnly", "showFile"], ["style", "height:30px", "class", "w-100 progress", 4, "ngIf"], [1, "w-100", "progress", 2, "height", "30px"], ["role", "progressbar", "aria-valuenow", "0", "aria-valuemin", "0", "aria-valuemax", "100", 1, "progress-bar", "progress-bar-striped"], [3, "config", "type", "identifier", "response", 4, "ngIf"], [3, "config", "type", "identifier", "response"], [3, "transactionrequirement", "transactionNumber", "requirement", "nextCreditId", "config", "transactionrequirementresponse"], [1, "col-12"], ["src", "/assets/public/images/loading.gif", "alt", ""]], template: function RequirementDetailUserComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "swal", 0, 1);
        ɵɵtemplate(2, RequirementDetailUserComponent_ng_container_2_Template, 3, 1, "ng-container", 2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", 3);
        ɵɵelement(4, "a", 4);
        ɵɵelementEnd();
        ɵɵelementStart(5, "div", 5);
        ɵɵelementStart(6, "div", 6);
        ɵɵelementStart(7, "div", 7);
        ɵɵelement(8, "span", 8);
        ɵɵpipe(9, "i18n");
        ɵɵelementEnd();
        ɵɵelementStart(10, "div", 9);
        ɵɵtemplate(11, RequirementDetailUserComponent_ng_container_11_Template, 5, 5, "ng-container", 10);
        ɵɵelementEnd();
        ɵɵtemplate(12, RequirementDetailUserComponent_ng_container_12_Template, 2, 1, "ng-container", 10);
        ɵɵtemplate(13, RequirementDetailUserComponent_ng_container_13_Template, 4, 2, "ng-container", 10);
        ɵɵtemplate(14, RequirementDetailUserComponent_ng_container_14_Template, 3, 0, "ng-container", 10);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵɵreference(1);
        ɵɵproperty("showCloseButton", true)("showConfirmButton", false);
        ɵɵadvance(2);
        ɵɵproperty("swalPortal", ctx.swalTargets.content);
        ɵɵadvance(2);
        ɵɵproperty("swal", _r0);
        ɵɵadvance(4);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(9, 9, ctx.requirement == null ? null : ctx.requirement.name), ɵɵsanitizeHtml);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.requirement == null ? null : ctx.requirement.description);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.config.showDetailHeaderContent);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.loaded);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.loaded);
    } }, directives: [SwalComponent, SwalPortalDirective, SwalDirective, NgIf, RequirementDatesComponent, NgTemplateOutlet, IndividualResponseComponent, NgForOf, TableFilesComponent, InputUploadFileFlexComponent, ResponseIndividualRequirementComponent], pipes: [I18nPipe], styles: [".box[_ngcontent-%COMP%]{background-color:#fff;box-shadow:0 2px 4px 0 hsla(0,0%,91.8%,.5);color:#4a4a4a;margin-left:auto;margin-right:auto;max-height:90vh!important}box_scroll[_ngcontent-%COMP%]{min-height:1px;overflow-y:auto}.box-button[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto}.bg-gray[_ngcontent-%COMP%]{background-color:#f5f7fa;min-height:auto}@media (max-width:768px){.box[_ngcontent-%COMP%]{font-size:1rem!important}.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}@media (max-width:992px){.box[_ngcontent-%COMP%], .box-button[_ngcontent-%COMP%]{width:auto!important}}.caret-down[_ngcontent-%COMP%]{color:#e2e2e4;font-size:3rem;line-height:.7rem}.m-b-1[_ngcontent-%COMP%]{margin-bottom:1rem}.m-b-3[_ngcontent-%COMP%]{margin-bottom:3rem}.m-b-2[_ngcontent-%COMP%]{margin-bottom:2rem}.m-t-2[_ngcontent-%COMP%]{margin-top:2rem}.m-t-3[_ngcontent-%COMP%]{margin-top:3rem}.p-t-0[_ngcontent-%COMP%]{padding-top:0}.p-b-2[_ngcontent-%COMP%]{padding-bottom:2rem}@media (max-width:768px){.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}.text-size-1[_ngcontent-%COMP%]{font-size:.5rem}.text-size-2[_ngcontent-%COMP%]{font-size:2rem}.text-size-3[_ngcontent-%COMP%]{font-size:1rem}@media (min-width:1200px){.container[_ngcontent-%COMP%]{max-width:960px}}.box-2[_ngcontent-%COMP%], .box-3[_ngcontent-%COMP%]{text-align:center}.box-2[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #ccc;font-size:3rem;height:70px;margin-left:auto;margin-right:auto;margin-top:-50px;width:69px}.fz-title[_ngcontent-%COMP%]{font-size:1.5rem}.bt2black[_ngcontent-%COMP%]{border-top:1px solid #000}.bt2gray[_ngcontent-%COMP%]{border-top:1px solid #ccc}.termsAndConditions[_ngcontent-%COMP%]{color:#777;font-size:.75rem}.color-white[_ngcontent-%COMP%]{color:transparent}.color-yellow[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-incomplete)}.color-orange[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-warning)}.color-purple[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-inconsistent)}.color-blue[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-success)}.color-red[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-error)}.color-green[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-success)}.color-gray-light[_ngcontent-%COMP%]{color:#ccc}.color-a4a4a4[_ngcontent-%COMP%]{color:#4a4a4a}.section-title[_ngcontent-%COMP%]{font-size:.7rem}.Button--secondary[_ngcontent-%COMP%]:not(.Button--disabled){background:#fff;color:#646f79;fill:#848f99}.Button.Button--small[_ngcontent-%COMP%]{height:30px;line-height:30px;padding:0 9px}.Button[_ngcontent-%COMP%]{align-items:center;border-radius:4px;border-style:solid;border-width:1px;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-size:13px;justify-content:center;line-height:1;min-width:50px;text-align:center;transition-duration:.2s;transition-property:background,border,box-shadow,color,fill}.border-red[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-error)}.border-green[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-success)}.border-purple[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-inconsistent)}.border-yellow[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-incomplete)}.border-orange[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-warning)}.badge-gray-light[_ngcontent-%COMP%]{background-color:#bdbdbd;color:#fff}.nav[_ngcontent-%COMP%]{align-items:center;border-radius:5 5 0 0;display:block;flex-wrap:nowrap;height:50px;list-style:none;margin-bottom:0}.nav-item[_ngcontent-%COMP%]{margin-right:1.8rem;padding-top:3px}.nav-item[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{background:var(--ak-step-nav-link-background);border:1px solid var(--ak-step-nav-link-borderColor);border-radius:3rem;color:var(--ak-step-nav-link-color);font-size:.9rem;margin-top:5px;padding:3px 15px}.nav-item.active[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{background:var(--ak-step-nav-link-backgroundActive)}.nav-item[_ngcontent-%COMP%]   .nav-link.bg-disabled[_ngcontent-%COMP%]{background:#ddd!important}.ModalLayer[_ngcontent-%COMP%]{align-items:center;bottom:0;display:flex;flex-direction:column;left:0;position:fixed;right:0;top:0;z-index:10000}.Carousel-leftButtonContainer[_ngcontent-%COMP%]{left:45px}.Carousel-rightButtonContainer[_ngcontent-%COMP%]{right:55px}@media (max-width:576px){.Carousel-leftButtonContainer[_ngcontent-%COMP%], .Carousel-rightButtonContainer[_ngcontent-%COMP%]{border-color:transparent;position:relative}.Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-leftButton[_ngcontent-%COMP%], .Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-rightButton[_ngcontent-%COMP%]{border-color:transparent}.CircularButton--circular[_ngcontent-%COMP%]{border:0 solid #fff}}.Carousel-leftButtonContainer[_ngcontent-%COMP%], .Carousel-rightButtonContainer[_ngcontent-%COMP%]{align-items:center;bottom:0;cursor:pointer;display:flex;flex-direction:column;height:100vh;justify-content:center;position:absolute;top:0;z-index:10331}.center-vertical[_ngcontent-%COMP%]{align-items:center;height:100vh}.Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-leftButton[_ngcontent-%COMP%], .Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-rightButton[_ngcontent-%COMP%]{border-color:grey;color:grey;filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}.Carousel-leftButtonContainer[_ngcontent-%COMP%]:hover, .Carousel-rightButtonContainer[_ngcontent-%COMP%]:hover{border-color:var(--ak-color-2);color:var(--ak-color-2)}.CircularButton.CircularButton--medium[_ngcontent-%COMP%]{height:45px;width:45px}.Carousel-leftButton[_ngcontent-%COMP%], .Carousel-rightButton[_ngcontent-%COMP%]{box-shadow:0 5px 20px 0 rgba(21,27,38,.08)}.CircularButton--circular[_ngcontent-%COMP%]{background:#fff;border:1px solid #b7bfc6;border-radius:50%;box-sizing:border-box;color:#848f99;fill:#848f99;flex:0 0 auto;font-size:13px;height:30px;line-height:1;transition:box-shadow .2s,color .2s,background .2s,fill .2s,border-color .2s;width:30px}.CircularButton[_ngcontent-%COMP%]{align-items:center;display:inline-flex;justify-content:center}a[_ngcontent-%COMP%]{color:#14aaf5;cursor:pointer;text-decoration:none}.AttachmentMetadataBar[_ngcontent-%COMP%]{align-items:center;background-color:#000;border-bottom:1px solid rgba(100,111,121,.4);color:#fff;display:flex;flex:0 0 auto;font-size:16px;font-weight:400;line-height:20px}.AttachmentsCarousel[_ngcontent-%COMP%]{background-color:#0c0c0c;display:flex;flex:1 1 auto;flex-direction:column;min-height:1px;min-width:1px;width:100%}.CloseButton[_ngcontent-%COMP%]{align-items:center;display:inline-flex;fill:#848f99}.AttachmentImageWithRotation[_ngcontent-%COMP%]{align-items:center;box-sizing:border-box;display:flex;flex-direction:column;height:100%;justify-content:center;position:relative;width:100%}.AttachmentImageWithRotation-image[_ngcontent-%COMP%]{background-color:#fff;flex:0 1 auto;max-height:100%;max-width:100%;min-height:1px;width:auto}.AttachmentsCarousel-previewImage.AttachmentsCarouselSlide[_ngcontent-%COMP%]{border-left-width:65px;border-right-width:65px}.AttachmentsCarouselSlide[_ngcontent-%COMP%]{background:#000}.Carousel-child[_ngcontent-%COMP%]{height:100%;left:0;position:absolute;top:0;width:100%}.AttachmentsCarouselPlaceholder-nonImagePlaceholder[_ngcontent-%COMP%]{align-items:center;color:#fff;display:flex;flex-direction:column}.AttachmentMetadataBar-left[_ngcontent-%COMP%]{align-items:center;display:flex;flex:1 1 auto;justify-content:space-between;margin-right:20px;min-width:1px}.AttachmentMetadataBar-attachmentDetails[_ngcontent-%COMP%]{display:flex;flex:1 1 auto;flex-direction:column;margin-left:20px;margin-right:20px;min-width:1px}.AttachmentMetadataBar-attachmentName[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.AttachmentMetadataBar-attachmentCreatedTime[_ngcontent-%COMP%]{color:#848f99}.AttachmentMetadataBar-attachmentButtons[_ngcontent-%COMP%]{display:flex;flex-direction:row}.AttachmentMetadataBar-closeButton[_ngcontent-%COMP%]   .Icon[_ngcontent-%COMP%]{height:24px;width:24px}.AttachmentMetadataBar-closeButton[_ngcontent-%COMP%]{fill:#fff;opacity:.5}.AttachmentMetadataBar-annotateIcon[_ngcontent-%COMP%], .AttachmentMetadataBar-downloadIcon[_ngcontent-%COMP%]{flex:0 0 auto;margin-right:10px}.Icon[_ngcontent-%COMP%]{height:16px;width:16px}foreignObject[_ngcontent-%COMP%], image[_ngcontent-%COMP%], marker[_ngcontent-%COMP%], pattern[_ngcontent-%COMP%], svg[_ngcontent-%COMP%]:not(:root), symbol[_ngcontent-%COMP%], user[_ngcontent-%COMP%]   agent[_ngcontent-%COMP%]   stylesheet[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]:not(:root){overflow:hidden}.Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-leftButton[_ngcontent-%COMP%], .Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-rightButton[_ngcontent-%COMP%]{background:transparent;border-color:#fff;color:#fff;fill:#fff}.AttachmentMetadataBar-right[_ngcontent-%COMP%]{align-items:center;border-left:1px solid rgba(100,111,121,.4);display:flex;flex:0 0 auto;height:60px;justify-content:center;width:60px}.AttachmentsCarousel-carouselContainer[_ngcontent-%COMP%]{display:flex;flex:1 1 auto;flex-direction:row;min-height:1px}.AttachmentsCarousel-carousel[_ngcontent-%COMP%]{flex:1 1 auto;min-width:1px}.Carousel[_ngcontent-%COMP%]{overflow:hidden;position:relative;z-index:100}.AttachmentsCarousel-previewImage[_ngcontent-%COMP%]{border-left-width:65px;border-right-width:65px}.AttachmentsCarouselSlide[_ngcontent-%COMP%]{align-items:center;border:20px solid transparent;box-sizing:border-box;display:flex;flex-direction:column;justify-content:center}.AttachmentMetadataBar-downloadLink[_ngcontent-%COMP%], .AttachmentMetadataBar-openOriginalLink[_ngcontent-%COMP%], .AttachmentMetadataBar-proofingToggle[_ngcontent-%COMP%]{align-items:center;border-radius:4px;color:#fff;display:flex;fill:#fff;flex:0 0 auto;height:40px;margin-right:15px;padding:0 10px;white-space:nowrap}.SingleTaskPaneSpreadsheet-header[_ngcontent-%COMP%]{background:#fff;flex-shrink:0}.SingleTaskPaneToolbar[_ngcontent-%COMP%]{height:80px}.SingleTaskPaneToolbar-button[_ngcontent-%COMP%]{flex-shrink:0;height:80px;margin-left:4px}.SingleTaskPaneToolbarAnimation-row[_ngcontent-%COMP%]{align-items:flex-end;box-sizing:border-box;display:flex;height:40px;max-width:10000px;opacity:1;overflow:hidden;padding-left:2px;transition:opacity .2s ease-in}.SingleTaskPaneToolbarAnimation[_ngcontent-%COMP%]{flex-grow:1;height:80px;margin-right:16px;min-width:1px;overflow-y:hidden;width:100%}.SingleTaskPaneToolbarAnimation-title[_ngcontent-%COMP%]{cursor:pointer;flex-grow:1;font-size:16px;line-height:56px;overflow:hidden;padding:28px 0;text-overflow:ellipsis;white-space:nowrap}.inline[_ngcontent-%COMP%]{float:left}.description[_ngcontent-%COMP%]{font-size:1rem}.description-2[_ngcontent-%COMP%]{font-size:14px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:40px}.img-folder[_ngcontent-%COMP%]{width:30px}@media (max-width:768px){.description[_ngcontent-%COMP%]{font-size:15px}.box-rq-detail[_ngcontent-%COMP%]{max-height:60vh!important;overflow-y:scroll}.description-2[_ngcontent-%COMP%]{font-size:13px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:30px!important}.img-folder[_ngcontent-%COMP%]{width:26px}}.box-rq-detail[_ngcontent-%COMP%]{max-height:73vh;overflow-y:scroll}.contex[_ngcontent-%COMP%]{padding-top:20px}@media (max-width:768px){.contex[_ngcontent-%COMP%]{height:90vh!important;padding-top:0}}.ak-text-req-name[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.min-h[_ngcontent-%COMP%]{height:32px}.des-rq[_ngcontent-%COMP%]{background:#f3f3f3;border-radius:10px;color:#444}.fz-14[_ngcontent-%COMP%]{font-size:14px}.bobillo[_ngcontent-%COMP%]{width:50px}.blink_me[_ngcontent-%COMP%]{-webkit-animation:blinker 2s linear infinite;animation:blinker 2s linear infinite}@-webkit-keyframes blinker{50%{opacity:0}}@keyframes blinker{50%{opacity:0}}.description-3[_ngcontent-%COMP%]{font-size:18px!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RequirementDetailUserComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-requirement-detail-user',
                templateUrl: './requirement-detail-user.component.html',
                styleUrls: ['./requirement-detail-user.component.css']
            }]
    }], function () { return [{ type: DatePipe }, { type: AkeelaTemplateService }, { type: ElementRef }, { type: HttpService }, { type: I18nPipe }, { type: UploadService }, { type: RequirementsService }, { type: ErrorService }, { type: LocalService }, { type: SwalPortalTargets }]; }, { requirement: [{
            type: Input
        }], config: [{
            type: Input
        }], requirements: [{
            type: Input
        }], close: [{
            type: Output
        }], showFile: [{
            type: Output
        }], response: [{
            type: Output
        }], finishupload: [{
            type: Output
        }], updatefiles: [{
            type: Output
        }], doSomethingOnWindowsScroll: [{
            type: HostListener,
            args: ['scroll', ['$event']]
        }] }); })();

function RequirementsUserComponent_ng_template_1_div_0_ng_container_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function RequirementsUserComponent_ng_template_1_div_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementsUserComponent_ng_template_1_div_0_ng_container_9_ng_container_1_Template, 1, 0, "ng-container", 19);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵɵnextContext(3);
    const _r1 = ɵɵreference(3);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", _r1);
} }
function RequirementsUserComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 11);
    ɵɵlistener("click", function RequirementsUserComponent_ng_template_1_div_0_Template_div_click_0_listener() { ɵɵrestoreView(_r14); const ctx_r13 = ɵɵnextContext(2); return ctx_r13.close_window(); });
    ɵɵelementStart(1, "div", 12);
    ɵɵlistener("click", function RequirementsUserComponent_ng_template_1_div_0_Template_div_click_1_listener() { ɵɵrestoreView(_r14); const ctx_r15 = ɵɵnextContext(2); return ctx_r15.close_window(); });
    ɵɵelementStart(2, "div", 13);
    ɵɵlistener("click", function RequirementsUserComponent_ng_template_1_div_0_Template_div_click_2_listener($event) { ɵɵrestoreView(_r14); return $event == null ? null : $event.stopPropagation(); });
    ɵɵelementContainerStart(3);
    ɵɵelementStart(4, "div", 14);
    ɵɵelementStart(5, "div", 15);
    ɵɵlistener("click", function RequirementsUserComponent_ng_template_1_div_0_Template_div_click_5_listener() { ɵɵrestoreView(_r14); const ctx_r17 = ɵɵnextContext(2); return ctx_r17.close_window(); });
    ɵɵelement(6, "i", 16);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 17);
    ɵɵelementStart(8, "div", 18);
    ɵɵtemplate(9, RequirementsUserComponent_ng_template_1_div_0_ng_container_9_Template, 2, 1, "ng-container", 6);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext(2);
    ɵɵadvance(9);
    ɵɵproperty("ngIf", !ctx_r10.show_window_requirement_close);
} }
function RequirementsUserComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵtemplate(0, RequirementsUserComponent_ng_template_1_div_0_Template, 10, 1, "div", 10);
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("ngIf", ctx_r0.show_window_requirement);
} }
function RequirementsUserComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "akeela-requirement-detail-user", 20);
    ɵɵlistener("showFile", function RequirementsUserComponent_ng_template_2_Template_akeela_requirement_detail_user_showFile_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r18 = ɵɵnextContext(); return ctx_r18.show_file($event); })("finishupload", function RequirementsUserComponent_ng_template_2_Template_akeela_requirement_detail_user_finishupload_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r20 = ɵɵnextContext(); return ctx_r20.finish_upload($event); })("response", function RequirementsUserComponent_ng_template_2_Template_akeela_requirement_detail_user_response_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r21 = ɵɵnextContext(); return ctx_r21.emit_response($event); })("updatefiles", function RequirementsUserComponent_ng_template_2_Template_akeela_requirement_detail_user_updatefiles_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r22 = ɵɵnextContext(); return ctx_r22.update_files($event); })("close", function RequirementsUserComponent_ng_template_2_Template_akeela_requirement_detail_user_close_0_listener() { ɵɵrestoreView(_r19); const ctx_r23 = ɵɵnextContext(); return ctx_r23.close_window(); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("requirement", ctx_r2.currentRequirement)("requirements", ctx_r2.requirements)("config", ctx_r2.config);
} }
function RequirementsUserComponent_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function RequirementsUserComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 21);
    ɵɵtemplate(1, RequirementsUserComponent_div_5_ng_container_1_Template, 1, 0, "ng-container", 19);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r3.templates["requirementsHeaderContent"]);
} }
function RequirementsUserComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 22);
    ɵɵelement(2, "img", 23);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 29);
    ɵɵelementStart(1, "div", 30);
    ɵɵelement(2, "div", 31);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement_r28 = ɵɵnextContext().$implicit;
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 1, requirement_r28.index), ɵɵsanitizeHtml);
} }
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_5_hr_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "hr", 42);
} }
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_5_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 43);
    ɵɵelementStart(1, "div", 44);
    ɵɵelementStart(2, "span", 45);
    ɵɵtext(3);
    ɵɵpipe(4, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "div");
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const row2_r37 = ɵɵnextContext(3).$implicit;
    const ctx_r46 = ɵɵnextContext(5);
    ɵɵadvance(3);
    ɵɵtextInterpolate(ɵɵpipeBind1(4, 2, ctx_r46.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier] == null ? null : ctx_r46.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier].response));
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", ctx_r46.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier] == null ? null : ctx_r46.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier].object == null ? null : ctx_r46.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier].object.responseDescription, " ");
} }
const _c0$5 = function (a0, a1) { return { "text-secondary-2": a0, "text-primary": a1 }; };
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 37);
    ɵɵelement(2, "i", 38);
    ɵɵelementEnd();
    ɵɵelement(3, "div", 39);
    ɵɵpipe(4, "i18n");
    ɵɵtemplate(5, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_5_hr_5_Template, 1, 0, "hr", 40);
    ɵɵtemplate(6, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_5_div_6_Template, 7, 4, "div", 41);
    ɵɵelementEnd();
} if (rf & 2) {
    const row2_r37 = ɵɵnextContext(2).$implicit;
    const ctx_r41 = ɵɵnextContext(5);
    ɵɵadvance(2);
    ɵɵproperty("ngClass", ɵɵpureFunction2(6, _c0$5, !((ctx_r41.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier] == null ? null : ctx_r41.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier].status) == "COMPLETED"), (ctx_r41.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier] == null ? null : ctx_r41.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier].status) == "COMPLETED"));
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(4, 4, row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.name), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r41.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier] == null ? null : ctx_r41.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier].response);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r41.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier] == null ? null : ctx_r41.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier].response);
} }
const _c1$3 = function (a0, a1) { return { "ak-text-req-name ": a0, "animate__animated animate__fadeIn": a1 }; };
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r50 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "i", 46);
    ɵɵelementStart(2, "div", 47);
    ɵɵlistener("mouseout", function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_6_Template_div_mouseout_2_listener() { ɵɵrestoreView(_r50); const i_stf_r39 = ɵɵnextContext(2).index; const ctx_r49 = ɵɵnextContext(5); return (ctx_r49.akFocus[i_stf_r39] = false); })("mouseover", function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_6_Template_div_mouseover_2_listener() { ɵɵrestoreView(_r50); const i_stf_r39 = ɵɵnextContext(2).index; const ctx_r52 = ɵɵnextContext(5); return (ctx_r52.akFocus[i_stf_r39] = true); });
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = ɵɵnextContext(2);
    const row2_r37 = ctx_r54.$implicit;
    const i_stf_r39 = ctx_r54.index;
    const ctx_r42 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction2(5, _c0$5, !((ctx_r42.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier] == null ? null : ctx_r42.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier].status) == "COMPLETED"), (ctx_r42.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier] == null ? null : ctx_r42.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier].status) == "COMPLETED"));
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction2(8, _c1$3, !ctx_r42.akFocus[i_stf_r39], ctx_r42.akFocus[i_stf_r39]))("innerHTML", ɵɵpipeBind1(3, 3, row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.name), ɵɵsanitizeHtml);
} }
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "i", 46);
    ɵɵelement(2, "div", 39);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const row2_r37 = ɵɵnextContext(2).$implicit;
    const ctx_r43 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction2(4, _c0$5, !((ctx_r43.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier] == null ? null : ctx_r43.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier].status) == "COMPLETED"), (ctx_r43.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier] == null ? null : ctx_r43.files[row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.identifier].status) == "COMPLETED"));
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 2, row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.name), ɵɵsanitizeHtml);
} }
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 31);
} if (rf & 2) {
    const row2_r37 = ɵɵnextContext(2).$implicit;
    ɵɵproperty("innerHTML", row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.description, ɵɵsanitizeHtml);
} }
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r59 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 34);
    ɵɵlistener("click", function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_Template_div_click_1_listener() { ɵɵrestoreView(_r59); const row2_r37 = ɵɵnextContext().$implicit; const ctx_r57 = ɵɵnextContext(5); return ctx_r57.open_window(row2_r37.requirement); });
    ɵɵpipe(2, "i18n");
    ɵɵelementStart(3, "div");
    ɵɵelementStart(4, "div", 35);
    ɵɵtemplate(5, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_5_Template, 7, 9, "div", 6);
    ɵɵtemplate(6, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_6_Template, 4, 11, "div", 6);
    ɵɵtemplate(7, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_7_Template, 4, 7, "div", 6);
    ɵɵelementEnd();
    ɵɵtemplate(8, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_div_8_Template, 1, 1, "div", 36);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const row2_r37 = ɵɵnextContext().$implicit;
    const ctx_r40 = ɵɵnextContext(5);
    ɵɵclassMapInterpolate2("col-12  ", ctx_r40.akGrid == 3 ? "mb-3" : "", "  ", ctx_r40.akGrid != 3 ? "col-md-4" : "", "  fz-14 mt-4 ");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1(" active-cursor rq section-box ", ctx_r40.akGrid != 1 ? "h-100" : "", "  p-2 text-secondary");
    ɵɵproperty("title", ɵɵpipeBind1(2, 13, row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.name));
    ɵɵadvance(3);
    ɵɵproperty("title", row2_r37 == null ? null : row2_r37.requirement == null ? null : row2_r37.requirement.name);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r40.akGrid == 2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r40.akGrid == 1);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r40.akGrid == 3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r40.config.isDetailEnable);
} }
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_div_1_Template, 9, 15, "div", 33);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const row2_r37 = ctx.$implicit;
    const ctx_r36 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r36.viewOptional || ctx_r36.validateRequiredRule(row2_r37 == null ? null : row2_r37.requirement));
} }
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 32);
    ɵɵtemplate(2, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_ng_container_2_Template, 2, 1, "ng-container", 26);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement_r28 = ɵɵnextContext().$implicit;
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", requirement_r28.value);
} }
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 50);
    ɵɵpipe(1, "i18n");
    ɵɵpipe(2, "i18n");
} if (rf & 2) {
    const ctx_r62 = ɵɵnextContext(5);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, "@i18n-no-requirements-criteria") + ɵɵpipeBind1(2, 3, ctx_r62.config.filterRequirementsByResponse.state), ɵɵsanitizeHtml);
} }
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "div", 48);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_3_div_3_Template, 3, 5, "div", 49);
    ɵɵelement(4, "hr");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r33 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 2, "@i18n-no-requirements"), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r33.config.isFilterRequirementsByResponse);
} }
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_akeela_considerations_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-considerations", 51);
} if (rf & 2) {
    const requirement_r28 = ɵɵnextContext().$implicit;
    const ctx_r34 = ɵɵnextContext(3);
    ɵɵproperty("considerations", ctx_r34.getConsiderations(requirement_r28.index));
} }
function RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_div_1_Template, 4, 3, "div", 27);
    ɵɵtemplate(2, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_2_Template, 3, 1, "ng-container", 6);
    ɵɵtemplate(3, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_ng_container_3_Template, 5, 4, "ng-container", 6);
    ɵɵtemplate(4, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_akeela_considerations_4_Template, 1, 1, "akeela-considerations", 28);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement_r28 = ctx.$implicit;
    const ctx_r27 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r27.viewOptional || !ctx_r27.viewOptional && (requirement_r28 == null ? null : requirement_r28.contentOblig) == true);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement_r28.value.length > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement_r28.value.length === 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r27.config.isEnableConsiderationsByCategory);
} }
function RequirementsUserComponent_ng_container_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r65 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 24);
    ɵɵelementStart(2, "i", 25);
    ɵɵlistener("click", function RequirementsUserComponent_ng_container_9_ng_container_1_Template_i_click_2_listener() { ɵɵrestoreView(_r65); const ctx_r64 = ɵɵnextContext(2); return ctx_r64.akGrid = 2; });
    ɵɵelementEnd();
    ɵɵelementStart(3, "i", 25);
    ɵɵlistener("click", function RequirementsUserComponent_ng_container_9_ng_container_1_Template_i_click_3_listener() { ɵɵrestoreView(_r65); const ctx_r66 = ɵɵnextContext(2); return ctx_r66.akGrid = 1; });
    ɵɵelementEnd();
    ɵɵelementStart(4, "i", 25);
    ɵɵlistener("click", function RequirementsUserComponent_ng_container_9_ng_container_1_Template_i_click_4_listener() { ɵɵrestoreView(_r65); const ctx_r67 = ɵɵnextContext(2); return ctx_r67.akGrid = 3; });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(5, RequirementsUserComponent_ng_container_9_ng_container_1_ng_container_5_Template, 5, 4, "ng-container", 26);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r25 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵclassMapInterpolate1(" ", ctx_r25.akGrid == 2 ? "text-primary" : "text-secondary", " fas fa-th-large active-cursor  ");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("  ", ctx_r25.akGrid == 1 ? "text-primary" : "text-secondary", " fas fa-th active-cursor d-none d-inline-block pl-2");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("  ", ctx_r25.akGrid == 3 ? "text-primary" : "text-secondary", " fas fa-list active-cursor  pl-2");
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r25.requirements);
} }
function RequirementsUserComponent_ng_container_9_ng_container_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 50);
    ɵɵpipe(1, "i18n");
    ɵɵpipe(2, "i18n");
} if (rf & 2) {
    const ctx_r68 = ɵɵnextContext(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, "@i18n-no-requirements-criteria") + ɵɵpipeBind1(2, 3, ctx_r68.config.filterRequirementsByResponse.state), ɵɵsanitizeHtml);
} }
function RequirementsUserComponent_ng_container_9_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "div", 48);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, RequirementsUserComponent_ng_container_9_ng_container_2_div_3_Template, 3, 5, "div", 49);
    ɵɵelement(4, "hr");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r26 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 2, "@i18n-no-requirements"), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r26.config.isFilterRequirementsByResponse);
} }
function RequirementsUserComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementsUserComponent_ng_container_9_ng_container_1_Template, 6, 10, "ng-container", 6);
    ɵɵtemplate(2, RequirementsUserComponent_ng_container_9_ng_container_2_Template, 5, 4, "ng-container", 6);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.requirements.length > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.requirements.length === 0);
} }
function RequirementsUserComponent_akeela_considerations_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-considerations", 52);
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext();
    ɵɵproperty("considerations", ctx_r6.considerations_plan)("general", true);
} }
function RequirementsUserComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r70 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 53);
    ɵɵelementStart(1, "div", 17);
    ɵɵelementStart(2, "div", 32);
    ɵɵelementStart(3, "div", 5);
    ɵɵelementStart(4, "akeela-requirements-response", 54);
    ɵɵlistener("responsetransaction", function RequirementsUserComponent_div_11_Template_akeela_requirements_response_responsetransaction_4_listener($event) { ɵɵrestoreView(_r70); const ctx_r69 = ɵɵnextContext(); return ctx_r69.emit_response_transaction($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("transactionrequirement", ctx_r7.transactionrequirement)("config", ctx_r7.config);
} }
function RequirementsUserComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r72 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 55);
    ɵɵelementStart(1, "div", 17);
    ɵɵelementStart(2, "div", 32);
    ɵɵelementStart(3, "div", 5);
    ɵɵelementStart(4, "div", 56);
    ɵɵelementStart(5, "div", 57);
    ɵɵlistener("click", function RequirementsUserComponent_div_12_Template_div_click_5_listener() { ɵɵrestoreView(_r72); const ctx_r71 = ɵɵnextContext(); return ctx_r71.updateDocRecibidoPrepareArray(); });
    ɵɵtext(6, "Guardar Fisicos");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function RequirementsUserComponent_div_13_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function RequirementsUserComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 55);
    ɵɵtemplate(1, RequirementsUserComponent_div_13_ng_container_1_Template, 1, 0, "ng-container", 19);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r9.templates["requirementsFooterContent"]);
} }
class RequirementsUserComponent {
    constructor(templateService, _httpService, _requerementsService, _upload, _error) {
        this.templateService = templateService;
        this._httpService = _httpService;
        this._requerementsService = _requerementsService;
        this._upload = _upload;
        this._error = _error;
        this.showFile = new EventEmitter();
        this.response = new EventEmitter();
        this.openWindowRequirement = new EventEmitter(false);
        this.responsetransaction = new EventEmitter(); // en caso de que este activada la respuesta al trámite
        this.responseTransactionChange = new EventEmitter(); // en caso de que este activado el cambio de valor del trámite (caso de incompleto)
        this.finishupload = new EventEmitter();
        this.templates = {};
        this.inputreadonly = false;
        this.readonly = false;
        this.activate_physical_file = false;
        this.selected = null;
        this.requirements = null;
        this.transactionrequirement = null;
        this.files = {};
        this.currentRequirement = null;
        this.show_window_requirement = false;
        this.show_window_requirement_close = true;
        this.activate_save_checkmark = false;
        this.check_doc_physical = [];
        this.submit_disabled = false;
        this.response_active = false;
        this.categories = null;
        this.plans = null;
        this.considerations_plan = null;
        this.animate_init = true;
        this.screenMin = false;
        this.akFocus = {};
        this.akGrid = 2;
    }
    getResponsePreview(event) {
    }
    ngOnDestroy() {
        this.close_window();
        if (this.transitionSubscription) {
            this.transitionSubscription.unsubscribe();
        }
    }
    ngOnInit() {
        if (screen.width < 768) {
            this.screenMin = true;
        }
        else {
            this.screenMin = false;
        }
        this._upload.resetResponseUpload();
        this.getCategories();
        this.getPlansByProduct();
        this.initFiles();
        // Versionamiento al cargar un archivo ó al eliminar archivo lógico
        this._upload.getResponseUpload().subscribe((response) => {
            if (response) {
                if (this.config.isActiveVerifyChangeTransaction === true) {
                    if (String(response.body.transaction.identifier) !== String(this.config.idCurrentTransaction)) {
                        this.responseTransactionChange.emit(response.body.transaction.identifier);
                    }
                }
            }
        });
    }
    getCategories() {
        this._httpService.executeRequest(this.config.endpoints.getCategoriesByPlan.name, this.config.endpoints.getCategoriesByPlan.params, true).subscribe((response) => {
            this.categories = response;
        });
    }
    getPlansByProduct() {
        this._httpService.executeRequest(this.config.endpoints.getPlansByProduct.name, this.config.endpoints.getPlansByProduct.params, true).subscribe((response) => {
            this.plans = response;
            let plan = null;
            let plan_selected = null;
            plan = this.plans.filter((plan) => {
                return plan.identifier === this.config.transactionData.idPlan;
            });
            if (!isNullOrUndefined(plan)) {
                if (plan.length === 1) {
                    plan_selected = (plan[0].personMarkets).filter((pm) => {
                        return pm.audienceType === this.config.transactionData.audience;
                    });
                }
                if (!isNullOrUndefined(plan_selected)) {
                    if (plan_selected[0].alternateName) {
                        this.considerations_plan = Array(plan_selected[0].alternateName);
                    }
                }
            }
        });
    }
    initFiles() {
        this._httpService.executeRequest(this.config.endpoints.getRequirements.name, this.config.endpoints.getRequirements.params, true).subscribe((response) => {
            this.requirements = this._requerementsService.format_response(response, this.config);
            this.transactionrequirement = response;
            this.files = this._upload.files[this.config.viewName] = this._requerementsService.loadFileObject(this.requirements, this.config);
            this.check_requirements();
            this.generate_array_doc_physical();
        });
    }
    check_requirements() {
        if (this.config.isResponseActive) {
            this.response_active = this.isCompletedResponses();
        }
        this.response.emit(this._requerementsService.check_requirements(this.requirements, this.files, this.config));
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
    open_window(requirement) {
        if (this.show_window_requirement) {
            setTimeout(() => {
                this.show_window_requirement_close = true;
                this.openWindowRequirement.emit(false);
            }, 0);
            setTimeout(() => {
                this.open_rq(requirement);
            }, 60);
        }
        else {
            this.open_rq(requirement);
        }
    }
    open_rq(requirement) {
        this._upload.resetChangeRequirementById();
        // window.scroll(0, 0);
        this.currentRequirement = requirement;
        // this._requerementsService.setUpdateModalRQ(true);
        this.show_window_requirement = true;
        this.animate_init = false;
        this.show_window_requirement_close = false;
        this.openWindowRequirement.emit(true);
    }
    close_window() {
        setTimeout(() => {
            this.openWindowRequirement.emit(false);
            this.show_window_requirement_close = true;
        }, 600);
        this.show_window_requirement = false;
    }
    show_file(file) {
        this.showFile.emit(file);
    }
    emit_response(response) {
        this.response.emit(response);
    }
    finish_upload(response) {
        this.finishupload.emit(response);
        this.initFiles();
    }
    emit_response_transaction(event) {
        this.responsetransaction.emit(event);
    }
    generate_array_doc_physical() {
        // tslint:disable-next-line:forin
        for (const index in this.files) {
            this.check_doc_physical[index] = {
                checked: this.files[index].object.consigned,
                consigned: this.files[index].object.consigned,
                object: {}
            };
        }
    }
    update_files($event) {
        this.files = $event;
        // console.log(this.files);
        this.check_requirements();
    }
    isCompletedResponses() {
        for (const index in this.files) {
            if ((isNullOrUndefined(this.files[index].response) || this.files[index].response === this.config.statusResponseRequirement.inconsistent) && this.validateRequiredRule(this.files[index].object.requirement)) {
                return false;
            }
        }
        return true;
    }
    updateDocRecibido(event) {
        this.activate_save_checkmark = true;
        if (event.checked) {
            this.check_doc_physical[event.identifier].checked = !this.check_doc_physical[event.identifier].checked;
        }
        else {
            this.check_doc_physical[event.identifier].checked = false;
        }
    }
    updateDocRecibidoPrepareArray() {
        const object_send = [];
        const object = {};
        this.submit_disabled = true;
        this.activate_save_checkmark = true;
        // tslint:disable-next-line:forin
        for (const index in this.files) {
            if (this.check_doc_physical[index].checked === true && (this.check_doc_physical[index].consigned === false || isNullOrUndefined(this.check_doc_physical[index].consigned))) {
                if (this.files[index].object.identifier !== null) {
                    object_send.push({
                        identifier: this.files[index].object.identifier,
                        consigned: true,
                        consignedUsername: this.config.endpoints.saveRequirementPhysical.format.consignedUsername
                    });
                }
                else {
                    object_send.push({
                        transaction: { identifier: this.files[index].object.transaction.identifier },
                        requirement: { identifier: this.files[index].object.requirement.identifier },
                        person: { identifier: this.config.endpoints.saveRequirementPhysical.format.person.identifier },
                        consigned: true,
                        consignedUsername: this.config.endpoints.saveRequirementPhysical.format.consignedUsername
                    });
                }
            }
            else if (this.check_doc_physical[index].checked === false && this.check_doc_physical[index].consigned === true) {
                if (this.files[index].object.identifier !== null) {
                    object_send.push({
                        identifier: this.files[index].object.identifier,
                        consigned: false,
                        consignedUsername: this.config.endpoints.saveRequirementPhysical.format.consignedUsername
                    });
                }
                else {
                    object_send.push({
                        transaction: { identifier: this.files[index].object.transaction.identifier },
                        requirement: { identifier: this.files[index].object.requirement.identifier },
                        person: { identifier: this.config.endpoints.saveRequirementPhysical.format.person.identifier },
                        consigned: false,
                        consignedUsername: this.config.endpoints.saveRequirementPhysical.format.consignedUsername
                    });
                }
            }
        }
        this.config.endpoints.saveRequirementPhysical.params.body = {
            transactionRequirements: object_send
        };
        this._httpService.executeRequest(this.config.endpoints.saveRequirementPhysical.name, this.config.endpoints.saveRequirementPhysical.params, true).subscribe((response) => {
        }, error => {
            this._error.show(error);
        });
    }
    download_files() {
        this._httpService.executeRequest(this.config.endpoints.downloadAllFilesZip.name, this.config.endpoints.downloadAllFilesZip.params, true).subscribe((response) => {
            if (!isNullOrUndefined(response)) {
                response['action'] = 'downloadzip';
                if (true) {
                    response['deleteAfterShow'] = this.config.endpoints.deleteArchive;
                    response['deleteAfterShow']['params']['body']['identifier'] = response.identifier;
                    // this._httpService.executeRequest(response.deleteAfterShow.name, response.deleteAfterShow.params, true).subscribe((del: any) => {
                    // }, error => {
                    // });
                }
            }
            this.showFile.emit(response);
        }, error => {
            this._error.show(error);
        });
    }
    validateRequiredRule(requirement) {
        return this._requerementsService.validateRequiredRule(this.config, requirement);
    }
    ak_sanatize_html(text) {
        return text.replace(/<[^>]*>/g, '');
    }
    getConsiderations(category) {
        const response = [];
        if (!isNullOrUndefined(this.categories)) {
            response.push(this.categories.filter((cat) => {
                return cat.name === category;
            }));
            if (response.length > 0) {
                return response[0].alternateName;
            }
        }
        return response;
    }
}
/** @nocollapse */ RequirementsUserComponent.ɵfac = function RequirementsUserComponent_Factory(t) { return new (t || RequirementsUserComponent)(ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(RequirementsService), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(ErrorService)); };
/** @nocollapse */ RequirementsUserComponent.ɵcmp = ɵɵdefineComponent({ type: RequirementsUserComponent, selectors: [["akeela-requirements-user"]], inputs: { config: "config", folder: "folder", viewOptional: "viewOptional" }, outputs: { showFile: "showFile", response: "response", openWindowRequirement: "openWindowRequirement", responsetransaction: "responsetransaction", responseTransactionChange: "responseTransactionChange", finishupload: "finishupload" }, decls: 14, vars: 7, consts: [["akeelaRequirementsContent", "", "componentName", "requirementsWindowContent"], ["requirement", ""], [1, "animated", "fadeIn"], ["class", "box", 4, "ngIf"], [1, "box", "p-b-1"], [1, "col-12"], [4, "ngIf"], [3, "considerations", "general", 4, "ngIf"], ["class", "box m-t-2  m-b-2 p-b-1 p-t-1", 4, "ngIf"], ["class", "box-transparent m-t-2  m-b-2 p-b-1 p-t-1", 4, "ngIf"], ["class", "ak-form-modal full-modal teme-gray compleat-modal", 3, "click", 4, "ngIf"], [1, "ak-form-modal", "full-modal", "teme-gray", "compleat-modal", 3, "click"], [1, "body", "ml-2", "mr-2", 3, "click"], [1, "container", "bg-white", "mb-2", "radius", 3, "click"], [1, "d-flex", "w-100", "pt-3"], [1, "ml-auto", "text-right", 3, "click"], [1, "fas", "fa-times", 2, "font-size", "1.5rem"], [1, "w-100"], [1, "d-block", "overflow-auto", "pb-5", 2, "max-height", "100%", "background", "#fcfcfc"], [4, "ngTemplateOutlet"], [3, "requirement", "requirements", "config", "showFile", "finishupload", "response", "updatefiles", "close"], [1, "box"], [1, "col-12", "p-t-1", "p-b-1"], ["src", "./assets/public/images/loading.gif", "alt", ""], [1, "text-right", 2, "font-size", "20px"], [3, "click"], [4, "ngFor", "ngForOf"], ["class", "font-weight-normal mt-2 mt-4", 4, "ngIf"], [3, "considerations", 4, "ngIf"], [1, "font-weight-normal", "mt-2", "mt-4"], [1, "d-flex", "justify-content-star"], [3, "innerHTML"], [1, "row"], [3, "class", 4, "ngIf"], [3, "title", "click"], [3, "title"], [3, "innerHTML", 4, "ngIf"], [1, "mb-3", "mt-2", "text-center"], [1, "fas", "fa-file-alt", "fa-3x", 3, "ngClass"], [1, "animate__animated", "animate__fadeIn", "pl-2", 3, "innerHTML"], ["class", "p-0 mb-0", 4, "ngIf"], ["class", "p-2 text-dark text-left", "style", "font-size:13px", 4, "ngIf"], [1, "p-0", "mb-0"], [1, "p-2", "text-dark", "text-left", 2, "font-size", "13px"], [1, "mb-1", "mt-2"], [1, "badge", "badge-gray"], [1, "fa", "fa-file-alt", "float-left", "mr-2", "mt-1", 3, "ngClass"], [3, "ngClass", "innerHTML", "mouseout", "mouseover"], [1, "w-100", "text-center", "pt-2", 3, "innerHTML"], ["class", "w-100 text-center", 3, "innerHTML", 4, "ngIf"], [1, "w-100", "text-center", 3, "innerHTML"], [3, "considerations"], [3, "considerations", "general"], [1, "box", "m-t-2", "m-b-2", "p-b-1", "p-t-1"], [3, "transactionrequirement", "config", "responsetransaction"], [1, "box-transparent", "m-t-2", "m-b-2", "p-b-1", "p-t-1"], [1, "col-12", "pull-right", "text-right"], [1, "btn", "btn-primary", "pull-right", 3, "click"]], template: function RequirementsUserComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "akeela-requirements-template");
        ɵɵtemplate(1, RequirementsUserComponent_ng_template_1_Template, 1, 1, "ng-template", 0);
        ɵɵelementEnd();
        ɵɵtemplate(2, RequirementsUserComponent_ng_template_2_Template, 1, 3, "ng-template", null, 1, ɵɵtemplateRefExtractor);
        ɵɵelementStart(4, "div", 2);
        ɵɵtemplate(5, RequirementsUserComponent_div_5_Template, 2, 1, "div", 3);
        ɵɵelementStart(6, "div", 4);
        ɵɵelementStart(7, "div", 5);
        ɵɵtemplate(8, RequirementsUserComponent_div_8_Template, 3, 0, "div", 6);
        ɵɵelementEnd();
        ɵɵtemplate(9, RequirementsUserComponent_ng_container_9_Template, 3, 2, "ng-container", 6);
        ɵɵelementEnd();
        ɵɵtemplate(10, RequirementsUserComponent_akeela_considerations_10_Template, 1, 2, "akeela-considerations", 7);
        ɵɵtemplate(11, RequirementsUserComponent_div_11_Template, 5, 2, "div", 8);
        ɵɵtemplate(12, RequirementsUserComponent_div_12_Template, 7, 0, "div", 9);
        ɵɵtemplate(13, RequirementsUserComponent_div_13_Template, 2, 1, "div", 9);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(5);
        ɵɵproperty("ngIf", ctx.config.showHeaderContent);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.requirements === null || ctx.config === null);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.requirements !== null && ctx.config !== null);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.config.isEnableConsiderationsByRequirements && ctx.considerations_plan !== null);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.config.isResponseActive && ctx.response_active && ctx.config.isGlobalResponseActive);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.config.isPhysicalCheckActive && ctx.activate_save_checkmark && !ctx.config.isReadonlyPhysical);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.config.showFooterContent);
    } }, directives: [AkeelaRequirementsTemplateComponent, AkeelaRequirementContentDirective, NgIf, NgTemplateOutlet, RequirementDetailUserComponent, NgForOf, NgClass, ConsiderationsComponent, ResponseComponent], pipes: [I18nPipe], styles: [".box[_ngcontent-%COMP%]{background-color:#fff}.box[_ngcontent-%COMP%], .box-transparent[_ngcontent-%COMP%]{color:#4a4a4a}.box[_ngcontent-%COMP%], .box-button[_ngcontent-%COMP%], .box-transparent[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto}.bg-gray[_ngcontent-%COMP%]{background-color:#f5f7fa;min-height:auto}@media (max-width:768px){.box[_ngcontent-%COMP%]{font-size:1rem!important}.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}@media (max-width:992px){.box[_ngcontent-%COMP%], .box-button[_ngcontent-%COMP%]{width:auto!important}}.caret-down[_ngcontent-%COMP%]{color:#e2e2e4;font-size:3rem;line-height:.7rem}.m-b-1[_ngcontent-%COMP%]{margin-bottom:1rem}.m-b-3[_ngcontent-%COMP%]{margin-bottom:3rem}.m-b-2[_ngcontent-%COMP%]{margin-bottom:2rem}.m-t-2[_ngcontent-%COMP%]{margin-top:2rem}.m-t-3[_ngcontent-%COMP%]{margin-top:3rem}.p-t-0[_ngcontent-%COMP%]{padding-top:0}.p-b-2[_ngcontent-%COMP%]{padding-bottom:2rem}@media (max-width:768px){.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}.text-size-1[_ngcontent-%COMP%]{font-size:.5rem}.box-2[_ngcontent-%COMP%], .box-3[_ngcontent-%COMP%]{text-align:center}.box-2[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #ccc;font-size:3rem;height:70px;margin-left:auto;margin-right:auto;margin-top:-50px;width:69px}.box_1[_ngcontent-%COMP%]{margin-top:25px}.description[_ngcontent-%COMP%]{font-size:1rem}.description-2[_ngcontent-%COMP%]{font-size:14px;line-height:14px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:50px}.img-folder[_ngcontent-%COMP%]{width:30px}@media (max-width:768px){.description[_ngcontent-%COMP%]{font-size:14px}.description-2[_ngcontent-%COMP%]{font-size:13px;line-height:13px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:34px!important}.img-folder[_ngcontent-%COMP%]{width:26px}}.description-label[_ngcontent-%COMP%]{font-size:.875rem}.fz-title[_ngcontent-%COMP%]{font-size:1.5rem}.bt2black[_ngcontent-%COMP%]{border-top:1px solid #000}.termsAndConditions[_ngcontent-%COMP%]{color:#777;font-size:.75rem}.color-white[_ngcontent-%COMP%]{color:transparent}.color-yellow[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-incomplete)}.color-orange[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-warning)}.color-purple[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-inconsistent)}.color-blue[_ngcontent-%COMP%], .color-green[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-success)}.color-red[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-error)}.color-gray-light[_ngcontent-%COMP%]{color:#ccc}.color-black[_ngcontent-%COMP%]{color:#000}.section-title[_ngcontent-%COMP%]{font-size:.7rem}.selected-icon[_ngcontent-%COMP%]{background:#ededed;background:-webkit-gradient(left bottom,right top,color-stop(0,#ededed),color-stop(53%,#f6f6f6),color-stop(100%,#fff));background:linear-gradient(45deg,#ededed,#f6f6f6 53%,#fff);border-radius:10px;cursor:pointer;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ededed\",endColorstr=\"#ffffff\",GradientType=1)}.Button[_ngcontent-%COMP%]{border-radius:4px;transition-duration:.2s;transition-property:background,border,box-shadow,color,fill}.border-red[_ngcontent-%COMP%]{border-color:red}.border-green[_ngcontent-%COMP%]{border-color:green}.Button--secondary[_ngcontent-%COMP%]:not(.Button--disabled){background:#fff;color:#646f79;fill:#848f99}.Button.Button--small[_ngcontent-%COMP%]{height:30px;line-height:30px;padding:0 9px}.Button[_ngcontent-%COMP%]{align-items:center;border-style:solid;border-width:1px;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-size:13px;justify-content:center;line-height:1;min-width:50px;text-align:center}.color-blue[_ngcontent-%COMP%]{background-color:#007bff;color:#fff}.color-gray[_ngcontent-%COMP%]{background-color:#d8d8d8;border-color:#d8d8d8;color:#000}.border-red[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-error)}.border-green[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-success)}.border-purple[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-inconsistent)}.border-yellow[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-incomplete)}.border-orange[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-warning)}.skin-white[_ngcontent-%COMP%]{background-color:#fff}.badge-gray-light[_ngcontent-%COMP%]{background-color:#bdbdbd;color:#fff}.badge-gray[_ngcontent-%COMP%]{background-color:#848f99;color:#fff}.font-light[_ngcontent-%COMP%]{opacity:.7}.font-color-gray[_ngcontent-%COMP%]{color:#bdbdbd}.font-color-black[_ngcontent-%COMP%]{color:#000}.ak-icon-req[_ngcontent-%COMP%]{color:#adb5bd}.ak-text-req-name[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.px-12[_ngcontent-%COMP%]{font-size:12px}.cirecle-status[_ngcontent-%COMP%]{font-size:7px;margin-top:5px;position:absolute}.ak-req-add[_ngcontent-%COMP%]{border-radius:21px;color:#fff;font-size:12px;font-weight:900;height:24px;padding:3px;width:24px}.fz-12[_ngcontent-%COMP%]{font-size:9px}.rq-coments[_ngcontent-%COMP%]{background:#efefef;border-radius:10px;padding:6px 20px}.section-box.rq[_ngcontent-%COMP%]{border:1px solid #fafafa}.section-box.rq[_ngcontent-%COMP%]:hover{background:#fafafa;border:1px solid #d8d8d8}.ak-modal-right[_ngcontent-%COMP%]{background:#fff;box-shadow:0 0 10px -5px #444;height:100%;position:fixed;right:0;width:40%;z-index:999}.fz-14[_ngcontent-%COMP%]{font-size:14px}.cat-icon[_ngcontent-%COMP%]{color:#ccc;font-size:12px;margin-top:5px;padding-right:5px}.cat-icon2[_ngcontent-%COMP%]{background-color:#fff;border-radius:14px;font-size:18px;margin-left:-14px;padding:4px;position:absolute;top:28px}.full-modal[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.5)!important;display:flex;flex:1;flex-direction:column;justify-content:center;overflow:auto;padding:50px 200px;right:0;top:0}@media (max-width:900px){.full-modal[_ngcontent-%COMP%]{padding:0}}.radius[_ngcontent-%COMP%]{border-radius:10px}.full-modal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{background:#fff;box-shadow:0 1px 0 rgba(0,0,0,.10196078);margin-bottom:0;min-height:3.3rem;padding:.7rem;position:static}.full-modal[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]{background-color:transparent;margin-top:0;overflow:auto}.title-section[_ngcontent-%COMP%]{color:var(--ak-color-title-section);margin-top:.3rem}.title-section.selected[_ngcontent-%COMP%]{color:var(--ak-color-title-section-selected)}.text-secondary-2[_ngcontent-%COMP%]{color:#ccc!important}.fz-13[_ngcontent-%COMP%]{font-size:13px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RequirementsUserComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-requirements-user',
                templateUrl: './requirements-user.component.html',
                styleUrls: ['./requirements-user.component.css']
            }]
    }], function () { return [{ type: AkeelaTemplateService }, { type: HttpService }, { type: RequirementsService }, { type: UploadService }, { type: ErrorService }]; }, { config: [{
            type: Input
        }], folder: [{
            type: Input
        }], viewOptional: [{
            type: Input
        }], showFile: [{
            type: Output
        }], response: [{
            type: Output
        }], openWindowRequirement: [{
            type: Output
        }], responsetransaction: [{
            type: Output
        }], responseTransactionChange: [{
            type: Output
        }], finishupload: [{
            type: Output
        }] }); })();

function RequirementUploadBriefcaseComponent_ng_container_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 5);
    ɵɵelementStart(1, "div", 6);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵstyleProp("width", ctx_r2.files[ctx_r2.requirement == null ? null : ctx_r2.requirement.identifier].progress + "%");
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r2.files[ctx_r2.requirement == null ? null : ctx_r2.requirement.identifier].progress, " % ");
} }
function RequirementUploadBriefcaseComponent_ng_container_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 7);
    ɵɵtext(2);
    ɵɵelement(3, "br");
    ɵɵtext(4);
    ɵɵelement(5, "br");
    ɵɵtext(6);
    ɵɵelement(7, "br");
    ɵɵtext(8);
    ɵɵelement(9, "br");
    ɵɵtext(10);
    ɵɵelement(11, "br");
    ɵɵtext(12);
    ɵɵelement(13, "br");
    ɵɵtext(14);
    ɵɵelement(15, "br");
    ɵɵtext(16);
    ɵɵelement(17, "br");
    ɵɵelement(18, "br");
    ɵɵtext(19, " ((files[requirement.identifier].progress===null) && !this.config.isReadonly && this.config.isDigitalUploadActive===true) || (validateSpecialApplySpecialCase(files[requirement?.identifier].response) && config.enableEspecialUpload.active ) || (!this.config.isReadonly && this.config.isDigitalUploadActive)");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵtextInterpolate1("files[requirement.identifier].progress : ", ctx_r3.files[ctx_r3.requirement.identifier].progress, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" this.config.isReadonly : ", ctx_r3.config.isReadonly, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" this.config.isDigitalUploadActive : ", ctx_r3.config.isDigitalUploadActive, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" files[requirement?.identifier].response : ", ctx_r3.files[ctx_r3.requirement == null ? null : ctx_r3.requirement.identifier].response, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" validateSpecialApplySpecialCase(files[requirement?.identifier].response) : ", ctx_r3.validateSpecialApplySpecialCase(ctx_r3.files[ctx_r3.requirement == null ? null : ctx_r3.requirement.identifier].response), " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" config.enableEspecialUpload.active : ", ctx_r3.config.enableEspecialUpload.active, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" this.config.isReadonly : ", ctx_r3.config.isReadonly, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" this.config.isDigitalUploadActive: ", ctx_r3.config.isDigitalUploadActive, " ");
} }
function RequirementUploadBriefcaseComponent_ng_container_2_ng_container_5_akeela_input_upload_file_flex_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "akeela-input-upload-file-flex", 9);
    ɵɵlistener("response", function RequirementUploadBriefcaseComponent_ng_container_2_ng_container_5_akeela_input_upload_file_flex_1_Template_akeela_input_upload_file_flex_response_0_listener($event) { ɵɵrestoreView(_r7); const ctx_r6 = ɵɵnextContext(3); return ctx_r6.notificacion($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(3);
    ɵɵproperty("config", ctx_r5.config)("type", "button")("identifier", ctx_r5.requirement == null ? null : ctx_r5.requirement.identifier);
} }
function RequirementUploadBriefcaseComponent_ng_container_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementUploadBriefcaseComponent_ng_container_2_ng_container_5_akeela_input_upload_file_flex_1_Template, 1, 3, "akeela-input-upload-file-flex", 8);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.files[ctx_r4.requirement.identifier].progress === null && !ctx_r4.config.isReadonly && ctx_r4.config.isDigitalUploadActive === true || ctx_r4.validateSpecialApplySpecialCase(ctx_r4.files[ctx_r4.requirement == null ? null : ctx_r4.requirement.identifier].response) && ctx_r4.config.enableEspecialUpload.active || !ctx_r4.config.isReadonly && ctx_r4.config.isDigitalUploadActive);
} }
function RequirementUploadBriefcaseComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 3);
    ɵɵlistener("window.scroll", function RequirementUploadBriefcaseComponent_ng_container_2_Template_div_window_scroll_1_listener($event) { ɵɵrestoreView(_r9); const ctx_r8 = ɵɵnextContext(); return ctx_r8.doSomethingOnWindowsScroll($event); });
    ɵɵelementContainerStart(2);
    ɵɵtemplate(3, RequirementUploadBriefcaseComponent_ng_container_2_div_3_Template, 3, 3, "div", 4);
    ɵɵtemplate(4, RequirementUploadBriefcaseComponent_ng_container_2_ng_container_4_Template, 20, 8, "ng-container", 2);
    ɵɵelementContainerEnd();
    ɵɵtemplate(5, RequirementUploadBriefcaseComponent_ng_container_2_ng_container_5_Template, 2, 1, "ng-container", 2);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("ngIf", ctx_r0.files[ctx_r0.requirement == null ? null : ctx_r0.requirement.identifier].progress !== null && ctx_r0.files[ctx_r0.requirement == null ? null : ctx_r0.requirement.identifier].progress !== 99);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.files[ctx_r0.requirement == null ? null : ctx_r0.requirement.identifier].progress === null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.files[ctx_r0.requirement == null ? null : ctx_r0.requirement.identifier].progress === null || ctx_r0.files[ctx_r0.requirement == null ? null : ctx_r0.requirement.identifier].progress == 99);
} }
function RequirementUploadBriefcaseComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 10);
    ɵɵelement(2, "img", 11);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
class RequirementUploadBriefcaseComponent {
    constructor(datePipe, templateService, eleRef, _httpService, _i18n, _upload, _requirement, _error, localStorage, swalTargets) {
        this.datePipe = datePipe;
        this.templateService = templateService;
        this.eleRef = eleRef;
        this._httpService = _httpService;
        this._i18n = _i18n;
        this._upload = _upload;
        this._requirement = _requirement;
        this._error = _error;
        this.localStorage = localStorage;
        this.swalTargets = swalTargets;
        this.close = new EventEmitter();
        this.showFile = new EventEmitter();
        this.response = new EventEmitter();
        this.finishupload = new EventEmitter();
        this.updatefiles = new EventEmitter();
        this.templates = {};
        this.list = 'LOADING';
        this.obj_aux = [];
        this.loaded = false;
        this.history_responses = null;
        this.transactionrequirement = null;
        this.transactionrequirementbackup = null;
        this._back = null;
        this._next = null;
        this.sel_requirement = null;
        this.sel_transactionrequirement = null;
        this.sel_type = null;
        this.sel_file = null;
        this.currentdate = new Date();
        this.lastVersion = false;
        this.descroptionRq = false;
        this.modeDebug = false;
    }
    ngOnInit() {
        this.loaded = true;
        this.files = this._upload.files[this.config.viewName];
        this.subscription_change_files = this._upload.getChangresFilesArr().subscribe((files) => {
            console.log('Via de respose');
            console.log(this._upload.files[this.config.viewName]);
            this.files = this._upload.files[this.config.viewName];
            this.loaded = true;
            this.response.emit({});
            //this.check_requirements();
            //this.getRequirementFiles();
        });
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
    getRequirementFiles() {
        // console.log('Invoco el servicio que solicita los files');
        const params = this.config.endpoints.getRequirement.params;
        params.path.idRequirement = this.requirement.identifier;
        if (this.subscription_files_options) {
            this.subscription_files_options.unsubscribe();
        }
        // console.log('entro inicioo');
        this.subscription_files_options = this._httpService.executeRequest(this.config.endpoints.getRequirement.name, params, true).subscribe((response) => {
            this.list = null;
            this.transactionrequirement = response;
            if (response.requirementArchives && response.requirementArchives.length > 0) {
                // console.log('entro en caso 1');
                // console.log(response.requirementArchives);
                this.list = response.requirementArchives;
            }
            else {
                // console.log('entro en caso 2');
                // console.log(this._upload.files[this.config.viewName]);
                this._upload.files[this.config.viewName][this.requirement.identifier].status = null;
                this.updatefiles.emit(this._upload.files[this.config.viewName]);
                this.list = null;
            }
        }, error => {
            // alert('va por el error');
            this.transactionrequirement = null;
            this._upload.files[this.config.viewName][this.requirement.identifier].status = null;
            this.updatefiles.emit(this._upload.files[this.config.viewName]);
            this.list = null;
        });
    }
    getRequirementHistory() {
        this.history_responses = null;
        const params = this.config.endpoints.getHistoryResponseRequirement.params;
        params.path.idRequirement = this.requirement.identifier;
        this._httpService.executeRequest(this.config.endpoints.getHistoryResponseRequirement.name, params, true).subscribe((history) => {
            this.history_responses = history;
        });
    }
    getRequirementById(identifier) {
        let response = null;
        this.requirements.forEach((element) => {
            element.value.forEach((element2) => {
                if (element2.requirement.identifier.toString() === identifier.toString()) {
                    response = element2.requirement;
                }
            });
        });
        return response;
    }
    getBackNext() {
        this.lastVersion = false;
        let next = null;
        let back = null;
        let case_break = 0;
        const auxiliar = [];
        for (const aux of this.requirements) {
            for (const req of aux.value) {
                auxiliar.push(req.requirement.identifier);
            }
        }
        for (const r of auxiliar) {
            if (case_break < 2) {
                if (parseInt(r, 10) !== parseInt(this.requirement.identifier, 10) && case_break === 0) {
                    back = r;
                }
                else if (parseInt(r, 10) === parseInt(this.requirement.identifier, 10)) {
                    case_break = 1;
                }
                else if (case_break === 1) {
                    next = r;
                    case_break = 2;
                }
            }
        }
        this._next = next;
        this._back = back;
    }
    notificacion(evt) {
        console.log('NOTIFICACION*********');
        console.log(evt);
        console.log('*********');
        if (evt.type !== 'success') {
            swal.fire({
                title: evt.title,
                html: evt.html
            });
        }
        this.finishupload.emit(true);
    }
    validate_expiration(expiration) {
        if (expiration !== null) {
            const date = this.generate_object_date(expiration);
            if (this.currentdate.getTime() > date.getTime()) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    generate_object_date(epoc) {
        return new Date(epoc * 1000);
    }
    next(close) {
        if (this._next) {
            //   window.scroll(0, 0);
            this.loaded = false;
            this._upload.setChangeRequirementById(this._next);
        }
        else {
            if (close) {
                this.cerrar();
            }
        }
    }
    back() {
        // window.scroll(0, 0);
        this.loaded = false;
        this._upload.setChangeRequirementById(this._back);
    }
    cerrar() {
        this.close.emit(true);
    }
    show_file(file) {
        this.showFile.emit(file);
    }
    update_dates(object, type) {
        this.sel_type = type;
        if (type !== 'transaction') {
            this.sel_file = object;
        }
        const box = this.eleRef.nativeElement.querySelector('#idshowdates');
        box.dispatchEvent(new Event('click'));
    }
    ngOnDestroy() {
        if (this.subscription_files) {
            this.subscription_files.unsubscribe();
        }
        if (this.subscription_files_options) {
            this.subscription_files_options.unsubscribe();
        }
        if (this.subscription_change_files) {
            this.subscription_change_files.unsubscribe();
        }
    }
    swipeleft(event) {
        this.next();
    }
    swiperight(event) {
        this.back();
    }
    doSomethingOnWindowsScroll($event) {
        // TODO: MIGRACIÓN
        // this.scrollOffset = $event.srcElement.children[0].scrollTop;
        // console.log('window scroll: ', this.scrollOffset);
    }
    countCurrentElement(identifier) {
        let count = 1;
        for (const element of this.requirements) {
            for (const requirement of element.value) {
                if (requirement.requirement.identifier === identifier) {
                    return count;
                }
                else {
                    count++;
                }
            }
        }
    }
    countRequirements() {
        let count = 0;
        this.requirements.forEach((element) => {
            element.value.forEach((element2) => {
                count++;
            });
        });
        return count;
    }
    validateNewFilesUpdated() {
        for (const row of this.list) {
            if (this.transactionrequirement.responseDate) {
                if (this.transactionrequirement.responseDate.orderDate < row.dateOfThing.startDate) {
                    return true;
                }
            }
        }
        return false;
    }
    download_files_requirement() {
        const params = this.config.endpoints.downloadRequirementFilesZip.params;
        params.request.idTransactionRequirement = this.transactionrequirement.identifier;
        this._httpService.executeRequest(this.config.endpoints.downloadRequirementFilesZip.name, params, true).subscribe((response) => {
            if (!isNullOrUndefined(response)) {
                response['action'] = 'downloadzip';
                if (true) {
                    response['deleteAfterShow'] = this.config.endpoints.deleteArchive;
                    response['deleteAfterShow']['params']['body']['identifier'] = response.identifier;
                }
            }
            this.showFile.emit(response);
        }, error => {
            this._error.show(error);
        });
    }
    time_to_expiration(expiration_date) {
        if (!isNullOrUndefined(expiration_date)) {
            if (expiration_date > 0) {
                return this.calcDate(new Date(), new Date(expiration_date * 1000));
            }
        }
        return '';
    }
    calcDate(date1, date2) {
        const diff = Math.floor(date2.getTime() - date1.getTime());
        const day = 1000 * 60 * 60 * 24;
        const days = Math.floor(diff / day);
        const months = Math.floor(days / 31);
        const years = Math.floor(months / 12);
        let message = '';
        if (years > 0 || months > 0 || days > 0) {
            message += '(';
            if (years > 0) {
                message += years + 'a';
            }
            if (months > 0) {
                message += months + 'm ';
            }
            if (days > 0) {
                message += days + 'd ';
            }
            message += ')';
        }
        else if (years < -1 || months < -1 || days < -1) {
            message = '<span class="text-danger">(Vencido)</span>';
        }
        else {
            message = '';
        }
        return message;
    }
    validateSpecialApplySpecialCase(response) {
        if (!isNullOrUndefined(this.config.enableEspecialUpload)) {
            if (!isNullOrUndefined(this.config.enableEspecialUpload.active)) {
                if (this.config.enableEspecialUpload.active) {
                    for (const status of this.config.enableEspecialUpload.status) {
                        if (status === response) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
    validateRequiredRule(requirement) {
        return this._requirement.validateRequiredRule(this.config, requirement);
    }
    word_count(word) {
        // Obtenemos el texto del campo
        let texto = word;
        // Reemplazamos los saltos de linea por espacios
        texto = texto.replace(/\r?\n/g, " ");
        // Reemplazamos los espacios seguidos por uno solo
        texto = texto.replace(/[ ]+/g, " ");
        // Quitarmos los espacios del principio y del final
        texto = texto.replace(/^ /, "");
        texto = texto.replace(/ $/, "");
        // Troceamos el texto por los espacios
        const textoTroceado = texto.split(" ");
        // Contamos todos los trozos de cadenas que existen
        const numeroPalabras = textoTroceado.length;
        // Mostramos el número de palabras
        return numeroPalabras;
    }
    ak_splice(textoHTML) {
        let response = '';
        if (!isNullOrUndefined(textoHTML)) {
            response = textoHTML
                .replace(/<[^>]*>/g, "")
                .split(" ")
                .splice(0, 10)
                .join(" ");
        }
        return response;
    }
    ak_sanatize_html(text) {
        return text.replace(/<[^>]*>/g, '');
    }
    validateDatesConditions(requirement) {
        if (!isNullOrUndefined(requirement.showDateOfIssue) || !isNullOrUndefined(requirement.showExpirationDate)) {
            if (requirement.showDateOfIssue === true || requirement.showExpirationDate === true) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }
    getResponsePreview(data) {
    }
}
/** @nocollapse */ RequirementUploadBriefcaseComponent.ɵfac = function RequirementUploadBriefcaseComponent_Factory(t) { return new (t || RequirementUploadBriefcaseComponent)(ɵɵdirectiveInject(DatePipe), ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(RequirementsService), ɵɵdirectiveInject(ErrorService), ɵɵdirectiveInject(LocalService), ɵɵdirectiveInject(SwalPortalTargets)); };
/** @nocollapse */ RequirementUploadBriefcaseComponent.ɵcmp = ɵɵdefineComponent({ type: RequirementUploadBriefcaseComponent, selectors: [["akeela-requirement-upload-briefcase"]], hostBindings: function RequirementUploadBriefcaseComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("scroll", function RequirementUploadBriefcaseComponent_scroll_HostBindingHandler($event) { return ctx.doSomethingOnWindowsScroll($event); });
    } }, inputs: { requirement: "requirement", config: "config", requirements: "requirements" }, outputs: { close: "close", showFile: "showFile", response: "response", finishupload: "finishupload", updatefiles: "updatefiles" }, decls: 4, vars: 2, consts: [[1, "w-100", 2, "touch-action", "auto !important"], [1, "p-3"], [4, "ngIf"], [1, "mb-3", 3, "window.scroll"], ["style", "height:30px", "class", "w-100 progress", 4, "ngIf"], [1, "w-100", "progress", 2, "height", "30px"], ["role", "progressbar", "aria-valuenow", "0", "aria-valuemin", "0", "aria-valuemax", "100", 1, "progress-bar", "progress-bar-striped"], [1, "d-none"], [3, "config", "type", "identifier", "response", 4, "ngIf"], [3, "config", "type", "identifier", "response"], [1, "col-12"], ["src", "/assets/public/images/loading.gif", "alt", ""]], template: function RequirementUploadBriefcaseComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵtemplate(2, RequirementUploadBriefcaseComponent_ng_container_2_Template, 6, 3, "ng-container", 2);
        ɵɵtemplate(3, RequirementUploadBriefcaseComponent_ng_container_3_Template, 3, 0, "ng-container", 2);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.loaded);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.loaded);
    } }, directives: [NgIf, InputUploadFileFlexComponent], styles: [".box[_ngcontent-%COMP%]{background-color:#fff;box-shadow:0 2px 4px 0 hsla(0,0%,91.8%,.5);color:#4a4a4a;margin-left:auto;margin-right:auto;max-height:90vh!important}box_scroll[_ngcontent-%COMP%]{min-height:1px;overflow-y:auto}.box-button[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto}.bg-gray[_ngcontent-%COMP%]{background-color:#f5f7fa;min-height:auto}@media (max-width:768px){.box[_ngcontent-%COMP%]{font-size:1rem!important}.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}@media (max-width:992px){.box[_ngcontent-%COMP%], .box-button[_ngcontent-%COMP%]{width:auto!important}}.caret-down[_ngcontent-%COMP%]{color:#e2e2e4;font-size:3rem;line-height:.7rem}.m-b-1[_ngcontent-%COMP%]{margin-bottom:1rem}.m-b-3[_ngcontent-%COMP%]{margin-bottom:3rem}.m-b-2[_ngcontent-%COMP%]{margin-bottom:2rem}.m-t-2[_ngcontent-%COMP%]{margin-top:2rem}.m-t-3[_ngcontent-%COMP%]{margin-top:3rem}.p-t-0[_ngcontent-%COMP%]{padding-top:0}.p-b-2[_ngcontent-%COMP%]{padding-bottom:2rem}@media (max-width:768px){.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}.text-size-1[_ngcontent-%COMP%]{font-size:.5rem}.text-size-2[_ngcontent-%COMP%]{font-size:2rem}.text-size-3[_ngcontent-%COMP%]{font-size:1rem}@media (min-width:1200px){.container[_ngcontent-%COMP%]{max-width:960px}}.box-2[_ngcontent-%COMP%], .box-3[_ngcontent-%COMP%]{text-align:center}.box-2[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #ccc;font-size:3rem;height:70px;margin-left:auto;margin-right:auto;margin-top:-50px;width:69px}.fz-title[_ngcontent-%COMP%]{font-size:1.5rem}.bt2black[_ngcontent-%COMP%]{border-top:1px solid #000}.bt2gray[_ngcontent-%COMP%]{border-top:1px solid #ccc}.termsAndConditions[_ngcontent-%COMP%]{color:#777;font-size:.75rem}.color-white[_ngcontent-%COMP%]{color:transparent}.color-yellow[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-incomplete)}.color-orange[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-warning)}.color-purple[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-inconsistent)}.color-blue[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-success)}.color-red[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-error)}.color-green[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-success)}.color-gray-light[_ngcontent-%COMP%]{color:#ccc}.color-a4a4a4[_ngcontent-%COMP%]{color:#4a4a4a}.section-title[_ngcontent-%COMP%]{font-size:.7rem}.Button--secondary[_ngcontent-%COMP%]:not(.Button--disabled){background:#fff;color:#646f79;fill:#848f99}.Button.Button--small[_ngcontent-%COMP%]{height:30px;line-height:30px;padding:0 9px}.Button[_ngcontent-%COMP%]{align-items:center;border-radius:4px;border-style:solid;border-width:1px;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-size:13px;justify-content:center;line-height:1;min-width:50px;text-align:center;transition-duration:.2s;transition-property:background,border,box-shadow,color,fill}.border-red[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-error)}.border-green[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-success)}.border-purple[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-inconsistent)}.border-yellow[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-incomplete)}.border-orange[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-warning)}.badge-gray-light[_ngcontent-%COMP%]{background-color:#bdbdbd;color:#fff}.nav[_ngcontent-%COMP%]{align-items:center;border-radius:5 5 0 0;display:block;flex-wrap:nowrap;height:50px;list-style:none;margin-bottom:0}.nav-item[_ngcontent-%COMP%]{margin-right:1.8rem;padding-top:3px}.nav-item[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{background:var(--ak-step-nav-link-background);border:1px solid var(--ak-step-nav-link-borderColor);border-radius:3rem;color:var(--ak-step-nav-link-color);font-size:.9rem;margin-top:5px;padding:3px 15px}.nav-item.active[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{background:var(--ak-step-nav-link-backgroundActive)}.nav-item[_ngcontent-%COMP%]   .nav-link.bg-disabled[_ngcontent-%COMP%]{background:#ddd!important}.ModalLayer[_ngcontent-%COMP%]{align-items:center;bottom:0;display:flex;flex-direction:column;left:0;position:fixed;right:0;top:0;z-index:10000}.Carousel-leftButtonContainer[_ngcontent-%COMP%]{left:45px}.Carousel-rightButtonContainer[_ngcontent-%COMP%]{right:55px}@media (max-width:576px){.Carousel-leftButtonContainer[_ngcontent-%COMP%], .Carousel-rightButtonContainer[_ngcontent-%COMP%]{border-color:transparent;position:relative}.Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-leftButton[_ngcontent-%COMP%], .Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-rightButton[_ngcontent-%COMP%]{border-color:transparent}.CircularButton--circular[_ngcontent-%COMP%]{border:0 solid #fff}}.Carousel-leftButtonContainer[_ngcontent-%COMP%], .Carousel-rightButtonContainer[_ngcontent-%COMP%]{align-items:center;bottom:0;cursor:pointer;display:flex;flex-direction:column;height:100vh;justify-content:center;position:absolute;top:0;z-index:10331}.center-vertical[_ngcontent-%COMP%]{align-items:center;height:100vh}.Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-leftButton[_ngcontent-%COMP%], .Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-rightButton[_ngcontent-%COMP%]{border-color:grey;color:grey;filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}.Carousel-leftButtonContainer[_ngcontent-%COMP%]:hover, .Carousel-rightButtonContainer[_ngcontent-%COMP%]:hover{border-color:var(--ak-color-2);color:var(--ak-color-2)}.CircularButton.CircularButton--medium[_ngcontent-%COMP%]{height:45px;width:45px}.Carousel-leftButton[_ngcontent-%COMP%], .Carousel-rightButton[_ngcontent-%COMP%]{box-shadow:0 5px 20px 0 rgba(21,27,38,.08)}.CircularButton--circular[_ngcontent-%COMP%]{background:#fff;border:1px solid #b7bfc6;border-radius:50%;box-sizing:border-box;color:#848f99;fill:#848f99;flex:0 0 auto;font-size:13px;height:30px;line-height:1;transition:box-shadow .2s,color .2s,background .2s,fill .2s,border-color .2s;width:30px}.CircularButton[_ngcontent-%COMP%]{align-items:center;display:inline-flex;justify-content:center}a[_ngcontent-%COMP%]{color:#14aaf5;cursor:pointer;text-decoration:none}.AttachmentMetadataBar[_ngcontent-%COMP%]{align-items:center;background-color:#000;border-bottom:1px solid rgba(100,111,121,.4);color:#fff;display:flex;flex:0 0 auto;font-size:16px;font-weight:400;line-height:20px}.AttachmentsCarousel[_ngcontent-%COMP%]{background-color:#0c0c0c;display:flex;flex:1 1 auto;flex-direction:column;min-height:1px;min-width:1px;width:100%}.CloseButton[_ngcontent-%COMP%]{align-items:center;display:inline-flex;fill:#848f99}.AttachmentImageWithRotation[_ngcontent-%COMP%]{align-items:center;box-sizing:border-box;display:flex;flex-direction:column;height:100%;justify-content:center;position:relative;width:100%}.AttachmentImageWithRotation-image[_ngcontent-%COMP%]{background-color:#fff;flex:0 1 auto;max-height:100%;max-width:100%;min-height:1px;width:auto}.AttachmentsCarousel-previewImage.AttachmentsCarouselSlide[_ngcontent-%COMP%]{border-left-width:65px;border-right-width:65px}.AttachmentsCarouselSlide[_ngcontent-%COMP%]{background:#000}.Carousel-child[_ngcontent-%COMP%]{height:100%;left:0;position:absolute;top:0;width:100%}.AttachmentsCarouselPlaceholder-nonImagePlaceholder[_ngcontent-%COMP%]{align-items:center;color:#fff;display:flex;flex-direction:column}.AttachmentMetadataBar-left[_ngcontent-%COMP%]{align-items:center;display:flex;flex:1 1 auto;justify-content:space-between;margin-right:20px;min-width:1px}.AttachmentMetadataBar-attachmentDetails[_ngcontent-%COMP%]{display:flex;flex:1 1 auto;flex-direction:column;margin-left:20px;margin-right:20px;min-width:1px}.AttachmentMetadataBar-attachmentName[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.AttachmentMetadataBar-attachmentCreatedTime[_ngcontent-%COMP%]{color:#848f99}.AttachmentMetadataBar-attachmentButtons[_ngcontent-%COMP%]{display:flex;flex-direction:row}.AttachmentMetadataBar-closeButton[_ngcontent-%COMP%]   .Icon[_ngcontent-%COMP%]{height:24px;width:24px}.AttachmentMetadataBar-closeButton[_ngcontent-%COMP%]{fill:#fff;opacity:.5}.AttachmentMetadataBar-annotateIcon[_ngcontent-%COMP%], .AttachmentMetadataBar-downloadIcon[_ngcontent-%COMP%]{flex:0 0 auto;margin-right:10px}.Icon[_ngcontent-%COMP%]{height:16px;width:16px}foreignObject[_ngcontent-%COMP%], image[_ngcontent-%COMP%], marker[_ngcontent-%COMP%], pattern[_ngcontent-%COMP%], svg[_ngcontent-%COMP%]:not(:root), symbol[_ngcontent-%COMP%], user[_ngcontent-%COMP%]   agent[_ngcontent-%COMP%]   stylesheet[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]:not(:root){overflow:hidden}.Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-leftButton[_ngcontent-%COMP%], .Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-rightButton[_ngcontent-%COMP%]{background:transparent;border-color:#fff;color:#fff;fill:#fff}.AttachmentMetadataBar-right[_ngcontent-%COMP%]{align-items:center;border-left:1px solid rgba(100,111,121,.4);display:flex;flex:0 0 auto;height:60px;justify-content:center;width:60px}.AttachmentsCarousel-carouselContainer[_ngcontent-%COMP%]{display:flex;flex:1 1 auto;flex-direction:row;min-height:1px}.AttachmentsCarousel-carousel[_ngcontent-%COMP%]{flex:1 1 auto;min-width:1px}.Carousel[_ngcontent-%COMP%]{overflow:hidden;position:relative;z-index:100}.AttachmentsCarousel-previewImage[_ngcontent-%COMP%]{border-left-width:65px;border-right-width:65px}.AttachmentsCarouselSlide[_ngcontent-%COMP%]{align-items:center;border:20px solid transparent;box-sizing:border-box;display:flex;flex-direction:column;justify-content:center}.AttachmentMetadataBar-downloadLink[_ngcontent-%COMP%], .AttachmentMetadataBar-openOriginalLink[_ngcontent-%COMP%], .AttachmentMetadataBar-proofingToggle[_ngcontent-%COMP%]{align-items:center;border-radius:4px;color:#fff;display:flex;fill:#fff;flex:0 0 auto;height:40px;margin-right:15px;padding:0 10px;white-space:nowrap}.SingleTaskPaneSpreadsheet-header[_ngcontent-%COMP%]{background:#fff;flex-shrink:0}.SingleTaskPaneToolbar[_ngcontent-%COMP%]{height:80px}.SingleTaskPaneToolbar-button[_ngcontent-%COMP%]{flex-shrink:0;height:80px;margin-left:4px}.SingleTaskPaneToolbarAnimation-row[_ngcontent-%COMP%]{align-items:flex-end;box-sizing:border-box;display:flex;height:40px;max-width:10000px;opacity:1;overflow:hidden;padding-left:2px;transition:opacity .2s ease-in}.SingleTaskPaneToolbarAnimation[_ngcontent-%COMP%]{flex-grow:1;height:80px;margin-right:16px;min-width:1px;overflow-y:hidden;width:100%}.SingleTaskPaneToolbarAnimation-title[_ngcontent-%COMP%]{cursor:pointer;flex-grow:1;font-size:16px;line-height:56px;overflow:hidden;padding:28px 0;text-overflow:ellipsis;white-space:nowrap}.inline[_ngcontent-%COMP%]{float:left}.description[_ngcontent-%COMP%]{font-size:1rem}.description-2[_ngcontent-%COMP%]{font-size:14px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:40px}.img-folder[_ngcontent-%COMP%]{width:30px}@media (max-width:768px){.description[_ngcontent-%COMP%]{font-size:15px}.box-rq-detail[_ngcontent-%COMP%]{max-height:60vh!important;overflow-y:scroll}.description-2[_ngcontent-%COMP%]{font-size:13px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:30px!important}.img-folder[_ngcontent-%COMP%]{width:26px}}.box-rq-detail[_ngcontent-%COMP%]{max-height:73vh;overflow-y:scroll}.contex[_ngcontent-%COMP%]{padding-top:20px}@media (max-width:768px){.contex[_ngcontent-%COMP%]{height:90vh!important;padding-top:0}}.ak-text-req-name[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.min-h[_ngcontent-%COMP%]{height:32px}.des-rq[_ngcontent-%COMP%]{background:#f3f3f3;border-radius:10px;color:#444}.fz-14[_ngcontent-%COMP%]{font-size:14px}.bobillo[_ngcontent-%COMP%]{width:50px}.blink_me[_ngcontent-%COMP%]{-webkit-animation:blinker 2s linear infinite;animation:blinker 2s linear infinite}@-webkit-keyframes blinker{50%{opacity:0}}@keyframes blinker{50%{opacity:0}}.description-3[_ngcontent-%COMP%]{font-size:18px!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RequirementUploadBriefcaseComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-requirement-upload-briefcase',
                templateUrl: './requirement-upload-briefcase.component.html',
                styleUrls: ['./requirement-upload-briefcase.component.css']
            }]
    }], function () { return [{ type: DatePipe }, { type: AkeelaTemplateService }, { type: ElementRef }, { type: HttpService }, { type: I18nPipe }, { type: UploadService }, { type: RequirementsService }, { type: ErrorService }, { type: LocalService }, { type: SwalPortalTargets }]; }, { requirement: [{
            type: Input
        }], config: [{
            type: Input
        }], requirements: [{
            type: Input
        }], close: [{
            type: Output
        }], showFile: [{
            type: Output
        }], response: [{
            type: Output
        }], finishupload: [{
            type: Output
        }], updatefiles: [{
            type: Output
        }], doSomethingOnWindowsScroll: [{
            type: HostListener,
            args: ['scroll', ['$event']]
        }] }); })();

function RequirementsBriefcaseComponent_ng_template_1_div_0_div_9_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "akeela-requirement-upload-briefcase", 18);
    ɵɵlistener("showFile", function RequirementsBriefcaseComponent_ng_template_1_div_0_div_9_ng_container_4_Template_akeela_requirement_upload_briefcase_showFile_1_listener($event) { ɵɵrestoreView(_r11); const ctx_r10 = ɵɵnextContext(4); return ctx_r10.show_file($event); })("finishupload", function RequirementsBriefcaseComponent_ng_template_1_div_0_div_9_ng_container_4_Template_akeela_requirement_upload_briefcase_finishupload_1_listener($event) { ɵɵrestoreView(_r11); const ctx_r12 = ɵɵnextContext(4); return ctx_r12.finish_upload($event); })("response", function RequirementsBriefcaseComponent_ng_template_1_div_0_div_9_ng_container_4_Template_akeela_requirement_upload_briefcase_response_1_listener($event) { ɵɵrestoreView(_r11); const ctx_r13 = ɵɵnextContext(4); return ctx_r13.emit_response($event); })("updatefiles", function RequirementsBriefcaseComponent_ng_template_1_div_0_div_9_ng_container_4_Template_akeela_requirement_upload_briefcase_updatefiles_1_listener($event) { ɵɵrestoreView(_r11); const ctx_r14 = ɵɵnextContext(4); return ctx_r14.update_files($event); })("close", function RequirementsBriefcaseComponent_ng_template_1_div_0_div_9_ng_container_4_Template_akeela_requirement_upload_briefcase_close_1_listener() { ɵɵrestoreView(_r11); const ctx_r15 = ɵɵnextContext(4); return ctx_r15.close_window(); });
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("requirement", ctx_r9.currentRequirement)("requirements", ctx_r9.requirements)("config", ctx_r9.config);
} }
function RequirementsBriefcaseComponent_ng_template_1_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 16);
    ɵɵelement(2, "span", 17);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
    ɵɵtemplate(4, RequirementsBriefcaseComponent_ng_template_1_div_0_div_9_ng_container_4_Template, 2, 3, "ng-container", 6);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext(3);
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 2, ctx_r7.currentRequirement == null ? null : ctx_r7.currentRequirement.name), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", !ctx_r7.show_window_requirement_close);
} }
function RequirementsBriefcaseComponent_ng_template_1_div_0_div_10_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "option", 22);
    ɵɵpipe(2, "i18n");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const option_r18 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("value", option_r18 == null ? null : option_r18.identifier)("innerHTML", ɵɵpipeBind1(2, 2, option_r18 == null ? null : option_r18.name), ɵɵsanitizeHtml);
} }
function RequirementsBriefcaseComponent_ng_template_1_div_0_div_10_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "akeela-requirement-upload-briefcase", 18);
    ɵɵlistener("showFile", function RequirementsBriefcaseComponent_ng_template_1_div_0_div_10_ng_container_5_Template_akeela_requirement_upload_briefcase_showFile_1_listener($event) { ɵɵrestoreView(_r20); const ctx_r19 = ɵɵnextContext(4); return ctx_r19.show_file($event); })("finishupload", function RequirementsBriefcaseComponent_ng_template_1_div_0_div_10_ng_container_5_Template_akeela_requirement_upload_briefcase_finishupload_1_listener($event) { ɵɵrestoreView(_r20); const ctx_r21 = ɵɵnextContext(4); return ctx_r21.finish_upload($event); })("response", function RequirementsBriefcaseComponent_ng_template_1_div_0_div_10_ng_container_5_Template_akeela_requirement_upload_briefcase_response_1_listener($event) { ɵɵrestoreView(_r20); const ctx_r22 = ɵɵnextContext(4); return ctx_r22.emit_response($event); })("updatefiles", function RequirementsBriefcaseComponent_ng_template_1_div_0_div_10_ng_container_5_Template_akeela_requirement_upload_briefcase_updatefiles_1_listener($event) { ɵɵrestoreView(_r20); const ctx_r23 = ɵɵnextContext(4); return ctx_r23.update_files($event); })("close", function RequirementsBriefcaseComponent_ng_template_1_div_0_div_10_ng_container_5_Template_akeela_requirement_upload_briefcase_close_1_listener() { ɵɵrestoreView(_r20); const ctx_r24 = ɵɵnextContext(4); return ctx_r24.close_window(); });
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("requirement", ctx_r17.currentRequirement)("requirements", ctx_r17.requirements)("config", ctx_r17.config);
} }
function RequirementsBriefcaseComponent_ng_template_1_div_0_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "select", 19);
    ɵɵlistener("ngModelChange", function RequirementsBriefcaseComponent_ng_template_1_div_0_div_10_Template_select_ngModelChange_1_listener($event) { ɵɵrestoreView(_r26); const ctx_r25 = ɵɵnextContext(3); return ctx_r25.rqOther = $event; })("change", function RequirementsBriefcaseComponent_ng_template_1_div_0_div_10_Template_select_change_1_listener() { ɵɵrestoreView(_r26); const ctx_r27 = ɵɵnextContext(3); return ctx_r27.changeOtherRq(ctx_r27.rqOther); });
    ɵɵelementStart(2, "option", 20);
    ɵɵtext(3, "Seleccione");
    ɵɵelementEnd();
    ɵɵtemplate(4, RequirementsBriefcaseComponent_ng_template_1_div_0_div_10_ng_container_4_Template, 3, 4, "ng-container", 21);
    ɵɵelementEnd();
    ɵɵtemplate(5, RequirementsBriefcaseComponent_ng_template_1_div_0_div_10_ng_container_5_Template, 2, 3, "ng-container", 6);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("value", ctx_r8.rqOther)("ngModel", ctx_r8.rqOther);
    ɵɵadvance(1);
    ɵɵproperty("selected", true);
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r8.rqOtherList);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r8.show_window_requirement_close && ctx_r8.rqOther != "");
} }
function RequirementsBriefcaseComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 8);
    ɵɵlistener("click", function RequirementsBriefcaseComponent_ng_template_1_div_0_Template_div_click_0_listener() { ɵɵrestoreView(_r29); const ctx_r28 = ɵɵnextContext(2); return ctx_r28.close_window(); });
    ɵɵelementStart(1, "div", 9);
    ɵɵlistener("click", function RequirementsBriefcaseComponent_ng_template_1_div_0_Template_div_click_1_listener() { ɵɵrestoreView(_r29); const ctx_r30 = ɵɵnextContext(2); return ctx_r30.close_window(); });
    ɵɵelementStart(2, "div", 10);
    ɵɵlistener("click", function RequirementsBriefcaseComponent_ng_template_1_div_0_Template_div_click_2_listener($event) { ɵɵrestoreView(_r29); return $event == null ? null : $event.stopPropagation(); });
    ɵɵelementContainerStart(3);
    ɵɵelementStart(4, "div", 11);
    ɵɵelementStart(5, "div", 12);
    ɵɵlistener("click", function RequirementsBriefcaseComponent_ng_template_1_div_0_Template_div_click_5_listener() { ɵɵrestoreView(_r29); const ctx_r32 = ɵɵnextContext(2); return ctx_r32.close_window(); });
    ɵɵelement(6, "i", 13);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 14);
    ɵɵelementStart(8, "div", 15);
    ɵɵtemplate(9, RequirementsBriefcaseComponent_ng_template_1_div_0_div_9_Template, 5, 4, "div", 6);
    ɵɵtemplate(10, RequirementsBriefcaseComponent_ng_template_1_div_0_div_10_Template, 6, 5, "div", 6);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext(2);
    ɵɵadvance(9);
    ɵɵproperty("ngIf", !(ctx_r6.config == null ? null : ctx_r6.config.endpoints == null ? null : ctx_r6.config.endpoints.getOtherRequirements));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r6.config == null ? null : ctx_r6.config.endpoints == null ? null : ctx_r6.config.endpoints.getOtherRequirements);
} }
function RequirementsBriefcaseComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵtemplate(0, RequirementsBriefcaseComponent_ng_template_1_div_0_Template, 11, 2, "div", 7);
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("ngIf", ctx_r0.show_window_requirement);
} }
function RequirementsBriefcaseComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "akeela-requirement-detail", 18);
    ɵɵlistener("showFile", function RequirementsBriefcaseComponent_ng_template_2_Template_akeela_requirement_detail_showFile_0_listener($event) { ɵɵrestoreView(_r34); const ctx_r33 = ɵɵnextContext(); return ctx_r33.show_file($event); })("finishupload", function RequirementsBriefcaseComponent_ng_template_2_Template_akeela_requirement_detail_finishupload_0_listener($event) { ɵɵrestoreView(_r34); const ctx_r35 = ɵɵnextContext(); return ctx_r35.finish_upload($event); })("response", function RequirementsBriefcaseComponent_ng_template_2_Template_akeela_requirement_detail_response_0_listener($event) { ɵɵrestoreView(_r34); const ctx_r36 = ɵɵnextContext(); return ctx_r36.emit_response($event); })("updatefiles", function RequirementsBriefcaseComponent_ng_template_2_Template_akeela_requirement_detail_updatefiles_0_listener($event) { ɵɵrestoreView(_r34); const ctx_r37 = ɵɵnextContext(); return ctx_r37.update_files($event); })("close", function RequirementsBriefcaseComponent_ng_template_2_Template_akeela_requirement_detail_close_0_listener() { ɵɵrestoreView(_r34); const ctx_r38 = ɵɵnextContext(); return ctx_r38.close_window(); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("requirement", ctx_r2.currentRequirement)("requirements", ctx_r2.requirements)("config", ctx_r2.config);
} }
function RequirementsBriefcaseComponent_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function RequirementsBriefcaseComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 23);
    ɵɵtemplate(1, RequirementsBriefcaseComponent_div_5_ng_container_1_Template, 1, 0, "ng-container", 24);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r3.templates["requirementsHeaderContent"]);
} }
function RequirementsBriefcaseComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 25);
    ɵɵelement(2, "img", 26);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r61 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 43);
    ɵɵelementStart(1, "div", 44);
    ɵɵelementStart(2, "div", 45);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelement(4, "div", 46);
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 47);
    ɵɵelementStart(6, "app-preview-img", 48);
    ɵɵlistener("response", function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_div_6_div_1_Template_app_preview_img_response_6_listener($event) { ɵɵrestoreView(_r61); const ctx_r60 = ɵɵnextContext(7); return ctx_r60.getResponsePreview($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const row3_r57 = ctx.$implicit;
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", row3_r57.name, "");
    ɵɵadvance(3);
    ɵɵproperty("identifier", row3_r57 == null ? null : row3_r57.identifier);
} }
function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 41);
    ɵɵtemplate(1, RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_div_6_div_1_Template, 7, 2, "div", 42);
    ɵɵelementEnd();
} if (rf & 2) {
    const row2_r49 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", row2_r49.requirementArchives);
} }
function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_hr_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "hr", 49);
} }
function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 50);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const row2_r49 = ɵɵnextContext().$implicit;
    const ctx_r54 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r54.files[row2_r49 == null ? null : row2_r49.requirement == null ? null : row2_r49.requirement.identifier] == null ? null : ctx_r54.files[row2_r49 == null ? null : row2_r49.requirement == null ? null : row2_r49.requirement.identifier].object == null ? null : ctx_r54.files[row2_r49 == null ? null : row2_r49.requirement == null ? null : row2_r49.requirement.identifier].object.responseDescription, " ");
} }
function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 17);
} if (rf & 2) {
    const row2_r49 = ɵɵnextContext().$implicit;
    ɵɵproperty("innerHTML", row2_r49 == null ? null : row2_r49.requirement == null ? null : row2_r49.requirement.description, ɵɵsanitizeHtml);
} }
function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r66 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 32);
    ɵɵelementStart(2, "div", 33);
    ɵɵpipe(3, "i18n");
    ɵɵelement(4, "div", 34);
    ɵɵpipe(5, "i18n");
    ɵɵtemplate(6, RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_div_6_Template, 2, 1, "div", 35);
    ɵɵelementStart(7, "div");
    ɵɵtemplate(8, RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_hr_8_Template, 1, 0, "hr", 36);
    ɵɵtemplate(9, RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_div_9_Template, 2, 1, "div", 37);
    ɵɵelementEnd();
    ɵɵtemplate(10, RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_div_10_Template, 1, 1, "div", 38);
    ɵɵelementStart(11, "div", 39);
    ɵɵelementStart(12, "button", 40);
    ɵɵlistener("click", function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_Template_button_click_12_listener() { ɵɵrestoreView(_r66); const row2_r49 = ctx.$implicit; const ctx_r65 = ɵɵnextContext(5); return !(ctx_r65.config == null ? null : ctx_r65.config.endpoints == null ? null : ctx_r65.config.endpoints.getOtherRequirements) ? ctx_r65.open_window(row2_r49.requirement) : ctx_r65.open_window_other_modal(); });
    ɵɵtext(13, "Adjuntar ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const row2_r49 = ctx.$implicit;
    const ctx_r48 = ɵɵnextContext(5);
    ɵɵadvance(2);
    ɵɵclassMapInterpolate1(" rq section-box ", ctx_r48.akGrid != 1 ? "h-100" : "", "  p-2 pb-3 pt-3 text-dark");
    ɵɵproperty("title", ɵɵpipeBind1(3, 9, row2_r49 == null ? null : row2_r49.requirement == null ? null : row2_r49.requirement.name));
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(5, 11, row2_r49 == null ? null : row2_r49.requirement == null ? null : row2_r49.requirement.name), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", (row2_r49.requirementArchives == null ? null : row2_r49.requirementArchives.length) >= 1);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r48.files[row2_r49 == null ? null : row2_r49.requirement == null ? null : row2_r49.requirement.identifier] == null ? null : ctx_r48.files[row2_r49 == null ? null : row2_r49.requirement == null ? null : row2_r49.requirement.identifier].object == null ? null : ctx_r48.files[row2_r49 == null ? null : row2_r49.requirement == null ? null : row2_r49.requirement.identifier].object.responseDescription);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r48.files[row2_r49 == null ? null : row2_r49.requirement == null ? null : row2_r49.requirement.identifier] == null ? null : ctx_r48.files[row2_r49 == null ? null : row2_r49.requirement == null ? null : row2_r49.requirement.identifier].object == null ? null : ctx_r48.files[row2_r49 == null ? null : row2_r49.requirement == null ? null : row2_r49.requirement.identifier].object.responseDescription);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r48.config.isDetailEnable);
} }
function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 31);
    ɵɵtemplate(2, RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_ng_container_2_Template, 14, 13, "ng-container", 21);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement_r42 = ɵɵnextContext().$implicit;
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", requirement_r42.value);
} }
function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_6_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 53);
    ɵɵpipe(1, "i18n");
    ɵɵpipe(2, "i18n");
} if (rf & 2) {
    const ctx_r68 = ɵɵnextContext(5);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, "@i18n-no-requirements-criteria") + ɵɵpipeBind1(2, 3, ctx_r68.config.filterRequirementsByResponse.state), ɵɵsanitizeHtml);
} }
function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "div", 51);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_6_div_3_Template, 3, 5, "div", 52);
    ɵɵelement(4, "hr");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r46 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 2, "@i18n-no-requirements"), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r46.config.isFilterRequirementsByResponse);
} }
function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_akeela_considerations_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-considerations", 54);
} if (rf & 2) {
    const requirement_r42 = ɵɵnextContext().$implicit;
    const ctx_r47 = ɵɵnextContext(3);
    ɵɵproperty("considerations", ctx_r47.getConsiderations(requirement_r42.index));
} }
function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 14);
    ɵɵelementStart(1, "div", 28);
    ɵɵelementStart(2, "div", 29);
    ɵɵelement(3, "div", 17);
    ɵɵpipe(4, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(5, RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_5_Template, 3, 1, "ng-container", 6);
    ɵɵtemplate(6, RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_ng_container_6_Template, 5, 4, "ng-container", 6);
    ɵɵelement(7, "br");
    ɵɵtemplate(8, RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_akeela_considerations_8_Template, 1, 1, "akeela-considerations", 30);
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement_r42 = ctx.$implicit;
    const ctx_r41 = ɵɵnextContext(3);
    ɵɵadvance(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(4, 4, requirement_r42.index), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", requirement_r42.value.length > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement_r42.value.length === 0);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r41.config.isEnableConsiderationsByCategory);
} }
function RequirementsBriefcaseComponent_ng_container_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementsBriefcaseComponent_ng_container_9_ng_container_1_div_1_Template, 9, 6, "div", 27);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r40 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r40.requirements);
} }
function RequirementsBriefcaseComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, RequirementsBriefcaseComponent_ng_container_9_ng_container_1_Template, 2, 1, "ng-container", 6);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.requirements.length > 0);
} }
class RequirementsBriefcaseComponent {
    constructor(templateService, _httpService, _requerementsService, _upload, _error, _i18n) {
        this.templateService = templateService;
        this._httpService = _httpService;
        this._requerementsService = _requerementsService;
        this._upload = _upload;
        this._error = _error;
        this._i18n = _i18n;
        this.showFile = new EventEmitter();
        this.response = new EventEmitter();
        this.openWindowRequirement = new EventEmitter(false);
        this.finishupload = new EventEmitter();
        this.templates = {};
        this.inputreadonly = false;
        this.readonly = false;
        this.activate_physical_file = false;
        this.selected = null;
        this.requirements = null;
        this.transactionrequirement = null;
        this.files = {};
        this.currentRequirement = null;
        this.show_window_requirement = false;
        this.show_window_requirement_close = true;
        this.activate_save_checkmark = false;
        this.check_doc_physical = [];
        this.submit_disabled = false;
        this.response_active = false;
        this.categories = null;
        this.considerations_plan = null;
        this.animate_init = true;
        this.screenMin = false;
        this.akFocus = {};
        this.akGrid = 2;
        this.rqOtherList = [];
        this.rqOther = "";
        this.deleteFile = () => {
        };
        this.listOtherReq = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._httpService.executeRequest(this.config.endpoints.getOtherRequirements.name, this.config.endpoints.getOtherRequirements.params, true).toPromise();
                let arr = [];
                for (const property in response) {
                    let arrTemp = response[property];
                    arrTemp === null || arrTemp === void 0 ? void 0 : arrTemp.forEach(value => {
                        arr = [...arr, value];
                    });
                    //  console.log(`${response[property]}`);
                }
                this.rqOtherList = arr;
            }
            catch (error) {
                console.log(error);
            }
        });
    }
    ngOnDestroy() {
        // this.close_window();
    }
    ngOnInit() {
        if (this.config.endpoints.getOtherRequirements) {
            this.listOtherReq();
        }
        if (screen.width < 768) {
            this.screenMin = true;
        }
        else {
            this.screenMin = false;
        }
        // this.getCategories();
        // this._upload.getChangresFilesArr().subscribe((files: any) => {
        //   this.initFiles();
        // });
        this.initFiles();
    }
    getCategories() {
        this._httpService.executeRequest(this.config.endpoints.getCategoriesByPlan.name, this.config.endpoints.getCategoriesByPlan.params, true).subscribe((response) => {
            this.categories = response;
        });
    }
    initFiles() {
        this._httpService.executeRequest(this.config.endpoints.getRequirements.name, this.config.endpoints.getRequirements.params, true).subscribe((response) => {
            var _a;
            let requirements = this._requerementsService.format_response2(response, this.config);
            for (const row in requirements) {
                let rql = requirements[row];
                for (const row2 in rql.value) {
                    let rq = rql.value[row2];
                    if ((this.validateRequiredRule(rq === null || rq === void 0 ? void 0 : rq.requirement))) {
                        requirements[row]['contentOblig'] = true;
                    }
                }
            }
            this.requirements = requirements;
            this.files = this._upload.files[this.config.viewName] = this._requerementsService.loadFileObject(this.requirements, this.config, (_a = this.config) === null || _a === void 0 ? void 0 : _a.baseEndpoint);
        });
    }
    validateRequiredRule(requirement) {
        return this._requerementsService.validateRequiredRule(this.config, requirement);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
    open_window_other_modal() {
        // console.log("entro open wd");
        if (this.show_window_requirement) {
            setTimeout(() => {
                this.show_window_requirement_close = true;
                this.openWindowRequirement.emit(false);
            }, 0);
        }
        setTimeout(() => {
            this.show_window_requirement = true;
            this.animate_init = false;
            this.show_window_requirement_close = false;
            this.openWindowRequirement.emit(false);
        }, 60);
    }
    changeOtherRq(identifier) {
        if (identifier != "") {
            let tmp = this.rqOtherList.filter((value) => (value === null || value === void 0 ? void 0 : value.identifier) == identifier);
            this.open_window(tmp[0]);
        }
    }
    open_window(requirement) {
        // console.log("entro open wd");
        if (this.show_window_requirement) {
            setTimeout(() => {
                this.show_window_requirement_close = true;
                this.openWindowRequirement.emit(false);
            }, 0);
            setTimeout(() => {
                this.open_rq(requirement);
            }, 60);
        }
        else {
            this.open_rq(requirement);
        }
    }
    open_rq(requirement) {
        this._upload.resetChangeRequirementById();
        // window.scroll(0, 0);
        this.currentRequirement = requirement;
        // this._requerementsService.setUpdateModalRQ(true);
        this.show_window_requirement = true;
        this.animate_init = false;
        this.show_window_requirement_close = false;
        this.openWindowRequirement.emit(true);
    }
    close_window() {
        setTimeout(() => {
            this.openWindowRequirement.emit(false);
            this.show_window_requirement_close = true;
        }, 600);
        this.show_window_requirement = false;
    }
    show_file(file) {
        this.showFile.emit(file);
    }
    emit_response(response) {
        this.response.emit(response);
        this.finish_upload(response);
    }
    finish_upload(response) {
        console.log(response);
        this.finishupload.emit(true);
        this.show_window_requirement = false;
        this.wait();
        setTimeout(() => {
            swal.close();
            this.initFiles();
        }, 3000);
    }
    wait() {
        swal.fire({
            title: '',
            showCancelButton: false,
            showCloseButton: false,
            showConfirmButton: false,
            html: '<b>' + this._i18n.transform('@i18n-text-please-wait') + '...<b><br><i class="fa fa-spin fa-spinner"></i>',
        });
    }
    update_files($event) {
        this.files = $event;
        // console.log(this.files);
    }
    isCompletedResponses() {
        for (const index in this.files) {
            if ((isNullOrUndefined(this.files[index].response) || this.files[index].response === this.config.statusResponseRequirement.inconsistent) && this.validateRequiredRule(this.files[index].object.requirement)) {
                return false;
            }
        }
        return true;
    }
    updateDocRecibido(event) {
        this.activate_save_checkmark = true;
        if (event.checked) {
            this.check_doc_physical[event.identifier].checked = !this.check_doc_physical[event.identifier].checked;
        }
        else {
            this.check_doc_physical[event.identifier].checked = false;
        }
    }
    updateDocRecibidoPrepareArray() {
        const object_send = [];
        const object = {};
        this.submit_disabled = true;
        this.activate_save_checkmark = true;
        // tslint:disable-next-line:forin
        for (const index in this.files) {
            if (this.check_doc_physical[index].checked === true && (this.check_doc_physical[index].consigned === false || isNullOrUndefined(this.check_doc_physical[index].consigned))) {
                if (this.files[index].object.identifier !== null) {
                    object_send.push({
                        identifier: this.files[index].object.identifier,
                        consigned: true,
                        consignedUsername: this.config.endpoints.saveRequirementPhysical.format.consignedUsername
                    });
                }
                else {
                    object_send.push({
                        transaction: { identifier: this.files[index].object.transaction.identifier },
                        requirement: { identifier: this.files[index].object.requirement.identifier },
                        person: { identifier: this.config.endpoints.saveRequirementPhysical.format.person.identifier },
                        consigned: true,
                        consignedUsername: this.config.endpoints.saveRequirementPhysical.format.consignedUsername
                    });
                }
            }
            else if (this.check_doc_physical[index].checked === false && this.check_doc_physical[index].consigned === true) {
                if (this.files[index].object.identifier !== null) {
                    object_send.push({
                        identifier: this.files[index].object.identifier,
                        consigned: false,
                        consignedUsername: this.config.endpoints.saveRequirementPhysical.format.consignedUsername
                    });
                }
                else {
                    object_send.push({
                        transaction: { identifier: this.files[index].object.transaction.identifier },
                        requirement: { identifier: this.files[index].object.requirement.identifier },
                        person: { identifier: this.config.endpoints.saveRequirementPhysical.format.person.identifier },
                        consigned: false,
                        consignedUsername: this.config.endpoints.saveRequirementPhysical.format.consignedUsername
                    });
                }
            }
        }
        this.config.endpoints.saveRequirementPhysical.params.body = {
            transactionRequirements: object_send
        };
        this._httpService.executeRequest(this.config.endpoints.saveRequirementPhysical.name, this.config.endpoints.saveRequirementPhysical.params, true).subscribe((response) => {
        }, error => {
            this._error.show(error);
        });
    }
    download_files() {
        this._httpService.executeRequest(this.config.endpoints.downloadAllFilesZip.name, this.config.endpoints.downloadAllFilesZip.params, true).subscribe((response) => {
            if (!isNullOrUndefined(response)) {
                response['action'] = 'downloadzip';
                if (true) {
                    response['deleteAfterShow'] = this.config.endpoints.deleteArchive;
                    response['deleteAfterShow']['params']['body']['identifier'] = response.identifier;
                    // this._httpService.executeRequest(response.deleteAfterShow.name, response.deleteAfterShow.params, true).subscribe((del: any) => {
                    // }, error => {
                    // });
                }
            }
            this.showFile.emit(response);
        }, error => {
            this._error.show(error);
        });
    }
    ak_sanatize_html(text) {
        return text.replace(/<[^>]*>/g, '');
    }
    getConsiderations(category) {
        const response = [];
        if (!isNullOrUndefined(this.categories)) {
            response.push(this.categories.filter((cat) => {
                return cat.name === category;
            }));
            if (response.length > 0) {
                return response[0].alternateName;
            }
        }
        return response;
    }
    trash_file(idfile, idrequirement) {
        swal.fire({
            title: this._i18n.transform('@i18n-popup-text-delete-question'),
            text: this._i18n.transform('@i18n-popup-text-delete-question-text'),
            showCancelButton: true,
            confirmButtonText: this._i18n.transform('@i18n-popup-text-yes'),
            cancelButtonText: this._i18n.transform('@i18n-popup-text-no'),
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                //&& this.validateSpecialApplySpecialCase(this.transactionrequirement.response)
                if ((this.config.isEnableLogicDelete)) {
                    const params = this.config.endpoints.saveLogicArchiveDelete.params;
                    params.path.idRequirement = idrequirement;
                    params.path.idArchive = idfile;
                    this._httpService.executeRequest(this.config.endpoints.saveLogicArchiveDelete.name, params, true).subscribe((response) => {
                        if (!isNullOrUndefined(response)) {
                            this._upload.setResponseUpload({
                                body: {
                                    transaction: {
                                        identifier: response
                                    }
                                }
                            });
                        }
                        // this.loaded = false;
                        // this.list = 'LOADING';
                        this._upload.setChangeRequirementById(idrequirement);
                    });
                }
                else {
                    const params = this.config.endpoints.deleteRequirement.params;
                    params.body.requirement.identifier = idrequirement;
                    params.body.requirementArchives[0].identifier = idfile;
                    this._httpService.executeRequest(this.config.endpoints.deleteRequirement.name, this.config.endpoints.deleteRequirement.params, true).subscribe((response) => {
                        // console.log('El delete Responde: ' + this.requirement.identifier);
                        // this.loaded = false;
                        // this.list = 'LOADING';
                        this._upload.setChangeRequirementById(idrequirement);
                    }, error => {
                        this._error.show(error);
                    });
                }
            }
        });
    }
    getResponsePreview(response) {
    }
}
/** @nocollapse */ RequirementsBriefcaseComponent.ɵfac = function RequirementsBriefcaseComponent_Factory(t) { return new (t || RequirementsBriefcaseComponent)(ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(RequirementsService), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(ErrorService), ɵɵdirectiveInject(I18nPipe)); };
/** @nocollapse */ RequirementsBriefcaseComponent.ɵcmp = ɵɵdefineComponent({ type: RequirementsBriefcaseComponent, selectors: [["akeela-requirements-briefcase"]], inputs: { config: "config", folder: "folder", viewOptional: "viewOptional" }, outputs: { showFile: "showFile", response: "response", openWindowRequirement: "openWindowRequirement", finishupload: "finishupload" }, decls: 10, vars: 4, consts: [["akeelaRequirementsContent", "", 3, "componentName"], ["requirement", ""], [1, "animated", "fadeIn"], ["class", "box", 4, "ngIf"], [1, "box", "p-b-1"], [1, "col-12"], [4, "ngIf"], ["class", "ak-form-modal full-modal teme-gray compleat-modal", 3, "click", 4, "ngIf"], [1, "ak-form-modal", "full-modal", "teme-gray", "compleat-modal", 3, "click"], [1, "body", "ml-2", "mr-2", 3, "click"], [1, "container", "bg-white", "mb-2", "radius", 3, "click"], [1, "d-flex", "w-100", "pt-3"], [1, "ml-auto", "text-right", 3, "click"], [1, "fas", "fa-times", 2, "font-size", "1.5rem"], [1, "w-100"], [1, "d-block", "overflow-auto", "pb-5", 2, "max-height", "100%", "background", "#fcfcfc"], [1, "description-3text-center", "font-weight-bold", "pr-2", "w-100", "mb-4"], [3, "innerHTML"], [3, "requirement", "requirements", "config", "showFile", "finishupload", "response", "updatefiles", "close"], [1, "form-control", 3, "value", "ngModel", "ngModelChange", "change"], ["value", "", 3, "selected"], [4, "ngFor", "ngForOf"], [3, "value", "innerHTML"], [1, "box"], [4, "ngTemplateOutlet"], [1, "col-12", "p-t-1", "p-b-1"], ["src", "./assets/public/images/loading.gif", "alt", ""], ["class", "w-100", 4, "ngFor", "ngForOf"], [1, "font-weight-normal", "mt-2", "mt-4"], [1, "d-flex", "justify-content-star"], [3, "considerations", 4, "ngIf"], [1, "row"], [1, "col-12", "fz-14", "mt-4"], [2, "cursor", "auto", 3, "title"], [1, "animate__animated", "animate__fadeIn", "pl-2", "pb-3", "img-briefcase-box", 3, "innerHTML"], ["class", "row w-100", 4, "ngIf"], ["class", "p-0 mb-0", 4, "ngIf"], ["class", "p-2 text-dark", "style", "font-size:13px", 4, "ngIf"], [3, "innerHTML", 4, "ngIf"], [1, "mt-2", "mb-5"], [1, "btn", "btn-primary", "float-lg-right", 3, "click"], [1, "row", "w-100"], ["class", "col-12 col-md-4 mb-2", 4, "ngFor", "ngForOf"], [1, "col-12", "col-md-4", "mb-2"], [1, "row", "text-secondary", "mb-2", "small"], [1, "col-10", "text-truncate", "w-90"], [1, "col-2", "pull-right"], [1, "mt-2", "mb-4"], [1, "img-briefcase-box", 3, "identifier", "response"], [1, "p-0", "mb-0"], [1, "p-2", "text-dark", 2, "font-size", "13px"], [1, "w-100", "text-center", "pt-2", 3, "innerHTML"], ["class", "w-100 text-center", 3, "innerHTML", 4, "ngIf"], [1, "w-100", "text-center", 3, "innerHTML"], [3, "considerations"]], template: function RequirementsBriefcaseComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "akeela-requirements-template");
        ɵɵtemplate(1, RequirementsBriefcaseComponent_ng_template_1_Template, 1, 1, "ng-template", 0);
        ɵɵelementEnd();
        ɵɵtemplate(2, RequirementsBriefcaseComponent_ng_template_2_Template, 1, 3, "ng-template", null, 1, ɵɵtemplateRefExtractor);
        ɵɵelementStart(4, "div", 2);
        ɵɵtemplate(5, RequirementsBriefcaseComponent_div_5_Template, 2, 1, "div", 3);
        ɵɵelementStart(6, "div", 4);
        ɵɵelementStart(7, "div", 5);
        ɵɵtemplate(8, RequirementsBriefcaseComponent_div_8_Template, 3, 0, "div", 6);
        ɵɵelementEnd();
        ɵɵtemplate(9, RequirementsBriefcaseComponent_ng_container_9_Template, 2, 1, "ng-container", 6);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("componentName", ctx.config == null ? null : ctx.config.urlModal);
        ɵɵadvance(4);
        ɵɵproperty("ngIf", ctx.config.showHeaderContent);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.requirements === null || ctx.config === null);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.requirements !== null && ctx.config !== null);
    } }, directives: [AkeelaRequirementsTemplateComponent, AkeelaRequirementContentDirective, NgIf, RequirementUploadBriefcaseComponent, SelectControlValueAccessor, NgControlStatus, NgModel, NgSelectOption, ɵangular_packages_forms_forms_x, NgForOf, RequirementDetailComponent, NgTemplateOutlet, PreviewImgComponent, ConsiderationsComponent], pipes: [I18nPipe], styles: [".box[_ngcontent-%COMP%]{background-color:#fff}.box[_ngcontent-%COMP%], .box-transparent[_ngcontent-%COMP%]{color:#4a4a4a}.box[_ngcontent-%COMP%], .box-button[_ngcontent-%COMP%], .box-transparent[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto}.bg-gray[_ngcontent-%COMP%]{background-color:#f5f7fa;min-height:auto}@media (max-width:768px){.box[_ngcontent-%COMP%]{font-size:1rem!important}.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}@media (max-width:992px){.box[_ngcontent-%COMP%], .box-button[_ngcontent-%COMP%]{width:auto!important}}.caret-down[_ngcontent-%COMP%]{color:#e2e2e4;font-size:3rem;line-height:.7rem}.m-b-1[_ngcontent-%COMP%]{margin-bottom:1rem}.m-b-3[_ngcontent-%COMP%]{margin-bottom:3rem}.m-b-2[_ngcontent-%COMP%]{margin-bottom:2rem}.m-t-2[_ngcontent-%COMP%]{margin-top:2rem}.m-t-3[_ngcontent-%COMP%]{margin-top:3rem}.p-t-0[_ngcontent-%COMP%]{padding-top:0}.p-b-2[_ngcontent-%COMP%]{padding-bottom:2rem}@media (max-width:768px){.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}.text-size-1[_ngcontent-%COMP%]{font-size:.5rem}.box-2[_ngcontent-%COMP%], .box-3[_ngcontent-%COMP%]{text-align:center}.box-2[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #ccc;font-size:3rem;height:70px;margin-left:auto;margin-right:auto;margin-top:-50px;width:69px}.box_1[_ngcontent-%COMP%]{margin-top:25px}.description[_ngcontent-%COMP%]{font-size:1rem}.description-2[_ngcontent-%COMP%]{font-size:14px;line-height:14px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:50px}.img-folder[_ngcontent-%COMP%]{width:30px}@media (max-width:768px){.description[_ngcontent-%COMP%]{font-size:14px}.description-2[_ngcontent-%COMP%]{font-size:13px;line-height:13px}.ak-rq-pl[_ngcontent-%COMP%]{padding-left:34px!important}.img-folder[_ngcontent-%COMP%]{width:26px}}.description-label[_ngcontent-%COMP%]{font-size:.875rem}.fz-title[_ngcontent-%COMP%]{font-size:1.5rem}.bt2black[_ngcontent-%COMP%]{border-top:1px solid #000}.termsAndConditions[_ngcontent-%COMP%]{color:#777;font-size:.75rem}.color-white[_ngcontent-%COMP%]{color:transparent}.color-yellow[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-incomplete)}.color-orange[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-warning)}.color-purple[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-inconsistent)}.color-blue[_ngcontent-%COMP%], .color-green[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-success)}.color-red[_ngcontent-%COMP%]{color:var(--ak-requirements-icon-error)}.color-gray-light[_ngcontent-%COMP%]{color:#ccc}.color-black[_ngcontent-%COMP%]{color:#000}.section-title[_ngcontent-%COMP%]{font-size:.7rem}.selected-icon[_ngcontent-%COMP%]{background:#ededed;background:-webkit-gradient(left bottom,right top,color-stop(0,#ededed),color-stop(53%,#f6f6f6),color-stop(100%,#fff));background:linear-gradient(45deg,#ededed,#f6f6f6 53%,#fff);border-radius:10px;cursor:pointer;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ededed\",endColorstr=\"#ffffff\",GradientType=1)}.Button[_ngcontent-%COMP%]{border-radius:4px;transition-duration:.2s;transition-property:background,border,box-shadow,color,fill}.border-red[_ngcontent-%COMP%]{border-color:red}.border-green[_ngcontent-%COMP%]{border-color:green}.Button--secondary[_ngcontent-%COMP%]:not(.Button--disabled){background:#fff;color:#646f79;fill:#848f99}.Button.Button--small[_ngcontent-%COMP%]{height:30px;line-height:30px;padding:0 9px}.Button[_ngcontent-%COMP%]{align-items:center;border-style:solid;border-width:1px;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-size:13px;justify-content:center;line-height:1;min-width:50px;text-align:center}.color-blue[_ngcontent-%COMP%]{background-color:#007bff;color:#fff}.color-gray[_ngcontent-%COMP%]{background-color:#d8d8d8;border-color:#d8d8d8;color:#000}.border-red[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-error)}.border-green[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-success)}.border-purple[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-inconsistent)}.border-yellow[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-incomplete)}.border-orange[_ngcontent-%COMP%]{border-color:var(--ak-requirements-icon-warning)}.skin-white[_ngcontent-%COMP%]{background-color:#fff}.badge-gray-light[_ngcontent-%COMP%]{background-color:#bdbdbd;color:#fff}.badge-gray[_ngcontent-%COMP%]{background-color:#848f99;color:#fff}.font-light[_ngcontent-%COMP%]{opacity:.7}.font-color-gray[_ngcontent-%COMP%]{color:#bdbdbd}.font-color-black[_ngcontent-%COMP%]{color:#000}.ak-icon-req[_ngcontent-%COMP%]{color:#adb5bd}.ak-text-req-name[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.px-12[_ngcontent-%COMP%]{font-size:12px}.cirecle-status[_ngcontent-%COMP%]{font-size:7px;margin-top:5px;position:absolute}.ak-req-add[_ngcontent-%COMP%]{border-radius:21px;color:#fff;font-size:12px;font-weight:900;height:24px;padding:3px;width:24px}.fz-12[_ngcontent-%COMP%]{font-size:9px}.rq-coments[_ngcontent-%COMP%]{background:#efefef;border-radius:10px;padding:6px 20px}.section-box.rq[_ngcontent-%COMP%]{border:1px solid #fafafa}.section-box.rq[_ngcontent-%COMP%]:hover{background:#fafafa;border:1px solid #d8d8d8}.ak-modal-right[_ngcontent-%COMP%]{background:#fff;box-shadow:0 0 10px -5px #444;height:100%;position:fixed;right:0;width:40%;z-index:999}.fz-14[_ngcontent-%COMP%]{font-size:14px}.cat-icon[_ngcontent-%COMP%]{color:#ccc;font-size:12px;margin-top:5px;padding-right:5px}.cat-icon2[_ngcontent-%COMP%]{background-color:#fff;border-radius:14px;font-size:18px;margin-left:-14px;padding:4px;position:absolute;top:28px}.full-modal[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.5)!important;display:flex;flex:1;flex-direction:column;justify-content:center;overflow:auto;padding:50px 200px;right:0;top:0}@media (max-width:900px){.full-modal[_ngcontent-%COMP%]{padding:0}}.radius[_ngcontent-%COMP%]{border-radius:10px}.full-modal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{background:#fff;box-shadow:0 1px 0 rgba(0,0,0,.10196078);margin-bottom:0;min-height:3.3rem;padding:.7rem;position:static}.full-modal[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]{background-color:transparent;margin-top:0;overflow:auto}.title-section[_ngcontent-%COMP%]{color:var(--ak-color-title-section);margin-top:.3rem}.title-section.selected[_ngcontent-%COMP%]{color:var(--ak-color-title-section-selected)}.text-secondary-2[_ngcontent-%COMP%]{color:#ccc!important}.fz-13[_ngcontent-%COMP%]{font-size:13px}.ptn[_ngcontent-%COMP%]{font-size:12px;position:absolute}.rc3[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.section-box[_ngcontent-%COMP%]{box-shadow:none!important}.img-container[_ngcontent-%COMP%]{height:300px!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RequirementsBriefcaseComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-requirements-briefcase',
                templateUrl: './requirements-briefcase.component.html',
                styleUrls: ['./requirements-briefcase.component.css']
            }]
    }], function () { return [{ type: AkeelaTemplateService }, { type: HttpService }, { type: RequirementsService }, { type: UploadService }, { type: ErrorService }, { type: I18nPipe }]; }, { config: [{
            type: Input
        }], folder: [{
            type: Input
        }], viewOptional: [{
            type: Input
        }], showFile: [{
            type: Output
        }], response: [{
            type: Output
        }], openWindowRequirement: [{
            type: Output
        }], finishupload: [{
            type: Output
        }] }); })();

function ProgressComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 3);
    ɵɵelementStart(1, "div", 4);
    ɵɵelementStart(2, "div", 5);
    ɵɵelement(3, "div", 6);
    ɵɵelementStart(4, "div", 7);
    ɵɵtext(5, "Aprobados");
    ɵɵelementEnd();
    ɵɵelement(6, "hr", 8);
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 5);
    ɵɵelement(8, "div", 9);
    ɵɵelementStart(9, "div", 7);
    ɵɵtext(10, "Incompletos");
    ɵɵelementEnd();
    ɵɵelement(11, "hr", 8);
    ɵɵelementEnd();
    ɵɵelementStart(12, "div", 5);
    ɵɵelement(13, "div", 10);
    ɵɵelementStart(14, "div", 7);
    ɵɵtext(15, "Rechazados");
    ɵɵelementEnd();
    ɵɵelement(16, "hr", 8);
    ɵɵelementEnd();
    ɵɵelementStart(17, "div", 5);
    ɵɵelement(18, "div", 10);
    ɵɵelementStart(19, "div", 7);
    ɵɵtext(20, "En revisi\u00F3n");
    ɵɵelementEnd();
    ɵɵelement(21, "hr", 8);
    ɵɵelementEnd();
    ɵɵelementStart(22, "div", 5);
    ɵɵelement(23, "div", 11);
    ɵɵelementStart(24, "div", 12);
    ɵɵtext(25, "Total");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(26, "div", 13);
    ɵɵelementStart(27, "div", 14);
    ɵɵelementStart(28, "div", 15);
    ɵɵelementStart(29, "span", 16);
    ɵɵtext(30, "Aprobados");
    ɵɵelementEnd();
    ɵɵelement(31, "div", 17);
    ɵɵelementEnd();
    ɵɵelementStart(32, "div", 18);
    ɵɵelementStart(33, "span", 19);
    ɵɵtext(34, "Incompletos");
    ɵɵelementEnd();
    ɵɵelement(35, "div", 20);
    ɵɵelementEnd();
    ɵɵelementStart(36, "div", 21);
    ɵɵelementStart(37, "span", 19);
    ɵɵtext(38, "Rechazados");
    ɵɵelementEnd();
    ɵɵelement(39, "div", 22);
    ɵɵelementEnd();
    ɵɵelementStart(40, "div", 23);
    ɵɵelementStart(41, "span", 19);
    ɵɵtext(42, "En revisi\u00F3n");
    ɵɵelementEnd();
    ɵɵelement(43, "div", 22);
    ɵɵelementEnd();
    ɵɵelementStart(44, "div", 24);
    ɵɵelement(45, "div", 25);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext(2);
    ɵɵadvance(3);
    ɵɵproperty("innerHTML", ctx_r1.balancerequirements == null ? null : ctx_r1.balancerequirements.total_required_responses_user_requirements_completed_in_status_verified, ɵɵsanitizeHtml);
    ɵɵadvance(5);
    ɵɵproperty("innerHTML", ctx_r1.balancerequirements == null ? null : ctx_r1.balancerequirements.total_required_responses_user_requirements_completed_in_status_incompleted, ɵɵsanitizeHtml);
    ɵɵadvance(5);
    ɵɵproperty("innerHTML", ctx_r1.balancerequirements == null ? null : ctx_r1.balancerequirements.total_required_responses_user_requirements_completed_in_status_rejected, ɵɵsanitizeHtml);
    ɵɵadvance(5);
    ɵɵproperty("innerHTML", ctx_r1.balancerequirements == null ? null : ctx_r1.balancerequirements.total_required_responses_user_requirements_completed_in_status_inconsistent, ɵɵsanitizeHtml);
    ɵɵadvance(5);
    ɵɵproperty("innerHTML", ctx_r1.balancerequirements == null ? null : ctx_r1.balancerequirements.total_requirements, ɵɵsanitizeHtml);
    ɵɵadvance(8);
    ɵɵproperty("innerHTML", ctx_r1.balancerequirements == null ? null : ctx_r1.balancerequirements.total_required_responses_user_requirements_completed_in_status_verified, ɵɵsanitizeHtml);
    ɵɵadvance(4);
    ɵɵproperty("innerHTML", ctx_r1.balancerequirements == null ? null : ctx_r1.balancerequirements.total_required_responses_user_requirements_completed_in_status_incompleted, ɵɵsanitizeHtml);
    ɵɵadvance(4);
    ɵɵproperty("innerHTML", ctx_r1.balancerequirements == null ? null : ctx_r1.balancerequirements.total_required_responses_user_requirements_completed_in_status_rejected, ɵɵsanitizeHtml);
    ɵɵadvance(4);
    ɵɵproperty("innerHTML", ctx_r1.balancerequirements == null ? null : ctx_r1.balancerequirements.total_required_responses_user_requirements_completed_in_status_inconsistent, ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ctx_r1.balancerequirements == null ? null : ctx_r1.balancerequirements.total_requirements, ɵɵsanitizeHtml);
} }
function ProgressComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵtemplate(1, ProgressComponent_div_0_div_1_Template, 46, 10, "div", 2);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.balancerequirements);
} }
class ProgressComponent {
    constructor() { }
    set balanceRequirements(value) {
        this.balancerequirements = value;
    }
    set configuration(value) {
        this.config = value;
    }
    ngOnInit() {
    }
}
/** @nocollapse */ ProgressComponent.ɵfac = function ProgressComponent_Factory(t) { return new (t || ProgressComponent)(); };
/** @nocollapse */ ProgressComponent.ɵcmp = ɵɵdefineComponent({ type: ProgressComponent, selectors: [["akeela-requirements-progress"]], inputs: { balanceRequirements: "balanceRequirements", configuration: "configuration" }, decls: 1, vars: 1, consts: [["class", "card active-cursor mt-3 mb-3", 4, "ngIf"], [1, "card", "active-cursor", "mt-3", "mb-3"], ["class", "card-body p-2 ", 4, "ngIf"], [1, "card-body", "p-2"], [1, "d-block", "d-md-none", "pl-2", "pr-2"], [1, "w-100"], [1, "text-success", "font-weight-bold", "float-right", 3, "innerHTML"], [1, ""], [1, "mt-1", "mb-1"], [1, "text-warning", "font-weight-bold", "float-right", 3, "innerHTML"], [1, "text-danger", "font-weight-bold", "float-right", 3, "innerHTML"], [1, "font-weight-bold", "float-right", 3, "innerHTML"], [1, "font-weight-bold"], [1, "d-none", "d-md-block"], [1, "d-flex", "bd-highlight"], [1, "bd-highlight", "item", "mr-2"], [1, "font-weight-bold", "pb-2", "pr-2"], [1, "text-success", "font-weight-bold", 3, "innerHTML"], [1, "bd-highlight", "item", "mr-2", "ml-2", "pr-2"], [1, "font-weight-bold", "pb-2"], [1, "text-warning", "font-weight-bold", 3, "innerHTML"], [1, "bd-highlight", "item", "pr-2", "ml-2"], [1, "text-danger", "font-weight-bold", 3, "innerHTML"], [1, "bd-highlight", "pr-2", "ml-2"], [1, "ml-auto", "bd-highlight", "ml-2"], [1, "mt-1", "float-right", "mr-2", "ak-abatar", "ak-dinamic-color-abatar", 3, "innerHTML"]], template: function ProgressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, ProgressComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.balancerequirements && ((ctx.balancerequirements == null ? null : ctx.balancerequirements.total_required_responses_user_requirements_completed_in_status_verified) > 0 || (ctx.balancerequirements == null ? null : ctx.balancerequirements.total_required_responses_user_requirements_completed_in_status_incompleted) > 0 || (ctx.balancerequirements == null ? null : ctx.balancerequirements.total_required_responses_user_requirements_completed_in_status_rejected) > 0 || (ctx.balancerequirements == null ? null : ctx.balancerequirements.total_required_responses_user_requirements_completed_in_status_inconsistent) > 0));
    } }, directives: [NgIf], styles: [".p-3[_ngcontent-%COMP%]{padding:0}.rectagle-container[_ngcontent-%COMP%]{background-color:#f4f1f1}.rectangle-container-label[_ngcontent-%COMP%]{color:#9b6c6c;font-style:normal;font-weight:700}.item[_ngcontent-%COMP%]{border-right:1px solid #ccc}.ak-abatar[_ngcontent-%COMP%]{font-size:1rem;height:38px;padding-top:9px;width:38px}.ak-abatar[_ngcontent-%COMP%], .ak-abatar-big[_ngcontent-%COMP%]{border-radius:50%;display:inline-block;text-align:center;text-transform:uppercase;vertical-align:middle}.ak-abatar-big[_ngcontent-%COMP%]{font-size:24px;height:60px;margin-right:5px;padding-top:19px;width:60px}.ak-dinamic-color-abatar[_ngcontent-%COMP%], .ak-dinamic-color-abatar[_ngcontent-%COMP%]:focus, .ak-dinamic-color-abatar[_ngcontent-%COMP%]:hover{background:#4a90e2!important;color:#fff!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProgressComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-requirements-progress',
                templateUrl: './progress.component.html',
                styleUrls: ['./progress.component.css']
            }]
    }], function () { return []; }, { balanceRequirements: [{
            type: Input
        }], configuration: [{
            type: Input
        }] }); })();

function CheckboxComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "input", 3);
    ɵɵlistener("click", function CheckboxComponent_ng_container_1_Template_input_click_1_listener() { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.update(); });
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("id", "check" + ctx_r0.identifier)("name", "check" + ctx_r0.identifier)("checked", ctx_r0.checked);
} }
function CheckboxComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "input", 4);
    ɵɵlistener("click", function CheckboxComponent_ng_container_2_Template_input_click_1_listener() { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(); return ctx_r4.update(); });
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("id", "check" + ctx_r1.identifier)("name", "check" + ctx_r1.identifier)("checked", ctx_r1.checked);
} }
class CheckboxComponent {
    constructor() {
        this.identifier = null;
        this.checked = false;
        this.readonly = false;
        this.changeValue = new EventEmitter();
    }
    ngOnInit() { }
    update() {
        if (!this.readonly) {
            this.checked = true;
            this.changeValue.emit({
                'checked': this.checked,
                'identifier': this.identifier
            });
        }
    }
}
/** @nocollapse */ CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(); };
/** @nocollapse */ CheckboxComponent.ɵcmp = ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["akeela-requirements-checkbox"]], inputs: { identifier: "identifier", checked: "checked", readonly: "readonly" }, outputs: { changeValue: "changeValue" }, decls: 5, vars: 3, consts: [[1, "demo"], [4, "ngIf"], [3, "for"], ["disabled", "", "type", "checkbox", 3, "id", "name", "checked", "click"], ["type", "checkbox", 3, "id", "name", "checked", "click"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, CheckboxComponent_ng_container_1_Template, 2, 3, "ng-container", 1);
        ɵɵtemplate(2, CheckboxComponent_ng_container_2_Template, 2, 3, "ng-container", 1);
        ɵɵelementStart(3, "label", 2);
        ɵɵelement(4, "span");
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.readonly === true);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.readonly === false);
        ɵɵadvance(1);
        ɵɵproperty("for", "check" + ctx.identifier);
    } }, directives: [NgIf], styles: [".demo[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]{display:none}.demo[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background-image:url(../../../assets/public/images/checkbox-uncheck.png);background-size:cover;cursor:pointer;display:inline-block;height:15px;margin:-1px 4px 0 0;vertical-align:middle;width:15px}.demo[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background-image:url(../../../assets/public/images/checkbox-check.png);background-size:cover}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-requirements-checkbox',
                templateUrl: './checkbox.component.html',
                styleUrls: ['./checkbox.component.css']
            }]
    }], function () { return []; }, { identifier: [{
            type: Input
        }], checked: [{
            type: Input
        }], readonly: [{
            type: Input
        }], changeValue: [{
            type: Output
        }] }); })();

const browser = navigator;
function getMedia() {
    return browser.getUserMedia
        || browser.webkitGetUserMedia
        || browser.mozGetUserMedia
        || browser.msGetUserMedia;
}
/*
export interface MediaDevice{
  deviceId: string
  kind: 'videoinput' | 'audioinput' | string
  label: string
  groupId: string
}*/
function dataUriToBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (!isNullOrUndefined(dataURI)) {
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(dataURI.split(',')[1]);
        }
        else {
            byteString = window['unescape'](dataURI.split(',')[1]);
        }
        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], { type: mimeString });
    }
    else {
        return null;
    }
}
/** single image to transmittable resource */
function dataUriToFormData(dataURI, options) {
    options = options || {};
    options.form = options.form || new FormData();
    options.form.append('file', dataUriToBlob(dataURI), options.fileName || 'file.png');
    return options.form;
}
function drawImageArrayToCanvas(imgArray) {
    const canvas = document.createElement('canvas');
    // const di = this.getVideoDimensions()
    const ctx = canvas.getContext('2d');
    const width = imgArray[0].split(';').length;
    const height = imgArray.length;
    canvas.width = width;
    canvas.height = height;
    ctx.clearRect(0, 0, width, height);
    const externData = {
        imgData: ctx.getImageData(0, 0, width, height),
        pos: 0
    };
    let tmp = null;
    for (let x = 0; x < imgArray.length; ++x) {
        let col = imgArray[x].split(';');
        for (let i = 0; i < width; i++) {
            tmp = parseInt(col[i], 10);
            externData.imgData.data[externData.pos + 0] = (tmp >> 16) & 0xff;
            externData.imgData.data[externData.pos + 1] = (tmp >> 8) & 0xff;
            externData.imgData.data[externData.pos + 2] = tmp & 0xff;
            externData.imgData.data[externData.pos + 3] = 0xff;
            externData.pos += 4;
        }
        /*if (externData.pos >= 4 * width * height) {
          ctx.putImageData(externData.imgData, 0, 0);
          externData.pos = 0;
        }*/
    }
    ctx.putImageData(externData.imgData, 0, 0);
    return canvas;
}
class Fallback {
    constructor(videoObject) {
        this.onImage = new EventEmitter();
        this.videoObject = videoObject;
        const dataImgArray = [];
        //method intended to live within window memory
        this.debug = (tag, message) => {
            if (tag == 'notify' && message == 'Capturing finished.') {
                this.onImage.emit(drawImageArrayToCanvas(dataImgArray));
            }
        };
        //method intended to live within window memory
        this.onCapture = () => {
            dataImgArray.length = 0;
            videoObject.save();
        };
        //method intended to live within window memory
        this.onSave = (data) => {
            dataImgArray.push(data);
        };
        //Flash swf file expects window.webcam to exist as communication bridge
        window['webcam'] = this;
    }
    captureToCanvas() {
        return new Promise((res, rej) => {
            const subscription = this.onImage.subscribe(img => {
                res(img);
                subscription.unsubscribe();
            });
            this.videoObject.capture();
        });
    }
    captureBase64(mime) {
        return this.captureToCanvas()
            .then((canvas) => canvas.toDataURL(mime || 'image/jpeg'));
    }
    /**
     * Add <param>'s into fallback object
     * @param cam - Flash web camera instance
     *
     */
    addFallbackParams(options) {
        const paramFlashVars = document.createElement('param');
        paramFlashVars.name = 'FlashVars';
        paramFlashVars.value = 'mode=' + options.fallbackMode + '&amp;quality=' + options.fallbackQuality;
        this.videoObject.appendChild(paramFlashVars);
        const paramAllowScriptAccess = document.createElement('param');
        paramAllowScriptAccess.name = 'allowScriptAccess';
        paramAllowScriptAccess.value = 'always';
        this.videoObject.appendChild(paramAllowScriptAccess);
        //is this even needed?
        this.videoObject.classid = 'clsid:D27CDB6E-AE6D-11cf-96B8-444553540000';
        const paramMovie = document.createElement('param');
        paramMovie.name = 'movie';
        paramMovie.value = options.fallbackSrc;
        this.videoObject.appendChild(paramMovie);
        this.videoObject.data = options.fallbackSrc;
    }
}
function videoInputsByDevices(devices) {
    return devicesByKind(devices, 'videoinput');
}
function audioInputsByDevices(devices) {
    return devicesByKind(devices, 'audioinput');
}
function audioOutputsByDevices(devices) {
    return devicesByKind(devices, 'audiooutput');
}
function devicesByKind(devices, kind) {
    return devices.filter(device => device.kind === kind);
}
function promiseDeviceById(id) {
    return promiseDevices().then(devices => devices.find(device => device.deviceId == id));
}
function promiseDevices() {
    //const x:Promise<any[]> = browser.mediaDevices.enumerateDevices().then( devices=>devices )
    return browser.mediaDevices.enumerateDevices();
}
function isFacingModeSupported() {
    if (!browser.mediaDevices)
        return false;
    const contraints = browser.mediaDevices.getSupportedConstraints();
    return contraints.facingMode;
}

function CamComponent_video_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "video", 1);
    ɵɵtext(1, "Video stream not available");
    ɵɵelementEnd();
} }
const template = `<video id='video' *ngIf='(isSupportUserMedia||isSupportWebRTC)' autoplay='' playsinline=''>Video stream not available</video>`;
class CamComponent {
    constructor(sanitizer, element) {
        this.sanitizer = sanitizer;
        this.element = element;
        this.isSupportUserMedia = false;
        this.isSupportWebRTC = false;
        this.isFallback = false;
        this.sets = { element: { width: 0, height: 0 } };
        this.mime = 'image/jpeg';
        this.useParentWidthHeight = false;
        this.success = new EventEmitter();
        this.refChange = new EventEmitter();
        this.errorChange = new EventEmitter();
        this.catcher = new EventEmitter();
    }
    ngOnInit() {
        this.isSupportUserMedia = getMedia() != null ? true : false;
        this.isSupportUserMedia = false;
        this.isSupportWebRTC = !!(browser.mediaDevices && browser.mediaDevices.getUserMedia);
    }
    ngAfterViewInit() {
        this.applyDefaults();
        setTimeout(() => this.afterInitCycles(), 0);
    }
    ngOnChanges(changes) {
        if (!this.initComplete)
            return;
        if (changes.facingMode
            || changes.videoDevice
            || changes.videoDeviceId) {
            this.redraw(); //restart
        }
        if (changes.reflect) {
            this.applyReflect();
        }
    }
    ngOnDestroy() {
        this.observer.disconnect();
        window.removeEventListener('resize', this.onResize);
        this.stop();
    }
    play() {
        return this.redraw();
    }
    stop() {
        const vid = this.getVideoElm();
        if (vid && vid.pause) {
            vid.pause();
        }
        if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
        }
    }
    redraw() {
        this.stop();
        this.startCapturingVideo();
    }
    afterInitCycles() {
        const media = getMedia();
        // Older browsers might not implement mediaDevices at all, so we set an empty object first
        if ((browser.mediaDevices === undefined) && !!media) {
            browser.mediaDevices = {};
        }
        // Some browsers partially implement mediaDevices. We can't just assign an object
        // with getUserMedia as it would overwrite existing properties.
        // Here, we will just add the getUserMedia property if it's missing.
        const getUserMediaUndefined = (browser.mediaDevices && browser.mediaDevices.getUserMedia === undefined) && !!media;
        if (getUserMediaUndefined) {
            browser.mediaDevices.getUserMedia = constraints => {
                return new Promise((resolve, reject) => {
                    const userMedia = media.call(browser, constraints, resolve, reject);
                    if (userMedia.then) {
                        userMedia.then(stream => this.applyStream(stream));
                    }
                })
                    .catch(err => this.catchError(err));
            };
        }
        this.initComplete = true;
        //deprecated. Use angular hash template referencing and @ViewChild
        setTimeout(() => this.refChange.emit(this), 0);
        this.createVideoResizer();
        this.startCapturingVideo()
            .then(() => setTimeout(() => this.resize(), 10))
            .catch(err => this.catchError(err));
    }
    applyReflect() {
        const videoElm = this.getVideoElm();
        if (!videoElm)
            return;
        if (this.reflect) {
            videoElm.style.transform = 'scaleX(-1)';
        }
        else {
            videoElm.style.transform = 'scaleY(1)';
        }
    }
    applyStream(stream) {
        const videoElm = this.getVideoElm();
        videoElm.srcObject = stream;
        this.applyReflect();
    }
    createVideoResizer() {
        this.observer = new MutationObserver(() => this.resize());
        const config = {
            attributes: true,
            childList: true,
            characterData: true
            //,subtree: true
        };
        this.observer.observe(this.element.nativeElement, config);
        this.onResize = () => this.resize();
        window.addEventListener('resize', this.onResize);
    }
    applyDefaults() {
        this.options = this.options || {};
        this.options.fallbackSrc = this.options.fallbackSrc || 'jscam_canvas_only.swf';
        this.options.fallbackMode = this.options.fallbackMode || 'callback';
        this.options.fallbackQuality = this.options.fallbackQuality || 200;
        this.isFallback = this.options.fallback || (!this.isSupportUserMedia && !this.isSupportWebRTC && this.options.fallbackSrc) ? true : false;
        if (!this.options.video && !this.options.audio) {
            this.options.video = true;
        }
    }
    onWebRTC() {
        let promise = Promise.resolve(null);
        return this.promiseVideoOptions()
            .then(options => {
            this.options.video = options;
            return this.setWebcam(this.options);
        });
    }
    promiseVideoOptions() {
        let promise = Promise.resolve();
        const videoOptions = {};
        if (this.options.video && isOb(this.options.video)) {
            Object.assign(videoOptions, this.options.video);
            if (videoOptions.width && isOb(videoOptions.width) && !Object.keys(videoOptions.width).length) {
                delete videoOptions.width;
            }
            if (videoOptions.height && isOb(videoOptions.height) && !Object.keys(videoOptions.height).length) {
                delete videoOptions.height;
            }
        }
        if (this.facingMode) {
            videoOptions.facingMode = this.facingMode; //{exact:this.facingMode}
        }
        if (this.videoDeviceId) {
            //videoOptions.deviceId = {exact:this.videoDeviceId}
            videoOptions.deviceId = this.videoDeviceId;
        }
        else if (this.videoDevice) {
            //videoOptions.deviceId = {exact:this.videoDevice.deviceId}
            videoOptions.deviceId = this.videoDevice.deviceId;
        }
        return promise.then(() => videoOptions);
    }
    //old method name (deprecated)
    resizeVideo(maxAttempts = 4) {
        return this.resize(maxAttempts);
    }
    resize(maxAttempts = 4) {
        const video = this.getVideoElm();
        if (!video)
            return;
        video.style.position = 'absolute';
        const elm = this.useParentWidthHeight ? this.element.nativeElement.parentNode : this.element.nativeElement;
        let width = this.options.width || parseInt(elm.offsetWidth, 10);
        let height = this.options.height || parseInt(elm.offsetHeight, 10);
        if (!width || !height) {
            width = window.innerWidth - 80;
            height = window.innerHeight - 100;
        }
        setTimeout(() => {
            video.width = width;
            video.height = height;
            this.sets.element.width = width;
            this.sets.element.height = height;
            video.style.position = 'static';
            //now that we set a width and height, it may need another adjustment if it pushed percent based items around
            const resizeAgain = (!this.options.width && width != parseInt(elm.offsetWidth, 10)) || (!this.options.height && height != parseInt(elm.offsetHeight, 10));
            if (resizeAgain && maxAttempts) {
                this.resize(--maxAttempts);
            }
        }, 1);
    }
    getVideoDimensions(video) {
        video = video || this.getVideoElm();
        const dim = { width: 0, height: 0 };
        if (video.videoWidth) {
            dim.width = video.videoWidth;
            dim.height = video.videoHeight;
        }
        else {
            dim.width = this.options.width || parseInt(this.element.nativeElement.offsetWidth, 10);
            dim.height = this.options.height || parseInt(this.element.nativeElement.offsetHeight, 10);
        }
        if (!dim.width)
            dim.width = 320;
        if (!dim.height)
            dim.height = 240;
        return dim;
    }
    getVideoElm() {
        const native = this.element.nativeElement;
        const elmType = this.isFallback ? 'object' : 'video';
        return native.getElementsByTagName(elmType)[0];
    }
    setWebcam(options) {
        return this.promiseStreamByVidOptions(options)
            .then(stream => {
            this.applyStream(stream);
            this.processSuccess(stream);
            this.stream = stream;
            return stream;
        })
            .catch(err => this.catchError(err));
    }
    catchError(err) {
        this.errorChange.emit(this.error = err);
        this.catcher.emit(err);
        if (!this.errorChange.observers.length && !this.catcher.observers.length) {
            return Promise.reject(err); //if no error subscriptions promise need to continue to be Uncaught
        }
    }
    promiseStreamByVidOptions(optionObject) {
        return new Promise((resolve, reject) => {
            try {
                browser.mediaDevices.getUserMedia(optionObject)
                    .then(stream => resolve(stream))
                    .catch((objErr) => reject(objErr));
            }
            catch (e) {
                reject(e);
            }
        });
    }
    processSuccess(stream) {
        if (this.isFallback) {
            this.setupFallback();
        }
        else {
            this.success.emit(stream);
        }
    }
    /**
     * Start capturing video stream
     *
     */
    startCapturingVideo() {
        if (!this.isFallback && this.isSupportWebRTC) {
            return this.onWebRTC();
        }
        return Promise.resolve(this.processSuccess());
    }
    getCanvas() {
        return document.createElement('canvas');
    }
    /** returns promise . @mime - null=png . Also accepts image/jpeg */
    getBase64(mime) {
        if (this.isFallback) {
            return this.flashPlayer.captureBase64(mime || this.mime);
            //return this.getFallbackBase64(mime)
        }
        else {
            const canvas = this.getCanvas();
            const video = this.getVideoElm();
            this.setCanvasWidth(canvas, video);
            const ctx = canvas.getContext('2d');
            if (this.reflect) {
                ctx.translate(canvas.width, 0);
                ctx.scale(-1, 1);
            }
            ctx.drawImage(video, 0, 0);
            return Promise.resolve(canvas.toDataURL(mime));
        }
    }
    setCanvasWidth(canvas, video) {
        const di = this.getVideoDimensions(video);
        canvas = canvas || this.getCanvas();
        canvas.width = di.width;
        canvas.height = di.height;
    }
    /** older browsers (IE11) cannot dynamically apply most attribute changes to object elements. Use this method during fallback */
    createVidElmOb() {
        const rtnElm = document.createElement('object');
        rtnElm.innerHTML = 'Video stream not available';
        rtnElm.setAttribute('type', 'application/x-shockwave-flash');
        rtnElm.setAttribute('data', this.options.fallbackSrc);
        let paramVar = document.createElement('param');
        paramVar.setAttribute('name', 'FlashVars');
        paramVar.setAttribute('value', 'mode=callback&amp;quality=200');
        rtnElm.appendChild(paramVar);
        paramVar = document.createElement('param');
        paramVar.setAttribute('name', 'allowScriptAccess');
        paramVar.setAttribute('value', 'always');
        rtnElm.appendChild(paramVar);
        paramVar = document.createElement('param');
        paramVar.setAttribute('name', 'movie');
        paramVar.setAttribute('value', this.options.fallbackSrc);
        rtnElm.appendChild(paramVar);
        const obs = this.element.nativeElement.getElementsByTagName('object');
        if (obs.length) {
            this.element.nativeElement.removeChild(obs[0]);
        }
        this.element.nativeElement.appendChild(rtnElm);
        return rtnElm;
    }
    setupFallback() {
        this.isFallback = true;
        const vidElm = this.getVideoElm() || this.createVidElmOb();
        this.flashPlayer = new Fallback(vidElm);
    }
    /** single image to FormData */
    captureAsFormData(options) {
        options = options || {};
        return this.getBase64(options.mime)
            .then(base64 => dataUriToFormData(base64, { fileName: options.fileName }));
    }
    dataUriToFormData(base64, options) {
        return dataUriToFormData(base64, { fileName: options.fileName });
    }
}
/** @nocollapse */ CamComponent.ɵfac = function CamComponent_Factory(t) { return new (t || CamComponent)(ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(ElementRef)); };
/** @nocollapse */ CamComponent.ɵcmp = ɵɵdefineComponent({ type: CamComponent, selectors: [["akeela-ack-webcam"]], inputs: { videoDevice: "videoDevice", videoDeviceId: "videoDeviceId", reflect: "reflect", facingMode: "facingMode", mime: "mime", useParentWidthHeight: "useParentWidthHeight", options: "options", ref: "ref", error: "error" }, outputs: { success: "success", refChange: "refChange", errorChange: "errorChange", catcher: "catch" }, exportAs: ["webcam"], features: [ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["id", "video", "autoplay", "", "playsinline", "", 4, "ngIf"], ["id", "video", "autoplay", "", "playsinline", ""]], template: function CamComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, CamComponent_video_0_Template, 2, 0, "video", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.isSupportUserMedia || ctx.isSupportWebRTC);
    } }, directives: [NgIf], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CamComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-ack-webcam',
                template: template,
                exportAs: 'webcam'
            }]
    }], function () { return [{ type: DomSanitizer }, { type: ElementRef }]; }, { videoDevice: [{
            type: Input
        }], videoDeviceId: [{
            type: Input
        }], reflect: [{
            type: Input
        }], facingMode: [{
            type: Input
        }], mime: [{
            type: Input
        }], useParentWidthHeight: [{
            type: Input
        }], options: [{
            type: Input
        }], success: [{
            type: Output
        }], ref: [{
            type: Input
        }], refChange: [{
            type: Output
        }], error: [{
            type: Input
        }], errorChange: [{
            type: Output
        }], catcher: [{
            type: Output,
            args: ['catch']
        }] }); })();
function isOb(v) {
    return typeof (v) === 'object';
}

function CameraComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 0);
    ɵɵelementStart(1, "div", 4);
    ɵɵelement(2, "img", 5);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵpropertyInterpolate("src", ctx_r0.base64 ? ctx_r0.base64 : null, ɵɵsanitizeUrl);
} }
function CameraComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 6);
    ɵɵelementStart(1, "akeela-ack-webcam", 7);
    ɵɵlistener("refChange", function CameraComponent_div_2_Template_akeela_ack_webcam_refChange_1_listener($event) { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(); return ctx_r4.cameras[0].webcam = $event; })("errorChange", function CameraComponent_div_2_Template_akeela_ack_webcam_errorChange_1_listener($event) { ɵɵrestoreView(_r5); const ctx_r6 = ɵɵnextContext(); return ctx_r6.cameras[0].error = $event; })("errorChange", function CameraComponent_div_2_Template_akeela_ack_webcam_errorChange_1_listener($event) { ɵɵrestoreView(_r5); const ctx_r7 = ɵɵnextContext(); return ctx_r7.logerror($event); })("success", function CameraComponent_div_2_Template_akeela_ack_webcam_success_1_listener($event) { ɵɵrestoreView(_r5); const ctx_r8 = ɵɵnextContext(); return ctx_r8.onSuccess($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ref", ctx_r1.cameras[0].webcam)("videoDeviceId", ctx_r1.cameras[0].videoDeviceId)("facingMode", "environment")("reflect", ctx_r1.cameras[0].reflect)("error", ctx_r1.cameras[0].error)("options", ctx_r1.cameras[0].options);
} }
function CameraComponent_div_3_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", 10);
    ɵɵlistener("click", function CameraComponent_div_3_a_2_Template_a_click_0_listener() { ɵɵrestoreView(_r11); const ctx_r10 = ɵɵnextContext(2); return ctx_r10.captureBase64(ctx_r10.cameras[0].webcam); });
    ɵɵelement(1, "i", 11);
    ɵɵelementEnd();
} }
function CameraComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 0);
    ɵɵelementStart(1, "div", 8);
    ɵɵtemplate(2, CameraComponent_div_3_a_2_Template, 2, 0, "a", 9);
    ɵɵelement(3, "br");
    ɵɵelement(4, "br");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r2.cameras[0].webcam && !ctx_r2.captured);
} }
function CameraComponent_div_4_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", 17);
    ɵɵlistener("click", function CameraComponent_div_4_span_4_Template_span_click_0_listener() { ɵɵrestoreView(_r16); const ctx_r15 = ɵɵnextContext(2); ctx_r15.showBase64 = null; return ctx_r15.captured = null; });
    ɵɵelement(1, "img", 18);
    ɵɵelementEnd();
} }
function CameraComponent_div_4_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1, " \u00A0\u00A0\u00A0\u00A0 ");
    ɵɵelementEnd();
} }
function CameraComponent_div_4_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", 17);
    ɵɵlistener("click", function CameraComponent_div_4_span_6_Template_span_click_0_listener() { ɵɵrestoreView(_r18); const ctx_r17 = ɵɵnextContext(2); return ctx_r17.uploadImage(); });
    ɵɵelement(1, "i", 19);
    ɵɵelementEnd();
} }
function CameraComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 12);
    ɵɵelementStart(1, "span", 13);
    ɵɵtext(2, "\u00BFDesea subir el archivo?");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 14);
    ɵɵtemplate(4, CameraComponent_div_4_span_4_Template, 2, 0, "span", 15);
    ɵɵtemplate(5, CameraComponent_div_4_span_5_Template, 2, 0, "span", 16);
    ɵɵtemplate(6, CameraComponent_div_4_span_6_Template, 2, 0, "span", 15);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r3.captured);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.captured);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.captured);
} }
class CameraComponent {
    constructor(element, http, swalTargets) {
        this.element = element;
        this.http = http;
        this.swalTargets = swalTargets;
        this.image = new EventEmitter();
        this.isFacingModeSupported = isFacingModeSupported();
        this.version = '';
        this.cameras = [];
        this.facingModes = ['user', 'environment', 'left', 'right'];
        this.captured = false;
        this.camera_active = false;
        this.showBase64 = null;
        this.addCamera();
    }
    addCamera() {
        this.cameras.push({
            options: {
                audio: false,
                video: { width: {}, height: {} },
                fallbackSrc: 'fallback/jscam_canvas_only.swf'
            }
        });
    }
    onSuccess(stream) {
        this.camera_active = true;
        console.log('Capturing video stream on your camera...');
    }
    captureBase64(webcam) {
        console.log('capturar');
        var sound = new Howl({
            src: ['assets/sounds/camera-shutter-click-01.mp3']
        });
        sound.play();
        return webcam.getBase64()
            .then(base => {
            this.captured = new Date();
            this.base64 = base;
            this.form = webcam.dataUriToFormData(this.base64, 'archivo.png');
        })
            .catch(e => console.error(e));
    }
    getErrorJson(error) {
        const keys = Object.getOwnPropertyNames(error);
        const ob = {};
        keys.forEach(key => ob[key] = error[key]);
        return ob;
    }
    uploadImage() {
        let object = {
            'identifier': this.identifier,
            'form': this.form
        };
        this.image.emit(object);
    }
    logerror(e) {
        console.error(e);
        console.info('debug cameras', this.cameras);
    }
}
/** @nocollapse */ CameraComponent.ɵfac = function CameraComponent_Factory(t) { return new (t || CameraComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(HttpClient), ɵɵdirectiveInject(SwalPortalTargets)); };
/** @nocollapse */ CameraComponent.ɵcmp = ɵɵdefineComponent({ type: CameraComponent, selectors: [["akeela-camera"]], inputs: { identifier: "identifier" }, outputs: { image: "image" }, decls: 5, vars: 4, consts: [[1, "row"], ["class", "row", 4, "ngIf"], ["class", "col-lg-12", "style", "width:100%;min-height:100%;", 4, "ngIf"], ["class", "text-center", "style", "position: fixed; bottom: 25px; width: 100%;", 4, "ngIf"], [1, "col-lg-12", 2, "align-content", "center"], ["width", "100%", 3, "src"], [1, "col-lg-12", 2, "width", "100%", "min-height", "100%"], [2, "width", "100%", "height", "100%", "display", "block", "text-align", "center", 3, "ref", "videoDeviceId", "facingMode", "reflect", "error", "options", "refChange", "errorChange", "success"], [1, "col-lg-12", "text-center"], ["class", "camera-press", 3, "click", 4, "ngIf"], [1, "camera-press", 3, "click"], [1, "fa", "fa-camera", 2, "color", "#000", "font-size", "20px"], [1, "text-center", 2, "position", "fixed", "bottom", "25px", "width", "100%"], [1, "text-white", "text-bold"], [2, "background-color", "rgba(255,255,255, 0.1)"], [3, "click", 4, "ngIf"], [4, "ngIf"], [3, "click"], ["src", "/assets/public/images/close.svg", 1, "ak-close", "pull-right", "close", 2, "color", "red"], ["aria-hidden", "true", 1, "fa", "fa-check", 2, "color", "green"]], template: function CameraComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, CameraComponent_div_1_Template, 3, 1, "div", 1);
        ɵɵtemplate(2, CameraComponent_div_2_Template, 2, 6, "div", 2);
        ɵɵelementEnd();
        ɵɵtemplate(3, CameraComponent_div_3_Template, 5, 1, "div", 1);
        ɵɵtemplate(4, CameraComponent_div_4_Template, 7, 3, "div", 3);
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.captured);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.captured);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.camera_active && !ctx.captured);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.captured);
    } }, directives: [NgIf, CamComponent], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CameraComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-camera',
                templateUrl: './camera.component.html'
            }]
    }], function () { return [{ type: ElementRef }, { type: HttpClient }, { type: SwalPortalTargets }]; }, { identifier: [{
            type: Input
        }], image: [{
            type: Output
        }] }); })();

const _c0$6 = ["fileInput"];
class InputUploadComponent {
    constructor(uploader, localStorage, imageCompressor) {
        this.uploader = uploader;
        this.localStorage = localStorage;
        this.imageCompressor = imageCompressor;
        this.refresh = false;
        this.subscriptions = new Subscription;
        this.loading = false;
        this.response = new EventEmitter();
        // tslint:disable-next-line:no-output-on-prefix
        this.onCompleteItem = new EventEmitter();
        this.selected = new EventEmitter();
        this.evtUpload = new EventEmitter();
        this.executeAction = (identifier) => {
            this.notify();
            this.returnPreview(identifier);
            // this.notify();
            // // alert(this.validateAttempt());
            // if (this._config ?.facialRecognition ?.active && this.validateAttempt()) {
            //   this.returnPreview(identifier);
            // } else {
            //   // alert('update');
            //   this.updateToQueue(identifier);
            // }
        };
        this.eventUpload = () => {
            this.evtUpload.emit(true);
        };
        this.validateAttempt = () => {
            var _a, _b;
            // alert('INPUT: ' + parseInt(this.localStorage.getItem('currentAttemp'), 10) + ' <-> ' + this._config.maxAttempt);
            if (isNullOrUndefined(this.localStorage.getItem('currentAttemp'))) {
                return true;
            }
            else {
                if (!isNullOrUndefined((_a = this._config) === null || _a === void 0 ? void 0 : _a.maxAttempt)) {
                    if (parseInt(this.localStorage.getItem('currentAttemp'), 10) > parseInt((_b = this._config) === null || _b === void 0 ? void 0 : _b.maxAttempt, 10)) {
                        // alert('es por acá');
                        return false;
                    }
                }
            }
            return true;
        };
        this.returnPreview = (identifier) => __awaiter(this, void 0, void 0, function* () {
            //await this.compress(fileBrowser.files[(fileBrowser.files.length - 1)])
            const fileBrowser = this.fileInput.nativeElement;
            // await this.compress(fileBrowser);
            this.response.emit({
                'type': 'preview',
                'identifier': identifier,
                'image': yield this.compress(fileBrowser.files[(fileBrowser.files.length - 1)])
            });
        });
        this.compress = (inputFile) => __awaiter(this, void 0, void 0, function* () {
            let config;
            let file = inputFile;
            if (inputFile.size <= 100000) {
                console.log('Archivo muy pequeño, no se comprime. ');
            }
            else if (inputFile.size <= 300000) {
                console.log('Se comprime al 90% de calidad. ');
                config = { orientation: 1, ratio: 60, quality: 90, enableLogs: true };
                file = yield this.imageCompressor.compressFile(inputFile, config);
            }
            else if (inputFile.size <= 1000000) {
                console.log('Se comprime al 30% de calidad. ');
                config = { orientation: 1, ratio: 60, quality: 30, enableLogs: true };
                file = yield this.imageCompressor.compressFile(inputFile, config);
            }
            else {
                console.log('Se comprime al 20% de calidad. ');
                config = { orientation: 1, ratio: 60, quality: 20, enableLogs: true };
                file = yield this.imageCompressor.compressFile(inputFile, config);
            }
            return file;
        });
        this.updateToQueue = (identifier) => __awaiter(this, void 0, void 0, function* () {
            if (!this.loading) {
                this.loading = true;
                this.refresh = true;
                const file_type_accepts = this._config.file.file_type_accepts;
                let max_file_size = null;
                if (!isNullOrUndefined(this._config.file.mb_max_filesize)) {
                    max_file_size = this._config.file.mb_max_filesize * 1000000;
                }
                const fileBrowser = this.fileInput.nativeElement;
                console.log(fileBrowser);
                if (fileBrowser.files.length > 0) {
                    if (this.validateTypeFile(fileBrowser.files[(fileBrowser.files.length - 1)].type, file_type_accepts)) {
                        if (this.validateTypeSize(fileBrowser.files[(fileBrowser.files.length - 1)].size, max_file_size)) {
                            this.subscriptions.add(this.uploader.postFileCompress(yield this.compress(fileBrowser.files[0]), identifier, this._config.viewName, false).subscribe((data) => {
                                this.refresh = false;
                                if (!isNullOrUndefined(this.fileInput)) {
                                    this.fileInput.nativeElement.value = '';
                                }
                                this.response.emit({ type: 'success' });
                                this.loading = false;
                            }));
                        }
                        else {
                            this.refresh = false;
                            if (!isNullOrUndefined(this.fileInput)) {
                                this.fileInput.nativeElement.value = '';
                            }
                            this.loading = false;
                            this.response.emit({ type: 'error', title: 'Error', html: 'Tamaño del archivo excede el máximo de ' + this.config.file.mb_max_filesize + ' MB permitido por archivo.' });
                        }
                    }
                    else {
                        this.refresh = false;
                        if (!isNullOrUndefined(this.fileInput)) {
                            this.fileInput.nativeElement.value = '';
                        }
                        this.loading = false;
                        this.response.emit({ type: 'error', title: 'Error', html: 'Tipo de archivo no soportado.' });
                    }
                }
            }
        });
    }
    set config(value) {
        this._config = value;
    }
    set title(value) {
        this._title = value;
    }
    set identifier(value) {
        this._identifier = value;
    }
    set faceChecked(value) {
        if (!isNullOrUndefined(value)) {
            this.updateToQueue(value);
        }
    }
    ngOnInit() {
    }
    validateTypeFile(file_type, file_type_accepts) {
        let accept = false;
        file_type_accepts.forEach(element => {
            if (element === file_type) {
                accept = true;
            }
        });
        return accept;
    }
    validateTypeSize(size, max_size) {
        if (!isNullOrUndefined(max_size)) {
            if (size <= max_size) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }
    getFile() {
        const element = document.querySelector('input[type="file"]');
        element.click();
    }
    notify() {
        this.selected.emit('seleccionado');
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
/** @nocollapse */ InputUploadComponent.ɵfac = function InputUploadComponent_Factory(t) { return new (t || InputUploadComponent)(ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(LocalService), ɵɵdirectiveInject(ImageCompressorService)); };
/** @nocollapse */ InputUploadComponent.ɵcmp = ɵɵdefineComponent({ type: InputUploadComponent, selectors: [["akeela-input-upload"]], viewQuery: function InputUploadComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$6, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.fileInput = _t.first);
    } }, inputs: { config: "config", title: "title", identifier: "identifier", faceChecked: "faceChecked" }, outputs: { response: "response", onCompleteItem: "onCompleteItem", selected: "selected", evtUpload: "evtUpload" }, decls: 4, vars: 1, consts: [[1, "w-100"], ["type", "file", "title", "Seleccione", "resize-max-height", "80", "resize-max-width", "80", "resize-quality", "0.1", "ng-image-compress", "", 2, "display", "none", 3, "change"], ["fileInput", ""], [1, "btn", "btn-outline-primary", "btn-block", 3, "innerHTML", "click"]], template: function InputUploadComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = ɵɵgetCurrentView();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "input", 1, 2);
        ɵɵlistener("change", function InputUploadComponent_Template_input_change_1_listener() { return ctx.executeAction(ctx._identifier); });
        ɵɵelementEnd();
        ɵɵelementStart(3, "button", 3);
        ɵɵlistener("click", function InputUploadComponent_Template_button_click_3_listener() { ɵɵrestoreView(_r1); const _r0 = ɵɵreference(2); _r0.click(); return ctx.eventUpload(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵproperty("innerHTML", ctx.loading ? "Subiendo..." : ctx._title, ɵɵsanitizeHtml);
    } }, styles: [".btn-ak[_ngcontent-%COMP%]{-o-border-image:initial;align-items:center;background:#0f66df;border:initial none;border-color:initial;border-image:initial;border-radius:16px;box-shadow:0 10px 30px 0 rgba(0,0,0,.1);color:#fff;cursor:pointer;display:inline-block;flex-direction:row;font-size:18px;font-weight:700;height:68px;justify-content:center;letter-spacing:normal;line-height:24px;margin:0;max-width:332px;outline:none;overflow:hidden;padding:0 24px 3px;pointer-events:auto;position:relative;text-align:center;text-transform:none;transform:perspective(1000px) translateZ(0);transition:all .1s ease-in-out 0s;width:100%}.label-ak[_ngcontent-%COMP%]{color:#111;flex-direction:row;opacity:.6;transition:all .3s ease-in-out 0s}.btn-file[_ngcontent-%COMP%], .label-ak[_ngcontent-%COMP%]{font-size:15px;font-weight:500}.btn-file[_ngcontent-%COMP%]{color:#fff;cursor:pointer;height:100%!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(InputUploadComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-input-upload',
                templateUrl: './input-upload.component.html',
                styleUrls: ['./input-upload.component.css']
            }]
    }], function () { return [{ type: UploadService }, { type: LocalService }, { type: ImageCompressorService }]; }, { config: [{
            type: Input
        }], title: [{
            type: Input
        }], identifier: [{
            type: Input
        }], faceChecked: [{
            type: Input
        }], response: [{
            type: Output
        }], onCompleteItem: [{
            type: Output
        }], selected: [{
            type: Output
        }], evtUpload: [{
            type: Output
        }], fileInput: [{
            type: ViewChild,
            args: ['fileInput', { static: false }]
        }] }); })();

const _c0$7 = ["photoPrev"];
function RequirementsCameraDetailComponent_div_15_iframe_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "iframe", 32);
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext(2);
    ɵɵproperty("src", ctx_r10.safe_url, ɵɵsanitizeResourceUrl);
} }
function RequirementsCameraDetailComponent_div_15_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 33);
} if (rf & 2) {
    const ctx_r11 = ɵɵnextContext(2);
    ɵɵpropertyInterpolate1("src", "./assets/", ctx_r11.safe_url_imagen, "", ɵɵsanitizeUrl);
} }
function RequirementsCameraDetailComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 29);
    ɵɵtemplate(1, RequirementsCameraDetailComponent_div_15_iframe_1_Template, 1, 1, "iframe", 30);
    ɵɵtemplate(2, RequirementsCameraDetailComponent_div_15_img_2_Template, 1, 1, "img", 31);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r0.reload && ctx_r0.safe_url);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r0.safe_url);
} }
function RequirementsCameraDetailComponent_akeela_webcam_22_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "akeela-webcam", 34);
    ɵɵlistener("response", function RequirementsCameraDetailComponent_akeela_webcam_22_Template_akeela_webcam_response_0_listener($event) { ɵɵrestoreView(_r13); const ctx_r12 = ɵɵnextContext(); return ctx_r12.notificacion($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("config", ctx_r2.config_webcam)("faceChecked", ctx_r2.faceCheckedW);
} }
function RequirementsCameraDetailComponent_ng_container_30_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 40);
} if (rf & 2) {
    const ctx_r14 = ɵɵnextContext(2);
    ɵɵproperty("src", ctx_r14.imagePreview, ɵɵsanitizeUrl);
} }
function RequirementsCameraDetailComponent_ng_container_30_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 41);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r15.valueDescriptorsComparation.detail, " ");
} }
function RequirementsCameraDetailComponent_ng_container_30_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 35);
    ɵɵelementStart(2, "div", 36);
    ɵɵtemplate(3, RequirementsCameraDetailComponent_ng_container_30_img_3_Template, 1, 1, "img", 37);
    ɵɵelementEnd();
    ɵɵelement(4, "div", 38);
    ɵɵtemplate(5, RequirementsCameraDetailComponent_ng_container_30_div_5_Template, 2, 1, "div", 39);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("ngIf", ctx_r3.imagePreview !== "" && ctx_r3.imagePreview !== null);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r3.valueDescriptorsComparation);
} }
function RequirementsCameraDetailComponent_ng_container_31_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "i", 46);
    ɵɵelement(2, "span", 47);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ctx_r16.faceDetectorError, ɵɵsanitizeHtml);
} }
function RequirementsCameraDetailComponent_ng_container_31_ng_container_4_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 47);
} if (rf & 2) {
    ɵɵproperty("innerHTML", " El Selfie no pudo ser analizada, por lo cual no se pudo comparar.", ɵɵsanitizeHtml);
} }
function RequirementsCameraDetailComponent_ng_container_31_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "i", 48);
    ɵɵelement(2, "span", 47);
    ɵɵtemplate(3, RequirementsCameraDetailComponent_ng_container_31_ng_container_4_span_3_Template, 1, 1, "span", 49);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", "Rostro detectado.", ɵɵsanitizeHtml);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r17.executeCompare);
} }
function RequirementsCameraDetailComponent_ng_container_31_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "i", 46);
    ɵɵelement(2, "span", 47);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ctx_r18.faceDetectorWarning, ɵɵsanitizeHtml);
} }
function RequirementsCameraDetailComponent_ng_container_31_img_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 50);
} if (rf & 2) {
    const ctx_r19 = ɵɵnextContext(2);
    ɵɵproperty("src", ctx_r19.imagePreviewResult, ɵɵsanitizeUrl);
} }
function RequirementsCameraDetailComponent_ng_container_31_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 41);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r20.valueDescriptorsComparation.detail, " ");
} }
function RequirementsCameraDetailComponent_ng_container_31_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 38);
    ɵɵelement(1, "br");
    ɵɵelementEnd();
} }
function RequirementsCameraDetailComponent_ng_container_31_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 35);
    ɵɵelementStart(2, "div", 42);
    ɵɵtemplate(3, RequirementsCameraDetailComponent_ng_container_31_ng_container_3_Template, 3, 1, "ng-container", 23);
    ɵɵtemplate(4, RequirementsCameraDetailComponent_ng_container_31_ng_container_4_Template, 4, 2, "ng-container", 23);
    ɵɵtemplate(5, RequirementsCameraDetailComponent_ng_container_31_ng_container_5_Template, 3, 1, "ng-container", 23);
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 43);
    ɵɵtemplate(7, RequirementsCameraDetailComponent_ng_container_31_img_7_Template, 1, 1, "img", 44);
    ɵɵtemplate(8, RequirementsCameraDetailComponent_ng_container_31_div_8_Template, 2, 1, "div", 39);
    ɵɵelementEnd();
    ɵɵtemplate(9, RequirementsCameraDetailComponent_ng_container_31_div_9_Template, 2, 0, "div", 45);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵclassProp("bgerror", ctx_r4.faceDetectorError)("bgwarning", ctx_r4.faceDetectorWarning)("bgsuccess", ctx_r4.files[ctx_r4._config.object[ctx_r4._config.category][ctx_r4.item].requirement.alternateName].status === "COMPLETED" && !ctx_r4.faceDetectorWarning && !ctx_r4.faceDetectorError);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.faceDetectorError !== null && ctx_r4.faceDetectorError !== "");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.files[ctx_r4._config.object[ctx_r4._config.category][ctx_r4.item].requirement.alternateName].status === "COMPLETED" && !ctx_r4.faceDetectorWarning && !ctx_r4.faceDetectorError);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.faceDetectorWarning !== null);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r4.imagePreviewResult !== "" && ctx_r4.imagePreviewResult !== null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.valueDescriptorsComparation);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r4.faceDetectorError && !ctx_r4.faceDetectorWarning || ctx_r4.failFaceAPI);
} }
function RequirementsCameraDetailComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "div");
    ɵɵelementStart(2, "div", 52);
    ɵɵelement(3, "i", 53);
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 54);
    ɵɵtext(5, " Espere un momento mientras analizamos la imagen... ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function RequirementsCameraDetailComponent_div_33_ng_container_9_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ", ", " ");
} }
function RequirementsCameraDetailComponent_div_33_ng_container_9_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵtemplate(2, RequirementsCameraDetailComponent_div_33_ng_container_9_ng_container_3_ng_container_2_Template, 2, 1, "ng-container", 23);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const format_r25 = ctx.$implicit;
    const i_r26 = ctx.index;
    const ctx_r24 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", format_r25, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r24._config.file.file_type_accepts_description.length !== i_r26 + 1);
} }
function RequirementsCameraDetailComponent_div_33_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtext(1);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, RequirementsCameraDetailComponent_div_33_ng_container_9_ng_container_3_Template, 3, 2, "ng-container", 61);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r23 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 2, "@i18n-requirements-formats-accepted"), ": ");
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r23._config.file.file_type_accepts_description);
} }
function RequirementsCameraDetailComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 55);
    ɵɵelementStart(1, "div", 0);
    ɵɵelementStart(2, "div", 56);
    ɵɵelementStart(3, "button", 57);
    ɵɵlistener("click", function RequirementsCameraDetailComponent_div_33_Template_button_click_3_listener() { ɵɵrestoreView(_r29); const ctx_r28 = ɵɵnextContext(); return ctx_r28.openCamera(); });
    ɵɵelement(4, "i", 58);
    ɵɵtext(5, "Camara");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 56);
    ɵɵelementStart(7, "akeela-input-upload", 59);
    ɵɵlistener("response", function RequirementsCameraDetailComponent_div_33_Template_akeela_input_upload_response_7_listener($event) { ɵɵrestoreView(_r29); const ctx_r30 = ɵɵnextContext(); return ctx_r30.notificacion($event); })("evtUpload", function RequirementsCameraDetailComponent_div_33_Template_akeela_input_upload_evtUpload_7_listener() { ɵɵrestoreView(_r29); const ctx_r31 = ɵɵnextContext(); return ctx_r31.clsCamera(); })("selected", function RequirementsCameraDetailComponent_div_33_Template_akeela_input_upload_selected_7_listener() { ɵɵrestoreView(_r29); const ctx_r32 = ɵɵnextContext(); return ctx_r32.reset(); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(8, "div", 60);
    ɵɵtemplate(9, RequirementsCameraDetailComponent_div_33_ng_container_9_Template, 4, 4, "ng-container", 23);
    ɵɵelementEnd();
    ɵɵelementStart(10, "div", 60);
    ɵɵtext(11, "Tama\u00F1o m\u00E1ximo de archivo 5 MB! ");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext();
    ɵɵclassProp("d-none", ctx_r6.hideButtons);
    ɵɵadvance(7);
    ɵɵproperty("faceChecked", ctx_r6.faceChecked)("title", "Adjuntar")("config", ctx_r6._config)("identifier", ctx_r6._config.object[ctx_r6._config.category][ctx_r6.item].requirement.alternateName);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r6._config.file.file_type_accepts_description);
} }
function RequirementsCameraDetailComponent_div_34_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 55);
    ɵɵelementStart(1, "div", 0);
    ɵɵelementStart(2, "div", 62);
    ɵɵelementStart(3, "a", 63);
    ɵɵlistener("click", function RequirementsCameraDetailComponent_div_34_Template_a_click_3_listener() { ɵɵrestoreView(_r34); const ctx_r33 = ɵɵnextContext(); return ctx_r33.showButtons(); });
    ɵɵtext(4, "\u00BFVolver a intentar?");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function RequirementsCameraDetailComponent_div_35_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 64);
    ɵɵelementStart(1, "button", 65);
    ɵɵlistener("click", function RequirementsCameraDetailComponent_div_35_Template_button_click_1_listener() { ɵɵrestoreView(_r36); const ctx_r35 = ɵɵnextContext(); return ctx_r35.next(); });
    ɵɵtext(2, "Continuar");
    ɵɵelement(3, "i", 66);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("disabled", ctx_r8.files[ctx_r8._config.object[ctx_r8._config.category][ctx_r8.item].requirement.alternateName].status !== "COMPLETED" ? true : false);
} }
function RequirementsCameraDetailComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 67);
    ɵɵelementStart(1, "div", 68);
    ɵɵelementStart(2, "span", 4);
    ɵɵelementStart(3, "a", 63);
    ɵɵlistener("click", function RequirementsCameraDetailComponent_div_36_Template_a_click_3_listener() { ɵɵrestoreView(_r38); const ctx_r37 = ɵɵnextContext(); return ctx_r37.changeStatusFacialRecognition(); });
    ɵɵtext(4, "\u00BFTienes problemas para continuar?");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
class RequirementsCameraDetailComponent {
    constructor(_i18n, _upload, webcamService, sanitizer, faceDetectorService, faceApiCompare, faceApiModel, localStorage, _httpService) {
        this._i18n = _i18n;
        this._upload = _upload;
        this.webcamService = webcamService;
        this.sanitizer = sanitizer;
        this.faceDetectorService = faceDetectorService;
        this.faceApiCompare = faceApiCompare;
        this.faceApiModel = faceApiModel;
        this.localStorage = localStorage;
        this._httpService = _httpService;
        this.item = 0;
        this.loading = false;
        this.reload = false;
        this.loaded = false;
        this.faceDetectorLoading = false;
        this.faceDetectorResponse = null;
        this.faceDetectorError = null;
        this.faceDetectorWarning = null;
        this.faceCheckedW = null;
        this.showYoutubeVideo = true;
        this.failFaceAPI = false;
        this.imagePreview = null;
        this.imageAux = null;
        this.imagePreviewResult = null;
        this.executeCompare = true;
        this.showCamera = false;
        this.hideButtons = false;
        this.liveRecognitionActive = false;
        this.valueDescriptorsComparation = null;
        this.safe_url_imagen = null;
        this.showFile = new EventEmitter();
        this.finish = new EventEmitter();
        this.event = new EventEmitter();
        this.subscription = new Subscription();
        this.config_webcam = null;
        this.reconocimientoFacialActivo = false;
        this.setSelfie = (img) => {
            this.localStorage.setItem('selfie_img', img);
        };
        this.reset = () => {
            this.faceChecked = null;
            this.faceCheckedW = null;
            this.faceDetectorError = null;
            this.faceDetectorIdentifierFile = null;
            this.faceDetectorLoading = false;
            this.faceDetectorResponse = false;
            this.imagePreview = null;
        };
        this.setAttempt = () => {
            // this.requirement.filter((req) => {
            //   return 
            // });
            if (!isNullOrUndefined(this.attempt)) {
                const attempt = this.attempt.filter((att) => {
                    return att.alternateName === this.requirement.alternateName;
                });
                if (attempt.length === 1) {
                    if (attempt[0].contentSize) {
                        this.localStorage.setItem('currentAttemp', attempt[0].contentSize);
                    }
                    else {
                        this.localStorage.removeItem('currentAttemp');
                    }
                }
            }
            else {
                this.localStorage.removeItem('currentAttemp');
            }
        };
        this.calculateYear = (years) => Math.floor(years) + ' años';
        this.getMostProbExpresion = (expresions) => {
            return expresions.reduce((acc, shot) => acc = acc > shot.amount ? acc : shot.amount, 0);
        };
        this.analisisFaceDetector = () => __awaiter(this, void 0, void 0, function* () {
            if (this.faceDetectorResponse.length > 0) {
                if (this.faceDetectorResponse.length === 1 || (this.faceDetectorResponse.length === 2 && this.requirement.alternateName === 'SELFIE_DOC_IDENTITY')) {
                    // this.files[this._config.object[this._config.category][this.item].requirement.alternateName].status = 'COMPLETED';
                    if (!isNullOrUndefined(this.faceDetectorIdentifierFile)) {
                        this.faceChecked = this.faceDetectorIdentifierFile;
                    }
                    else {
                        this.faceCheckedW = Date();
                    }
                    //alert(this.requirement.alternateName);
                    if (this.requirement.alternateName === 'SELFIE' && !this.liveRecognitionActive) {
                        this.saveAnalisis('');
                        this.setSelfie(this.imageAux);
                        this.hideButtons = true;
                    }
                    else {
                        let comp = null;
                        let response = null;
                        if (!this.liveRecognitionActive) {
                            try {
                                if (!isNullOrUndefined(this.localStorage.getItem('selfie_img'))) {
                                    this.executeCompare = true;
                                    comp = yield this.compareFace(this.localStorage.getItem('selfie_img'), this.imageAux);
                                    if (!isNullOrUndefined(comp)) {
                                        if (!isNullOrUndefined(comp.response)) {
                                            if (!isNullOrUndefined(comp.response.detail)) {
                                                response = comp.response.detail;
                                            }
                                        }
                                    }
                                }
                                else {
                                    let comp = null;
                                    let response = null;
                                    this.executeCompare = false;
                                }
                            }
                            catch (e) {
                                comp = null;
                                this.faceDetectorWarning = 'No se ha podido comparar su documento, puede intentar nuevamente o continuar. Recuerde que si la foto no coincide deberá revisar nuevamente la información.';
                            }
                        }
                        else {
                            let response = null;
                            this.valueDescriptorsComparation = response = yield this.faceApiCompare.compareDescriptors(this.localStorage.getItem('liveFinger'), JSON.stringify(this.faceDetectorResponse[0]['descriptor']));
                            if (!isNullOrUndefined(response)) {
                                if (response['response'] === 'success') {
                                    if (response['detail'] >= 0.6) {
                                        this.faceChecked = null;
                                        comp = null;
                                        this.faceDetectorError = 'No podemos vincular el rostro con la verificación fácial en vivo.';
                                        this.saveAnalisis('');
                                        yield this.saveAttempt();
                                        this.attempt = yield this.getAttempt();
                                        this.setAttempt(); //mario
                                        this.attempts = this.localStorage.getItem('currentAttemp');
                                        this.hideButtons = false;
                                    }
                                    else {
                                        this.faceDetectorError = '';
                                    }
                                }
                            }
                        }
                        //comp = await this.faceApiCompare.compare(this.localStorage.getItem('selfie_img'), this.imagePreview);
                        if (!this.liveRecognitionActive) {
                            if (response.includes('unknow')) {
                                this.faceDetectorWarning = '<b>Selfie no coincide</b><br>No podemos comparar correctamente su rostro con la Selfie, recuerde que si la foto no coincide deberá revisar nuevamente la información.';
                            }
                        }
                        if (this.faceDetectorError == '') {
                            setTimeout(() => {
                                let facedetector = '';
                                if (!isNullOrUndefined(this.faceDetectorResponse)) {
                                    facedetector = JSON.parse(this.faceDetectorResponse);
                                }
                                this.saveAnalisis(facedetector);
                            }, 30);
                        }
                    }
                    if (!isNullOrUndefined(this.faceCheckedW) && (this.faceDetectorError === '' || this.faceDetectorError === null)) {
                        this.webcamService.executeUploadFile();
                    }
                    //esto hace que se suba doble la imagen de la webcam
                }
                else {
                    this.saveAnalisis('');
                    //this.imagePreview = null;
                    //this.faceDetectorService.responseFaceApi.next(null);
                    yield this.saveAttempt();
                    this.attempt = yield this.getAttempt();
                    this.setAttempt();
                    //this.files[this._config.object[this._config.category][this.item].requirement.alternateName].status = '';
                    if (this.requirement.alternateName === 'SELFIE_DOC_IDENTITY') {
                        this.faceDetectorError = 'Debe tomarse una fotografia individual con su documento de identidad';
                    }
                    else {
                        this.faceDetectorError = 'Debe tomarse una fotografia individual';
                    }
                    this.hideButtons = false;
                }
            }
            else {
                this.saveAnalisis('');
                //this.imagePreview = null;
                //this.faceDetectorService.responseFaceApi.next(null);
                yield this.saveAttempt();
                this.attempt = yield this.getAttempt();
                this.setAttempt();
                //this.files[this._config.object[this._config.category][this.item].requirement.alternateName].status = '';
                if (!this.reconocimientoFacialActivo) {
                    if (!isNullOrUndefined(this.faceDetectorIdentifierFile)) {
                        this.faceChecked = this.faceDetectorIdentifierFile;
                    }
                    else {
                        this.faceCheckedW = Date();
                    }
                }
                this.faceDetectorError = 'No se puede identificar su rostro, por favor intente nuevamente';
                this.hideButtons = false;
            }
        });
        this.executeResponseFaceAPI = (response) => {
            if (!isNullOrUndefined(response)) {
                this.faceDetectorResponse = this.processResponse(response);
                this.localStorage.setItem('faceAPIEvaluation', JSON.stringify(this.faceDetectorResponse));
                this.faceDetectorLoading = false;
                this.faceDetectorError = null;
                this.faceDetectorWarning = null;
                if (!this.failFaceAPI) {
                    this.analisisFaceDetector();
                }
                else {
                    if (!isNullOrUndefined(this.faceDetectorIdentifierFile)) {
                        this.faceChecked = this.faceDetectorIdentifierFile;
                    }
                    else {
                        if (this.faceDetectorError === '') {
                            this.webcamService.executeUploadFile();
                        }
                        // este caso ya no aplica porque el componente de camara se oculta
                        // this.faceCheckedW = Date();
                    }
                }
            }
        };
        this.saveAnalisis = (result) => __awaiter(this, void 0, void 0, function* () {
            const params = {
                name: 'person$comparative_json$post',
                params: {
                    request: {},
                    path: {},
                    body: {
                        'identifier': this._config.identifierPerson,
                        'alternateName': this.requirement.alternateName,
                        'description': result
                    }
                }
            };
            return yield this._httpService.executeRequest(params.name, params.params, true).toPromise();
        });
        this.saveAttempt = () => __awaiter(this, void 0, void 0, function* () {
            const params = {
                name: 'person$increment_doc_attempts$post',
                params: {
                    request: {
                        'idPerson': this._config.identifierPerson,
                        'docCode': this.requirement.alternateName
                    },
                    path: {},
                    body: {}
                }
            };
            return yield this._httpService.executeRequest(params.name, params.params, true).toPromise();
        });
        this.getAttempt = () => __awaiter(this, void 0, void 0, function* () {
            this.localStorage.removeItem('currentAttemp');
            const params = {
                name: 'person$doc_attempts$get',
                params: {
                    request: {
                        'idPerson': this._config.identifierPerson
                    },
                    path: {},
                    body: {}
                }
            };
            return yield this._httpService.executeRequest(params.name, params.params, true).toPromise();
        });
        this.openCamera = () => {
            this.config_webcam = {
                width: 480,
                height: 480,
                facialRecognition: this._config.facialRecognition
            };
            this.showYoutubeVideo = false;
            this.showCamera = true;
        };
        this.closeCamera = () => {
            this.showCamera = false;
            this.config_webcam = null;
        };
        this.clsCamera = () => {
            this.showCamera = false;
            this.config_webcam = null;
            this.showYoutubeVideo = true;
        };
        this.next = () => __awaiter(this, void 0, void 0, function* () {
            this.hideButtons = false;
            this.localStorage.removeItem('currentAttemp');
            this.localStorage.removeItem('faceAPIEvaluation');
            this.webcamService.setImage(null);
            this.faceChecked = null;
            this.faceCheckedW = null;
            this.faceDetectorError = null;
            this.faceDetectorIdentifierFile = null;
            this.faceDetectorLoading = false;
            this.faceDetectorResponse = false;
            this.faceDetectorWarning = null;
            this.imagePreview = null;
            this.imagePreviewResult = null;
            this.showYoutubeVideo = true;
            if (this.files[this._config.object[this._config.category][this.item].requirement.alternateName].status === 'COMPLETED') {
                this.reload = true;
                if ((this.item + 1) < this._config.object[this._config.category].length) {
                    this.item++;
                }
                else if ((this.item + 1) >= this._config.object[this._config.category].length) {
                    this.finish.emit(true);
                }
                //this.safe_url = this.safe_url_(this._config.object[this._config.category][this.item]['link_youtube'] + '?autoplay=1&controls=1&rel=0&showinfo=0&modestbranding=1');
                if (this._config.object[this._config.category][this.item]['link_youtube'] !== "") {
                    this.safe_url = this.safe_url_(this._config.object[this._config.category][this.item]['link_youtube'] + '?autoplay=1&controls=1&rel=0&showinfo=0&modestbranding=1');
                    this.safe_url_imagen = "";
                }
                else {
                    this.safe_url_imagen = this._config.object[this._config.category][this.item]['imagen'];
                    this.safe_url = "";
                }
                this.requirement = this._config.object[this._config.category][this.item].requirement;
                this.attempt = yield this.getAttempt();
                this.setAttempt();
                setTimeout(() => {
                    this.reload = false;
                }, 30);
                this.replace_params();
            }
        });
        this.showButtons = () => {
            this.imagePreviewResult = null;
            this.hideButtons = false;
            this.showYoutubeVideo = true;
            this.faceDetectorError = null;
        };
        // returnPreview = async (identifier) => {
        //   //await this.compress(fileBrowser.files[(fileBrowser.files.length - 1)])
        //   const fileBrowser = this.fileInput.nativeElement;
        //   this.response.emit({
        //     'type': 'preview',
        //     'identifier': identifier,
        //     'image': await this.compress(fileBrowser.files[(fileBrowser.files.length - 1)])
        //   });
        // }
        // compress = async (inputFile) => {
        //     const config: CompressorConfig = { orientation: 1, ratio: 60, quality: 90, enableLogs: true };
        //     return await this.imageCompressor.compressFile(inputFile, config);
        // }
        this.validateAttempt = () => {
            var _a, _b;
            if (!this.liveRecognitionActive) {
                if (isNullOrUndefined(this.localStorage.getItem('currentAttemp'))) {
                    return true;
                }
                else {
                    if (!isNullOrUndefined((_a = this._config) === null || _a === void 0 ? void 0 : _a.maxAttempt)) {
                        if (parseInt(this.localStorage.getItem('currentAttemp'), 10) > parseInt((_b = this._config) === null || _b === void 0 ? void 0 : _b.maxAttempt, 10)) {
                            return false;
                        }
                    }
                }
                return true;
            }
            else {
                return true;
            }
        };
        // Takes a data URI and returns the Data URI corresponding to the resized image at the wanted size.
        this.resizeImage = (file, maxWidth, maxHeight) => __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                const image = new Image();
                image.src = URL.createObjectURL(file);
                image.onload = () => {
                    const width = image.width;
                    const height = image.height;
                    if (width <= maxWidth && height <= maxHeight) {
                        resolve(file);
                    }
                    let newWidth;
                    let newHeight;
                    if (width > height) {
                        newHeight = height * (maxWidth / width);
                        newWidth = maxWidth;
                    }
                    else {
                        newWidth = width * (maxHeight / height);
                        newHeight = maxHeight;
                    }
                    const canvas = document.createElement('canvas');
                    canvas.width = newWidth;
                    canvas.height = newHeight;
                    const context = canvas.getContext('2d');
                    context.drawImage(image, 0, 0, newWidth, newHeight);
                    canvas.toBlob(resolve, file.type, 0.6);
                };
                image.onerror = reject;
            });
        });
        this.selectFile = (imageBase64, name) => __awaiter(this, void 0, void 0, function* () {
            console.log('Estatus de reconocimiento fácial: ' + this.reconocimientoFacialActivo);
            if (this.reconocimientoFacialActivo && this.validateAttempt()) {
                this.detectFace(imageBase64, name).then((response) => {
                    var _a, _b, _c;
                    this.failFaceAPI = false;
                    if (!isNullOrUndefined(response)) {
                        this.imagePreviewResult = ((_c = (_b = (_a = this._config) === null || _a === void 0 ? void 0 : _a.facialRecognition) === null || _b === void 0 ? void 0 : _b.services) === null || _c === void 0 ? void 0 : _c.host) + '' + response.url;
                        this.imageAux = imageBase64;
                        this.imagePreview = null;
                        // this.imagePreviewURL = response.url;
                        // this.faceDetectorLoading= false;
                        // this.faceDetectorService.responseFaceApi.next(response.detectedFacesData);
                        this.executeResponseFaceAPI(response.detectedFacesData);
                        this.hideButtons = true;
                    }
                    else {
                        this.imagePreviewResult = null;
                        // this.faceDetectorLoading= false;
                        // this.faceDetectorService.responseFaceApi.next([]);
                        this.executeResponseFaceAPI([]);
                        this.hideButtons = true;
                    }
                }, error => {
                    this.imagePreviewResult = null;
                    // this.faceDetectorLoading= false;
                    // this.faceDetectorService.responseFaceApi.next([]);
                    this.failFaceAPI = true;
                    this.executeResponseFaceAPI([]);
                    this.hideButtons = true;
                    //this.showResponseError(error, imageBase64);
                });
            }
            else {
                this.failFaceAPI = false;
                this.localStorage.removeItem('faceAPIEvaluation');
                this.imagePreviewResult = imageBase64;
                this.imagePreview = null;
                //this.faceCheckedW = this.faceDetectorIdentifierFile;
                //this.faceCheckedW = new Date();
                this.faceDetectorLoading = false;
                this.faceDetectorError = null;
                this.faceDetectorWarning = null;
                //this.faceChecked = new Date();
                if (!this.reconocimientoFacialActivo) {
                    this.faceDetectorWarning = 'Reconocimiento Facial desactivado.';
                }
                else {
                    this.faceDetectorWarning = 'Intento (' + this.localStorage.getItem('currentAttemp') + '). La imagen no se evaluará con reconocimiento Fácial';
                }
                //if(this.liveRecognitionActive) {
                if (!isNullOrUndefined(this.faceDetectorIdentifierFile)) {
                    this.faceChecked = this.faceDetectorIdentifierFile;
                }
                else {
                    this.faceCheckedW = Date();
                    this.webcamService.executeUploadFile();
                }
                //}
                this.hideButtons = true;
            }
        });
        this.showResponseError = (error, imageBase64) => {
            this.imagePreviewResult = imageBase64;
            this.imagePreview = null;
            this.faceChecked = this.faceDetectorIdentifierFile;
            this.faceDetectorLoading = false;
            this.faceDetectorWarning = null;
            this.faceDetectorError = 'Acá llega el error';
        };
        this.detectFace = (image, name) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const pathResponse = {
                url: ((_c = (_b = (_a = this._config) === null || _a === void 0 ? void 0 : _a.facialRecognition) === null || _b === void 0 ? void 0 : _b.services) === null || _c === void 0 ? void 0 : _c.host) + '/detect',
                httpMethod: 'POST'
            };
            const formData = new FormData();
            formData.append("conf", JSON.stringify({
                "configuration": {
                    "type": "all",
                    "debug": true,
                    "weights": ["landmarks", "descriptors", "expressions"],
                    "draw": false
                }
            }));
            formData.append("name", name);
            formData.append("fileB64", image);
            return this._httpService.executeExternalFrontRequestMultipart(pathResponse, formData, {}).toPromise();
        });
        this.compareFace = (image1, image2) => __awaiter(this, void 0, void 0, function* () {
            var _d, _e, _f;
            const params = {
                pathResponse: {
                    url: ((_f = (_e = (_d = this._config) === null || _d === void 0 ? void 0 : _d.facialRecognition) === null || _e === void 0 ? void 0 : _e.services) === null || _f === void 0 ? void 0 : _f.host) + '/compare',
                    httpMethod: 'POST'
                },
                params: {
                    responseType: 'json',
                    body: {
                        "fileBase": image1,
                        "fileCompare": image2
                    }
                }
            };
            return this._httpService.executeRequestExternalUrl(params).toPromise();
        });
        this.blobToBase64 = (blob) => {
            return new Promise((resolve, error) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.readAsDataURL(blob);
            });
        };
        this.convertBlobToBase64 = (blob) => new Promise((resolve, reject) => {
            const reader = new FileReader;
            reader.onerror = reject;
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.readAsDataURL(blob);
        });
        this.processResponse = (response) => {
            const obj = response;
            if (!isNullOrUndefined(obj)) {
                if (obj.length > 0) {
                    // if (!isNullOrUndefined(obj['0']['descriptor'])) {
                    //   delete obj['0']['descriptor'];
                    // }
                    if (!isNullOrUndefined(obj['0']['unshiftedLandmarks'])) {
                        delete obj['0']['unshiftedLandmarks']['_positions'];
                    }
                    if (obj['0']['landmarks']) {
                        delete obj['0']['landmarks']['_positions'];
                    }
                }
            }
            return obj;
        };
        this.base64toBlob = (base64Data, contentType) => {
            contentType = contentType || '';
            const sliceSize = 1024;
            const byteCharacters = atob(base64Data);
            const bytesLength = byteCharacters.length;
            const slicesCount = Math.ceil(bytesLength / sliceSize);
            const byteArrays = new Array(slicesCount);
            for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
                const begin = sliceIndex * sliceSize;
                const end = Math.min(begin + sliceSize, bytesLength);
                const bytes = new Array(end - begin);
                for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                    bytes[i] = byteCharacters[offset].charCodeAt(0);
                }
                byteArrays[sliceIndex] = new Uint8Array(bytes);
            }
            return new Blob(byteArrays, { type: contentType });
        };
        this.changeStatusFacialRecognition = () => __awaiter(this, void 0, void 0, function* () {
            swal.fire({
                title: '',
                html: "¿Desea desactivar el reconocimiento facial?",
                showCancelButton: true,
                confirmButtonText: 'Si'
            }).then((result) => __awaiter(this, void 0, void 0, function* () {
                if (result.value) {
                    const params = {
                        name: 'person$active_facial_recognition$post',
                        params: {
                            request: {
                                'idPerson': this._config.identifierPerson,
                                'active': false
                            },
                            path: {},
                            body: {}
                        }
                    };
                    const response = yield this._httpService.executeRequest(params.name, params.params, true).toPromise();
                    this.reconocimientoFacialActivo = false;
                    this.webcamService.setImage(null);
                    this.faceChecked = null;
                    this.faceCheckedW = null;
                    this.faceDetectorError = null;
                    this.faceDetectorIdentifierFile = null;
                    this.faceDetectorLoading = false;
                    this.faceDetectorResponse = false;
                    this.faceDetectorWarning = null;
                    this.imagePreview = null;
                    this.imagePreviewResult = null;
                    this.showYoutubeVideo = true;
                    this.event.emit({
                        name: 'facial_recognition_disabled',
                        response: response
                    });
                }
            }));
        });
    }
    set config(value) {
        var _a, _b;
        this._config = value;
        this.reconocimientoFacialActivo = (_b = (_a = this._config) === null || _a === void 0 ? void 0 : _a.facialRecognition) === null || _b === void 0 ? void 0 : _b.active;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.attempts = this.localStorage.getItem('currentAttemp');
            this.liveRecognitionActive = this._config.facialRecognition.config.liveVideoValidationActive;
            this.localStorage.removeItem('faceAPIEvaluation');
            this.requirement = this._config.object[this._config.category][this.item].requirement;
            if (this._config.object[this._config.category][this.item]['link_youtube'] !== "") {
                this.safe_url = this.safe_url_(this._config.object[this._config.category][this.item]['link_youtube'] + '?autoplay=1&controls=1&rel=0&showinfo=0&modestbranding=1');
                this.safe_url_imagen = "";
            }
            else {
                this.safe_url_imagen = this._config.object[this._config.category][this.item]['imagen'];
                this.safe_url = "";
            }
            this.replace_params();
            this.attempt = yield this.getAttempt();
            this.setAttempt();
            this.subscription.add(this._upload.getChangresFilesArr().subscribe((files) => {
                this.files = this._upload.files[this._config.viewName];
                this.loaded = true;
            }));
            this.subscription.add(this._upload.getResponseUpload().subscribe((response) => {
                this._upload.files[this._config.viewName][this._config.object[this._config.category][this.item].requirement.alternateName]['idFile'] = response.body.requirementArchives[0].identifier;
                this._upload.files[this._config.viewName][this._config.object[this._config.category][this.item].requirement.alternateName]['nameFile'] = response.body.requirementArchives[0].name;
                this._upload.files[this._config.viewName][this._config.object[this._config.category][this.item].requirement.alternateName]['save']['data']['requirement']['identifier'] = response.body.identifier;
                this._upload.files[this._config.viewName][this._config.object[this._config.category][this.item].requirement.alternateName]['delete']['data']['requirement']['identifier'] = response.body.identifier;
                this.files = this._upload.files[this._config.viewName];
            }));
            // this.subscription.add(this.faceDetectorService.responseFaceApi.subscribe((response) => {
            //   console.log('esta respuesta:');
            //   console.log(response);
            //   if (!isNullOrUndefined(response)) {
            //     this.faceDetectorResponse = this.processResponse(response);
            //     this.localStorage.setItem('faceAPIEvaluation', JSON.stringify(this.faceDetectorResponse));
            //     this.faceDetectorLoading = false;
            //     this.faceDetectorError = null;
            //     this.faceDetectorWarning = null;
            //     this.analisisFaceDetector();
            //   }
            // }));
        });
    }
    ngAfterViewInit() {
        this.config_webcam = {
            width: 480,
            height: 480,
            facialRecognition: this._config.facialRecognition
        };
    }
    safe_url_(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    replace_params() {
        this._upload.files[this._config.viewName][this.requirement.alternateName]['save']['data']['requirement']['alternateName'] = this.requirement.alternateName;
        this._upload.files[this._config.viewName][this.requirement.alternateName]['delete']['data']['requirement']['alternateName'] = this.requirement.alternateName;
        this.files = this._upload.files[this._config.viewName];
    }
    show_file(file) {
        this.showFile.emit(file);
    }
    showFileVisor(identifier) {
        this.show_file({
            identifier: identifier,
            name: ''
        });
    }
    back() {
        this.reload = true;
        if (this.item > 0) {
            this.item--;
        }
        this.requirement = this._config.object[this._config.category][this.item].requirement;
        //this.safe_url = this.safe_url_(this._config.object[this._config.category][this.item]['link_youtube'] + '?autoplay=1&controls=1&rel=0&showinfo=0&modestbranding=1');
        if (this._config.object[this._config.category][this.item]['link_youtube'] !== "") {
            this.safe_url = this.safe_url_(this._config.object[this._config.category][this.item]['link_youtube'] + '?autoplay=1&controls=1&rel=0&showinfo=0&modestbranding=1');
            this.safe_url_imagen = "";
        }
        else {
            this.safe_url_imagen = this._config.object[this._config.category][this.item]['imagen'];
            this.safe_url = "";
        }
        setTimeout(() => {
            this.reload = false;
        }, 30);
        this.replace_params();
    }
    getRequirementById(identifier) {
        let response = null;
        this.requirements.forEach((element) => {
            element.value.forEach((element2) => {
                if (element2.requirement.identifier.toString() === identifier.toString()) {
                    response = element2.requirement;
                }
            });
        });
        return response;
    }
    resetCamera() {
        this.webcamService.setImage(null);
    }
    notificacion(evt) {
        return __awaiter(this, void 0, void 0, function* () {
            this.attempts = this.localStorage.getItem('currentAttemp');
            this.faceCheckedW = null;
            this.faceChecked = null;
            this.faceDetectorIdentifierFile = null;
            if (evt.type === 'preview' || evt.type === 'previewB64') {
                this.valueDescriptorsComparation = null;
                this.showYoutubeVideo = false;
                this.imagePreviewResult = null;
                this.imagePreview = null;
                this.faceDetectorError = null;
                this.faceDetectorResponse = null;
                this.faceDetectorLoading = true;
                if (evt.type === 'preview') {
                    // extraigo el base 64 de la imagen
                    // this.imagePreview = await URL.createObjectURL(evt.image);
                    //URL.revokeObjectURL(this.imagePreview);
                    this.imagePreview = yield this.blobToBase64(evt.image);
                    this.imagePreviewResult = null;
                    this.faceDetectorIdentifierFile = evt.identifier;
                    this.selectFile(this.imagePreview, evt.image.name);
                }
                else {
                    // console.log(evt);
                    // //this.faceDetectorIdentifierFile = evt.identifier;
                    // this.closeCamera();
                    // this.selectFileB64(evt.image);
                    this.closeCamera();
                    // diferencia entre input y webcam
                    this.webcamService.setImage(evt.image);
                    this.imagePreview = evt.image;
                    this.imagePreviewResult = null;
                    this.faceDetectorIdentifierFile = null;
                    this.selectFile(this.imagePreview, new Date().getTime() + 'camera.jpeg');
                }
            }
            else if (evt.type !== 'success') {
                this.faceDetectorError = null;
                swal.fire({
                    title: evt.title,
                    html: evt.html
                });
                this.hideButtons = false;
            }
            else if (evt.type) {
                this.hideButtons = true;
                this.faceChecked = null;
            }
        });
    }
    selectFileB64(file) {
        // FOUND: MARIO
        this.imagePreview = file;
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
/** @nocollapse */ RequirementsCameraDetailComponent.ɵfac = function RequirementsCameraDetailComponent_Factory(t) { return new (t || RequirementsCameraDetailComponent)(ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(WebcamService), ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(FaceDetectorResponseService), ɵɵdirectiveInject(FaceCompareService), ɵɵdirectiveInject(ModelLoaderService), ɵɵdirectiveInject(LocalService), ɵɵdirectiveInject(HttpService)); };
/** @nocollapse */ RequirementsCameraDetailComponent.ɵcmp = ɵɵdefineComponent({ type: RequirementsCameraDetailComponent, selectors: [["akeela-requirements-camera-detail"]], viewQuery: function RequirementsCameraDetailComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$7, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.main = _t.first);
    } }, inputs: { config: "config" }, outputs: { showFile: "showFile", finish: "finish", event: "event" }, decls: 37, vars: 18, consts: [[1, "row"], [1, "col-12", "col-md-10", "offset-md-1"], [1, "col-12", "mb-5", "mt-3"], [1, "text-left"], [1, "pt-2", "pb-1", "font-weight-light"], [1, "line"], [1, "bg-primary", "font-weight-light", 3, "ngClass"], [1, "col-12"], [1, "w-100", "text-center"], [1, "font-weight-bold", "mb-3"], [1, "font-weight-light", "text-dark"], [1, "mb-3", 3, "innerHTML"], ["class", "w-60 w-sm-100 ml-auto mr-auto text-center  mb-2 mt-2  ", 4, "ngIf"], [1, "col-12", 2, "display", "flex", "align-items", "center", "justify-content", "center"], [2, "width", "480px"], [1, "photo-prev"], ["photoPrev", ""], [3, "config", "faceChecked", "response", 4, "ngIf"], [1, "w-100", "text-center", "pt-2"], [3, "config", "identifier", "close"], [1, "box-main", "w-100", "text-center"], [1, "w-100", "text-center", 2, "display", "flex", "justify-content", "center"], [1, "w-100", "pt-2"], [4, "ngIf"], ["class", "overlay center gray", 4, "ngIf"], ["class", "mb-3 mt-3 text-center", 3, "d-none", 4, "ngIf"], ["class", "mb-3 mt-3 text-center", 4, "ngIf"], ["class", "w-100 mt-4 pt-2 mb-3 text-right", 4, "ngIf"], ["class", "col-12 mb-5 mt-2", 4, "ngIf"], [1, "w-60", "w-sm-100", "ml-auto", "mr-auto", "text-center", "mb-2", "mt-2"], ["class", "vy p-2 ak-shadow w-100", "title", "Youtube Video", "frameborder", "0", "allow", "accelerometer;autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", "allowfullscreen", "", 3, "src", 4, "ngIf"], [3, "src", 4, "ngIf"], ["title", "Youtube Video", "frameborder", "0", "allow", "accelerometer;autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", "allowfullscreen", "", 1, "vy", "p-2", "ak-shadow", "w-100", 3, "src"], [3, "src"], [3, "config", "faceChecked", "response"], [1, "w-100", "card"], [1, "card-body"], ["style", "max-height:200px!important;", "class", "pt-1 pb-1 rounded mx-auto", 3, "src", 4, "ngIf"], [1, "card-footer", "text-center"], ["class", "col-12 text-center", "style", "color:white", 4, "ngIf"], [1, "pt-1", "pb-1", "rounded", "mx-auto", 2, "max-height", "200px!important", 3, "src"], [1, "col-12", "text-center", 2, "color", "white"], [1, "card-header", "small", "text-left"], [1, "card-body", "small", "text-center"], ["style", "max-height:200px!important;", "class", "pt-1  rounded mx-auto pb-2", 3, "src", 4, "ngIf"], ["class", "card-footer text-center", 4, "ngIf"], [1, "fas", "fa-exclamation-circle", "pr-1"], [3, "innerHTML"], [1, "fas", "fa-check", "pr-1"], [3, "innerHTML", 4, "ngIf"], [1, "pt-1", "rounded", "mx-auto", "pb-2", 2, "max-height", "200px!important", 3, "src"], [1, "overlay", "center", "gray"], [1, "pb-1"], [1, "fas", "fa-spinner", "fa-spin", "fa-3x"], [1, "pt-1"], [1, "mb-3", "mt-3", "text-center"], [1, "col-6"], [1, "btn", "btn-outline-primary", "btn-block", 3, "click"], [1, "fas", "fa-camera", "pr-1"], [3, "faceChecked", "title", "config", "identifier", "response", "evtUpload", "selected"], [1, "small", "text-secondary", "text-md-right", "text-center"], [4, "ngFor", "ngForOf"], [1, "col"], ["href", "javascript:void()", 3, "click"], [1, "w-100", "mt-4", "pt-2", "mb-3", "text-right"], [1, "btn", "btn-primary", 3, "disabled", "click"], [1, "fas", "fa-arrow-right", "ml-1"], [1, "col-12", "mb-5", "mt-2"], [1, "text-center"]], template: function RequirementsCameraDetailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 0);
        ɵɵelementStart(3, "div", 2);
        ɵɵelementStart(4, "div", 3);
        ɵɵelementStart(5, "span", 4);
        ɵɵtext(6, "Verif\u00EDcate");
        ɵɵelementEnd();
        ɵɵelementStart(7, "div", 5);
        ɵɵelement(8, "div", 6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(9, "div", 7);
        ɵɵelementStart(10, "div", 8);
        ɵɵelementStart(11, "h5", 9);
        ɵɵtext(12);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(13, "div", 10);
        ɵɵelement(14, "div", 11);
        ɵɵtemplate(15, RequirementsCameraDetailComponent_div_15_Template, 3, 2, "div", 12);
        ɵɵelementStart(16, "div", 8);
        ɵɵelementStart(17, "div", 0);
        ɵɵelementStart(18, "div", 13);
        ɵɵelementStart(19, "div", 14);
        ɵɵelementStart(20, "div", 15, 16);
        ɵɵtemplate(22, RequirementsCameraDetailComponent_akeela_webcam_22_Template, 1, 2, "akeela-webcam", 17);
        ɵɵelementEnd();
        ɵɵelementStart(23, "div", 18);
        ɵɵelementStart(24, "div", 0);
        ɵɵelementStart(25, "div", 7);
        ɵɵelementStart(26, "akeela-webcam-buttons", 19);
        ɵɵlistener("close", function RequirementsCameraDetailComponent_Template_akeela_webcam_buttons_close_26_listener() { return ctx.clsCamera(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(27, "div", 20);
        ɵɵelementStart(28, "div", 21);
        ɵɵelementStart(29, "div", 22);
        ɵɵtemplate(30, RequirementsCameraDetailComponent_ng_container_30_Template, 6, 2, "ng-container", 23);
        ɵɵtemplate(31, RequirementsCameraDetailComponent_ng_container_31_Template, 10, 12, "ng-container", 23);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(32, RequirementsCameraDetailComponent_div_32_Template, 6, 0, "div", 24);
        ɵɵelementEnd();
        ɵɵtemplate(33, RequirementsCameraDetailComponent_div_33_Template, 12, 7, "div", 25);
        ɵɵtemplate(34, RequirementsCameraDetailComponent_div_34_Template, 5, 0, "div", 26);
        ɵɵtemplate(35, RequirementsCameraDetailComponent_div_35_Template, 4, 1, "div", 27);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(36, RequirementsCameraDetailComponent_div_36_Template, 5, 0, "div", 28);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(8);
        ɵɵproperty("ngClass", "line" + (ctx.item * 1 + 3));
        ɵɵadvance(4);
        ɵɵtextInterpolate(ctx._config.object[ctx._config.category][ctx.item].requirement.name);
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ctx._config.object[ctx._config.category][ctx.item].requirement.description, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showYoutubeVideo && !ctx.faceDetectorError);
        ɵɵadvance(1);
        ɵɵclassProp("d-none", !ctx.showCamera);
        ɵɵadvance(6);
        ɵɵproperty("ngIf", ctx.config_webcam !== null);
        ɵɵadvance(4);
        ɵɵproperty("config", ctx._config)("identifier", ctx._config.object[ctx._config.category][ctx.item].requirement.alternateName);
        ɵɵadvance(1);
        ɵɵclassProp("d-none", ctx.showCamera);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.imagePreview !== "" && ctx.imagePreview !== null);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.imagePreviewResult !== "" && ctx.imagePreviewResult !== null);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.faceDetectorLoading);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.showCamera);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.hideButtons);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.files[ctx._config.object[ctx._config.category][ctx.item].requirement.alternateName].status === "COMPLETED" && ctx.files[ctx._config.object[ctx._config.category][ctx.item].requirement.alternateName]["nameFile"] !== null && !ctx.faceDetectorError);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.attempts > 3 && (ctx._config == null ? null : ctx._config.facialRecognition == null ? null : ctx._config.facialRecognition.active) && ctx.reconocimientoFacialActivo);
    } }, directives: [NgClass, NgIf, WebcamButtonsComponent, WebcamComponent, InputUploadComponent, NgForOf], pipes: [I18nPipe], styles: [".cont-f[_ngcontent-%COMP%]{background:#fff;display:block;position:relative}.cont-c[_ngcontent-%COMP%], .cont-f[_ngcontent-%COMP%]{height:100%;width:100%}.cont-c[_ngcontent-%COMP%]{transition:all .3s ease-out 0s}.cont[_ngcontent-%COMP%]{align-items:center;color:#111;cursor:pointer;display:flex;flex:1 1 0%;flex-direction:column;height:calc(100% - 64px);justify-content:center;margin:32px;outline:none}.overlay[_ngcontent-%COMP%], .photo-prev[_ngcontent-%COMP%]{height:100%;width:100%}.overlay[_ngcontent-%COMP%]{bottom:0;color:#fff;cursor:pointer;display:flex;left:50%;position:absolute;right:0;top:50%;transform:translate(-50%,-50%);vertical-align:middle;z-index:1000}.overlay.center[_ngcontent-%COMP%]{align-items:center;justify-content:center;text-align:center}.overlay.center[_ngcontent-%COMP%], .overlay.left[_ngcontent-%COMP%]{position:absolute}.overlay.gray[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.3)}.overlay.white[_ngcontent-%COMP%]{background-color:hsla(0,0%,100%,0)}.bg-icon-green[_ngcontent-%COMP%]{color:#0e5a0e}.focus-camera[_ngcontent-%COMP%]{background:linear-gradient(90deg,#fff 4px,transparent 0) 0 0,linear-gradient(90deg,#fff 4px,transparent 0) 0 100%,linear-gradient(270deg,#fff 4px,transparent 0) 100% 0,linear-gradient(270deg,#fff 4px,transparent 0) 100% 100%,linear-gradient(180deg,#fff 4px,transparent 0) 0 0,linear-gradient(180deg,#fff 4px,transparent 0) 100% 0,linear-gradient(0deg,#fff 4px,transparent 0) 0 100%,linear-gradient(0deg,#fff 4px,transparent 0) 100% 100%;background-repeat:no-repeat;background-size:20px 20px;border-radius:8px;height:240px;left:80px;left:110px;position:absolute;top:60px;width:275px;z-index:9999}.bgerror[_ngcontent-%COMP%]{background-color:#f8d7da;border-color:#f5c6cb;color:#721c24}.bgsuccess[_ngcontent-%COMP%]{background-color:#d4edda;border-color:#c3e6cb;color:#155724}.bgwarning[_ngcontent-%COMP%]{background-color:#fff3cd;border-color:#ffeeba;color:#856404}.item-rd[_ngcontent-%COMP%]{border:1px solid var(--ak-color-2);border-radius:8px;display:inline-block;font-size:13px;line-height:15px;margin:0 7px;min-width:110px}.item-rd[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{color:#999}.item-rd[_ngcontent-%COMP%]   .box-text[_ngcontent-%COMP%]{height:70px}.item-rd[_ngcontent-%COMP%]:hover{background:hsla(0,0%,80%,.10980392156862745)}.item-rd2[_ngcontent-%COMP%]:hover{background-color:#fff}.item-rd2[_ngcontent-%COMP%], .item-rd2[_ngcontent-%COMP%]:hover{display:inline-block;font-size:12px;margin:3px 7px;padding:4px 10px}.item-rd2[_ngcontent-%COMP%]{background-color:#ddd;border:1px solid #ccc;border-radius:20px}.content-huella-circle[_ngcontent-%COMP%]{background:hsla(0,0%,100%,.5);border-radius:45px;font-size:8px;height:16px;padding-top:2px;position:absolute;right:76px;text-align:center;top:5px;width:16px;z-index:2}.blink_me_circle[_ngcontent-%COMP%]{-webkit-animation:blinker 1.5s linear infinite!important;animation:blinker 1.5s linear infinite!important}.noti[_ngcontent-%COMP%]{font-size:7px;padding-left:5px}.scrollmenu[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap}.scrollmenu[_ngcontent-%COMP%]:focus, .scrollmenu[_ngcontent-%COMP%]:hover{overflow:auto}[_ngcontent-%COMP%]::-webkit-scrollbar{height:3px;width:.5px}@media (max-width:768px){.scrollmenu[_ngcontent-%COMP%]{overflow:auto}[_ngcontent-%COMP%]::-webkit-scrollbar{height:0!important;width:0!important}}.item[_ngcontent-%COMP%]{border-right:1px solid #ccc}.fz-12[_ngcontent-%COMP%]{font-size:12px}.fz-14[_ngcontent-%COMP%]{font-size:14px!important}.fz-16[_ngcontent-%COMP%]{font-size:16px}.section-box[_ngcontent-%COMP%]{min-height:100%}.section-box[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{color:#aaa;font-size:30px}.box-flex[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding-right:10px}input[_ngcontent-%COMP%]::-moz-placeholder{font-size:24px!important}input[_ngcontent-%COMP%]:-ms-input-placeholder{font-size:24px!important}input[_ngcontent-%COMP%], input[_ngcontent-%COMP%]::placeholder{font-size:24px!important}.vy[_ngcontent-%COMP%]{border-radius:12px;max-width:426px;min-height:240px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RequirementsCameraDetailComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-requirements-camera-detail',
                templateUrl: './requirements-camera-detail.component.html',
                styleUrls: ['./requirements-camera-detail.component.css']
            }]
    }], function () { return [{ type: I18nPipe }, { type: UploadService }, { type: WebcamService }, { type: DomSanitizer }, { type: FaceDetectorResponseService }, { type: FaceCompareService }, { type: ModelLoaderService }, { type: LocalService }, { type: HttpService }]; }, { showFile: [{
            type: Output
        }], finish: [{
            type: Output
        }], event: [{
            type: Output
        }], config: [{
            type: Input
        }], main: [{
            type: ViewChild,
            args: ['photoPrev']
        }] }); })();

function RequirementsCameraComponent_akeela_requirements_camera_detail_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "akeela-requirements-camera-detail", 1);
    ɵɵlistener("finish", function RequirementsCameraComponent_akeela_requirements_camera_detail_0_Template_akeela_requirements_camera_detail_finish_0_listener($event) { ɵɵrestoreView(_r2); const ctx_r1 = ɵɵnextContext(); return ctx_r1.finish_e($event); })("event", function RequirementsCameraComponent_akeela_requirements_camera_detail_0_Template_akeela_requirements_camera_detail_event_0_listener($event) { ɵɵrestoreView(_r2); const ctx_r3 = ɵɵnextContext(); return ctx_r3.send_event($event); })("showFile", function RequirementsCameraComponent_akeela_requirements_camera_detail_0_Template_akeela_requirements_camera_detail_showFile_0_listener($event) { ɵɵrestoreView(_r2); const ctx_r4 = ɵɵnextContext(); return ctx_r4.show_file($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("config", ctx_r0._config);
} }
class RequirementsCameraComponent {
    constructor(templateService, _upload, _requerementsService, _httpService, _error) {
        this.templateService = templateService;
        this._upload = _upload;
        this._requerementsService = _requerementsService;
        this._httpService = _httpService;
        this._error = _error;
        this.show_window_requirement = false;
        this.templates = {};
        this.requirements = null;
        this.files = {};
        this.finish = new EventEmitter();
        this.showFile = new EventEmitter();
        this.response = new EventEmitter();
        this.event = new EventEmitter();
        this.send_event = (response) => {
            this.event.emit(response);
        };
    }
    set config(value) {
        this._config = value;
    }
    ngOnInit() {
        this._upload.resetResponseUpload();
        this.initFiles();
        this.subscription_files = this._upload.getChangeRequirementById().subscribe((idRequirement) => {
            //  if (idRequirement !== null) {
            //  //  console.log(idRequirement);
            //    // se indica que el archivo ya cargo...
            //    this.finishupload.emit(true);
            //    this.list = 'LOADING';
            //    this.requirement = this.getRequirementById(idRequirement);
            //    if (this.config.isHistoryResponsesShow) {
            //      this.getRequirementHistory();
            //    }
            //    setTimeout(() => {
            //     // console.log('Entra en llamada' + idRequirement);
            //      this.getRequirementFiles();
            //      //console.log('Sale en llamada' + idRequirement);
            // this._upload.files[this._config.viewName][this.requirement.alternateName]['save']['data']['requirement']['identifier'] = idRequirement;
            // this._upload.files[this._config.viewName][this.requirement.alternateName]['delete']['data']['requirement']['identifier'] = idRequirement;
            this.files = this._upload.files[this._config.viewName];
            //  this.getBackNext();
            //  this.loaded = true;
            //  this.check_requirements();
            // }, 10);
            //  }
        });
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
    initFiles() {
        // this._httpService.executeRequest(this._config.endpoints.getRequirements.name, this._config.endpoints.getRequirements.params, true).subscribe((response: any) => {
        this.requirements = this._requerementsService.format_response(this._config.object, this._config);
        this.files = this._upload.files[this._config.viewName] = this._requerementsService.loadFileObjectCamera(this.requirements, this._config, 'person');
        // });
    }
    show_file(file) {
        this.showFile.emit(file);
    }
    finish_e(event) {
        this.finish.emit(true);
    }
    counter(length) {
        if (length >= 0) {
            return new Array(length);
        }
        else {
            return new Array();
        }
    }
    openRequirement(requirement) {
        alert('abro' + requirement.identifier);
    }
    begin_upload() {
        this.show_window_requirement = true;
    }
    close_window() {
        this.show_window_requirement = false;
    }
}
/** @nocollapse */ RequirementsCameraComponent.ɵfac = function RequirementsCameraComponent_Factory(t) { return new (t || RequirementsCameraComponent)(ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(RequirementsService), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(ErrorService)); };
/** @nocollapse */ RequirementsCameraComponent.ɵcmp = ɵɵdefineComponent({ type: RequirementsCameraComponent, selectors: [["akeela-requirements-camera"]], inputs: { config: "config" }, outputs: { finish: "finish", showFile: "showFile", response: "response", event: "event" }, decls: 1, vars: 1, consts: [[3, "config", "finish", "event", "showFile", 4, "ngIf"], [3, "config", "finish", "event", "showFile"]], template: function RequirementsCameraComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, RequirementsCameraComponent_akeela_requirements_camera_detail_0_Template, 1, 1, "akeela-requirements-camera-detail", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx._config);
    } }, directives: [NgIf, RequirementsCameraDetailComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RequirementsCameraComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-requirements-camera',
                templateUrl: './requirements-camera.component.html',
                styleUrls: ['./requirements-camera.component.css']
            }]
    }], function () { return [{ type: AkeelaTemplateService }, { type: UploadService }, { type: RequirementsService }, { type: HttpService }, { type: ErrorService }]; }, { config: [{
            type: Input
        }], finish: [{
            type: Output
        }], showFile: [{
            type: Output
        }], response: [{
            type: Output
        }], event: [{
            type: Output
        }] }); })();

class AkeelaRequirementsModule {
}
/** @nocollapse */ AkeelaRequirementsModule.ɵmod = ɵɵdefineNgModule({ type: AkeelaRequirementsModule });
/** @nocollapse */ AkeelaRequirementsModule.ɵinj = ɵɵdefineInjector({ factory: function AkeelaRequirementsModule_Factory(t) { return new (t || AkeelaRequirementsModule)(); }, providers: [SwalPortalTargets, RequirementsService, AkeelaTemplateService], imports: [[
            I18nModule,
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            SweetAlert2Module.forRoot(),
            WebCamModule,
            MyDatePickerModule,
            AkeelaCommonModule,
            NgxFaceApiJsModule,
            NgxImageCompressorModule
        ], MyDatePickerModule, CommonModule, NgxFaceApiJsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AkeelaRequirementsModule, { declarations: [RequirementUploadBriefcaseComponent, RequirementsBriefcaseComponent, RequirementsUserComponent, RequirementDetailUserComponent, PreviewImgComponent, ProgressComponent, ConsiderationsComponent, TableFilesComponent, RequirementDatesComponent, ResponseIndividualRequirementComponent, ResponseComponent, CheckboxComponent, AkeelaRequirementsTemplateComponent, AkeelaRequirementContentDirective, CamComponent, CameraComponent, InputUploadFileFlexComponent, RequirementsComponent, RequirementDetailComponent, IconResponseComponent, IndividualResponseComponent, RequirementsCameraComponent, RequirementsCameraDetailComponent, InputUploadComponent], imports: [I18nModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule, SweetAlert2Module, WebCamModule,
        MyDatePickerModule,
        AkeelaCommonModule,
        NgxFaceApiJsModule,
        NgxImageCompressorModule], exports: [RequirementUploadBriefcaseComponent, RequirementsBriefcaseComponent, RequirementsUserComponent, RequirementDetailUserComponent, MyDatePickerModule, RequirementDatesComponent, ResponseIndividualRequirementComponent, ResponseComponent, CheckboxComponent, AkeelaRequirementsTemplateComponent, AkeelaRequirementContentDirective, CamComponent, CameraComponent, InputUploadFileFlexComponent, RequirementsComponent, RequirementDetailComponent, IconResponseComponent, IndividualResponseComponent, ConsiderationsComponent, CommonModule, ProgressComponent, RequirementsCameraComponent, NgxFaceApiJsModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaRequirementsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    I18nModule,
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    SweetAlert2Module.forRoot(),
                    WebCamModule,
                    MyDatePickerModule,
                    AkeelaCommonModule,
                    NgxFaceApiJsModule,
                    NgxImageCompressorModule
                ],
                // tslint:disable-next-line:max-line-length
                declarations: [RequirementUploadBriefcaseComponent, RequirementsBriefcaseComponent, RequirementsUserComponent, RequirementDetailUserComponent, PreviewImgComponent, ProgressComponent, ConsiderationsComponent, TableFilesComponent, RequirementDatesComponent, ResponseIndividualRequirementComponent, ResponseComponent, CheckboxComponent, AkeelaRequirementsTemplateComponent, AkeelaRequirementContentDirective, CamComponent, CameraComponent, InputUploadFileFlexComponent, RequirementsComponent, RequirementDetailComponent, IconResponseComponent, IndividualResponseComponent, RequirementsCameraComponent, RequirementsCameraDetailComponent, InputUploadComponent],
                // tslint:disable-next-line:max-line-length
                exports: [RequirementUploadBriefcaseComponent, RequirementsBriefcaseComponent, RequirementsUserComponent, RequirementDetailUserComponent, MyDatePickerModule, RequirementDatesComponent, ResponseIndividualRequirementComponent, ResponseComponent, CheckboxComponent, AkeelaRequirementsTemplateComponent, AkeelaRequirementContentDirective, CamComponent, CameraComponent, InputUploadFileFlexComponent, RequirementsComponent, RequirementDetailComponent, IconResponseComponent, IndividualResponseComponent, ConsiderationsComponent, CommonModule, ProgressComponent, RequirementsCameraComponent, NgxFaceApiJsModule],
                providers: [SwalPortalTargets, RequirementsService, AkeelaTemplateService]
            }]
    }], null, null); })();

/*
 * Public API Surface of requirements
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AkeelaRequirementContentDirective, AkeelaRequirementsModule, AkeelaRequirementsTemplateComponent, AkeelaTemplateService, CamComponent, CameraComponent, CheckboxComponent, ConsiderationsComponent, IconResponseComponent, IndividualResponseComponent, InputUploadFileFlexComponent, ProgressComponent, RequirementDatesComponent, RequirementDetailComponent, RequirementDetailUserComponent, RequirementUploadBriefcaseComponent, RequirementsBriefcaseComponent, RequirementsCameraComponent, RequirementsComponent, RequirementsService, RequirementsUserComponent, ResponseComponent, ResponseIndividualRequirementComponent };
//# sourceMappingURL=akeela-requirements.js.map
